const lang = {
    "WanJu": "玩具",
    "RiYongPing": "日用品",
    "NinHao": "您好！",
    "ZhuCe": "注册",
    "DengLu": "登录",
    "TuiChu": "退出",
    "XinYongHuZhiYin": "新用户指引",
    "BangZhuZhongXin": "帮助中心",
    "ShangPinFenLei": "热门分类",
    "QuanBu": "全部",
    "SouSuo": "搜索",
    "GouWuChe": "购物车",
    "NinDe": "我的",
    "ZhangHuZhongXin": "账户",
    "DaiChuLiDingDan": "待处理订单",
    "XuYaoQueRenCaiGou": "需要确认采购",
    "XuYaoZhiFuDingJin": "需要支付定金",
    "XuYaoZhiFuHuoKuan": "需要支付货款",
    "XuYaoChuLiYiChang": "需要处理异常",
    "BuHuoWeiWanCheng": "补货未完成",
    "NinDangQianMeiYouDaiChuLiDeDanJu": "没有需要处理的订单",
    "ShouYe": "首页",
    "YouHui": "优惠",
    "JiDan": "新品预售",
    "PinPaiQu": "品牌区",
    "ZuiXinShangPin": "推荐商品",
    "GengDuo": "更多",
    "NTianChuHuo": "{0}天出货",
    "ShengYu": "剩余",
    "TianS": "天",
    "XiaoShi": "小时",
    "Xiang": "箱",
    "Kuan": "款",
    "QingTianXieN": "请填写{0}",
    "QingXuanZeN": "请选择{0}",
    "BuYunXuChaoGuoNGeZiFu": "不允许超过{0}个字符",
    "NGeShiBuZhengQue": "{0}格式不正确",
    "DaXiaoBuNengChaoGuoN": "大小不能超过{0}",
    "GeShiBuZhengQue": "格式不正确",
    "XiaDanLiuCheng": "下单流程",
    "ZhaoShangPin": "找商品",
    "XianShangHeJia": "购物车管理",
    "XianShangXiaDan": "线上下单",
    "ZaiXianDingDanGenZongChuLi": "在线订单跟踪处理",
    "FaHuoFuKuan": "仓储物流",
    "SouSuoShangPin": "搜索商品",
    "XuanZeYiXiangShangPin": "选择意向商品",
    "ChaZhaoXiangSiKuan": "查找相似款",
    "JinXingDuiBi": "进行对比",
    "JiaRuGouWuCheZhong": "加入购物车中",
    "GouWuCheXuanZeShangPinTiJiaoHeJia": "自动核价",
    "ZaiShangPinChiChaKanHeJiaHouDeJieGuo": "管理商品",
    "ChuLiShangPinXinXiFanKui": "处理商品信息反馈",
    "ZaiShangPinChiZuHePODan": "在购物车内组合PO单",
    "SheZhiChuHuoShiJian": "设置出货时间",
    "SheZhiTieZhiHeMaiTou": "设置贴纸和唛头",
    "QueDingDingDanXinXiJiYaoQiu": "确定订单信息及要求",
    "TiJiaoPODan": "提交PO单",
    "ZhiFuPODanDingJin": "支付PO单定金",
    "ChaKanPODanShengChanJinDu": "查看PO单生产进度",
    "ChanShengShangPinYiChangShi": "产生商品异常时，进行线上处理",
    "TiJiaoHeDuiChuanWuXinXi": "提交/核对船务信息",
    "ChaKanZhiJianTuPian": "查看质检图片",
    "ChaKanYuChuHuoQingDan": "查看预出货清单",
    "JieShouChuHuoTongZhi": "接收出货通知",
    "XiaZaiGeNeiDanZheng": "下载各类单证（装箱单、发票、结算单）",
    "DengDaiShouHuo": "等待收货",
    "ZhiFuPODanHuoKuan": "支付PO单货款",
    "ShouHuoBingJianYanShangPin": "收货并检验商品",
    "RuHeZhuCe": "商品唯一，高效比价",
    "YongYouYiGeEssaCnZhangHao": "新建一个essa.cn账号",
    "RuHeZhaoShangPin": "如何找商品？",
    "ShaiXuanXuYaoCaiGouDeShangPin": "筛选需要采购的商品",
    "RuHeTiJiaoDingDan": "如何提交订单？",
    "ZaiXianTiJiaoCaiGouDingDan": "在线提交采购订单",
    "RuHeZhiFu": "什么是采购计划？",
    "DingDanHuoKuanZhiFuJiJieSuan": "订单货款支付及结算",
    "ZuiXinLaiFangYongHu": "最新来访用户",
    "AnFenLeiChaZhaoShangPin": "按分类查找商品",
    "SouSuoLiShi": "搜索历史",
    "QueDing": "确定",
    "QuXiao": "取消",
    "ShangJiaShiJian": "上架时间",
    "NTianNei": "{0}天内",
    "YiYueNei": "1月内",
    "BanNianNei": "半年内",
    "NinZhengZaiLiuLan": "您正在浏览……",
    "ZhanKai": "展开",
    "ShouQi": "收起",
    "QingChu": "清除",
    "QingChuQuanBu": "清除全部",
    "DaTu": "大图",
    "LieBiao": "列表",
    "MoRen": "推荐排序",
    "HuoQi": "货期",
    "QiDingLiang": "起订量",
    "JiaGe": "价格",
    "KuanKeXuan": "{0}款可选",
    "XiangShiDe": "相似的",
    "XiangShiShangPin": "相似商品",
    "JiaRuShouCang": "收藏",
    "YiShouCang": "已关注",
    "ShouCangChengGong": "关注成功",
    "KeNengYouBanQuanJiuFen": "可能有版权纠纷",
    "WeiZhaoDaoFuHeTiaoJianDeJiLu": "未找到符合条件的记录",
    "SouSuoZhong": "搜索中",
    "JiaGeJiBuFenXinPinXuYaoDengLuHouChaKan": "价格及部分新品需要登录后查看。",
    "DengLuHouChaKanJiaGe": "登录后查看价格",
    "JiaGeJiBuFenXinPinXuYaoTiShengDengJiHouChaKan": "价格及部分新品只有成交用户能查看。",
    "XuYaoTiShengDengJiHouCaiNengChaKanJiaGe": "需要提升等级后才能查看价格。",
    "SSShangPinJiaGeZhiYouVIPYongHuCaiNengChaKan": "S+S TOYS、DECORA商品价格只有成交用户才能查看。",
    "ShenMeShiVIPYongHu": "什么是成交用户",
    "DengJiShuoMing": "等级说明",
    "HuoDongJieShuJinShengNTian": "活动结束仅剩{0}天",
    "ZhiChi": "支持",
    "ShuLiang": "数量",
    "DanJia": "单价",
    "ShangPinBianHao": "商品编号",
    "XuanZe": "选择",
    "YiXuanZe": "已选择",
    "GongNKuan": "共{0}款",
    "YiXuanZeNKuan": "已选择{0}款",
    "ZongJi": "总计",
    "TiJi": "体积",
    "MaoJingZhong": "毛净重",
    "JiaRuGouWuChe": "加入询价",
    "NKuanShangPinYiJiaRuGouWuChe": "{0}款商品已加入购物车",
    "YiJiaRuGouWuChe": "查看购物车",
    "TianJiaChengGong": "添加成功",
    "ShangPinMiaoShu": "商品描述",
    "GongYingShangXinXi": "供应商信息",
    "ZhengShu": "证书",
    "ChangJianWenTi": "常见问题",
    "JiaoYiShuoMing": "交易说明",
    "JiBenXinXi": "基本信息",
    "ZhuYingChanPin": "主营产品",
    "QiYeZhengShu": "企业证书",
    "HeZuoNianXian": "合作年限",
    "ShuJuPingGu": "数据评估",
    "JiYuQianNNianShuJu": "基于前{0}年数据",
    "FaHuoZhunShiLv": "发货准时率",
    "ZhiLiangTouSuLv": "质量投诉率",
    "XinYongZhiShu": "信用指数",
    "XinPinYanFaNengLi": "新品研发能力",
    "MOQPingJunZhi": "MOQ平均值",
    "BaoJiaPingJunYongShi": "报价平均用时",
    "WenTiFanKuiPingJunYongShi": "问题反馈平均用时",
    "JieDanPingJunYongShi": "接单平均用时",
    "ShuJuPingGuJiSuanGuiZe": "数据评估计算规则",
    "FaHuoZhunShiLvN": "发货准时率：1-误期次数/出货总次数",
    "ZhiLiangTouSuLvN": "质量投诉率：1-投诉次数/出货总次数",
    "XinYongZhiShuN": "信用指数：1-拒绝索赔次数/需索赔次数",
    "XinPinYanFaNengLiN": "新品研发能力：上一年度新发布商品款式",
    "MOQPingJunZhiN": "MOQ平均值：商品MOQ总值/商品款数",
    "BaoJiaPingJunYongShiN": "报价平均用时：报价用时总计/报价次数",
    "WenTiFanKuiPingJunYongShiN": "问题反馈平均用时：问题反馈用时总数/问题反馈次数",
    "JieDanPingJunYongShiN": "接单平均用时：接单用时总数/接单次数",
    "JinNNianChuHuoLiang": "近{0}年出货量",
    "ZhangHao": "账号",
    "YongHuMingYouXiang2": "用户名/邮箱",
    "ZhangHaoBuCunZai": "账号不存在",
    "WangJiMiMa2": "忘记密码？",
    "MiMa": "密码",
    "ZhangHaoHuoMiMaCuoWu": "帐号或密码错误",
    "YongYouYiGeESSAZhangHao": "拥有一个ESSA帐号",
    "KaiShi": "开始",
    "HuanYing": "欢迎！",
    "MeiYouMaoYiGongSi": "没有贸易公司，只有工厂！价格透明，专业客户经理免费提供全程协助。在线交易，简单、高效、有保障。",
    "ZheLiShiDiYiBu": "这里是第一步……",
    "ZhangHaoYuMiMa": "帐号与密码",
    "DianZiYouXiangBiXuZhenShiYouXiao": "电子邮箱必须真实有效，注册之后会收到一封邮箱引导验证",
    "YouXiang": "电子邮箱",
    "SheZhiMiMa": "创建密码",
    "ZaiCiShuRuMiMa": "再次输入密码",
    "LianXiXinXi": "联系信息",
    "JiaoYiBiZhong": "交易币种",
    "JianYiXuanZeRenMinBiZuoWeiJiaoYiJieSuanHuoBi": "建议选择人民币作为交易结算货币，因为商品的人民币价格不会因汇率波动而发生变化",
    "GongSiMingCheng": "公司名称",
    "GuoJiaDiQu": "国家/地区",
    "DaZhou": "大洲",
    "GuoJia": "国家",
    "LianXiRen": "联系人",
    "GuoJiaDaiMa": "国家代码",
    "GuDingDianHua": "固定电话",
    "YiXiangCaiGouShangPin": "意向采购商品",
    "QingXuanZe": "请选择……",
    "XuanTian": "选填",
    "YiXiaXinXiWeiXuanTianXinXi": "以下信息为选填信息，如能提供将有助于我们为您提供更好的服务",
    "HeZuomoshi": "合作模式",
    "XiaoShoufangshi": "销售方式",
    "NianDuCaiGouLiang": "玩具采购规模",
    "DanKuanCaiGouLiang": "玩具单款采购量",
    "MuBiaoShiChang": "销售市场",
    "LiJiZhuCe": "立即注册",
    "DianZiYouXiangBuNengWeiKong": "电子邮箱不能为空",
    "QingTianXieZhengQueDeDianZiYouXiang": "请填写正确的电子邮箱",
    "ZhangHaoYiCunZai": "帐号已存在",
    "ZhiShao6GeZiFu": "至少6个字符,字母与数字组合,区分大小写,不能全为数字",
    "QingZaiCiShuRuMiMa": "请再次输入密码",
    "LiangCiMiMaBuYiZhi": "两次密码不一致",
    "QingTianXieGongSiMingCheng": "请填写公司名称",
    "GongSiYiCunZai": "公司已存在",
    "QingXuanZeGuoJiaDiQu": "请选择国家/地区",
    "QingTianXieGongSiGuHua": "请填写公司固话",
    "GuHuaBiXuWeiShuZi": "固话必须为数字",
    "GuHuaYiCunZai": "固话已存在，请重新输入",
    "QingTianXieLianXiRen": "请填写联系人",
    "QingXuanZeZhuYaoCaiGouDeShangPinLeiXing": "请选择主要采购的商品类型",
    "ZhiDuoXuanZeNXiang": "至多选择{0}项",
    "NinYiChengGongZhuCe": "您已成功注册！",
    "NinDeZhangHao": "您的帐号",
    "JiXu": "继续",
    "XiangChaKanReXiaoHeCuXiaoShangPinDeJiaGe": "想查看热销和促销商品的价格？请先前往您的电子邮箱查收邮件，并按指引完成验证。",
    "ChongXinFaSong": "重新发送",
    "NMiaoHouChongXinFaSong": "{0}秒后重新发送",
    "XuanZeYiWeiZhuanShuKeHuJingLiWeiNinFuWu": "选择一位专属客户经理为您服务",
    "NinZaiTiaoXuanShangPinDingDanChuLiYuDaoWenTiShi": "您在挑选商品、订单处理遇到问题时，可以联系您的客户经理来协助您解决。客户经理对您所在的行业比较熟悉，该服务完全免费。",
    "ChaKanQuanBuKeHuJingLi": "查看全部销售顾问",
    "JingYan": "经验",
    "KeYongNJiaoLiu": "可用{0}交流",
    "ShuXiNHangYe": "熟悉{0}行业",
    "QueDingXuanZeGaiKeHuJingLi": "确定选择该销售顾问？",
    "QingXianQianWangNinDeDianZiYouXiangChaShouYouJian": "请先前往您的电子邮箱查收邮件，并按指引完成验证。当你通过邮箱验证之后，我们的工作人员会及时与您联系。",
    "WoMenDeGongZuoRenYuanJiangZai1GeGongZuoRi": "我们的工作人员将在1个工作日内与您电话联系，协助您完成认证。通过认证之后，您可以查看商品的价格、进行下单。",
    "YouXiangYanZheng": "邮箱验证",
    "YiTongGuoYanZheng": "已通过验证",
    "QuanBuKeHuJingLi": "全部客户经理",
    "XingMing": "姓名",
    "WeiZhaoDaoFuHeTiaoJianDeKeHuJingLi": "未找到符合条件的客户经理",
    "ZhaoHuiMiMa": "找回密码",
    "YanZhengMa": "验证码",
    "HuanYiZhang": "换一张",
    "TiJiao": "提交",
    "YiFengZhongSheMiMaDeYouJianHuiFaWangNin": "一封重设密码的邮件会发往您注册的邮箱，请根据邮件指引，重新设置登录密码。",
    "ChongSheMiMa": "重设密码",
    "XinMiMa": "新密码",
    "TiJiaoChengGong": "提交成功",
    "MiMaChongSheChengGong": "密码重设成功",
    "XiTongWeiHuZhong": "系统维护中，请稍后访问！",
    "WeiHuShiJian": "维护时间",
    "XiTongWeiHuQiJian": "系统维护期间，如有问题请联系：{0}",
    "ZhiKanQiTaGongYingShang": "只看其他供应商",
    "DuiBi": "对比",
    "ShangPinDuiBi": "商品对比",
    "GaoLiangXianShiBuTongXiang": "高亮显示不同项",
    "YinCangXiangTongXiang": "隐藏相同项",
    "ShangPinMingChen": "商品名称",
    "ReMenPinPai": "热门品牌",
    "PinPaiLieBiao": "品牌列表",
    "GengDuoPinPai": "更多品牌",
    "QuanBuPinPai": "全部品牌",
    "DaoChu": "导出",
    "HaiChaNXiang": "还差{0}箱",
    "YiManZuCaiGouTiaoJian": "已满足采购条件",
    "LiJiCaiGou": "立即采购",
    "JiJiangZhunBeiShengChan": "即将准备生产，确定采购后不能取消",
    "YuJiDaoHuoRiQi": "预计到货日期",
    "CaiGou": "采购",
    "ShangPinChi": "采购计划",
    "NingDePODan": "您的PO单",
    "NinHaiMeiYouTiJiaoRenHePODan": "您还没有提交任何PO单。",
    "PinGui": "拼柜",
    "HaiMeiYouKeYiYongYuPinGuiDeShangPin": "还没有可以用于拼柜的商品。",
    "ZiChan": "资产",
    "ZiJinGuanLi": "支付账户",
    "HuiKuanMingXi": "汇款明细",
    "HaiWeiShouDaoNinDeHuiKuan": "还未收到您的汇款。",
    "QianKuanMingXi": "欠款明细",
    "NinMeiYouWeiZhiFuDeQianKuan": "您没有未支付的欠款。",
    "ShouXinGuanLi": "授信管理",
    "NingDeDuiZhangDan": "您的对账单",
    "HaiMeiYouDuiZhangShuJu": "还没有对账数据。",
    "GuanLi": "管理",
    "JiaoYiSheZhi": "交易设置",
    "MaiTouHeTieZhi": "唛头和贴纸",
    "HaiMeiYouTiJiaoMaiTouYangBan": "还没有提交唛头样板。",
    "HaiMeiYouTiJiaoTieZhiYangBan": "还没有提交贴纸样板。",
    "DingDanYaoQiu": "订单要求",
    "ShangPinFuWu": "商品服务",
    "ZhunShuShangPin": "专属商品",
    "DaiLiShangPin": "代理商品",
    "ShouCangJia": "收藏夹",
    "ShouCangDeShangPin": "收藏的商品",
    "ShouCangDePinPai": "关注的品牌",
    "QiTa": "其它",
    "TuiJianShangPin": "推荐商品",
    "HaiMeiYouTuiJianDeShangPin": "还没有推荐的商品。",
    "LiuLanLiShi": "浏览历史",
    "NinZuiJinWeiChaKanGuoRenHeShangPin": "您最近未查看过任何商品。",
    "LiuLan": "浏览",
    "NinGouWuCheZhongDiShangPin": "您的购物车中的商品",
    "NinGouWuCheZhongHaiMeiYouShangPin": "您的购物车中还没有商品。",
    "DaoRu": "导入",
    "XianXiaZaiMuBan": "先下载模板，录入商品后上传。",
    "XlsXlsxGeShi": "xls、xlsx格式，文件不允许超过10M",
    "ShangChuan": "添加",
    "ShangChuanZhong": "上传中",
    "XiaZaiMuBan": "下载模板",
    "ChengGongDaoRuNKuanShangPin": "成功导入{0}款商品",
    "XiTongCuoWu": "系统错误，请重试",
    "ChengGongTiJiaoNKuanShangPin": "成功导出了{0}款商品",
    "NinHaiWeiTongGuoRenZheng": "您还未通过认证，无法提交核价",
    "TianJiaShiJian": "添加时间",
    "XiaYiBuShiShenMe": "下一步是什么?",
    "GongYingShang": "供应商",
    "QuYu": "区域",
    "QuanBuQuYu": "全部区域",
    "QuanBuFenLei": "全部分类",
    "QuanBuBaoZhuang": "全部包装",
    "QuanBuZhuangTai": "状态",
    "QuanBuShiJian": "全部时间",
    "ShangPinBianHaoHuoMingCheng": "商品编号或名称",
    "FanHui": "返回",
    "QiSongLiang": "起送量",
    "GongYingShangYaoQiuDaDaoCiDingGouLiang": "供应商要求达到此订购量才安排送货",
    "QuanBuXuan": "全不选",
    "QuanXuan": "全选",
    "ShanChu": "删除",
    "QueDingShanChuGaiShangPin": "确定删除该商品？",
    "ShanChuChengGong": "删除成功",
    "NKuanShangPinYiShanChu": "{0}款商品已删除",
    "TiWen": "提问",
    "DengNGeWenTi": "…等{0}个问题",
    "ChengGongTiJiaoLeNGeWenTi": "成功提交了{0}个问题",
    "DangQianShuLiangXiaoYuMOQ": "当前数量小于MOQ，我们尝试向供应商争取，但不保证能满足您的要求。",
    "YiRuShouCang": "收藏",
    "QueDingJiangGaiShangPinYiRuShouCangJia": "确定将该商品移入收藏夹？",
    "DingGouLiang": "订购量",
    "GaiJiaGeWeiBaoKuoDanJiaXianShiWei": "该价格未包括“核价中”的商品价格。",
    "TiJiaoHouWoMenJiangDuiZheXieShangPin": "提交后，我们将对这些商品向供应商进行核价，期限约为2天（视商品数量的不同，时间可能略有差异）。您可在“采购计划”中查看这些商品核价的进展。",
    "ZanWuShangPin": "暂无商品",
    "HaiMeiYouDingDan": "还没有订单",
    "JiaGeBaoHuQiShengYuNTian": "价格保护期剩余{0}天",
    "QiTaWenTi": "其它问题",
    "JiangZheXieWenTiYingYong": "将这些问题应用至所有选择的商品",
    "XuanZeMuBan": "选择模板",
    "ZanWeiHuiFu": "暂未回复",
    "NinShangPinChiZhongDiShangPin": "您的计划采购中的商品",
    "HaiMeiYouShangPinNinKeYiCong": "还没有商品。您可以从购物车中提交。",
    "ZhiKanGeXingHuaBianGengDeShangPin": "只看个性化变更的商品",
    "GeXingHuaBianGengDeShangPin": "个性化变更的商品",
    "ChuLiHeJiaHouYouBianHuaDeShangPin": "处理核价后有变化的商品",
    "QuPinGui": "去拼柜",
    "HeJiaZhong": "核价中",
    "HeJiaWanCheng": "核价完成",
    "HeJiaHouQueRenWuWuDeShangPin": "核价后确认无误的商品可以进行拼柜并提交PO单。请注意：核价中、核价后有变化未处理的商品不能进行拼柜",
    "YiChangLeiXing": "异常类型",
    "XuYaoChuLiWanXiaLieShangPinHouCaiNengJiXu": "需要处理完下列商品后才能继续！",
    "NinCanYuJiDanDeXiaLieShangPin": "您参与新品预售的下列商品，现在已经满足采购条件，请立即确定采购，以方便我们及时安排生产。",
    "QingZhuYiQueRenCaiGouZhiHou": "请注意：确认采购之后我们将安排生产，届时将不能取消",
    "QueRenCaiGou": "确认采购",
    "QuXiaoCaiGou": "取消采购",
    "BuNengShaoYuNXiang": "不能少于{0}箱",
    "YiJingKeYiAnPaiShengChan": "已经可以安排生产，确定取消采购？",
    "HuoDongYiGuoQi": "活动已过期",
    "JieShou": "接受",
    "XiaCiCaiGou": "下次采购",
    "YuanJiaGe": "原价格",
    "XinJiaGe": "新价格",
    "YuanHuoQi": "原货期",
    "XinHuoQi": "新货期",
    "YuanYuZhuangGuiRiQi": "原预装柜日期",
    "XinYuZhuangGuiRiQi": "新预装柜日期",
    "YuanMOQ": "原MOQ",
    "XinMOQ": "新MOQ",
    "WeiNinTuiJianYiXiaXiangSiDeShangPin": "为您推荐以下相似的商品",
    "KeXiaDanDeShangPin": "可下单的商品",
    "ZhiKanWeiHuoShangPin": "只看尾货商品",
    "ZhiKanJiDanShangPin": "只看新品预售商品",
    "KeXiaDanDeJiDanShangPin": "可下单的新品预售商品",
    "KeXiaDanDeWeiHuoShangPin": "可下单的尾货商品",
    "WeiHuo": "尾货",
    "NinDeZhangHaoYouQiTaRenZhengZaiCaoZuo": "您的帐号有其他人正在操作！",
    "ShuaXin": "刷新",
    "YuFuWuQiLianJieShiBai": "与服务器连接失败！",
    "QingNTianNeiChuHuo": "请{0}天内出货",
    "WeiShenMeYaoXianQiQueRenLinShiPO": "为什么要限期提交PO？",
    "ZheShiYinWei": "这是因为",
    "NinKeXiaDanDeShangPinZhongRuGuoCunZai": "您可下单的商品中如果存在以下情况：",
    "RuKuManNTianDeWeiHuo": "入库满{0}天的尾货。",
    "JiDanChengGongManNTianDeShangPin": "新品预售成功满{0}天的商品。",
    "ZheXieShangPinDeJiYa": "这些商品的积压，容易造成ESSA的库存压力和仓储成本，因此，请您在{0}天内安排这些商品提交PO。",
    "XianChuHuoGui": "先出货柜",
    "QiTaHuoGui": "其它货柜",
    "ShenMeShiXianChuHuoGui": "什么是先出货柜？",
    "WeiZaiYueDingShiJianNeiTiJiaoPODeWeiHuo": "未在约定时间内提交PO的尾货、新品预售成功的商品，我们会将其集中放置在一条货柜中。您在下一次提交PO时，必须先提交这部分商品，以减轻ESSA的库存压力和仓储成本。",
    "BiXuXianAnPaiCiHuoGuiQueRenLinShiPO": "必须先安排此货柜提交PO，在此之前，其他货柜无法提交PO。",
    "WeiShenMe": "为什么？",
    "DangNinDeHuoYuanShangPinZhongCunZaiYiXiaLeiBieShangPinShi": "您可下单的商品中存在以下情况：",
    "WeiJianQingESSADeKuCunYaLi": "为减轻ESSA的库存压力，系统已将以上商品自动创建装柜。这些商品不能直接移出，只有当您提交的申请我们通过之后才能移出。",
    "QingFangXin": "请放心，此货柜与其他货柜的属性并无差别，只是限制了您移出以上商品的条件。",
    "HuoGuiBuManShi": "货柜不满时，您也可以往此货柜继续添加其他商品。",
    "ShenQingYanQi": "申请延期",
    "WoMenShenHeTongGuoZhiHou": "我们审核通过之后，该商品将从此货柜移出",
    "JiHuaChuHuoRiQi": "计划出货日期",
    "YanQiYuanYin": "延期原因",
    "ChengGongTiJiaoYanQiShenQing": "成功提交延期申请",
    "YanQiShenQingChuLiZhong": "延期申请处理中",
    "TianJia": "添加",
    "YiChu": "移出",
    "TianJiaHouShengYuShuLiangShaoYuMOQ": "添加后，剩余数量少于MOQ({0}箱)，可能无法再次下单。确定添加？",
    "TianJiaHouGaiGongYingShangShengYuShuLiang": "添加后，该供应商剩余数量少于起送量({0}箱)，可能无法再次下单。确定添加？",
    "HuoGuiNZhongDiShangPin": "货柜{0}中的商品",
    "ChaoChuHuoGuiKeZhuangTiJi": "超出货柜可装体积",
    "SuoXuanZeDeHuoGuiTiJiTaiXiao": "所选择的货柜体积太小",
    "YuJiZhuangGuiRiQi": "预计装柜日期",
    "YiXiangZhuangGuiRiQi": "意向装柜日期",
    "YuJiShouHuoRiQi": "预计收货日期",
    "ShouHuoRiQi": "收货日期",
    "ZhuangGuiRiQi": "装柜日期",
    "ZhuangGuiWanChengRiQi": "装柜完成日期",
    "YuJiDaoGangRiQi": "预计到港日期",
    "DaoGangRiQi": "到港日期",
    "DuanTuYunFei": "短途运费",
    "YinShangPinChanDiYuChuHuoQuYuBuYiZhi": "因商品产地与出货区域不一致，产生的货物调拨费用",
    "NinZaiGaiGongYingShangDeDingGouLiang": "您在该供应商的订购量小于起送量，无法下单",
    "BuFenGongYingShangDeDingGouLiangWei": "部分供应商的订购量未达到起送量，无法下单",
    "ManJianDiKou": "满减抵扣",
    "SheZhiMaiTouHeTieZhi": "设置唛头和贴纸",
    "BaoCunQuanBuHuoGui": "保存全部货柜",
    "GaiRiQiZaoYuZhengChangJiaoHuoRiQi": "该日期早于正常交货日期，不一定能满足。",
    "YinBuFenShangPinChuHuoQuYuTiaoZheng": "因部分商品出货区域调整，部分商品成交价已发生变化，敬请留意。",
    "ESSAShangPinTiaoMa": "ESSA商品条码",
    "TieZhiYangBan": "贴纸样板",
    "MaiTouYangBan": "唛头样板",
    "TieZhi": "贴纸",
    "MaiTou": "唛头",
    "ShiYongShuoMing": "使用说明",
    "TiJiaoDingDanZhiQian": "提交订单之前，您需要提供商品使用的贴纸和唛头信息。",
    "MeiKuanShangPinKeYiShiYongYiZhongMaiTou": "1.每款商品可以使用一种唛头，但是可以使用多种贴纸；点击右侧“+”图标可增加需要使用的唛头或贴纸。",
    "KeYiZaiXianBianJi": "2.可以在线编辑，只需要在商品用到的单元格里编辑信息。注意：需要使用的贴纸或唛头单元格，请填写完整信息。",
    "ShangPinBuXuYaoShiYongDeTieZhiHuoMaiTou": "3.商品不需要使用的贴纸或唛头请在单元格内填写“-”；当全部商品不需要使用某种贴纸或唛头时，请全部填写“-”后直接删除",
    "RuoZaiXianBianJiBuFangBianShi": "4.若在线编辑不方便时，您可以下载录入信息后，再进行上传。",
    "GaiMaiTouYiCunZai": "该唛头已存在",
    "GaiTieZhiYiCunZai": "该贴纸已存在",
    "BuFenShangPinYiSheZhiNeiRong": "部分商品已设置内容，不能删除",
    "TieZhiPaiBanTu": "贴纸排版图",
    "YiBaoCun": "已保存",
    "FuZhi": "复制",
    "ZhanTie": "粘贴",
    "QingShuRu": "请输入",
    "ShangChuanShiBai": "上传失败，请重试",
    "XiaZai": "下载",
    "BaoCunBingFanHui": "保存并返回",
    "QingZaiCiQueRen": "请再次确认",
    "BuHuoShangPinDeMaiTouHeTieZhiXinXiWuWu": "补货商品的唛头和贴纸信息无误？确认后我们会按此安排生产。",
    "NKuanShangPinYiBuHuoChengGong": "{0}款商品已补货成功",
    "NinBenCiBianJiDeMaiTouHeTieZhiXinXi": "您本次编辑的唛头和贴纸信息将不保存。",
    "QueDingQuXiao": "确定取消？",
    "JiJiangShengChengPODan": "即将生成PO单…",
    "XiaDanRen": "下单人",
    "HuoGuiLeiXing": "货柜类型",
    "XiaShuiGang": "下水港",
    "ChuHuoCang": "出货仓",
    "KuanShu": "款数",
    "TeShuYaoQiu": "特殊要求",
    "JieSuanFangShi": "结算方式",
    "YingFuDingJin": "应付定金",
    "TiJiaoPO": "提交PO",
    "YiXiaXinXiZhongYao": "以下信息重要",
    "QingHeDuiMaiTouHeTieZhiXinXiHouZaiTiJiaoPO": "请核对唛头和贴纸信息后再提交PO，提交之后我们会按此内容安排生产。",
    "ZhuYiTianXieNBiaoShi": "注意：填写“-”表示当前商品不使用该唛头或贴纸",
    "XiuGai": "修改",
    "BuNengWeiKong": "不能为空",
    "RuDuiDingDanYouEWaiYaoQiu": "如对订单有额外要求，请在此填写",
    "HuoGuiBuMan": "货柜不满，无法提交",
    "ShenQingTiJiao": "申请提交",
    "ShenQingLiYou": "申请理由",
    "ShenQingYiTiJiao": "申请已提交",
    "GaiHuoGuiTiJiaoPODeShenQingZhengZaiChuLiZhong": "该货柜提交PO的申请正在处理中，暂时不能操作。",
    "ZhuYiShangPinDeMaiTouHeTieZhi": "注意商品的唛头和贴纸内容是否符合您的要求。",
    "QueDingTiJiaoPO": "确定提交PO？",
    "ChengGongTiJiaoPO": "成功提交PO",
    "QiTaShuoMing": "是否授权ESSA协助调货",
    "ShouQuanESSADiaoHuo": "授权ESSA调货",
    "DangHuoWuShengChanGuoChengZhong": "下单后，货品在生产过程中，可能因为某种原因发生货期延误情况，为了避免因少量商品货期问题导致装柜时间延误，是否允许授权ESSA根据生产进度进行合理调货并通知我。\n（调货说明：当某些商品出现货期延误影响到整个货柜的出货时间时，ESSA将帮您把其他生产中的柜子里的商品与本柜进行部分商品调换，确保本柜能按照预定时间出货）",
    "XianJin": "现金",
    "HuoKuan": "货款",
    "FuWuFei": "服务费",
    "TieZhiFei": "贴纸费",
    "XiuGaiMingCheng": "修改名称",
    "XiuGaiChengGong": "修改成功",
    "MingCheng": "名称",
    "GuiGe": "规格",
    "QueRenShiYong": "确认使用",
    "TuiHuiXiuGai": "退回修改",
    "TianXieXiuGaiYiJian": "填写修改意见",
    "YiTuiHui": "已退回",
    "QueDingShanChuGaiTieZhi": "确定删除该贴纸？",
    "QueDingShanChuGaiMaiTou": "确定删除该唛头？",
    "ChiCun": "尺寸",
    "YanSe": "颜色",
    "WenDangTuPianTuZhi": "文档/图片/图纸",
    "YiTiJiaoZhiZuoShenQing": "已提交制作申请",
    "TiJiaoHouWoMenHuiJinXingZhiZuo": "提交后我们会进行制作，制作完成后可以在列表中查看，确认之后就可以在订单中使用。",
    "DingDanZhuangTai": "订单状态",
    "ZhiFuDingJinHouWoMenHuiKaiShiAnPaiShengChan": "支付定金后我们会开始安排生产。请注意：货柜的预装柜日期会根据我们收到定金的时间发生变化",
    "ZhunBeiShengChanXiangGuanDeAnPaiShiYi": "准备生产相关的安排事宜",
    "JinXingShengChan": "进行生产。由于生产需要一定周期，期间如果发生交货期延误、工厂停产等问题，我们会及时通知您进行处理",
    "DuiShengChanWanChengDeShangPinJinXingZhiJian": "对生产完成的商品进行质检",
    "JiangShengChanWanChengDeShangPinShouRu": "将生产完成的商品收入ESSA仓库",
    "JiangShangPinJinXingZhuangGui": "将商品进行装柜",
    "WanChengZhuangGui": "完成装柜。此时可以查看并下载装箱单和发票单。",
    "WanChengBaoGuanShiYi": "完成报关事宜。",
    "HuoGuiYiKaiShiYunShu": "货柜已开始运输，请及时支付剩余货款",
    "BenCiJiaoYiWanCheng": "本次交易完成",
    "ZhiKanZuiJinYiZhou": "只看最近一周",
    "ZhiKanZuiJinYiYue": "只看最近一月",
    "ZhiKanYiYueYiQian": "只看一月以前",
    "NinZuiJinYiZhouDePODan": "您最近一周的PO单",
    "NinZuiJinYiYueDePODan": "您最近一月的PO单",
    "NinYiYueQianDePODan": "您一月前的PO单",
    "ChaKanXiangXi": "查看详细",
    "DingDanGenZong": "订单跟踪",
    "ShangPinShengChanZhongChuXianYiChang": "商品生产中出现异常，请立即处理",
    "NinYiTiJiaoBuHuo": "您已提交补货，ESSA正在处理，您现在可以{0}补充唛头和贴纸信息{1}",
    "BuHuoShangPinYiHeJiaWanCheng": "为了尽快提交工厂生产，请及时对补货池的商品{0}确认唛头和贴纸信息{1}",
    "DingDanShuLiang": "订单数量",
    "QingZaiNTianNeiZhiFuDingJin": "请尽快支付定金，预装柜日期将根据我们收到定金的时间发生变化,可能会引起推迟",
    "QingJinKuaiZhiFuDingJin": "请尽快支付定金，预装柜日期将根据我们收到定金的时间发生变化",
    "BianGengJieSuanFangShi": "变更结算方式",
    "DangQianJieSuanFangShiWei": "当前结算方式为",
    "BianGengJieSuanFangShiWei": "变更结算方式为",
    "NinPODanZhongDiShangPin": "您的PO单中的商品",
    "ZhiJianTuPian": "质检图片",
    "ZhuangXiangDan": "装箱单",
    "ZhuangXiangTuPian": "装箱图片",
    "YiZhuangXiangDeShangPinQingDan": "已装箱的商品清单",
    "XiaZaiDanZheng": "下载单证",
    "XiaZaiShangPinTuPian": "下载商品图片",
    "XiangShu": "箱数",
    "NeiHeShu": "内盒数",
    "WaiXiangZhuangLiang": "外箱装量",
    "ZhuangLiang": "装量",
    "ZongGeShu": "总个数",
    "ZongMaoZhong": "总毛重",
    "ZongJingZhong": "总净重",
    "ZongTiJi": "总体积",
    "WaiXiangChiCun": "外箱尺寸(长*宽*高)",
    "FaPiao": "发票",
    "HuoHao": "货号",
    "TiaoXingMa": "条形码",
    "ChengJiaoJia": "成交价",
    "XiaoJi": "小计",
    "HeJi": "合计",
    "FaPiaoJinE": "发票金额",
    "YongLiang": "用量",
    "FuWuFeiLv": "服务费率",
    "JieSuanDan": "结算单",
    "BenDanFeiYongMingXi": "本单费用明细",
    "FeiYongXiang": "费用项",
    "HaiYunFei": "海运费",
    "DaiFuFOBFei": "代付FOB费",
    "BiZhong": "币种",
    "YingFuJinE": "应付金额",
    "YiZhiFu": "已支付",
    "HaiXuZhiFu": "还需支付",
    "LiShiFeiYongMingXi": "历史费用明细",
    "JinE": "金额",
    "JieZhiN": "截止{0}",
    "JieZhiXNinHaiXuZhiFu": "截止{0}，您还须支付",
    "FeiYongHeJi": "费用合计",
    "QiTaDanZheng": "其它单证",
    "ShangPinChuXianYiChang": "商品出现异常，请及时处理",
    "YiXiaShangPinYingXiangShengChanHuoChuHuo": "以下商品影响生产或出货，请及时处理",
    "ZhiJianBuHeGe": "质检不合格",
    "ShangPinGuiGeBianHua": "商品规格变化",
    "AnMOQCaiGou": "按MOQ采购",
    "CheXiao": "撤销",
    "YiJieShou": "已接受",
    "YiShanChu": "已删除",
    "AnYuanYuZhuangGuiRiQi": "按原预装柜日期{0}，仅能交付{1}箱",
    "AnYuanDingGouLiangNXiang": "按原订购量{0}箱，预装柜日期将延期到{1}",
    "YiRuQiTaPODan": "移入其它PO单",
    "XuanZePODan": "选择PO单",
    "YouESSAGenJuShiJiShengChanQingKuangDiaoPei": "由ESSA根据实际生产情况调配",
    "BaoCun": "保存",
    "BuManGui": "不满柜，可以调入商品或者补货",
    "DiaoRuShangPin": "调入商品",
    "XuanZeXuYaoDiaoRuShangPinDePODan": "选择需要调入商品的PO单，ESSA会根据这些订单中商品的实际生产进度进行调拨，并将结果通知您",
    "TiaoRu": "调入",
    "CongNGePOZhongXuanZeShangPinDiaoRu": "从{0}个PO中选择商品调入",
    "YunXuDiaoRuBiYuZhuangGuiRiQiWan": "允许调入比预装柜日期晚{0}天的商品",
    "NinYiShenQingCongQiTaPODanDiaoRuShangPin": "您已申请从其它PO单调入商品，ESSA正在处理",
    "BuHuo": "补货",
    "QuanBuLaiYuan": "全部来源",
    "YiXuanZeNKuanShangPin": "已选择{0}款商品",
    "NKuanShangPinTiJiaoZhiHou": "{0}款商品提交之后，我们会立即向供应商核价",
    "FuHeYuZhuangGuiRiQiDe": "符合预装柜日期的",
    "XiuGaiMiMa": "修改密码",
    "FaSongYanZhengYouJian": "发送验证邮件",
    "NinZaiXiuGaiMiMaQianXuYaoYanZhengZhangHao": "您在修改密码前需要验证帐号。点击“发送验证邮件”链接后，一封邮件将会发往您的邮箱，请根据邮件指引继续操作。",
    "YouJianYiFaSong": "邮件已发送",
    "YuanMiMa": "原密码",
    "MiMaXiuGaiChengGong": "密码修改成功",
    "XiuGaiYouXiang": "修改邮箱",
    "NinZaiXiuGaiYouXiangQianXuYaoYanZheng": "您在修改邮箱前需要验证帐号。点击“发送验证邮件”链接后，一封邮件将会发往您的邮箱，请根据邮件指引继续操作。",
    "YuanYouXiang": "原邮箱",
    "XinDeYouXiang": "新的邮箱",
    "XinDeYouXiangXuYaoTongGuoJiHuo": "新的邮箱需要通过激活后才能使用。提交之后一封邮件将会发往填写的新邮箱，请根据邮件指引完成激活操作。",
    "YouXiangXiuGaiChengGong": "邮箱修改成功",
    "GongSiXinXi": "公司信息",
    "BuFenShuYuGuanJianXinXi": "部分属于关键信息",
    "WeiBaoZhangNinDeXinXiZhengQueXing": "为保障您的信息正确性，当您变更关键信息后需要我们再次审核之后才能生效。",
    "GuanJianXinXiXiangZaiNinTiJiaoBianGengShi": "关键信息项在您提交变更时，我们会列出",
    "NinBianGengLeGuanJianXinXi": "您变更了关键信息",
    "GuanJianXinXi": "关键信息",
    "GuanJianXinXiBianGengShi": "关键信息变更时，需要我们审核之后才生效。",
    "GongSiWangZhi": "公司网址",
    "GongSiLOGO": "公司LOGO",
    "JingYingXinXi": "经营信息",
    "ZhuYingChanPinFenLei": "主营产品分类",
    "JieSuanYaoQiu": "结算要求",
    "JiaoYiHuoBi": "交易货币",
    "NinXuYaoShiYongXinHuoBiLaiJieSuan": "您需要使用新货币来结算时，请联系您的客户经理确认相关事宜",
    "NinYiTiJiaoShenQing": "您已提交申请，ESSA将尽快与您确认",
    "BaoCunChengGong": "保存成功",
    "ZhengShuYaoQiu": "证书要求",
    "QiYeZhengShuYaoQiu": "企业证书要求",
    "ChanPinZhengShuYaoQiu": "产品证书要求",
    "QiTaYaoQiu": "其它要求",
    "ShiYiTu": "示意图",
    "ZhangHaoXinXi": "账号信息",
    "YongHuMing": "用户名",
    "ZhiWu": "职务",
    "JiShiTongXunGongJu": "即时通讯工具",
    "GeXingHuaSheZhi": "个性化设置",
    "YeMianLiuLanSheZhi": "页面浏览设置",
    "MoRenBaoJiaFangShi": "默认报价方式",
    "MeiYeShangPinShuLiang": "每页商品数量",
    "JieGuoChaKanMoShi": "结果查看模式",
    "YeMianChaKanYuYan": "页面查看语言",
    "YuanGongZhangHao": "员工帐号",
    "SheWeiBOSSZhangHao": "设为BOSS帐号",
    "TiShengGaiZhangHaoGuanLiGongSiZiLiao": "提升该帐号管理公司资料、员工帐号的权限？提升之后，您将会被降级，无法再进行上述信息管理。此操作不影响您进行下单。",
    "NinDeZiJin": "您的资金",
    "ZiJinZongJi": "资金总计",
    "KeYongZiJin": "可用资金",
    "BaoZhengJin": "保证金",
    "NingDeYingFuKuan": "您的应付款",
    "LeiJiYingFu": "累计应付",
    "NingJinQiJiaoYiE": "您的近期交易额",
    "NNianDingHuoJinE": "{0}年订货金额",
    "NNianChuHuoJinE": "{0}年出货金额",
    "ZiJinFenPeiMingXi": "资金分配明细",
    "QuanBuYongTu": "全部用途",
    "ZhiFuHuoKuan": "支付货款",
    "ZhiFuDingJin": "支付定金",
    "QiTaFeiYong": "其它费用",
    "FenPeiRiQi": "分配日期",
    "JinNGeYue": "近{0}个月",
    "JinNNian": "近{0}年",
    "JinSanGeYue": "近三个月",
    "JinBanNian": "近半年",
    "JinYiNian": "近一年",
    "JinNian": "今年",
    "YongTu": "用途",
    "BenCiFenPeiJinE": "本次分配金额",
    "HuiLv": "汇率",
    "RuZhangRiQi": "入账日期",
    "ShouKuanJinE": "收款金额",
    "ShouKuanBiZhong": "收款币种",
    "RuZhangBiZhong": "入账币种",
    "RuZhangJinE": "入账金额",
    "RiQi": "日期",
    "ShuoMing": "说明",
    "BenYueZhangDan": "本月账单",
    "LiShiZhangDan": "历史账单",
    "DaiFang": "贷方",
    "JieFang": "借方",
    "ShangQiJieYu": "上期结余",
    "BenQiJieYu": "本期结余",
    "YuE": "余额",
    "HuiKuan": "汇款",
    "YiTongGuoRenZheng": "已通过认证",
    "DaiRenZheng": "待认证",
    "ShangCiDengLuShiJian": "上次登录时间",
    "WoShiN": "我是{0}，很高兴能为您服务！",
    "NinHaoWoShiN": "您好！我是您的销售顾问{0}",
    "WoCongShiWaiMaoHangYeYiJingYouNNian": "我从事外贸行业已经有{0}年，对{1}的{2}市场比较熟悉。",
    "CaiGouGuoChengZhongYouRenHeWenTi": "采购过程中有任何问题均可联系我({0})",
    "ChangYongGongNeng": "常用功能",
    "NinXuYaoChuLiDeShiXiang": "您需要处理的事项",
    "XiaDanQian": "下单前",
    "XiaDanHou": "下单后",
    "NKuanShangPinXuYaoQueRenCaiGou": "{0}款商品需要确认采购",
    "NZhangDingDanXuYaoZhiFuDingJin": "{0}张订单需要支付定金",
    "NZhangDingDanXuYaoZhiFuHuoKuan": "{0}张订单需要支付货款",
    "NZhangDingDanXuYaoChuLiYiChang": "{0}张订单需要处理异常",
    "NZhangDingDanBuHuoWeiWanCheng": "{0}张订单补货未完成",
    "ZhongYaoTiXing": "重要提醒",
    "WeiNinTuiJianDeShangPin": "为您推荐的商品",
    "NinDaiLiDeShangPin": "您代理的商品",
    "NinHaiMeiYouDaiLiRenHeShangPin": "您还没有代理任何商品。",
    "NinDeZhuanShuShangPin": "您的专属商品",
    "HaiWeiKaiFaNinZhuanShuDeShangPin": "还未开发您专属的商品。",
    "NinShouCangDeShangPin": "您收藏的商品",
    "NinHaiMeiYouShouCangRenHeShangPin": "您还没有收藏任何商品。",
    "NinShouCangDePinPai": "您关注的品牌",
    "NinHaiMeiYouShouCangRenHePinPai": "您还没有关注任何品牌。",
    "JinRuZhuanQu": "进入专区",
    "XiaoXiTiXing": "消息提醒",
    "JiaoYiTiXing": "交易提醒",
    "HuoDongTiXing": "活动提醒",
    "XiTongXiaoXi": "系统消息",
    "DaoChuMuBan": "导出模板",
    "BaoJiaDan": "报价单",
    "PODan": "PO单",
    "FaPiaoDan": "发票单",
    "DuiZhangDan": "对账单",
    "QiYongRiQi": "启用日期",
    "MuBanMingCheng": "模板名称",
    "KeFuReXian": "客服热线",
    "BeiJingShiJian": "北京时间，周一至周五",
    "LianXiFangShi": "联系方式",
    "DianHua": "电话",
    "ShiJian": "时间",
    "BaoZhuangYuYan": "包装语言",
    "CaiZhi": "主材质",
    "TuPian": "图片",
    "ZhengZaiChuLiQingShaoHou": "正在加载中…",
    "YanZhengMaBuZhengQue": "验证码不正确",
    "BaoQianMeiYouSouSuoDaoShangPin": "抱歉，没有搜索到相关的商品。",
    "QueDingYaoShanChuMa": "确定要删除吗？",
    "GongChangHuoHao": "工厂货号",
    "WoYiYueDuBingTongYiESSAYongHuZhuCeXieYi": "我已阅读并同意{0}《ESSA 用户注册协议》{1}",
    "DingDanPeiKuan": "订单赔款",
    "TuiKuan": "退款",
    "ZengPin": "赠品",
    "FengXiangJiaoDai": "封箱胶带",
    "ChongDianQiChaTou": "充电器插头",
    "ChongDianQiDianYa": "充电器电压",
    "YaoKongPinLv": "遥控频率",
    "WaiXiangMaTouYaoQiu": "外箱唛头要求",
    "NeiXiangMaTouYaoQiu": "内箱唛头要求",
    "TieZhiYaoQiu": "贴纸要求",
    "ZhiXiangYaoQiu": "纸箱要求",
    "TongYongMoBan": "通用模板",
    "ShouJi": "手机",
    "XingBie": "性别",
    "JinZhiChiGeShi": "仅支持JPG、GIF、PNG、JPEG、BMP格式",
    "HeJia": "提交核价",
    "WeiHeJia": "未核价",
    "YouKe": "游客",
    "ZhuCeCaiGouShang": "注册采购商",
    "RenZhengCaiGouShang": "认证采购商",
    "VipCaiGouShang": "成交采购商",
    "Zhang": "张",
    "WenJian": "文件",
    "mingzi": "名字",
    "XiuGaiMingZi": "修改名字",
    "Yuan": "元",
    "XiuGaiMingZiChengGong": "修改名字成功",
    "ShangChuanChengGong": "上传成功",
    "QingXuanZeGuiGe": "请选择规格",
    "WeiShangChuanWenJian": "未上传文件",
    "WangLuoGuZhangHuoZheXiTon": "很遗憾，系统出现异常，当前无法为您提供服务。请联系平台客服或你的销售顾问为你解决问题。",
    "CuoWuDaiMa": "错误代码",
    "RuGuoXuYaoBianGengJiaoYiB": "如果需要变更交易币种，请联系客服",
    "DangQianJiaoYiBiZhong": "当前交易币种",
    "YouXiangYanZhengLianJieYi": "邮箱验证链接已失效",
    "YuanMiMaBuZhengQue": "原密码不正确",
    "LeiJiQianKuan": "累计欠款",
    "WeiTongGuoYanZheng": "未通过验证",
    "BianGengJiaoYiBiZhongWei": "变更交易币种为",
    "QingTongYiXieYi": "请同意协议",
    "QingTianXieQuHao": "请填写区号",
    "Nian": "年",
    "DianZiYouXiangBiXuYouXiao": "电子邮箱必须有效 , 创建后需要完成验证才能使用帐号 , 之后您使用此帐号登录网站进行采购",
    "ZaiShuWanGongYingShangFaB": "在数万供应商发布的一百多万款商品中 , 自由挑选 , 信息丰富透明 , 并借助先进的信息科技完成从挑选询价到下单 , 跟踪等交易过程 , 简单而高效",
    "QingDengLu": "请登录",
    "XianZaiXuanZeYiWeiZhuanSh": "现在选择一位销售顾问",
    "DangNinChengWeiWoMenDeRen": "当您成为我们的认证用户之后,将有一位专属顾问为您服务,当您在挑选商品、处理订单遇到问题时...",
    "XiaoShiNeiWoMenGongZuoRen": "24小时内我们工作人员会与您联系,核实资料,协助您完成认证.",
    "ZhiNengXuanZeYiGe": "只能选择一个",
    "KanKanZhengZaiJinXingDeYo": "看看正在进行的优惠活动",
    "YanZhengMaWuXiao": "验证码无效",
    "ZhuYaoCaiGouLeiXingBuNeng": "主要采购类型不能超过5项",
    "QiTaXinXi": "交易信息",
    "ZhuYaoCaiGouLeiXing": "<b>主要销售地区和采购类型</b>（第一时间推荐新品与热销商品）",
    "XuanZeCaiGouLeiXingYouZhu": "选择采购类型 , 有助于我们为您提供更精致的服务",
    "XuanTianZheiXieXinXiYouZh.": "选填这些信息 , 有助于我们为您提供便好的服务.",
    "QuanQiuWanJuYuLiPinDeMaoY": "ESSA - 全球玩具与礼品的贸易服务平台",
    "DengLu1": "登录",
    "ZhuCe1": "注册",
    "ZhaoHuiMiMa1": "找回密码",
    "SouSuoLieBiao": "搜索列表",
    "KaiXinFangXin": "开心+放心",
    "TeJiaWanJu": "特价玩具",
    "JiDanTuanGou": "新品预售/团购",
    "WanJuPinPaiDaQuan": "玩具TOP品牌大全",
    "JingXuanWanJuChanPin": "精选玩具产品",
    "BangZhuZhongXin1": "帮助中心",
    "XiTongWeiHu": "系统维护",
    "WoDeZhangHu": "我的账户",
    "WoDeXiaoXi": "我的消息",
    "WoDeGouWuChe": "您的购物车",
    "WoDeCaiGouJiHua": "您的采购计划",
    "WoDeHuoGui": "我的货柜",
    "SheZhiTieZhiMaTou": "设置贴纸唛头",
    "TiJiaoDingDan": "提交订单",
    "WoDeDingDan": "我的订单",
    "WoDeZiChan": "支付管理",
    "ZhangHuSheZhi": "账户设置",
    "JiaoYiSheZhi1": "交易设置",
    "JieSuanYaoQiu1": "结算要求",
    "CaiGouYaoQiu": "采购要求",
    "HuoDaiLianXiRen": "货代联系人",
    "TieZhiYuMaTou": "贴纸与唛头",
    "MoBanGuanLi": "模板管理",
    "ShangPinFuWu1": "商品服务",
    "WoDeZhuanShuShangPin": "我的专属商品",
    "WoDeDaiLiShangPin": "我的代理商品",
    "GongSiXinXi1": "公司信息",
    "WoDeYuanGong": "我的员工",
    "ZhangHaoXinXi1": "账号信息",
    "JiBenZiLiao": "基本资料",
    "XiuGaiYouXiang1": "修改邮箱",
    "XiuGaiMiMa1": "修改密码",
    "ShouZangJia": "收藏夹",
    "ShouZangDeShangPin": "收藏的商品",
    "ShouZangDePinPai": "关注的品牌",
    "QiTa1": "其他",
    "LiuLanLiShi1": "浏览历史",
    "YeMianSheZhi": "页面设置",
    "DangQianHuoJuShengYuKongJ": "货柜商品总体积不允许超出货柜可装体积最大值：{0}m³",
    "ZuiDaXiangShuWeiXiang": "最大箱数为：{0}箱",
    "QingShuRuShuZi": "请输入数字",
    "GaiGongYingShangKeTianJiaDeShangPin": "该供应商可添加的商品",
    "GaiGongYingShangYiWuKeTianJiaShangPin": "该供应商已无可添加商品",
    "BaoCunQuanBuHuoGuiChengGong": "保存全部货柜成功",
    "ZhiDingShanChuHuoGuiYiBeiShanChu": "指定的要删除的货柜不存在于货柜列表中或者已经删除了",
    "ZhiDingShanChuHuoGuiBiXuWeiKong": "指定的要删除的货柜{0}必须为空货柜！",
    "QingXuanZeYaoShanChuDeShangPin": "请选择要删除的商品！",
    "QueDingYaoShanChuXuanZhongDeShangPinMa": "确定要删除选中的商品吗？",
    "QueDingYaoShanChuCiShangPinMa": "确定要删除此商品吗？",
    "ShenQingWeiManGuiTiJiaoPODoing": "您申请的未满柜提交PO，ESSA正在处理中",
    "QingXuanZeYaoTianJiaDeShangPin": "请选择要添加的商品！",
    "QingXuanZeYaoYiChuDeShangPin": "请选择要移出的商品！",
    "DangQianZhangHuYouQiTaRenZaiXiaDanLater": "您的订单正在跟进处理，如需操作请联系您的销售顾问。",
    "NinDeCaiGouJiHua": "您计划采购的商品",
    "DaoChuShangPin": "导出商品图片",
    "DangQianZhangHuYouQiTaRenZaiXiaDan": "当前帐户下有其他人正在下单!",
    "YiXuanZhongNKuan": "已选中{0}款",
    "WaiXiangMaoZhong": "外箱毛重",
    "JingZhong": "净重",
    "WaiXiangTiJi": "外箱体积",
    "DingGouLiangXiang": "订购量：{0}箱",
    "ZhuYiYouBuFenShangPinWeiM": "注意:有部份商品未满足下单条件。",
    "LiJiChuLi": "立即处理",
    "RiQiShenQingTiQianForPI": "货柜中部分商品的货期未能达到该日期装柜，您可以申请，我们会向供应商争取，请留意PO订单反馈结果！",
    "CaiGouLiang": "采购量",
    "XiaoYuQiSongLiangBuNengXiaDan": "当前采购量小于该供应商的起送量，供应商不运送商品，不能下单。",
    "SheZhiTieZhiMaiTou": "设置贴纸唛头",
    "HuoGuiNWeiManZuXiaDanTiaoJian": "货柜{0}中的以下商品未满足下单条件",
    "QingCanKaoCuoWuTiShiHouTiJiaoPI": "请参考“起送量”及“MOQ”的提示，处理后再次提交。",
    "MeiYouZhaoDaoXiangGuanDeS": "没有找到相关的商品",
    "QingHeDuiMaTouTieZhiXinXi": "请核对唛头、贴纸信息正确无误后再提交PO，提交后我们将按此内容安排生产",
    "TianBiaoShiBuShiYongGaiTi": "填“-”表示不使用该贴纸或唛头。",
    "ShangPinBianMa": "商品编码",
    "XuanZeTieZhiYangBan": "选择贴纸样板",
    "XuanZeMaTouYangBan": "选择唛头样板",
    "XiaZaiXinXi": "下载信息",
    "WaiXiang": "外箱",
    "ZhengMa": "正唛",
    "CeMa": "侧唛",
    "NeiXiang": "内箱",
    "BuHuoShangPinDeTieZhiMaTo": "补货商品的贴纸唛头信息无误？",
    "QueRenHouWoMeJiangAnCiAnP": "确认后，我们将按此安排生产。",
    "NinBenCiBianJiDeMaTouTieZ": "您本次编辑的唛头贴纸信息不保存！",
    "QueDingQuXiaoMa": "确定取消吗？",
    "CaiGouJiHua": "采购计划",
    "HuiYuanZhongXinShouYe": "会员中心首页",
    "DaiQueRenFuKuan": "待确认付款",
    "DaiQueRenDingJin": "待确认定金",
    "DaiChuLiYiChang": "待处理异常",
    "WeiWanChengDeDiaoBuHuo": "未完成的调补货",
    "NinMeiYouDaiChuLiDeDanJu": "您没有待处理的单据",
    "BangZhu": "帮助",
    "XinShouZhiNan": "新手指南",
    "XinShouShiPinJiaoCheng": "帮助中心",
    "FenZhongLeJie": "1分钟了解ESSA",
    "MianFeiZhuCe": "免费注册",
    "DengLuShuoMing": "登录说明",
    "YongHuDengJiQuanXian": "用户等级权限",
    "CaiGouShuoMing": "采购说明",
    "CaiGouShiPinJiaoCheng": "采购视频教程",
    "JiaoYiLiuCheng": "交易流程",
    "CaiGouJiHua1": "采购计划",
    "ShangPinPinJu": "商品拼柜",
    "PODan1": "PO单",
    "ZhiFuHeYunShu": "支付和运输",
    "BaoJiaFangShi": "报价方式",
    "ZhiFuFangShi": "如何支付",
    "DingHuoYaoQiu": "订货要求",
    "HuoYunShuoMing": "货运说明",
    "XiaShuiChengShi": "下水城市",
    "GuanYuWoMen": "关于我们",
    "GuanYu": "关于ESSA",
    "FuWuYuJiaZhi": "服务与价值",
    "SJieShao": "S+S介绍",
    "DJieShao": "DECORA介绍",
    "GongSiTuPian": "公司图片",
    "KeJian": "成交用户可见",
    "SuoYouLeiMu": "所有类目",
    "1059ER10018": "超过货柜可装体积，不允许确认补货",
    "TiaoJianDaCheng": "条件达成",
    "ShengYuXiangShu": "剩余",
    "KuaiSuChuHuo": "快速出货",
    "TuanGou": "团购",
    "JianYiSouSuo": "简易搜索",
    "RuHeXunJia": "如何询价",
    "ShiShiXunJiaHeChaXunShang": "所有商品免费核价",
    "KeKaoDeFuKuanFangShi": "自主安排您的采购计划",
    "FuWuYuBaoZhang": "如何支付",
    "ShouHouMaoYiBaoZhang": "可靠的付款方式",
    "ShangPinWeiYiGaoXiaoBiJia": "订单实时，自主掌控",
    "ChaoDaZhanTingXianXiaHuDo": "超大展厅，线下互动",
    "MaoYiBaoZhangJiangDiFengX": "贸易保障，降低风险",
    "JiaGeDi": "商品唯一，高效比价",
    "DaFuLiPaiSongYuanChangJia": "商品全为工厂标准价格，对比功能助高效甄选商品",
    "ShangPinDuo": "订单实时，自主掌控",
    "HaiLiangChanPinXinXiQingS": "可自主操作，订单实时监控",
    "ZaiXianJiaoYi": "超大展厅，线下互动",
    "ZiZhuCaoZuoYiTiHuaShiShiD": "线上海量商品信息，线下样品展厅可印证",
    "ShiNianPinPai": "贸易保障，降低风险",
    "KeKaoDeHeZuoHuoBanGongJia": "可靠的合作伙伴，10年品牌共建诚信交易",
    "WuTiaoJianTuiHuan": "无条件退换",
    "YiWaiQingKuangYouBaoZhang": "意外情况有保障",
    "BaoXianMianFeiSong": "保险免费送",
    "ShuiZiXianPingAnXian": "水渍险/平安险",
    "ZhiLiangYouPeiChang": "质量有赔偿",
    "DaoGangKanZhiLiangShouHou": "到港看质量，ESSA售后强",
    "XinShouZhiYin": "新手指引",
    "ChaKanGengDuo": "查看更多",
    "ZhuYi": "注意",
    "ShangPinHeJiaJieGuoYouYiC": "商品核价结果有异常",
    "TiShi": "提示",
    "GaiShangPinYiGuoJiaGeBaoH": "该商品已过价格保护期",
    "ZaiCiHeJia": "再次核价",
    "YanZhengMaCuoWu": "验证码错误",
    "WangLuoGuZhangHuoZheXiTonCode": "很遗憾，系统出现异常，当前无法为您提供服务。请联系平台客服或你的销售顾问为你解决问题。错误代码：{0}",
    "YongHuXinXiYiGuoQiQingZho": "用户信息已过期，请重新登录。{0}秒后自动跳转",
    "CunRu": "存入",
    "ZhiChu": "支出",
    "XieYi": "协议",
    "WoYiJingYueDuBingTongYi": "我已经阅读并同意",
    "XiangQing": "详情",
    "ChanPinZhengShu": "产品证书",
    "ZhuCaiZhi": "主材质",
    "ZhangHaoYiJinYong": "账号已禁用",
    "QingXianQianWangNinDeDian": "请先前往您的电子邮箱查收邮件",
    "CuoWu": "错误",
    "KeFuTuanDui": "ESSA的顾问团队",
    "NinQueDingXuanZeGaiKeFu": "您确定选择该顾问",
    "JiYuQianSanNianShuJu": "基于前三年数据",
    "BaoZhuangFenLi": "包装分离",
    "BaoZhuangNianLingBiaoQian": "包装年龄标签",
    "JinNianChuHuoLiang": "近3年出货量",
    "JiDanTuanGouShangPinJiaGe": "新品预售/团购商品只有成交用户才能查看",
    "ShanChuBuChengGong": "删除不成功",
    "CaiGouShangZhangHaoXiaJin": "采购商账号下仅剩余一个货柜时，不允许删除",
    "KongHuoJuCaiNengBeiShanCh": "空货柜才能被删除",
    "GaiShangPinYiJingQueRenGo": "该商品已经确认购买过，后续只能增加订购量，不能减少",
    "GengXinShiBai": "更新失败",
    "QuXiaoCaiGouShiBai": "取消采购失败",
    "XunJiaZhongDeShangPinBuNe": "询价中的商品不能更改订购量",
    "FeiHuoDongShangPinDingGou": "非活动商品订购量在【可用量】与【采购MOQ】范围内的值不允许选择",
    "FeiHuoDongShangPinDingGou1": "非活动商品订购量不允许小于询价后的【采购MOQ】",
    "HuoDongShangPinZaiDiaoZhe": "活动商品在调整订购量时不能低于【MOQ】",
    "JiDanTuanGouHuoDongBuCunZ": "新品预售/团购活动不存在",
    "HuoDongZhuangTaiJiDanZhon": "活动状态 = 新品预售中/团购中时，调整【订购量】不能低于【MOQ】",
    "QueRenCaiGouQianDiaoZheng": "确认采购前,调整【订购量】不能低于【MOQ】",
    "QueRenCaiGouHouBuYunXuDia": "确认采购后,不允许调整【订购量】",
    "JiDanChengGongHouBuYunXuD": "新品预售成功后,不允许调整【订购量】，不允许删除",
    "JiDanShiBaiHouZhiYunXuSha": "新品预售失败后,只允许删除",
    "ErCiHeJiaShiBai": "二次核价失败",
    "ShangPinBuFuHeYaoQiuWuFaT": "商品不符合要求，无法添加到采购计划",
    "JiDanTuanGouZhiJieJiaRuSh": "新品预售/团购直接加入采购计划失败",
    "JiDanTuanGouHuoDongBuZaiY": "新品预售/团购活动不在有效期内",
    "XunJiaZhongDeShangPinBuYu": "询价中的商品不允许删除",
    "YiQueRenDeShangPinBuYunXu": "已确认的商品不允许删除",
    "HuoJuYiJingYouGeBuNengZai": "货柜已经有30个不能再增加",
    "YiXiangYuZhuangJuRiQiShou": "意向预装柜日期手工调整时最多比默认时间提前10天",
    "ShangPinShengYuShuLiangBu": "商品剩余数量={0},不允许小于该商品的采购MOQ={1}",
    "ShangPinBianHaoDeTieZhiMa": "商品编号{0}的贴纸唛头没有正确设置",
    "ShangPinBianHaoDingGouLia": "商品编号{0}订购量达不到MOQ",
    "GongYingShangBianHaoWeiDe": "供应商编号为{0}的订购量不满足起送量",
    "CaiGouShangMeiYouSheZhiJi": "采购商没有设置交易币种",
    "CaiGouShangZhangHaoXiaBuC": "采购商账号下不存在可删除的货柜",
    "WeiHuoBuNengGaiBianXiangS": "尾货不能改变箱数，只能整款移动",
    "ShouDongDiaoZhengDeRiQiYu": "手动调整的日期允许比【默认预装柜日期】小至多10天，且不允许小于当前日期+15天",
    "HaiCha": "还差",
    "ShuRuShangPinBianHaoGongC": "输入商品编号，关键字或以图搜图",
    "CaiGouJiHuaZhongShiKongDe": "采购计划中是空的",
    "ChaKanCaiGouJiHua": "查看采购计划",
    "HeJiaShiBai": "核价失败",
    "ShangChuanXinXi": "上传信息",
    "CiDanYiJingShenQingLeDiao": "此PO单已经申请了调货",
    "CiDanBuNengZaiGengGaiJieS": "此PO单不能再更改结算方式",
    "TianJiaGouWuCheChengGong": "添加购物车成功",
    "GouWuCheShiKongDe": "购物车是空的",
    "HPBangZhuZhongXin": "帮助中心",
    "BuCunZaiHeShiDeBaoBiaoMoB": "不存在合适的报表模版，请联系管理员",
    "QingXuanZeYaoDaoChuDeShuJ": "请选择要导出的商品",
    "QingXuanZeMoBan": "请选择模版",
    "ShangPinTuPian": "商品图片",
    "QingShuRuQuHao": "请输入区号",
    "BuNengZhongFuXuanZe": "不能重复选择",
    "Shi": "是",
    "Fou": "否",
    "QingTianJiaShangPin": "请添加商品",
    "LeiMu": "类目",
    "QueShaoBaoBiaoZiYuanBianMaCanShu": "缺少报表资源编码参数，请联系开发人员。",
    "QingXianXiaZaiMoBanTianXi": "请先下载模版，填写后上传",
    "queren": "确认",
    "ShengChanYaoQiu": "生产要求",
    "BeiZhu": "备注",
    "BaoZhuangYaoQiu": "包装要求",
    "BuManJuLiYouWeiKong": "不满柜理由为空",
    "NinZaiZhiFuDingJinHouEssaWeiNinTouChan": "您在支付定金后，ESSA将立即为您进行投产。",
    "ZhengZaiZhunBeiShengChanXiangGuanDeAnPai": "正在准备生产相关的安排。",
    "NinDeDingDanYiJingZaiShengChanZhong": "您的订单已经在生产中，由于生产需要一定的周期，生产过程中如果发生货期延误、工厂停产等问题，届时需要您进行处理。",
    "ShengChanYiWanBiZhengZaiJinXinZhiJian": "生产已完毕，正在进行质检",
    "ShangPinYiZhiJianWanChengZhengZaiShouRuEssaCangKu": "商品已质检完成，正在收入ESSA仓库",
    "DingDanYiJingZhuangGuiWanCheng": "订单已经开始装柜",
    "HuoWuYiJingZhuangGuiWanCheng": "货物已经装柜完成",
    "YiJingBaoGuanTongGuo": "已经报关通过",
    "NinDeHuoGuiYiZaiYunShuGuoChengZhongQingJiShiZhiFu": "您的货柜已在运输过程中，请及时支付货款",
    "TiDanYiJiaoFu": "提单已交付",
    "PoDanLieBiaoShiKongDe": "Po单列表是空的",
    "LieBiaoShiKongDe": "列表是空的",
    "XunJiaYiChangXuYaoChuLi": "询价异常，需要处理",
    "YiChangChuLi": "异常处理",
    "ChaKanShangPin": "查看商品",
    "QiTaDanJu": "其他单据",
    "FuWuFeiYouHuoGuiShangPinKuanShuJueDing": "服务费由货柜商品款数决定",
    "GaiFeiYongBaoKuoHuoKuanTieZhiFeiFuWuFeiDaiFuFob": "该费用包括货款、贴纸费、服务费、代付FOB",
    "YiXuanZhong": "已选中",
    "Jian": "件",
    "YiXiaShangPinYiGuoJiaGeBaoHuQi": "以下商品已过价格保护期",
    "YiXiaJia": "已下架",
    "YiJieSouCiMoq": "已接受此MOQ",
    "ShangPinXinXiYiChang": "商品信息异常",
    "ZhiJianYiChang": "质检异常",
    "YiDongDaoN": "移动到{0}",
    "ZanShiMeiPoDan": "暂时没po单",
    "QingChaKan": "请查看",
    "GouWuCheZhongShiKongDe": "购物车中是空的",
    "JiBenGouWuLiuChen": "基本购物流程",
    "ChaZhaoShangPinJiaRuGouWuChe": "查找商品加入购物车",
    "TiJiaoBingQueRenPI": "提交并确认采购计划",
    "PIPinGuiBingTiJiaoPO": "采购计划拼柜提交订单",
    "QueRenPO": "确认订单",
    "ChuHuoJiaoYiWanCheng": "出货交易完成",
    "QueRenXinMiMa": "确认新密码",
    "KeHuFuWu": "客户服务",
    "YiChangYuanYin": "异常原因",
    "JiaGeYiChang": "价格异常",
    "HuoQiYiChang": "货期异常",
    "MOQYiChang": "MOQ异常",
    "WuLiaoKeYongLiangBuZu": "配件不足",
    "TingChanXiaJia": "停产下架",
    "HeZuoFangShi": "合作方式",
    "XiaoShouQuDao": "销售渠道",
    "BaoZhuangChiCun": "包装尺寸",
    "SuoYouXunJiaWanChengHouHe": "所有询价完成后核价结果没有异常的商品都可以在“拼柜”中查看，你可以从中挑选部分商品组成一个货柜提交订单，或者你可以先处理核价结果有异常的商品。",
    "QingHuaDongYanZhengMa": "请滑动验证码",
    "TuoDongHuaKuaiDaoZuiYou": "拖动滑块到最右",
    "ZhongXinTianXie": "重新填写",
    "TianXieShangMianDeYouXian": "填写上面的邮箱地址并提交后，一封验证邮件将会发往该邮箱，前往邮箱查收邮件，根据邮件的提示，继续注册过程",
    "JiXuJiJiangWanChengZhuCe": "继续，即将完成注册",
    "SheZhiMiMa1": "设置密码",
    "QianWangNinDeYouXiangChaS": "前往您的邮箱查收邮件，根据邮件提示，继续注册过程",
    "YanZhengYouXiang": "验证邮箱",
    "QianWangNinDeDianZiYouXia": "前往您的电子邮箱查收邮件,按邮件内容提示操作",
    "XinPinTuiJian": "新品推荐",
    "HaiYouYiChangWeiChuLi": "还有异常未处理",
    "CaiGouShuLiang": "采购数量",
    "JiDanZhong": "新品预售中",
    "TuanGouZhong": "团购中",
    "QingQueRen": "请确认",
    "ZhuJiMa": "助记码",
    "HongShengJiuBianHao": "宏升编号",
    "XuanZeZhou": "选择洲",
    "XuanZeSheng": "选择省",
    "XuanZeGuoJia": "选择国家或地区",
    "XiaYiBu": "下一步",
    "YnV5ZXJfY29uZmlybV9lbWFpbF9jb2Rl": "新品预售商品活动条件达成",
    "cHJvX2xvYWRfZGF0ZV9jaGFuZ2VkX2VtYWls": "预装柜日期变更",
    "cG9fYWJub3JtYWxfZW1haWw=": "PO单异常",
    "cmVwbGVuaXNoX2lucXVpcnlfZW1haWxfY29kZQ==": "补货商品询价完成",
    "YnV5ZXJfc3RpbWFya19lbWFpbF9jb2Rl": "贴纸唛头制作完成",
    "cG9fYmlsbF9vZl9sYW5kaW5nX2VtYWls": "提单创建成功",
    "c3VibWl0X3BvX2J5X3NhbGVzX2VtYWls": "代提交PO",
    "QnV5ZXJfU3RhdGVtZW50cw==": "每月对账单",
    "UmVtYWluX0JhbGFuY2VfUGF5bWVudF9lbWFpbA==": "货柜到港",
    "YnV5ZXJfZ29vZHNfcmVjb21tZW5kX2VtYWlsX2NvZGU=": "推荐商品",
    "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA==": "装柜完成",
    "cGF5bWVudGRfZXBvc2l0X2VtYWls": "定金支付",
    "BulkMaterialConfirmBuyTemplate": "船务资料确认提醒",
    "YouJianTuiDing": "邮件退订",
    "YouJianDingYue": "邮件订阅",
    "MeiYouGouXuanDeXiangMuWoM": "这是邮件订阅的功能，下列没有勾选的项目，我们将不再发送邮件通知，您可以根据自己的要求，去修改您想要订阅的邮件。",
    "NinXiangYaoTuiDingDeFuWu": "您想要退订的服务",
    "QingBuYaoFaJiWoDeYouJianT": "请不要发给我\"{0}\"的邮件通知，谢谢！",
    "XiangXiDeYouJianFuWuSheZh": "详细的邮件服务设置可以在会员中心账户设置中了解，",
    "YouJianFuWu": "邮件服务",
    "QuXiaoDingYue": "取消订阅",
    "DianJiZheiLi": "点击这里",
    "TuiDingChengGong": "退订成功",
    "DanJuDingJinBiLi": "单柜定金比例",
    "DanJuGuDingDingJin": "单柜固定定金",
    "BaoZhengJinEDu": "您的保证金等级",
    "YnV5ZXJfY29uZmlybV9lbWFpbF9jb2Rl_remark": "新品预售中的商品活动达成时发送的邮件。",
    "c3VibWl0X3BvX2J5X3NhbGVzX2VtYWls_remark": "您的业务员代您提交PO时发送的邮件。",
    "cHJvX2xvYWRfZGF0ZV9jaGFuZ2VkX2VtYWls_remark": "预期装柜的日期发送变化时发送的邮件。",
    "cG9fYWJub3JtYWxfZW1haWw=_remark": "PO单发送异常情况需要处理时发送的邮件。",
    "cmVwbGVuaXNoX2lucXVpcnlfZW1haWxfY29kZQ==_remark": "补货商品完成核价时发送的邮件。",
    "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA==_remark": "商品装柜完成时发送的邮件",
    "cG9fYmlsbF9vZl9sYW5kaW5nX2VtYWls_remark": "商品提单创建完成时发送的邮件",
    "UmVtYWluX0JhbGFuY2VfUGF5bWVudF9lbWFpbA==_remark": "货柜抵达港口时发送的邮件",
    "YnV5ZXJfc3RpbWFya19lbWFpbF9jb2Rl_remark": "贴纸唛头制作完成时发送的邮件",
    "YnV5ZXJfZ29vZHNfcmVjb21tZW5kX2VtYWlsX2NvZGU=_remark": "给您推荐新品时发送的邮件",
    "QnV5ZXJfU3RhdGVtZW50cw==_remark": "每个月的对账单定期发送的邮件",
    "GengXinZhong1": "更新中",
    "DaiQueRen1": "待确认",
    "ZhongTu": "中图",
    "XiaoTu": "小图",
    "FenBianLv": "分辨率",
    "QingXuanZeTuPianGeShi": "请选择图片格式",
    "QingXuanZeShangPin": "请选择商品",
    "WaiBuDingDanHao": "外部订单号",
    "JinNengXuanZeNGe": "只能选择{0}款商品",
    "JieXiChuCuoQingChangShiZh": "格式不符合要求，请重新下载模板后再次上传",
    "1007S0019": "贴纸唛头不存在,{0}",
    "ShangChuanChengGongNKuan": "成功导入{0}款商品",
    "ShangChuanShiBaiCunZaiBuYiZhiDeNeiRong": "上传失败存在不一致的内容",
    "MeiKuanShangPinZuiDuoZhiY": "每款商品最多只允许设置一种唛头样板",
    "TieMa": "贴唛",
    "ZiDuanZhiBuWanZheng": "字段值不完整",
    "ShangPin": "商品",
    "De": "贴纸唛头信息",
    "CunZaiBuYiZhiDeNeiRong": "存在不一致的内容",
    "DingGouLiangWuXiao": "商品{0}订购量无效",
    "GaiShangPinYuJiZhuangGuiR": "该商品的预装柜日期",
    "RuGuoMOQBuManZuQingJiangQ": "如果MOQ不满足，请将其移出或者从左边货源商品中添加，使其满足MOQ",
    "RuGuoQiSongLiangBuManZuQ": "如果起送量不满足，请将其移出或者添加同一供应商的商品",
    "RuGuoYuJiZhuangGuiRiQiBuM": "如果预计装柜日期不满足，请将其移出或者修改预计装柜日期",
    "MaiTouShuLiangBuNengChaoGuoShangPinShuL": "唛头数量不能超过商品数量",
    "YangBanLieBiaoWeiK": "样板列表为空",
    "QingQingKongLieBiaoHouZaiShanC": "请清空列表后再删除",
    "BaoCunTieZhiHeMaiTouYiC": "保存贴纸和唛头异常",
    "QingJiangTieZhiMaiTouXinXiTianXieWanZ": "请将贴纸/唛头信息填写完整",
    "BaoCunTieZhiHeMaiTouChengG": "保存贴纸和唛头成功",
    "TieZhiYiJingYingShuaWanBiXuZhiFuFanGongFeiY": "{0}，您修改以下信息，需要支付返工费用。",
    "ShenQingXiuGai": "申请修改",
    "LeiBie": "类别",
    "ShouFeiFangShi": "收费方式",
    "ShouFeiBiaoZhun": "收费标准",
    "AnZhang": "按张",
    "AnXiang": "按箱",
    "ShenQingXiuGaiTieZhiChengG": "申请修改贴纸成功",
    "BuHuoShangPinShangWeiJinRuPODan": "补货商品尚未进入PO单！",
    "CaoZuoChengGong": "操作成功",
    "CaoZuoShiBai": "操作失败",
    "PaiBanTu": "排版图",
    "XiaZaiShiBai": "下载失败",
    "JiaoHuoQi": "交货期",
    "KeHuDingDanHao": "客户订单号",
    "KuaiJieJian": "快捷键",
    "QiYong": "启用",
    "YiQiYong": "已启用",
    "XiangTongZiDuanZhiBiXuYiZhiQingHeDui": "相同字段值必须一致，请核对以下标记出的贴纸/唛头信息",
    "GuDingTieZhi": "固定贴纸",
    "GuDingMaTou": "固定唛头",
    "ShiYong": "使用",
    "BuShiYong": "不使用",
    "YiShiYong": "已使用",
    "TiJiaoHeJia": "提交核价",
    "ZanWuWenJianXuXiaZai": "没有文件可以下载",
    "ChengGongTiJiaoBuManGuiXiaDanShenQing": "不满柜申请提交成功",
    "YaSuoBao": "压缩包",
    "ZuiZaoJiaoHuoRiQiWeiQingD": "最早交货日期为{0}，请调整意向装柜日期",
    "CiMaiTouZanWuTuPianXinXi": "此唛头暂无图片信息",
    "CiTieZhiZanWuTuPianXinXi": "此贴纸暂无图片信息",
    "Huo": "或",
    "CiMaTouWuXuTianXieNeiRongQingXuanZe": "此唛头无需填写内容请选择",
    "JiWuLiaoDeHuoDongShangPinG": "活动商品 {0}，在货柜中订购量或剩余订购量都需要满足活动销售MOQ：{1}，请先调整。",
    "JiWuLiaoDeHuoDongShangPinC": "活动商品{0}，采购计划中订购量需要满足MOQ={1}",
    "HuoJuZhuangTaiChuYuBuManJ": "货柜状态处于不满柜申请中, 不允许提交",
    "SanHuoYiXiangZhuangJuRiQi": "散货意向装柜日期小于最早出货时间（即当前时间+{0}天），请调整意向装柜日期",
    "FeiSanHuoYiXiangZhuangJuR": "非散货意向装柜日期小于最早出货时间（即当前时间+{0}天），请调整意向装柜日期",
    "HuoJuCunZaiHuoQiYiChangSh": "货柜存在货期异常商品，请处理后再提交",
    "ShangPinDeTieZhiMaTouMeiY": "商品{0}的贴纸唛头没有正确地设置",
    "HuoDongShangPinXuYaoManZu": "活动商品，需要满足采购MOQ",
    "GongYingShangDingGouLiang": "供应商{0}订购量不满足起送量",
    "TieZhiYiJingYingShuaWanBiCode": "贴纸已经印刷完毕",
    "TieZhiShengChanZhongCode": "贴纸生产中",
    "TieZhiMaTouMingChengZhong": "贴纸唛头名称重复",
    "YiKuanShangPinZhiNengLuRuYiFenMaiTouQingHeDui": "一款商品只能录入一个唛头，请核对数据",
    "ShangPinBianHaoWuXiao": "商品编号无效",
    "YiChangChuLiBaoCunChengGong": "异常处理保存成功",
    "MeiYouBianGeng": "没有变更",
    "BaoZhuang": "{0}包装",
    "XuanZeQiTaBaoZhuangYuYan": "选择其他包装语言",
    "YuGaiShangPinXiangSiDe": "与该商品相似的",
    "QingXuanZeShangPinShuLiang": "请选择商品数量",
    "ZhongZhi": "重置",
    "MeiZhaoDaoFuHeTiaoJianJiL": "没找到符合条件记录，请重新调整筛选条件",
    "GeShuHuiAnZhaoZhuangLiang": "个数将按商品装量自动换算成箱数",
    "ZuiXinShangPin1": "最新商品",
    "1059B10002": "补货池商品未完成询价",
    "BianJiGouWuChe": "编辑购物车",
    "Ge": "个",
    "GeShu": "个数",
    "KeHuZiDingYiWenTi": "客户自定义问题",
    "DanWei": "单位：",
    "BaoCunGouWuCheShuJuYiC": "保存购物车数据异常",
    "ShuJuChuLiYiChangQingShuaX": "数据处理异常，请刷新页面",
    "TianJiaYiHang": "添加一行",
    "ShangPinBianMaLuRuYouWuQingHeDui": "商品编码录入有误，无法获取装量，请核对",
    "QingJiangShangPinXinXiTianXieWanZ": "请将商品信息填写完整",
    "ZhuangLiangBuYunXuBianJi": "装量不允许编辑",
    "BianHaoHuoMingCheng": "请输入订单编号",
    "ChengGongQuXiaoCaiGou": "成功取消采购",
    "PiLiangTianJiaShangPin": "批量添加商品",
    "TianXieShangPinXinXi": "填写商品信息",
    "BianHaoHuoZheMingChen": "编号或者名称",
    "DanYuanGeBiXuShiWenBenGeS": "excel单元格必须是文本格式",
    "XiangQingYeWuQuanXianTiShi": "该商品属于新品，需要进行账户认证才能查看详情，认证会在1-3个工作日内完成，请保持您的联系方式通讯正常，ESSA将尽快联系您进行认证审核。",
    "XuanZeShangPin": "选择商品",
    "Wu": "无",
    "JiXuPinGui": "继续拼柜",
    "HeDuiXinXi": "核对信息",
    "ShangPinSuoZaiLeiMu": "商品所属类目",
    "DengLuXinLai": "New To ESSA?",
    "ZaiTuWeiHuoDeShouHuoRiQiC": "在途尾货{0}的收货日期超出PO单预装柜日期",
    "TuanGouShangPinDeShouHuoR": "团购商品{0}的收货日期超出PO单预装柜日期",
    "DuoXuan": "多选",
    "ZhaoBuDaoGaiYeMian": "对不起，找不到该页面。",
    "NiKeNengXuYaoHuiDao": "你可能需要回到",
    "HuoZheQu": "或者去",
    "YiChangShangPinYiBeiChuLi": "您操作的异常商品已被处理，请刷新页面后重新查看",
    "NinHaiYouShuXingMeiYouXuanZe": "您还有属性没有选择",
    "NKuanShangPing": "{0}款商品",
    "DingGouLiangDanWeiXiang": "订购量（外箱）",
    "GeShuDanWeiGe": "个数（单位：个）",
    "ChengGongTiJiao{0}KuanDaoChu{1}BuNengDaoChu": "成功导出了{0}款商品，其中商品{1}是不能导出的",
    "ChengGongTiJiao{0}KuanTiWen{1}BuNengTiWen": "成功提交了{0}款商品，其中商品{1}是不能提问的",
    "ChengGongTiJiao{0}KuanShanChu{1}BuNengShanChu": "成功删除了{0}款商品，其中商品{1}是不能删除的",
    "ShouCangShangPin": "收藏商品",
    "TianJiaGouWuCheChengGongHuoDongYiDaCheng": "添加购物车成功，商品活动已达成，请前往购物车确认采购",
    "GouWuCheYiYou{0}{1}": "购物车中已有 {0}{1}，确定将以当前数量覆盖购物车中数量",
    "CiKuanHuoDongShangPinHuoDongYiDaCheng": "此款活动商品活动已达成，加入后，购物车中请及时确认采购。",
    "CiKuanHuoDongShangPinNinYiQueRenGouMai": "此款活动商品您已确认购买，请到购物车查看或调整箱数。",
    "YiChuHuoDongWeiDaChengSha": "注意：当前货柜编号为{0}的商品已下架或可能已参与活动且活动未达成，不能进行拼柜，已移回购物车!",
    "HuoDongXiaoShouMOQBuNengXiaoYu": "采购数量不能小于活动销售MOQ",
    "ZiDingYiWenTiZiShuBuNengC": "自定义问题字数不能超过{0},{1}",
    "QingWenNinSanChuDeYuanYinShi": "请问您删除的原因是",
    "DaiHuiFu": "待回复",
    "YouHuiFu": "有回复",
    "QingRenZhenTianXieYiXiaZiLiaoBaoZhengNeiRongZhenShi": "请认真填写以下资料，保证内容真实。电子邮箱必须有效，创建后需通过邮箱验证才能完成注册。",
    "WoMenJiangHuiTongGuoNinDeXinXiHuoZheDianHua": "我们将会通过您的信息或者电话联系您进行后续审核，非玩具或日用品采购商将会被取消会员资格。",
    "HuanYingLaiDaoEssa": "欢迎来到www.essa.cn!",
    "NinKeYiChaKanChanPinDeJiaGe": "1、您可以查看到产品的价格",
    "NinKeYiHuoQuDaoZuiXinDeChanPinXinXi": "2、您可以获取到最新的产品信息",
    "WoMenJiangBuDingQiGeiNinTuiSongZuiXinDeYouHuiHuoDong": "3、我们将不定期给您推送最新的优惠活动",
    "ZhuCeChengWeiEssaHuiYuanNinJiangKeHuoDe": "注册成为essa会员，您将可获得：",
    "GongXiNinYiTiJiaoChengGong": "恭喜您已提交成功！",
    "JiDanShangPinMeiYouZaiJiD": "新品预售商品{0}没有在新品预售活动中",
    "HuoDongShangPinXuYaoManZuH": "活动商品需要满足活动MOQ {0}",
    "MiaoHou": "{0}s后",
    "NinDeZhangHou": "您的账号",
    "1059PR10019": "邮箱重复",
    "WeiDengLuHuoWeiRenZhengQingRenZhengHouChaKan": "未登录或未认证的用户，请先登录或等待认证之后，才能进行商品核价",
    "WoDe": "我的",
    "DingDan": "订单",
    "RenZhengHuoYongHuCaiKeCan": "认证或VIP用户才可参与活动商品，请及时联系您的业务员认证。",
    "YiTiWen": "已提问",
    "YiQueRenCaiGouDeHuoDongSh": "已确认采购的活动商品，不能再加入购物车",
    "GaiBanWenTi": "改版问题",
    "BuZhiChi": "不支持",
    "WoMenDeHeZuoHuoBan": "我们的合作伙伴",
    "100AnQuan": "100%安全",
    "GongChangJia": "工厂价",
    "GaoXiaoBianJie": "高效便捷",
    "ShiPinJieShao": "视频介绍",
    "QingXuanZeNinSuoZaiDeGuoJ": "请选择您所在的国家",
    "DingWeiGuoJia": "定位国家",
    "DingWeiShiBaiQingShouDong": "定位失败，请手动选择您所在国家或重新刷新",
    "ZhengZaiDingWeiZhong": "正在定位中...",
    "QingXuanZeGuoJia": "请选择国家或者地区",
    "NinHaoNinShiGuoJiaCaiGouS": "您好，您是{0}国家采购商，已帮您定位至{1}",
    "HuanYiPi": "换一批",
    "ZuiJinFangWenGuoJia": "最近访问国家",
    "HuiYuanQuanYi": "会员权益",
    "MianFeiChaKanJiHeDuiShangPinJiaGe": "免费查看及核对商品价格",
    "ChaKanZuiXinChanPin": "查看最新产品",
    "DingQiHuoQuYouZhiShangPinTuiJian": "定期获取优质商品推荐",
    "ChaZhaoShangPin": "查找商品",
    "ShangPinGuanLi": "商品管理",
    "ZuZhiChuHuoJiHua": "组织出货计划",
    "ChaKanDingDanShengChanGuoCheng": "查看订单生产过程",
    "FuKuanShouHuo": "付款收货",
    "YiZhanTiaoXuanShangPin": "一站挑选商品",
    "FenLeiChaZhao": "分类查找",
    "XiangSiKuanDuiBi": "相似款对比",
    "RuHeChaZhaoShangPin": "如何查找商品",
    "ShangPinZiZhuGuanLi": "商品自主管理",
    "ZiDongHeJia": "自动核价",
    "GuanLiShangPin": "管理商品",
    "GouWuCheGuanLi": "购物车管理",
    "ShouGeZaiXianPinGuiDeJiaoYiPingTai": "首个在线拼柜的交易平台",
    "GenJuJiHuaZiWoZuZhuang": "根据计划自我组装",
    "SheZhiYiXiangZhuangGuiShiJian": "设置意向装柜时间",
    "SheZhiTieZhiMaiTouXinXi": "设置贴纸唛头信息",
    "RuHeJinXingPinGui": "如何进行拼柜",
    "QueRenDingDanXinXi": "确认订单信息",
    "ZhiDingShengChanYaoQiu": "制定生产要求",
    "LiaoJieDingHuoYaoQiu": "了解订货要求",
    "ChaKanShengChanJinDu": "查看生产进度",
    "WeiNinLiuXiaFanKuiXinXi": "为您留下反馈信息",
    "24XiaoShiSuiYiChaKanZuiXinDongTai": "24小时随意查看最新动态",
    "ChaKanZhiJianTuPianJiXinXi": "查看质检图片及信息",
    "NinDeDingDanYiJingShengChanWanCheng": "您的订单已经生产完成",
    "HuoYunYiJingDaoGang": "货运已经到港",
    "TiDanDianFangZaiXianChaKan": "提单电放在线查看",
    "DingDanLiuCheng": "订单流程",
    "PoDanLieBiao": "订单列表",
    "GongSiShiLi": "公司实力",
    "ZhengShuBaoZhang": "证书保障",
    "BaoZhangTiXi": "保障体系",
    "KuaiSu": "快速",
    "GaoXiao": "高效",
    "ZhuZhan": "essa.cn玩具在线采购平台",
    "ZhuZhanFuWuXiangQing": "主站服务详情",
    "AnBianHaoJingZhunSouSuo": "精准搜索",
    "CaiGouWanJu": "采购玩具",
    "CaiGouRiYongPin": "采购日用品",
    "ReMenTuiJian": "热门推荐",
    "TuiJianMa": "优惠券代码",
    "TuiJianMaWuXiao": "优惠券代码无效，请重新输入",
    "YiZhuCeChengGong": "已注册成功",
    "QingShuRuTuiJianMa": "请输入优惠券代码",
    "BuYingYongTieZhi": "不使用贴纸",
    "BuYingYongMaTou": "不使用唛头",
    "ZhongXinJiHuoQingLianXiNi": "重新激活，请联系您的专属业务客服，联系方式查看操作：",
    "DengLuXiTong": "登录系统",
    "ShuBiaoYiRuNinDeZhangHao": "鼠标移入“您的账号”",
    "JinRuHuiYuanZhongXinShouY": "进入“会员中心首页”",
    "ZhiJieQuHuiYuanZhongXinSh": "直接去会员中心首页",
    "NinYiJiHuoChengGongQingBa": "您已激活成功，请保持邮箱及手机畅通，耐心等待essa认证，谢谢",
    "RuoMeiNengJiShiWeiNinRenZ": "若essa没能及时为您认证时，可能会你短暂性看不到商品价格，请继续耐心等待，给您带来的不便请见谅！",
    "LiuLanShangPin": "浏览商品",
    "NinShiYongZhuCeYiChengGon": "您试用注册已成功，试用期为7天，请7天内前往邮箱永久激活账号",
    "ZhuYiXiaoShiHouRuoBuJiHuo": "注意：7天后若不激活账号，账号将降级，导致您无法查看平台特色商品及商品价格。",
    "JiHuoChengGong": "激活成功",
    "JiHuoShiBai": "激活失败",
    "QingXianXuanZeTieZhi": "请先选择贴纸",
    "QingXianXuanZeMaTou": "请先选择唛头",
    "QingXianSheZhiTieZhi": "请先设置贴纸",
    "QingXianSheZhiMaTou": "请先设置唛头",
    "SheZhiMaTouXinXi": "设置唛头信息",
    "SheZhiTieZhiXinXi": "设置贴纸信息",
    "YuLanDingDan": "预览订单",
    "ShangYiBu": "上一步",
    "ZanShiBaoCun": "暂时保存",
    "ZanShiBaoCunChengGong": "暂时保存成功",
    "ZhengZaiBaoCun": "正在保存...",
    "BuZhouYiQueRenNinYaoShiYo": "步骤一：确认您要使用的唛头样板（如果这里没有合适你的样板，请联系我们的业务员提供的样板）",
    "TianJiaMaTouMoBan": "添加唛头模板",
    "XuanZeMaTouYangShi": "选择唛头样式",
    "NinDeMaTouYangBan": "您的唛头样板",
    "WuMaTouYangShi": "无唛头样式!",
    "BuZhouErGouXuanNinYaoShiY": "步骤二：勾选您要使用对应唛头的商品：",
    "TieZhiBuZhouYiQueRenNinYaoShiYo": "步骤一：确认您要使用的贴纸样板（如果这里没有合适你的样板，请联系我们的业务员提供的样板）",
    "TianJiaTieZhiMoBan": "添加贴纸模板",
    "NinDeTieZhiYangBan": "您的贴纸样板",
    "WuTieZhiYangBan": "无贴纸样板!",
    "TieZhiBuZhouErGouXuanNinYaoShiY": "步骤二：勾选您要使用对应贴纸的商品：",
    "TiShiTongYiKuanShangPinZh": "提示：同一款商品只能设置一种唛头",
    "TieZhiYangBanYuLanRuXia": "{0}贴纸样板预览如下：",
    "MaTouYangBanYuLanRuXia": "{0}唛头样板预览如下：",
    "NinHaoZiZhuSheZhiTieZhiMa": "您好，自主设置贴纸唛头的功能暂时未开放，请先联系您的业务员帮您添加，谢谢。",
    "BaoCunTieZhiYiChang": "保存贴纸异常",
    "BaoCunMaTouYiChang": "保存唛头异常",
    "DingDanZongJiaWei": "订单总价",
    "MaiTouXinXi": "唛头信息",
    "TieZhiXinXi": "贴纸信息",
    "NinBenCiBianJiDeTieZhiMaT": "您本次编辑的贴纸唛头信息将不保存！确定返回吗？",
    "HaiMeiYouMaTouTieZhiYangB": "还没有唛头贴纸样板,请联系我们业务员并提供您需要使用的样板给我们",
    "QingShuRuMingCheng": "请输入名称",
    "YiChangLieBiao": "异常列表",
    "ZhengZaiShenHeZhongBuKeXiuGai": "正在审核中",
    "WuMaTouYangBan": "无唛头样板",
    "TiShiTongYiKuanShangPinKe": "提示：同一款商品可以设置多张贴纸样板。",
    "WoShiMaiJia": "我是工厂",
    "ZhongYangBanYuYeMianBuYiZ": "Excel中样板与页面不一致，请重新下载模板",
    "WeiChanShengFeiYongJiJiangFanHuiPO": "未产生费用，即将返回订单详情",
    "QingXuanZeTieZhiYangShi": "请选择贴纸样式！",
    "QingXuanZeMaTouYangShi": "请选择唛头样式!",
    "MoBanYouWuQingZhongXinXia": "模板有误，请重新下载模板编辑导入。",
    "QingJiangTieZhiXinXiTianX": "请将贴纸信息填写完整。",
    "QingJiangMaTouXinXiTianXi": "请将唛头信息填写完整。",
    "QuShouYe": "去首页",
    "WeiRenZhengWuFaXiaPinGuiXiaDan24XiaoShiNeiHuiLianXiNin": "对不起，您的账号还未经过认证，无法拼柜下单，24小时内essa会联系您，请保持手机及邮箱畅通，耐心等待认证！",
    "QingLianXiNinDeZhuanShuYeWuKeFuJinXingZiXun": "如有需要，请联系您的专属客服进行咨询！",
    "ShiYongCaiGouShang": "试用采购商",
    "YuZhuangJuRiQiYiChang": "预装柜日期异常",
    "GongChangDingGouLiangBuZu": "工厂订购量不足",
    "GongChangQuXiaoShengChan": "工厂取消生产",
    "YinWuLiaoCaiGouYiChangQuX": "因物料采购异常取消",
    "ZhengZaiYiChu": "正在移出",
    "ZhengZaiTianJia": "正在添加",
    "LiShiYiChangQuXiaoJiLu": "历史商品取消记录",
    "YiChangQuXiaoJiLu": "商品取消记录",
    "QuXiaoYuanYin": "取消原因",
    "QuXiaoShiJian": "取消时间",
    "ZongGeShuDanWeiGe": "取消总个数",
    "WoShiNinDeZhuanShuKeFuKeYiYuWoLianXi": "我是您的销售顾问，如您在采购过程中有任何疑问可以与我联系。",
    "CongYeJingYan": "从业经验",
    "ShuXiYuYan": "熟悉语言",
    "ZhuGongShiChangQuYu": "主攻市场区域",
    "CongYeHangYe": "从事行业",
    "GeRenYouShiJiFuWuBeiZhu": "个人优势及服务备注",
    "ZiWoMiaoShu": "自我描述",
    "NNianGongZuoJingYan": "{0}年",
    "DianJiChaKanGengDuoZiLiao": "点击查看更多资料",
    "XiaoShouGuWen": "销售顾问",
    "ZhengZaiXiaZai": "正在下载",
    "ShuangJiKongBaiBiaoGeJinR": "1.单击空白表格进入编辑，非空白单元格不支持编辑，也不支持复制粘贴",
    "BiaoGeZhiChiJianPanFuZhiH": "2.表格支持键盘Ctrl+C（复制）和Ctrl+V（粘贴）快捷键",
    "BiaoGeZhiChiDuoXuanDanYua": "3.表格支持多选单元格复制及粘贴",
    "ZhiChiCongZhongDuoGeDanYu": "4.支持从Excel中Ctrl+C多个单元格内容后直接Ctrl+V至表格中",
    "YinWuLiaoCaiGouYiChangBuNengXiaDan": "抱歉，因物料采购异常，不能继续下单。",
    "GongChangYiQuXiaoShengChanBuNengXiaDan": "抱歉，工厂已取消生产，不能继续下单。",
    "ZuoTian": "昨天",
    "YongHuFangWenLiang": "用户访问量",
    "GuoJiaFangWenLiang": "国家访问量",
    "WoZhiDaoLe": "我知道了",
    "XiaoShouGuWenXiangQing": "销售顾问详情",
    "MoSiKeFuWuBu": "莫斯科服务部",
    "QuXiaoXiangShu": "取消箱数",
    "ShengChanQuXiao": "生产取消",
    "DingDanBianHao": "订单编号",
    "CaoZuo": "操作",
    "XiaDanShiJian": "下单时间",
    "ShangPinLaiYuan": "商品来源",
    "ShangPinLeiXing": "商品类型",
    "KuaiSuBiJia": "快速比价",
    "DeGongChangKuChanPinKuYiJ": "ESSA玩具工厂库、产品库已经涵盖中国2万家玩具工厂，",
    "QingShuRuGongYingShangMin": "请输入供应商名称、品牌名称、工厂货号或商品关键字",
    "RuHeBiJia": "如何比价？",
    "DiYiBuJingZhunSouXuanShan": "精准搜选商品",
    "DiErBuQuXunJia": "去询价",
    "DiSanBuGouWuCheHuoQuGongY": "购物车获取供应商最新报价",
    "DiSiBuDaoChuBaoJiaDanBiJi": "导出报价单比价",
    "DeWanJuKuanShiDouZaiZheiL": "您可以在这里找到全球80%的玩具款式！",
    "DiYiBu": "第一步：",
    "DiErBu": "第二步：",
    "DiSanBu": "第三步：",
    "DiSiBu": "第四步：",
    "GuoQuYiTianWanGongChangZh": "过去一天，2万工厂中有{0} 家上新了 {1}款新品",
    "GuoQuYiZhouWanGongChangZh": "过去一周，2万工厂中有 {0}家上新了 {1}款新品",
    "GuoQuYiGeYueWanGongChangZ": "过去一个月，2万工厂中有{0}家上新了{1}款新品",
    "ZhongTiJi": "取消总体积",
    "TiShiShangPinYouDuoKuanSh": "提示：商品有多款时，可添加多个唛头样板",
    "TiShiKeXuanZeDuoGeTieZhiY": "提示：可选择多个贴纸样板",
    "ZhuYiZongGeShuHeDingGouLi": "注意：总个数和订购量只能二选一填写，从Excel中同时Ctrl+V 粘贴两列进来时，将按总个数为准计算订购量（总个数=订购量 x 装量）",
    "GongYingShangMingCheng": "供应商",
    "DengYu": "等于",
    "DaYu": "大于",
    "KuanXiangSi": "{0}款相似",
    "ChaKanQuanBuXinPin": "查看全部新品",
    "XinPinBaoHu": "新品保护",
    "CiShangPinShuYuXinKuanBao": "您的账户在认证审核中，请耐心等待！",
    "GongZuoShiJianNeiFenZhong": "工作时间内，5分钟快速认证",
    "FeiGongZuoShiJianYuJiXuYa": "非工作时间，预计需要2个工作日完成认证。",
    "QingLianXiNinDeXiaoShouGu": "您也可以主动联系您的销售顾问{0}完成认证",
    "GengDuoShaiXuanXiang": "更多筛选项",
    "RenZhengYongHuKeJian": "认证用户可见",
    "ChaKanJiaGeQingXianDengLu": "查看价格，请先登录",
    "RenZhengHouKeJianJiaGe": "认证后可见价格",
    "ZuiJinYiGeYue": "最近一个月",
    "JiaGongChangShangXinLeKua": "{0}家工厂上新了{1}款",
    "ZuiJinYiGeYuePinPaiShangX": "最近一个月的品牌上新",
    "ChuHuoQuYu": "出货区域",
    "XinZeng": "新增",
    "BaoZhuangFangShi": "包装方式",
    "XiaoYuDengYu": "小于等于",
    "XinPinQingBao": "新品情报",
    "GongYouJiaGongChangKuanXi": "共有{0}家工厂{1}款新品",
    "CunZaiBuFuHeTiaoJianDaoRu": "存在不符合条件导入购物车的商品",
    "NinZhangHaoDengJiBuNengCh": "找不到符合条件的商品",
    "KuanXinPin": "{0}款新品",
    "PinPaiLeiXing": "品牌类型",
    "WoGuanZhuDePinPai": "我关注的品牌",
    "TuiJianPinPai": "推荐品牌",
    "XinPin": "新品",
    "XiangSiKuanShuLiang": "相似款数量",
    "ChanDiQuYu": "产地区域",
    "QuanBuShangPin": "全部商品",
    "KePinJu": "可拼柜",
    "HuoDongShangPin": "活动商品",
    "QingYouXianChuLiYiXiaShan": "请优先处理以下商品",
    "NinCanJiaDeJiDanHeTuanGou": "您参加的\"新品预售\"和\"团购\"活动，当商品的数量满足采购条件时，我们即将下单生产，请您确认。",
    "SanTianNeiBuQueRenCaiGouX": "三天内不确认采购系统将自动取消采购。",
    "ZhuTi": "主题",
    "ShiXiao": "失效",
    "GuoQi": "过期",
    "TianJiaJinGouWuCheShiJian": "添加进购物车时间",
    "GuoQiShangPinQingJinKuaiP": "过期商品请重新询价再尽快拼柜",
    "YiQueRenDeHuoDongBuNengSh": "已确认的活动不能删除，请去除勾选",
    "YiJiang": "已降",
    "YiSheng": "已升",
    "GaiKuanShangPinZhengZaiDe": "该款商品正在等待工厂回复，预计1-2个工作日",
    "XinPinYuShou": "新品预售",
    "YiQueRen": "已确认",
    "TianHouZiDongShanChu": "{0}天后自动删除",
    "ShangPinXinXi": "商品信息",
    "ZhongXinChuJia": "议价",
    "NinDeGouWuCheMeiYouShangP": "您的购物车没有商品",
    "HuoDongZhuangTai": "活动状态",
    "XunJiaZhuangTai": "询价状态",
    "YiXiaShangPinWeiGouWuCheL": "以下商品为购物车里全部商品",
    "YiXiaShangPinWeiHuoDongSh": "以下商品为活动商品",
    "YiXiaShangPinYiManZuPinJu": "以下商品已满足拼柜条件",
    "YiXiaShangPinYiXunJiaWanC": "以下商品已询价完成或活动达成，可直接进入拼柜下单",
    "XunJiaHouYiXiaShangPinYou": "询价后以下商品有变化",
    "YiXiaShangPinKeNengShiJia": "以下商品是价格与您询价时有变化，请先处理，接受最新信息后商品可下单。",
    "GongKuanDaiQueRenCaiGouDe": "共{0}款待确认采购的商品",
    "PiLiangShanChu": "批量删除",
    "PiLiangTiWen": "批量提问",
    "PiLiangDaoChu": "批量导出",
    "PiLiangDaoRu": "批量导入",
    "QingChuShiXiaoShangPin": "清除失效商品",
    "ChaKanKePinJuShangPin": "查看可拼柜商品",
    "PiLiangJieShou": "批量接受",
    "KaiShiPinJu": "开始拼柜",
    "DaoChuBaoJiaDan": "导出报价单",
    "QueDingCongGouWuCheZhongS": "确定从购物车中删除所有选中的商品？",
    "QueDingCongGouWuCheZhongQ": "确定从购物车中清除所有失效商品？",
    "NinKeYiDiaoZhengJiaGeHuoD": "您可以调整价格或订购量，再次向供应商发起议价",
    "TuanGouQiaTanZhong": "团购洽谈中",
    "TuanGouShiBai": "团购失败",
    "TuanGouChengGong": "团购成功",
    "XinPinYuShouZhong": "新品预售中",
    "XinPinYuShouQiaTanZhong": "新品预售洽谈中",
    "XinPinYuShouShiBai": "新品预售失败",
    "XinPinYuShouChengGong": "新品预售成功",
    "CanKaoJia": "参考价",
    "MeiYouSheZhiZhuTiDeShangP": "没有设置主题的商品",
    "SheZhiZhuTi": "设置主题",
    "QuanBuShuXing": "全部属性",
    "QueDingJieShouSuoYouXuanZ": "确定接受所有选中的商品？",
    "GongTiWenLeGeWenTi": "共提问了{0}个问题",
    "QiTaCaiGouShangDaiLiShang": "其他采购商代理商品",
    "QiTaCaiGouShangZhuanShuSh": "其他采购商专属商品",
    "XiaJiaShangPin": "下架商品",
    "XinPinYuShouShiBaiShangPi": "新品预售失败商品",
    "YiQueRenGouMaiDingGouLian": "已确认购买，订购量请在购物车中调整",
    "WuShangPinChaKanQuanXianQ": "无商品查看权限，请联系您销售顾问咨询",
    "ZhuYiHeBingDaoXinZhuTiDeS": "注意：合并到新主题的商品将从原主题移除",
    "ChuangJianXinZhuTi": "创建新主题",
    "JiaRuYiYouZhuTi": "加入已有主题",
    "QingShuRuZhuTi": "请输入主题",
    "ZhengZhuang": "整装",
    "FenZhuang": "分装",
    "WuZhuTi": "无主题",
    "ShengYuQueRenShiJian": "剩余确认时间{0}h",
    "KaiShiShiJian": "开始时间",
    "JieShuShiJian": "结束时间",
    "BaoZhuangLeiXing": "包装类型",
    "YinHuoDongYiDaChengWeiJiS": "因活动已达成，未及时确认采购",
    "ShangPinYiZhongXinFaQiYiJ": "商品已重新发起议价",
    "ShangPinYiXiaJia": "商品已下架",
    "YinShangPinYiJingCanYuHuo": "因商品已经参与活动，不能直接拼柜",
    "GongKuanShangPinKeYiPinJu": "共 {0} 款商品可以拼柜",
    "QingJinKuaiZaiShangPinXia": "请尽快在商品限定时间内确认，倒计时结束系统将自动取消采购",
    "HuiLvBianHua": "汇率变化",
    "JiaJiaLvBianHua": "加价率变化",
    "ShangPinTiJiBianHua": "商品体积变化",
    "ShangPinZhuangLiangBianHu": "商品装量变化",
    "ShangPinZhongLiangBianHua": "商品重量变化",
    "ChangGuiBaoJiaDan": "常规报价单",
    "ShangPinChuHuoCangMoRenWe": "商品出货仓默认为商品产地",
    "ZhiDingShangPinBaoJiaFang": "指定商品报价方式导报价单",
    "ShangPinChuHuoJiangAnSuoX": "商品出货将按所选出货仓、下水港、货柜类型报价，中间可能影响 FOB均摊费及可能产生短途运费",
    "GaiShangPinYiGuoJiaGeBaoHuNC": "该商品已过价格保护期，{0}天不处理将过期",
    "YuanWaiXiangZhuangLiang": "原外箱装量",
    "ShangPinYiPinRuZaiHaoHuoJ": "商品已拼入在{0}号货柜，请先从货柜移除。",
    "ShangPinYiZaiDingDanZhong": "商品已在订单{0}中准备补货，请先从补货池移除。",
    "CunZaiShangPinBuNengShanC": "存在商品不能删除，请检查。",
    "FOBJunTan": "FOB均摊",
    "ShangPinBaoJia": "商品报价",
    "ZanShiMeiYouShiXiaoBaoBei": "暂时没有失效的商品",
    "JiaGeBiYuanJiaGeGaoShiFouYiJia": "价格比原价高，是否继续提交议价",
    "WanJuCaiGouPiFaYiGeChiXuG": "玩具采购&批发|一个持续更新玩具的采购平台",
    "HuoDongShangPinBuXiaoYuN": "活动商品订购量不能小于活动销售MOQ：{0}",
    "QingXuanZePinGuiDeZiYuan": "请选择拼柜的商品",
    "ChanDi": "产地",
    "KePinLiang": "可拼量",
    "GouWuCheShangPin": "购物车商品",
    "YiRu": "移入",
    "YiPinLiang": "已拼量",
    "WeiManZuCaiGouTiaoJianShangPin": "未满足采购条件商品",
    "BaoJiaGuiZe": "报价规则",
    "BaoJiaGuiZe1": "EXW标准报价规则",
    "BaoJiaGuiZe2": "出货仓为商品产地的报价",
    "BaoJiaGuiZe3": "FOB标准报价规则",
    "BaoJiaGuiZe4": "商品产地为汕头时",
    "ShanTouZuHeBaoJia": "汕头（出货仓）- 汕头（下水港）-40HQ（货柜）组合报价",
    "BaoJiaGuiZe5": "商品产地为广州时",
    "BaoJiaGuiZe6": "商品产地为义乌时",
    "GuangZhouZuHeBaoJia": "广州（出货仓）- 广州（下水港）-40HQ（货柜）组合报价",
    "YiWuZuHeBaoJia": "义乌（出货仓）- 宁波（下水港）-40HQ（货柜）组合报价",
    "BaoJiaGuiZeZhuYi": "注意:下单时若柜子出货仓、下水港、货柜类型变化,可能会影响商品FOB均摊及产生短途运费(出货仓与产地不在同一区域时,将产生短途运费).",
    "BuFenShangPinBuFuHePinGui": "部分商品不符合拼柜,系统已移出货柜",
    "BuYunXuPinGuiYuanYin": "不允许拼柜原因",
    "YiChuShiJian": "移除时间",
    "BuFuHePinGuiKuan": "以下{0}款商品不符合拼柜,系统已移出货柜",
    "YiXiangBangZhu1": "1.意向装柜时间：以当前时间拼柜时间开始计算；",
    "YiXiangBangZhu2": "2.商品正式出货，需要制作贴纸唛头、订舱、运输等时间，因此货柜的最短出货时间为15天，当柜子最长货期+准备时间大于15天才可以调整意向装柜时间；",
    "YiXiangBangZhu3": "3.若意向装柜日期早于正常交货日期，不一定能满足。",
    "YuanJia": "原价",
    "HuoGui": "货柜",
    "CartMeiYouPinGuiShangPin": "您的购物车没有可拼柜的商品",
    "XiaYiBuSheZhiTieZhiMaiTou": "下一步,设置贴纸唛头",
    "HuoDongShangPinBuZhiChiYiJia": "活动商品暂不支持议价",
    "TiaoZhengJiaGeHuoDingGouLiang": "调整价格或订购量,可以向供应商发起议价",
    "WeiTongGuoRenZhen": "账号还未通过认证,您的意向采购价及订购量会在账号认证通过后向供应商询价,请耐心等待",
    "WoDeZhuangGuiRiQi": "我的意向装柜日期",
    "ShangPinZhuangGuiRiQi": "该商品的预装柜日期",
    "ZuiDaKePinLiang": "最大可拼量",
    "ShangPinGuoQiQingJinKuaiPinGui": "该商品已过期，请尽快完成拼柜，{0}天后删除;",
    "QiDingLiangBuZuQingTiaoZheng": "起订量不足,将无法下单,请先增加订购量",
    "KePinRuLiangYiDaZuiDaJiXu": "可拼入量已达最大，继续拼入请先前往购物车增加商品订购量",
    "QuGouWuChe": "去购物车",
    "YiXiaShangPinBuYunXuDaoRu": "以下{0}款商品不允许导入",
    "QingShuRuZhengZhengShu": "请输入正整数",
    "ShangPinBianHaoNYiCunZai": "商品编号{0}已存在",
    "QingShuRuXiaoShuWeiNZhengShu": "请输入小数位最多为{0}位的正数",
    "JiaZaiZhuTiShiBai": "加载主题失败",
    "XuanZeYiYouZhuTi": "选择已有主题",
    "XinZhuTi": "新主题",
    "QingShuRuBenCiTianJiaShangPinZhuTi": "请输入本次添加的商品主题",
    "BuYunXuDaoRuYuanYin": "不允许导入原因",
    "JiaGeBaoJiaFangShi": "价格（报价方式：{0}）",
    "YiChangShangPinBuNengTiWen": "异常商品不能提问，不能询价，请处理异常后操作。",
    "GouWuCheNeiHaiMeiYouShang": "购物车内还没有商品，您可以在网站搜索商品加入购物车，或者批量导入商品。",
    "PiLiangDaoRuShangPin": "批量导入商品",
    "QiSongLiangBuZu": "起送量不足",
    "DangQianYiXiangZhuangJuRi": "当前意向装柜日期过小，请先调整",
    "WeiHuoGuoQiQingChuLi": "商品货期过长无法按您的意向装柜日期出货,请处理",
    "ZuiJinYiZhou": "最近一周",
    "ZuiJinSanGeYue": "最近三个月",
    "QingShuRuTuiJianZhuTi": "请输入推荐主题",
    "TuiJianMiaoShu": "推荐描述",
    "TuiJianShiJian": "推荐时间",
    "ChaKanQuanBuShangPin": "查看全部商品",
    "ShiXiaoShangPinBuNengCanJiaCaiGou": "失效商品不能参加采购",
    "CunZaiBuManZuXiaDanTiaoJi": "货柜中存在商品不能下单，货柜将按供应商分组查看，请按页面提示先处理。",
    "JiaBaoNeiBuYiJiaJiangBuFa": "价保内不议价将不发送询价",
    "GongYingShangZaiShou": "供应商在售商品",
    "WuYiChangTianJia": "购物车中询价完成无异常的商品才可以添加",
    "GongYingShangWuKePin": "当前供应商无可拼入商品,请在货柜中增加已拼入商品订购量或选择该供应商其他商品.先发送询价,询价完成再进入柜中.",
    "JingPinTuiJian": "精品推荐",
    "HuoDongTuiJian": "活动推荐",
    "JingZhunTuiJian": "精准推荐",
    "ReXiaoTuiJian": "热销推荐",
    "DaoChuShangPin1": "导出商品",
    "YiXiaJiaBuNengTianJiaGouW": "{0} 已下架，不能添加购物车",
    "CaoZuoShiJian": "操作时间",
    "QingShuaXinYeMian": "请刷新页面",
    "QingXuanZeYuanYin": "请选择原因",
    "QingXianXuanZePinJuShangP": "请先选择拼柜商品",
    "QingXianXuanZeHuoJuZhongS": "请先选择货柜中商品",
    "WuKePinJuShangPin": "无可拼柜商品",
    "WuJiaGeYiChangShangPin": "无价格异常商品",
    "WuHuoDongShangPin": "无活动商品",
    "HuoDongShangPinShengYuDeD": "{0} 活动商品剩余的订购量或补货的订购量不满足活动销售MOQ，工厂将不接单，请先调整。",
    "GaiHuoDongShangPinShengYu": "该活动商品剩余的订购量或补货的订购量不满足活动销售MOQ，工厂将不接单，请先调整。",
    "ZhuYiHuoJuBaoJiaFangShiCh": "注意：货柜报价方式、出货仓、下水港、货柜类型变化,可能会影响商品FOB均摊及产生短途运费(出货仓与产地不在同一区域时,将产生短途运费).",
    "GouWuCheNeiZanShiMeiYouSh": "购物车内暂时没有商品，您可以批量导入商品或去添加商品",
    "KeSheZhiNinDeYiXiangZhuan": "可设置您的意向装柜日期,我们尽量向工厂争取,但不一定满足",
    "DingGouLiangYiQueRenQieBu": "活动商品的订购量已确认且不能减少，如有疑问请咨询在线客服",
    "DingGouLiangZengJiaHouBuN": "订购量增加后不能减少，请确认是否继续",
    "LiShiXiaDanHaiWeiZhuangJu": "历史下单还未装柜走的商品，请尽快优先拼走。",
    "WangJiMiMa": "忘记密码",
    "RiYongPinLeiMu": "日用品类目",
    "WanJuLeiMu": "玩具类目",
    "FenLei": "分类",
    "BianJiTieZhi": "编辑贴纸",
    "BianJiMaiTou": "编辑唛头",
    "ChaKanTieZhiMaTou": "查看贴纸唛头",
    "WaiXiangChiCun2": "外箱尺寸",
    "ShouCangPinPai": "关注品牌",
    "ShangPinXiangQing": "商品详情",
    "ChanPinRenZhen": "产品认证",
    "CheJian": "车间",
    "ZiYouZhanTing": "自有展厅",
    "BanGongQuYu": "办公区域",
    "ShouQiGengDuoWenTi": "收起更多问题",
    "ZhanKaiGengDuoWenTi": "展开更多问题",
    "HuoDongMuBiaoXiangShu": "活动目标箱数",
    "YiDaChengHuoDongMuBiaoXiangShu": "已达成活动目标箱数",
    "HaiChaXiangShu": "还差箱数",
    "TuanGouTip2": "商品正在参与团购且活动已达成，正与工厂采购谈判，请尽快加购物车并确认箱数！",
    "TuanGouTip1": "商品正在参与团购活动，越早加购物车越优惠哦！",
    "YuShouTip2": "商品正在参与新品预售且活动已达成，正与工厂采购谈判，请尽快加购物车并确认箱数！",
    "YuShouTip1": "商品正在参与新品预售活动，越早加购物车越优惠哦！",
    "YiShouZangShangPin": "已收藏商品",
    "YiShouZangPinPai": "已关注品牌",
    "PinPai": "品牌",
    "HuoDongGuiZe": "活动规则",
    "NinYiChengGongDengLuQingX": "您已成功登录，请先选择一位您的销售顾问。",
    "NinZhiQianYiXuanZeLeXiaoS": "您之前已选择了销售顾问，页面刷新后将进入首页。",
    "KeCanGuan": "可参观",
    "BaoZhuangXingShi": "包装形式",
    "NeiRongWeiKong": "内容为空, 请联系我们的业务员为你提供样板",
    "DangQianWuKeYongDeMaTouYa": "当前无可用的唛头样板，如贵司有唛头需求，请通过email或其他联系方式把贵司唛头样式发给您的销售顾问。",
    "DangQianWuKeYongDeTieZhiY": "当前无可用的贴纸样板，如贵司有贴纸需求，请通过email或其他联系方式把贵司贴纸样式发给您的销售顾问。",
    "ZhuCeTiaoJian1": "我同意并遵守",
    "ZhuCeTiaoJian2": "《ESSA平台采购商注册及服务条款》",
    "ZhuCeTiaoJian3": "请阅读并选择是否同意上述注册条款",
    "WeiZhaoDaoFuHeTiaoJianDeDingDan": "未找到符合条件的订单，请重新输入订单编号",
    "PingTaiZhuCeJiFuWuTiaoKuan": "ESSA平台采购商注册及服务条款",
    "YuanGongZhangHaoWeiKong": "您可以为贵公司员工创建平台账号，账号创建后可用于登录essa平台，然后可以进行选品，询价，导报价单，拼柜下单等采购操作",
    "DianWoTianJia": "点我添加",
    "WanShanZiliaoKeZengJiaXinYuDu": "完善资料可增加信誉度",
    "QingXuanZeYiXiangCaiGouShangPin": "请选择意向采购类目",
    "QingXuanZeZhiWu": "请选择职务",
    "DanPinShengChanYaoQiu": "个性化要求内容",
    "GongChangFanKuiJiLu": "工厂反馈记录",
    "ChaKanFanKuiJiLu": "查看反馈记录",
    "QingShuRuShengChanYaoQiu": "请输入商品个性化要求",
    "TeShuShangPinShengChanYaoQiu": "商品个性化要求",
    "WeiHuoShangPinBuNengChongSheShengChanYaoQiu": "注意：尾货商品不能重设生产要求，有问题请在“非生产要求”中向ESSA反馈。",
    "GouWuCheZhongDeZiDingYiWenTi": "购物车中的提问",
    "WenTi": "问题",
    "HuiFu": "回复",
    "ZuiDuoShuRu1000GeZiAo": "特殊生产要求不能超过1000个字哦",
    "KeHuHuoHao": "客户货号",
    "QingShuRuShangPinBianHao": "请输入商品编号",
    "QingShuRuGongChangHuoHao": "请输入工厂货号",
    "QingShuRuKeHuHuoHao": "请输入客户货号",
    "ZanWuFanKuiJiLu": "暂无反馈记录",
    "GongChangFanKui": "工厂反馈",
    "ShouQuan": "同意",
    "BuShouQuan": "不可以，需要通知我们",
    "NinKeYiZhenDuiBenCiDingDa": "例如电池规格，打包要求等",
    "ChangGuiShengChanYaoQiu": "工厂生产要求",
    "QingXianSheZhiDingDanXian": "请先设置订单相关要求",
    "TieZhiMaTouXinXiHeDui": "贴纸唛头信息核对",
    "QingXuanZeShouQuanFangShi": "请选择授权方式",
    "ShengYuKePinXiangShu": "剩余可拼箱数",
    "YiPinXiangShu": "{0}已拼箱数",
    "ZuiDuoShuRuZi": "最多输入{0}字",
    "RuGuoNinBenCiDingDanZhong": "如果您本次订单中有某些个性化要求的商品，您可以针对这些商品进行设置个性化生产要求，essa将严格按照您的要求来跟进生产进度",
    "NinYiJingShenQingBuHuoSha": "您已经申请了补货，ESSA正在处理",
    "FeiShengChanYaoQiu": "ESSA注意事项",
    "YiXiaKuanShangPinGongChan": "以下{0}款商品，工厂有反馈",
    "YouTiWenDeShangPin": "有提问的商品",
    "YouShengChanYaoQiuShangPi": "有个性化要求的商品",
    "ShangPinDeTiWen": "商品的提问",
    "BuHuoJuTiJinEJiangYiZuiZh": "补货具体金额，将以最终成功补入订单的商品为准重新计算",
    "BuHuoShangPinZongJia": "补货商品总价",
    "DingDanYiChangYiBeiQiTaRe": "订单异常已被其他人处理过",
    "QueRenBuHuo": "确认补货",
    "QueRenBuHuoDingDan": "确认补货信息",
    "BuHuoTiJi": "补货体积",
    "ZongKuanShu": "总款数",
    "BuHuoKuanShu": "补货款数",
    "TianJiaNKuanBuHuoShangPin": "共{0}款补货商品",
    "ChaoChuYuZhuangGuiRiQiShiFouBuHuo": "商品货期超出预装柜日期，可能无法按预装柜日期交付，请确定是否添加补货？",
    "TianJiqQiTaBuHuoShangPinZhaoShangPin": "若想从购物车外其他商品补货，请先把商品加入购物车询价，询价完成再进行补货",
    "LieBiaoKongXuanZeQiTaShangPinHuoXunJia": "列表是空的，点下拉选择其它补货来源看看，如无合适商品，请在平台重新选择商品后加入购物车询价，询价完成再补货",
    "TiJiaoHouWoMenJiangXunJia": "提交后我们将尽快安排工厂生产",
    "QingXuanZeXingBie": "请选择性别",
    "ZhouJin": "走进",
    "NinMeiYouFeiShengChanYaoQiu": "您没有质检及生产完成之后货品装柜摆放组合等非生产过程的要求",
    "FanKuiShiJian": "反馈时间",
    "BuHuoChengGongJiangJinKua": "补货成功，将尽快安排生产",
    "YiChangYiChuLiWanChengShe": "异常已处理完成，生产前请先设置贴纸唛头",
    "ShaoHou": "稍后",
    "QuSheZhi": "去设置",
    "BingWuShangPinBuHuoChengG": "异常处理完成",
    "KeKaoDeHeZuoHuoBanChengXinJiaoYi": "4、可靠的合作伙伴！共建诚信交易",
    "LianXiWoMen": "联系我们",
    "MouXieShangPinXuYaoZh": "1、某些商品需要装到柜子最后一排；",
    "ZhiJianTuPianXuYaoZhengMi": "2、质检图片需要正面、侧面及背面三张图。",
    "GuanYuShangPinZaiShengCha": "关于商品在生产过程中要注意的事项，工厂将按照您的要求跟进生产",
    "LiRu": "例如",
    "NinDeShangPinQuanBuWeiWei": "您的商品全部为尾货商品，已不能重新设置个性化要求，有其他要求，请在“essa注意事项”中备注",
    "ShangPinYiZhongXinFaQiYiJPI": "商品{0}已重新发起议价",
    "YuZhuangJuRiQiTuiChiTongZ": "预装柜日期推迟通知",
    "ZhuYiLiShiBianGengQingZai": "注意：历史预装柜日期变更请在订单跟踪中查阅",
    "JiXuTuiChiYuZhuangJuRiQi": "继续推迟预装柜日期",
    "DanDaoRuYiXiaShangPinDaoZ": "PO单导入以下商品导致预装柜日期推迟",
    "YiXiaShangPinDaoZhiYuZhua": "以下商品导致了预装柜日期推迟",
    "DiaoZhengShiJian": "调整时间：{0}",
    "TuiChiZhi": "推迟至",
    "ZhuYiZuiWanZhiYunXuTuiChi": "注意：最晚只允许推迟至{0}",
    "TuiChiYuZhuangJuRiQi": "推迟预装柜日期",
    "QueRenYuZhuangJuRiQiTuiCh": "确定预装柜日期推迟到{0}？",
    "QingXuanZeRiQi": "请选择日期",
    "XinYuJiZhuangJuRiQi": "新预计装柜日期",
    "CiRiQiZaoYuZhengChangJiao": "此日期早于正常交货日期{0}，工厂不一定能满足，请等待工厂确认。",
    "YouYuWeiShouDaoQueRenDing": "由于未收到定金，订单还无法向工厂下单，导致订单预装柜日期推迟至{0}号，请尽快支付定金（定金以到账时间为准）",
    "YouYuBangNinCongZhongDiao": "由于{0}从{1}中调入{2}款商品，导致订单预装柜日期推迟至{3}号，请知悉！",
    "YouYuShangPinShengChanGuo": "由于商品生产过程未能按原计划完成，导致订单预装柜日期推迟至{0}号，给你带来的不便，请原谅!",
    "YouYuWuFaDingDaoCangGuDin": "由于{0}，订单预装柜日期推迟至{1}号，给你带来的不便，请谅解！",
    "PiLiangJieShouBingDiaoChu": "批量接受并调出",
    "DiaoChu": "调出",
    "DiaoJinN": "调进{0}",
    "QingXuanZeYaoDiaoJiDe": "请选择要调进的订单",
    "YiXuanZeShangPinDeTiJi": "已选择商品的体积",
    "ZuiZhangYuZhuangJuRiQi": "最长预装柜日期",
    "ShengYuTiJi": "剩余体积",
    "DiaoJin": "调进",
    "NinShenQingDiaoJinDeShang": "您调进的商品体积已超过调进订单的体积上限不建议您调进，若继续调进，essa可能根据货柜实际情况联系您重新调整。确定继续调进？",
    "GaiYuanZhuangJuRiQiDiaoRu": "该订单原预装柜日期：{0}；调进后订单预装柜日期将延长至{1}，确定继续调进？",
    "GaiYuanZhuangJuRiQiTongShi": "该订单原预装柜日期：{0}；调进后订单预装柜日期将延长至{1}。同时调进后超货柜体积上限，不建议您调进，若继续调进，essa可能根据货柜实际情况联系您重新调整。确定继续调进？",
    "QueRenDiaoJin": "确认调进？",
    "NinDangQianWuKeDiaoJinDeD": "您当前无可调进的订单",
    "QingXianGouXuanShangPin": "请先勾选商品",
    "YuanShiYuJiZhuangGuiRiQi": "原始预计装柜日期",
    "QueDingShanChuXunJiaShangPin": "确定重新询价所有选中的商品？",
    "PiLiangXunJia": "批量询价",
    "SouDingDan": "搜订单",
    "SouShangPin": "搜商品",
    "PoMoRenTiShi": "可按商品编号、工厂货号货客户货号搜索，支持您同时搜索多个商品，搜索多个商品时，不同编号请以空格隔开，最多能同时搜索10个不同商品",
    "QingXianRenZhengNinDeCaiG": "请先认证您的采购商身份",
    "FeiGongZuoShiJianYuJiXuYa1": "非工作时间，预计需要两个工作日完成认证",
    "GuiSiXiaMianWuYuanGongZha": "贵司下面无员工账号",
    "NinDangQianDeCaiGouShangD": "您当前的采购商等级还不能维护员工账号，请联系贵司销售顾问进行认证。",
    "LianXiXiaoShouGuWen": "联系平台客服",
    "TiShengGuDingBaoZhengJinE": "提升固定保证金等级",
    "DanBaoDingDan": "担保订单",
    "QueRenDingDan": "确认订单",
    "YongZhenShiDeXinXiWanShan": "用真实的信息完善以下内容，你可获得更加精准的商机推送，采购效率提升40%",
    "GuiSiGuDingBaoZhengJinHai": "贵司固定保证金还可担保货款额度{0}，不足以担保此张订单。",
    "GuiSiGuDingBaoZhengJinHaiBu": "贵司固定保证金还可担保货款额度{0}，足以担保订单。",
    "QingZaiChuHuoQianZhiFuDin": "注意：请在出货前支付定金",
    "GaiDingDanDingJinYiDaoZha": "该订单定金已到账，请尽快确认PO，以免影响工厂生产。",
    "QingJinKuaiZhiFuDingJinZh": "请尽快支付定金：{0}；支付成功以essa收到定金为准，定金到账后请及时确认订单",
    "GuiSiDingDanDingJinJiDing": "贵司订单{0}定金及订单商品信息已确认无误，可确认订单？",
    "DanBaoCiDingDaoHouShengYu": "担保此订单后，剩余可担保的货款为 {0}",
    "QueRenDanBaoDingDan": "确认担保订单 {0}？",
    "BuHaoYiSiGuiSiDangQianYou": "不好意思，贵司当前有正在担保中的订单，不允许变更定金模式，请先把订单货款支付完成。",
    "DingDanYiQueRenJiangJinKu": "订单已确认，ESSA将尽快为您安排生产！",
    "QueRenDanBaoChengGongJian": "确认担保成功，ESSA将尽快为您安排生产！",
    "BuHaoYiSiDingDanYiJingBeiQueRen": "不好意思，订单已经被{0}确认！",
    "BuHaoYiSiDingDanYiJingBeiDanBao": "不好意思，订单已经被{0}确认担保！",
    "GuDingBaoZhengJin": "固定保证金",
    "ShenQingGengHuanDingJinMo": "申请更换定金模式",
    "GuDingBaoZhengJinJinE": "固定保证金等级",
    "DanBaoHuoKuanJinE": "可担保的货款",
    "HaiKeDanBaoHuoKuanJinE": "您的可用担保货款额度",
    "ShouXinEDu": "平台授信额度",
    "SheZhiBaoZhengJinJinE": "更改保证金等级",
    "WoXiangLeJieDingJinMoShi": "我想了解ESSA定金模式",
    "BaoZhengJinJinE": "保证金等级",
    "TiXian": "提现",
    "WeiShiYong": "未使用",
    "ShiYongZhong": "使用中",
    "BuHaoYiSiGuiSiHaiYouHuoKu": "您账号中有{0}货款正在担保中，不能降级保证金到{1}（对应可担保的货款为{2}）。",
    "QueRenJiangE": "确认降级？",
    "JiangEHouDuoYuDeBaoZhengJ": "降级后，空出的保证金金额将转出到您的可用资金。",
    "BuHaoYiSiDangQianNinYouDu": "不好意思，当前您有多张PO正在担保中，定金不能提现，请贵司货款支付完成后，再提现。",
    "QueDingTiQuGuDingBaoZheng": "确定提取固定保证至可用资金？",
    "QueRenBaoZhengEDuCongTiSh": "确认保证等级从{0}提升至{1}；提升之后，对应的可担保货款也从{2}提升至{3}？",
    "GuDingBaoZhengJinTiShengC": "固定保证金等级提升成功！",
    "GuiSiYouZhangDaiQueRenDan": "贵司有{0}张待确认担保的订单，现保证金等级已能担保所有订单，Essa将尽快安排生产！",
    "NinYouZhangDaiDanBaoDeDin1": "您有{0}张待担保的订单，现保证金等级只能担保部分订单，是否前往先确认部分订单？或继续提升等级至{1}以担保全部订单？",
    "QuQueRenPO": "去确认PO",
    "JiXuTiShengEDu": "继续提升额度",
    "NinYouZhangDaiDanBaoDeDin": "您有{0}张待担保的订单，现保证金等级提升仍无法担保您的订单，保证金等级需提升至{1}可担保全部订单",
    "BuHaoYiSiGuiSiXiaKeYongZi": "不好意思，贵司下可用资金不足，无法提升保证金等级，还差金额{0}请联系您的销售顾问咨询入账，再重新分配！",
    "DanJuBiLiDingJin": "单柜比例定金",
    "Qian": "欠",
    "GongSiZhuZhangHaoCaiNengB": "公司主账号才能变更保证金等级",
    "ZhiSuoYouDingDanDaiZhiFuQ": "指所有订单待支付清的货款金额",
    "GuDingDingJin": "固定定金",
    "DingJinZhiFuShiJian": "定金支付时间",
    "TiJiaoDingDanHouMeiZhangD": "提交订单后，每张订单根据您下单时货柜柜型，需要支付相应的固定定金。定金支付完成方可确认PO,同时工厂开始生产。",
    "DingJinGuanLi": "定金管理",
    "MianDingJin": "免定金",
    "WaiHui": "外汇",
    "DaiQueRenDingJinDingDan": "待确认定金订单",
    "YiChangDaiChuLiDingDan": "异常待处理订单",
    "DaiZhiFuHuoKuanDingDan": "待支付货款订单",
    "KeDiaoRuHuoBuHuoDingDan": "可调入或补货订单",
    "BuHuoZhongDingDan": "补货中订单",
    "DiaoHuoZhongDingDan": "调货中订单",
    "YiXiaXuYaoJinJiChuLi": "以下需要紧急处理",
    "GongSiDingJinMoShi": "公司定金模式",
    "DanBaoHuoKuanEDu": "可担保的货款额度",
    "HaiKeDanBaoHuoKuanEDu": "还可担保货款额度",
    "GouWuCheZhongKuanShangPin": "购物车中 {0} 款商品已准备与供应商洽谈，请尽快决策是否采购 ",
    "NinYouZhangDingDanBaoZhen": "贵司下有{0}张订单待担保，为能正确提交至工厂生产，请尽快重新提升保证金等级。",
    "TiShengBaoZhengJinEDu": "提升固定保证金等级",
    "ChaKanQuanBu": "查看全部",
    "BianGengDingJinMoShi": "变更定金模式",
    "QueDingGengHuanGuiSiDingJinMoShi": "确定更换贵司定金模式为{0}",
    "GuiSiDingJinMoShiGengHuanChengGong": "贵司定金模式更换成功！",
    "GengHuanHouXinXiaDeDanJia": "更换后，新下的PO单将按此定金模式交易，已经下的订单将不受新定金模式影响，按原定金模式交易直至交易完成。",
    "QingXuanZeXinDeDingJinMoS": "请选择新的定金模式",
    "NinDangQianShiYongDeDingJ": "您当前使用的定金模式",
    "ShiYongBaoZhengJinKeYiRan": "使用保证金可以让你顺畅快速的确认订单至工厂生产，无需等待支付定金的时候，缩短贵司提货时间",
    "JiangTiGongBuTongCengJiDe": "ESSA将提供不同层级的保证金，根据贵司业务规模的情况，满足贵司多方位需求",
    "GaiDingJinMoShiHaoChu": "该定金模式好处",
    "XuanZeBuTongBaoZhengJinJi": "选择不同保证金等级，所能担保货款金额标准",
    "ZhengDanManJuHuoSanHuoXia": "整单满柜或散货下单",
    "AnHuoKuanJinEShouQuBiLi": "按货款金额收取比例",
    "ZhengDanBuManJuXiaDan": "整柜不满柜下单",
    "JuTiJuXingDeDingDanJiangA": "具体柜型的订单将按以下标准收取定金",
    "ZhengDanXiaDan": "整柜下单",
    "SanHuoXiaDan": "散货下单",
    "GengHuan": "更换",
    "QingSheZhiGuiSiBaoZhengJi": "请设置贵司保证金等级",
    "DanBaoZhongHuoKuanJinE": "担保中货款金额",
    "FenPeiBaoZhengJinQianKuan": "分配保证金差额",
    "ZhuangTai": "状态",
    "BaoZhengJinFenPeiChengGon": "保证金分配成功",
    "QueDingFenPeiKeYongZiJinB": "确定分配可用资金补齐保证金差额？",
    "DingJinTiQuHouZhongXinXia": "定金提取后，重新下新订单时将无法提交至工厂生产，将需要贵司再次分配定金，确定继续提现？",
    "GuDingBaoZhengJinTiXianCh": "固定保证金提现成功",
    "GuDingBaoZhengJinJiangECh": "固定保证金降额成功",
    "DuiGuiSiShouXinDeEDuYongY": "ESSA对贵司授信的额度，用于缓冲资金汇款过程银行或汇率问题引起的差额；可暂时担保货款一部分资金。",
    "DangQianGuDingBaoZhengJin": "当前固定保证金额度不足，可用资金充足时，请尽快分配资金进保证金，以免影响担保订单。",
    "NinYouZhangDingDanDaiZhiF": "您有{0}张订单待支付定金，为能正常提交至工厂生产，请尽快支付定金，有问题请联系您的销售顾问。",
    "TongZhi": "通知",
    "QingWanShanZiLiao": "请完善资料",
    "WeiZhaoDaoFuHeTiaoJianDeShangPin": "未找到符合条件的商品",
    "ShiJiDaoGangRiQi": "实际到港日期",
    "GongKuanZongTiJiDeShangPi": "共{0}款，总体积 {1}的商品可以拼柜",
    "BuHaoYiSiGuiSiXiaBaoZheng": "您的保证金只能再担保{0}的货款；为能补货成功，请提升保证金等级至{1}",
    "DingDanBeiChengGongTiJiao": "订单被{0}成功提交",
    "QingXuanZeWanJuCaiGouGuiM": "请选择玩具采购规模",
    "QingXuanZeWanJuDanKuanCai": "请选择玩具单款采购量",
    "ZhengJuShouQu": "整单收取",
    "DanJiaJunTanShouQu": "单价均摊收取",
    "DaiZhiFuDingJinDingDan": "待支付定金订单",
    "DaiQueRenDingDan": "待确认订单",
    "DaiZhiFuQianKuanDingDan": "待支付订单",
    "GuiSiDangQianBaoZhengJinQ": "贵司当前保证金差额 {0}，不能担保订单",
    "HaiQingBaoZhengJinQianKua": "去提升保证金等级",
    "GuiSiXiaYouZhangDingDanBa": "贵司下有{0}张订单待担保，为能正常提交至工厂生产，请尽快提升保证金等级 至{1}",
    "BaoJiaZuHe": "报价组合",
    "YiXiaDanDanBuManGuiDeHuoGui": "已下单但不满柜的货柜",
    "WeiTiJiaoDingDanDeHuoGui": "未提交订单的货柜",
    "QingXuanZeNinZhunBeiZuZhuangxxxDeChuHuoLeiXing": "请选择您准备组装订单{0}号货柜的出货类型",
    "ZhengDan": "整柜",
    "SanHuo": "散货",
    "XinHuoGuiDouShiYongGaiBaoJiaZuHe": "新货柜都使用该报价组合",
    "LiShiChangYongBaoJiaZuHe": "历史常用报价组合",
    "FanHuiXiuGaiBaoJiaZuHe": "返回修改报价组合",
    "HuoGuiShangPinZongTiZhiBuYunXuChaoChuHuoGuiZuiDaZhi": "货柜商品总体积不允许超出货柜可装体积最大值",
    "QueDingHuoGuiBaoJiaZuHeWuWu": "货柜中超过一半款数的商品产地与报价组合的出货仓不一致，确定货柜报价组合无误？",
    "WeiBuYingXiangDingDanYuZhuangGuiRiQi": "注意：为不影响订单预装柜日期，请尽快支付定金，预装柜日期将根据定金实际到账日期而做相应推迟。",
    "QingZaiChuHuoQianZhiFuDingJin": "注意：请在出货前支付定金。",
    "QingQueRenYiXiaXinXiShiFouZhengQue": "请确认以下信息是否正确",
    "XiuGaiBaoJiaZuHe": "修改报价组合",
    "GuiSiHaiWeiSheZhiGuDingBaoZhengJinJinE": "贵司还未设置固定保证金等级",
    "DingDanTiJiaoChengGong": "订单提交成功，ESSA将尽快为您安排生产！",
    "DingDanTiJiaoChengGongQingJinKuaiZhiFuDingJin": "订单提交成功，请尽快支付定金，以免影响工厂生产。",
    "GuiSiHaiWeiSheZhiGuDingBaoZhengJinJinEQingXianSheZhi": "贵司还未设置固定保证金等级，请先设置保证金等级。",
    "GuiSiHaiWeiSheZhiGuDingBaoZhengJinJinEQingLianXixxxXianSheZhi": "贵司还未设置固定保证金等级，请联系{0}先设置。",
    "TiShengGuDingBaoZhengJinJinE": "提升固定保证金等级",
    "NinYiChengGongTiJiaoDingDanQingJinKuaiTiShengBaoZhengJin": "您已成功提交订单，请尽快提升保证金等级，尽早确认订单，以免耽误工厂生产！",
    "NinYiChengGongTiJiaoDingDanQingJinKuaiHuanQingBaoZhengJinQianKuan": "您的保证金不够担保此次订单的货款。须提升保证金等级才能确认订单和安排生产。",
    "WeiNengShunLiQueRenDingDanNinDeBaoZhengJinJinEXuTiShengZhi": "为能顺利确认订单，您的保证金等级需提升至",
    "RuoNinZhangHaoZiJinBuZuQingLianXiNinDeXiaoShouGuWenXXX": "注意：若您账号资金不足，请联系您的销售顾问，先提升资金额度。若您有在担保的贷款，可支付一部分尾款，以空出更多担保金额。",
    "NinDangQianShiYongDeShiXXXDeDingDanFuWu": "您当前使用的是{0}的订单服务",
    "BaoZhengJinQianKuanJinE": "还差保证金",
    "ZuiJinNGe": "最近{0}个",
    "DangQianKeYongZiJinBuZuQi": "当前可用资金不足，请先入账至ESSA，可用资金充足后再分配。",
    "GuanBi": "关闭",
    "BianGengBaoZhengJinEDu": "变更固定保证金等级",
    "FuWuFeiJiangYiDingDanHuoK": "服务费将以订单货款的相对比例计算收取",
    "GuiSiXiaYouZhangDingDanDa": "贵司下有{0}张订单待担保，请先还清固定保证金差额",
    "NinDangQianDeCaiGouShangDD": "您的账户在认证审核中，暂时不能在网站进行交易。您可以联系平台客服了解认证进度。",
    "GuDingBaoZhengJinTiQuHouZ": "固定保证金提取后，重新下新订单时将无法提交至工厂生产，需要贵司再次分配定金",
    "YiShuRuCuoWuCiShengYuCiJi": "已输入错误  {0}次，剩余{1}次机会",
    "CuoWuCiShuGuoDuoQingXiaoS": "错误次数过多，请{0} 小时后重试，或使用找回登录密码功能解锁",
    "CuoWuCiShuGuoDuoQingFenZh": "错误次数过多，请  {0} 分钟后重试，或使用找回登录密码功能解锁",
    "MiMaCuoWuQingZhongXinShuR": "密码错误，请重新输入",
    "MiMaCuoWuLianXuCiShuRuCuo": "密码错误，连续5次输入错误将锁定账号",
    "KeBuHuo": "可补货",
    "ShenChangAnPaiZhong": "生产安排中",
    "YiChangDaiChuLi": "异常待处理",
    "ShenQingTiaoRuZhong": "申请调入中",
    "ShangPinSuoZaiXiLie": "商品所属系列",
    "BuChongYiXiangCaiGouShangPin": "请先补充公司信息中的意向采购商品",
    "BuHuoZhong": "补货中",
    "MoSiKeTuiGuangFuWuBanShiC": "莫斯科推广服务办事处",
    "JiaZaiGengDuo": "加载更多",
    "PinPaiXiangQing": "品牌详情",
    "CheMeiYouKePinGuiDeShangPin": "您的购物车没有可拼柜的商品",
    "ShaiXuan": "筛选",
    "MeiYouGengDuoShuJu": "没有更多数据",
    "YiXuan": "已选",
    "ShangPinJieShao": "商品介绍",
    "FaBuZhaoYang": "发布找样",
    "FaBu": "发布",
    "FaBuMiaoShu": "详细描述一下宝贝，方便更加精准的找到商品。如宝贝的品牌、功能、品名等等",
    "ShangPinSuoShuFenLei": "商品所属分类",
    "ZyWenXinTiShi": "温馨提示：essa目前提供精准找样服务，通过找样发布服务可获取到商品详细信息",
    "ShiBai": "失败",
    "TuPianShuoMing": "图片说明",
    "TuPianShuoMing1": "请上传单款商品图片,仅可单款商品找样",
    "TuPianShuoMing2": "若您上传多款商品图，将默认随机挑选一款进行找样",
    "TuPianShuoMing3": "最多可上传4张jpg/png格式图片，大小小于5M",
    "WoDeZhaoYang": "我的找样",
    "FaBuChengGong": "发布成功",
    "FaBuShiBai": "发布失败",
    "ChaKanZhaoYangXiangQing": "您可以点击我的找样查看找样详情",
    "XuanZeShangPinSuoShuFenLei": "选择商品所属分类",
    "TianJiaBuChongXingShuoMing": "可继续添加补充性说明",
    "BuChongShuoMing": "补充说明",
    "ZhanKaiQuanBu": "展开全部",
    "YiDongDuanJinKeBianJiHeChaKan": "移动端仅可简易编辑和查看购物车商品，您可通过电脑端完成更多操作：如拼柜、下单。",
    "ShangPinZanWeiYiJiaQingXianRenZheng": "商品暂未议价，请先认证，认证通过后自动询价",
    "YiYiJia": "已议价",
    "QingXuanZeWenTi": "请选择问题",
    "ChaKanHuiFu": "查看回复",
    "NGeWenTi": "{0}个问题",
    "QingXianDengLuNMiaoHouJiangTiaoZhuan": "请先登录，3S后将自动跳转登录页面",
    "BianJi": "编辑",
    "JiaGeQuJian": "价格区间",
    "DengLuBingRenZhengHouJiaGeKeJian": "登录并认证后价格可见",
    "QingXianDengLu": "请先登录",
    "WeiTongGuoRenZheng": "账号未通过认证,您的意向采购价及订购量会在认证通过后向供应商询价,请耐心等待",
    "TuXiangShiBieZhong": "图像识别中",
    "ZhiShaoNGeZiFu": "至少{0}位字符",
    "ZhuCeYouXiang": "注册邮箱",
    "ZhiShaoShuRuNGeZiFu": "至少输入{0}位字符",
    "ZaiCiShuRu": "再次输入",
    "QueRenXiuGai": "确认修改",
    "YiYouZhangHaoQuDengLu": "已有账号？去登录",
    "DianJiZhuCeJiTongYiZunShou": "点击注册，即表示您同意遵守《essa平台采购商注册及服务条款》",
    "FanHuiDengLu": "返回登录",
    "NinDeZhangHaoTiJiaoChengGongQingQ": "您的账号提交成功，请前往您的邮箱{0}按邮件内容提示完成账户注册",
    "GongXiNinZhuCeChengGongNMiaoHou": "恭喜您注册成功！{0}后系统将自动登录并跳转",
    "DangNinChengWeiWoMenDeRenZhengYonghuJiangYou": "温馨提示：当您成为我们的认证用户之后,将有一位专属顾问为您服务",
    "NinXuanZheDeXiaoShouGuWenHuiZaiNXiaoShiNei": "您选择的销售顾问会在{0}小时内与您联系，认证您的采购商身份。认证成功后，您将拥有查看所有商品价格等特权。{1}后将自动登录跳转首页。",
    "NMiaoHouZiDongDengLu": "{0}后将自动登录跳转首页",
    "GaiZhangHuShangWeiZhuCe": "该账户尚未注册，请先注册",
    "GaiYouXiangYiZhuCeQingGengHuan": "该邮箱已注册，请更换邮箱或登录",
    "ChongZhiMiMaChengGongFanHui": "重置密码成功！{0}后系统将返回登录页",
    "WoDeShouCang": "我的收藏",
    "QuanBuLeiMu": "全部类目",
    "QiHuo": "期货",
    "LieBiaoWeiKong": "列表为空",
    "ChengGongJiaRuGouWuChe": "成功加入购物车",
    "ChengGongShanChu": "成功删除",
    "YiGeYueYiNei": "一个月以内",
    "SanGeYueYiNei": "三个月以内",
    "SanGeYueZhiQian": "三个月之前",
    "SheZhi": "设置",
    "ZhangHuXinXi": "账户信息",
    "ZhangHuMing": "账户名",
    "WoDeXiaoShouGuWen": "我的销售顾问",
    "GuanYuESSA": "关于ESSA",
    "TuiChuDengLu": "退出登录",
    "QingXuanZeNiSuoZaiGuoJia": "请选择你所在国家",
    "YuYan": "语言",
    "MingChengHeHuoHao": "名称和货号",
    "ZiDingYi": "自定义",
    "LiShiSouSuo": "历史搜索",
    "QingKongLiShiJiLu": "清空历史记录",
    "invalidPO": "此订单已无效",
    "ShangChuanDeTuPianXiangSuJinLiangQingXi": "上传的图片像素尽量清晰",
    "TuPianBeiJingJinLiangShiYongChunSeBeiJing": "图片背景尽量使用纯色背景",
    "KeShiYongCaiJianGongNengTuChuShangPinZhongDian": "可裁剪图片突出商品重点",
    "TuPianShangZhiBaoHanDanGeShangPin": "图片上只包含单个商品",
    "TuPianShiBieZhongMaShangJiuHao": "图片识别中，马上就好",
    "TuoZhuaiTuPianDaoZheLi": "拖拽图片到这里",
    "BenDiShangChuanTuPian": "本地上传图片",
    "XiangSiShangPin": "相似商品",
    "SouSuoJieGuoBuJingZhun": "搜索结果不精准？",
    "DianJiZuoCeKeYiDuiYuanTuJinXingCaiJian": "点击左侧，可以对原图进行裁剪或者净化背景后重新搜索",
    "HuoDeSouTuJingZhunJieGuoDeXiaoJiQiao": "获得搜图精准结果的小技巧",
    "LiuLanShangPinGengBianJie": "浏览商品更便捷",
    "CiKuanHuoDongShangPinNinYiQueQingChaKan": "此款活动商品您已确认购买，请到购物车查看",
    "ZanWuTuiJianShuJu": "暂无推荐数据",
    "ZhangHaoWeiTongGuoRenZhengNew": "账号未通过认证，您的意向采购价及订购量会在认证通过后向供应商询价，请耐心等待。",
    "DengLuHouJiaGou": "登录后可加入购物车",
    "ShouJiBan": "手机版",
    "QueDingYaoTuiChuDengLuMa": "确定要退出登录吗",
    "RenZhengYuanLianXiFangShi": "认证员联系方式如下",
    "YiShouLuZhongGuoDeWanJuGo": "已收录中国80%的玩具工厂，每天有数百工厂上传新品",
    "XiLie": "系列",
    "LiangCiShuRuDeMiMaBuYiZhi": "两次输入的密码不一致",
    "ShangChuanTuPian": "上传图片",
    "QingShuRuNGeZiYiNei": "请输入{0}个字以内",
    "XiangQingMiaoShu": "详情描述",
    "TianJiaBuChongShuoMing": "添加补充说明",
    "ChaKanQuanBuBuChongShuoMing": "查看全部补充说明",
    "ESSATiGongJinZhunZhaoYangTips": "温馨提示：ESSA目前提供精准找样服务，客户可将认知的商品通过找样发布服务获取到商品详细信息。",
    "YiJieShu": "已结束",
    "YiFanKui": "已反馈",
    "DaiFanKui": "待反馈",
    "YiQuXiao": "已取消",
    "BianHao": "编号",
    "BenCiZhaoYangYiJieShu": "本次找样已结束",
    "ESSAWeiNiZhaoDaoXinAiDeBaoBei": "ESSA为您找到心爱的宝贝，点击下方查看",
    "ESSAZanShiWeiZhaoDaoMinXinAiDeBaoBei": "ESSA暂时未找到您心爱的宝贝，请稍等",
    "BenCiZhaoYangYiQuXiao": "本次找样已取消",
    "JieShuZhaoYang": "结束找样",
    "JiXuZhaoYang": "继续找样",
    "MeiYouChaXunDaoZhaoYangShuJu": "没有查询到找样数据",
    "ChaKanXiangQing": "查看详情",
    "ShangPinFenLeiS": "商品分类",
    "BianJiZhaoYangXinXi": "编辑找样信息",
    "ZhaoYangFuWu": "找样服务",
    "LiShiZhaoYangJieGuo": "历史找样结果",
    "ZhaoYangJieGuo": "找样结果",
    "QingShangChuanDanKuanTuPianZhaoYang": "请上传单款商品图片，仅可单款商品找样",
    "DuoKuanJiangSuiJiXuanZeYiKuanZhaoYang": "若您上传多款商品图，将默认随机挑选一款进行找样",
    "ZuiDuoChuanSiZhangTuPian": "最多可上传4张jpg/png格式图片，大小<5M",
    "QuanBuBuChongShuoMing": "全部补充说明",
    "ChongXinJiaZai": "重新加载",
    "HenBaoQianNinYaoFangWenDeYeMianMiShiZaiYuZhouZhongQingDianJiChongXinJiaZai": "很抱歉，您要访问的页面迷失在宇宙中,请点击重新加载",
    "FaBuShiJian": "发布时间",
    "ShouDaoFanKui": "收到反馈",
    "CKXiangQing": "查看详情",
    "ZhaoYangMiaoShu": "找样描述",
    "GongDuoShaoKuang": "共{0}款",
    "WeiZhaoDaoShangPin": "ESSA暂时未找到您心爱的宝贝，请稍后…",
    "YiJingZhaoDaoShangPin": "ESSA为您找到心爱的宝贝",
    "ZhaoYangYiQuXiao": "本次找样已取消",
    "ZhaoYangYiJieShu": "本次找样已结束",
    "XuanZeShiJian": "选择时间",
    "DengLuHouZaiFaQiZhaoYang": "您尚未登录，请登录后再发起找样",
    "CMYKBuZhiChi": "系统不支持CMYK模式图片，请先将图片转换成RGB模式重新上传！",
    "FanHuiShangYiYe": "返回上一页",
    "FanHuiShouYe": "返回首页",
    "YeMianNongDiuLe": "对不起,您访问的页面弄丢了",
    "JiXuFangWen": "您可以通过以下方式继续访问",
    "MeiYouShuJu": "没有数据",
    "YiShiXiao": "已失效",
    "TuiJianLeiXing": "推荐类型",
    "TuXiangShiBieShiBai": "图像识别失败",
    "QingShanChuXiaJiaChanPin": "请删除下架商品",
    "TuiJianZhuTi": "推荐主题",
    "originQuantityNotEqualQuantity": "购物车商品已添加到暂存柜或者补货池",
    "TuPianShuoMing4": "上传的单款商品图片最优为整体图、正面图、背面图、侧面图",
    "KaiFaZhong": "开发中",
    "ZongWenJianDaXiaoChaoChuXianZhi": "总文件大小超出限制{0}",
    "ZuiDuoYunXuYiCiXingShangChuanShu": "最多允许一次性上传{0}个文件",
    "WenJianChongFu": "文件重复",
    "XiTongBuZhiChiCMYK": "系统不支持CMYK模式图片，请先将图片转换成RGB模式重新上传！",
    "ShiFouQueRenShanChu": "是否确认删除",
    "BangNingZhaoYang": "帮您找样",
    "WenXinTiShi": "温馨提示",
    "GaiBanShangPin": "改版商品",
    "ShiChangShangPin": "市场商品",
    "dealing": "订单加载中",
    "GongXiNin_Yi": "恭喜您，已成功提交PO，您当前固定保证金不够担保该订单，请尽快分配资金，补齐保证金差额，以免延误工厂生产",
    "GongXiNin_Er": "恭喜您，已成功提交PO，您当前固定保证金不够担保该订单，请尽快提升保证金等级，以免延误工厂生产。",
    "GongXiNin_San": "恭喜您，已成功提交PO，您当前固定保证金足够担保该订单，请点击\"确定\"，系统会自动帮您分配定金",
    "GongXiNin_Si": "恭喜您，已成功提交PO，请在出货前支付定金",
    "GongXiNin_Wu": "恭喜您，已成功提交PO，当前可用资金足够支付定金，请点击\"确定\"，系统会自动帮您分配定金",
    "GongXiNin_Liu": "恭喜您，已成功提交PO，可用资金不足以支付该笔订单定金，请增加可用资金",
    "GongXiNin_Qi": "恭喜您，已成功提交PO，您当前为VIP免定金客户，请直接确认PO",
    "DingDanXinXi": "订单信息",
    "PODanHao": "PO单号",
    "DingDanZongJinE": "订单总金额",
    "TieZhiFeiYong": "贴纸费用",
    "FuWuFeiYong": "服务费用",
    "YuZhuangGuiShiJian": "预装柜时间",
    "DingJinDanBaoFangShi": "定金担保方式",
    "ZiJinXinXi": "资金信息",
    "ZhangHuBaoZhengJinDengJi": "账户保证金等级",
    "KeDanBaoHuoKuanEDu": "可担保货款额度",
    "YiDanBaoHuoKuan": "已担保货款",
    "ShengYuKeDanBaoHuoKuanEDu": "剩余可担保货款额度",
    "HaiChaBaoZhengJin": "还差保证金",
    "GaiBiDingDanSuoXuHuoKuanDanBaoEDu": "该笔订单所需货款担保额度",
    "ZhangHuKeYongZiJin": "账户可用资金",
    "BenDanXuZhiFuDingJin": "本单需支付定金",
    "ChaKanZiJinMingXi": "查看资金明细",
    "GongXiNin_Er_Er": "恭喜您，已成功提交PO，请联系主账号并提升固定保证金等级",
    "LiJiQueRen": "立即确认",
    "DingDanMianShouDingJin": "订单免收定金，请尽快确认，ESSA将在订单确认后安排生产",
    "ZuGouDanBaoBenDan": "账户保证金金额足够担保本单,请确认订单，ESSA将在订单确认后安排生产",
    "KeYongZiJinZuGouZhiFu": "可用资金足够支付该笔订单定金{0}元，请尽快确认PO，以免影响工厂生产。",
    "KeYongZiJinBuZuZhiFu": "可用资金不足够支付该笔订单定金{0}元，请尽快联系essa增加可用资金，资金到账后及时确认PO",
    "ShiYongZhiFuGaiBiDingDanDingJin": "使用{0}支付该笔订单定金",
    "NiDeZhangHuKeYongZiJinBuZuZhiFuBenDanDingJin": "您的账户可用资金{0}不足支付本单定金{1}，根据您的良好信用，essa授信该单{2}的金额临时满足支付定金",
    "NinDangQianWeiMianDingJinKeHu": "您当前为免定金客户，请直接确认PO 。",
    "DingDanYiTiJiao": "订单已提交",
    "BenDanYiZhiFu_QingLianXiESSA": "注意：本单已支付{0}定金，请联系essa支付{1}定金尾款",
    "DingDanYiQueRen": "订单已确认",
    "YeMianMiShiJiangChongXinQiHang": "很抱歉，您要访问的页面迷失在宇宙中,将重新起航",
    "DengLuHouQieBaoJiaFangShi": "登录后可切换报价方式",
    "GenJuNinDeLiangHaoXinYong": "根据您的良好信用，essa授信该单{0}的金额临时满足支付定金",
    "QueRenZhiFu": "确认支付",
    "QueRenZhiFuJiangHuiCongZiJin": "确认支付将会从可用资金扣除{0}作为本单定金",
    "WeiKuanZhiFuQianZhiFu": "说明：本单所需定金{0},essa授信该单{1}的金额临时满足支付定金，实际还需支付定金{1}，该笔资金需要在尾款支付前支付",
    "DanBaoChengGong": "担保成功",
    "ZhiFuChengGong": "支付成功",
    "ShiYongHuoKuanEDu": "使用{0}货款额度担保该笔订单",
    "c3VibWl0X3BvX2VtYWls": "提交订单",
    "c3VibWl0X3BvX2VtYWls_remark": "订单提交后发送的邮件",
    "cG9fY29uZmlybQ==": "确认订单",
    "cG9fY29uZmlybQ==_remark": "订单提交后确认订单发送的邮件",
    "BangDingChengGong": "绑定已成功，请继续操作",
    "BangDingShiBai": "绑定已失败，请重新操作",
    "BaoCunShiBai": "保存失败，请重新操作",
    "QingWanChengZhangHuZiLiaoWanChengZhuCe": "请完成账户资料,完成注册",
    "YanZhengMaYiFaSong": "验证码已发送",
    "QingShuRuYanZhengMa": "请输入验证码",
    "WanCheng": "完成",
    "ShouJiZhuCe": "手机注册",
    "QieHuanShouJiZhuCe": "切换手机注册",
    "QieHuanYouXiangZhuCe": "切换邮箱注册",
    "YanZhengMaYouWuQingChongXinShuRu": "验证码有误,请重新输入",
    "FaSongYanZhengMa": "发送验证码",
    "BangDingShouJi": "绑定手机",
    "YanZhengShouJi": "验证手机",
    "BangDingShouJiChengGong": "绑定手机已成功",
    "YanZhengShouJiChengGong": "验证手机已成功",
    "HaoMaoGeShiYouWu": "号码格式有误",
    "ShouJiHaoMa": "手机号码",
    "YanZheng": "验证",
    "QuBangDing": "去绑定",
    "QinAiDe": "亲爱的",
    "ShangWeiDengJiYouXiang": "您好，您的账户尚未登记电子邮箱，为方便后续重要消息通知到您，请您补齐电子邮件",
    "YouXiangYanZhengHouKeDeng": "温馨提示：邮箱验证成功后，您可使用邮箱登录essa",
    "YangZhengMaFaSongYouXiang": "验证码已发送至您邮箱",
    "QingGouXuanCaiGouLeiXing": "请勾选采购类型",
    "ShouJiDengLu": "手机登录",
    "YouXiangDengLu": "邮箱登录",
    "GengDuoYuZhong": "更多语种",
    "WoXiangYongDianZiYouXiangZhuCe": "我想用电子邮箱注册",
    "WoXiangYongShouJiHaoMaZhuCe": "我想用手机号码注册",
    "YouXiangZhuCe": "邮箱注册",
    "HuoQuYanZhengMa": "获取验证码",
    "YanZhengMaShuRuYouWuChongXin": "验证码输入有误，请重新输入",
    "ShouJiHaoMaGeShiYouWuQingChongXin": "手机号码格式有误，请重新输入",
    "YanZhengMaFaSongShiBai": "验证码发送失败",
    "ZhuCeChengGongXuanYeWuYuan": "注册成功，{0}后系统将跳转业务员选定页面",
    "GaiZhangHuYiCunZaiQingQueRen": "该账户已存在，请确认手机号码",
    "GaiZhangHuBuCunZaiQingQueRen": "该账户不存在，请确认手机号码",
    "GaiZhangHuYiJinYongQingQueRen": "该账户已禁用，请确认手机号码",
    "WoXiangYongDianZiYouXiangZhaoHuiMiMa": "我想用电子邮箱找回密码",
    "WoXiangYongShouJiZhaoHuiMiMa": "我想用手机号码找回密码",
    "ShangWeiDengJiShouJiHaoMa": "您的账户尚未登记手机号码，为保护账户安全，请绑定手机",
    "KuaGuoCaiGouPingTai": "essa.cn 一个玩具跨国采购平台",
    "JingXuanTuiJian": "精选推荐",
    "QingTianXieZhenShiYouXiao": "请填写真实有效的手机号码，通过手机短信验证才能进行下一步，注册成功的手机号码可作为登录用户名",
    "yi_jing_bang_ding_shou_ji": "已经绑定手机",
    "wu_xiao_yan_zheng_ma": "验证码无效",
    "yi_jing_bang_ding_email": "已经绑定邮箱",
    "shou_ji_yi_jing_bei_shi_yong": "手机已经被使用",
    "you_xiang_yi_jing_bei_shi_yong": "邮箱已经被使用",
    "LiJiBangDing": "立即绑定",
    "ShouJiHaoMaCunZai": "手机号码已存在",
    "ShuRuKuangBuNengWeiKong": "输入框不能为空",
    "ZhiShaoNGeZiFuZiMuYuShuZiZuHeQuFenDaXiaoXie": "至少6个字符，字母与数字组合，区分大小写",
    "DianJiDengLu": "点击登录",
    "QianWangBangDing": "前往绑定",
    "NinHaiWeiBangDingShouJiHaoMa": "你还未绑定手机号码",
    "DianJiChaKanGengDuoYouZhi": "点击查看更多优质商品 —essa.cn，一个玩具跨国采购平台",
    "ChongZhiMiMa": "重置密码",
    "QuYanZheng": "去验证",
    "DiJiaReXiaoPinCuXiaoTuanG": "低价热销品促销团购",
    "MeiYueGengXinPinPaiReXiao": "每月更新品牌热销品，赶紧来团",
    "TuanGouShuoMing": "团购说明",
    "HuoBaoTuanGou": "火爆团购",
    "TuanGouShuoMing1": "团购宣传：来团购，买精品",
    "TuanGouShuoMing2": "每月1号上新，限时30天抢购",
    "TuanGouShuoMing3": "活动时间：每月1号开始，每月最后一天结束。",
    "TuanGouShuoMing4": "活动规则：",
    "TuanGouShuoMing5": "①每款活动商品都有1个活动目标箱数。只有满足了商品设定的目标箱数，才达到团购的条件。",
    "TuanGouShuoMing6": "②在活动时间内，您可以随时选择活动商品加入购物车，加入购物车的商品可以随时删除。",
    "TuanGouShuoMing7": "③当商品已达到活动箱数，我们会给您发送确认采购信息，请您于7天内完成确认。",
    "TuanGouShuoMing8": "④一旦确认采购，该订单将不能进行删除。如逾期未确认，我们将默认您取消对该款活动商品的采购。",
    "TuanGouShuoMing9": "⑤当活动状态在洽谈中时，您还可以对活动商品进行追加，但需要您马上确认采购。",
    "TuanGouShuoMing10": "⑥活动成功后，您确认采购的商品才能进行拼柜。若活动失败，我们将取消您的采购，但您还可以选择按照原厂的价格和起订量进行购买。",
    "GuiZe": "规则",
    "BangNingZhaoYang2": "点击帮您找样，ESSA专业人员为您匹配",
    "BangNingZhaoYang1": "找不到我想要的商品怎么办？",
    "FangWenGuoJia": "访问用户",
    "ReMenFenLei": "热门分类",
    "ShangPinBaoHu": "商品保护",
    "ChaKanQuanBuTuiJianPinPai": "查看全部推荐品牌",
    "ZanWuPinPai": "暂无品牌",
    "JinYiGeYuePinPaiGuanZhuDu": "近一个月的品牌关注度",
    "JinYiGeYuePinPaiShangXin": "近一个月的品牌上新款式",
    "XinZengNGeKuanShi": "新增<b>{0}</b>个新款式",
    "TuiJianPaiXu": "推荐排序",
    "GuanZhuDuPaiXu": "关注度排序",
    "GengXinKuanShuPaiXu": "更新款数排序",
    "ZhuYingLeiMu": "主营类目",
    "ZhuYingShiChang": "主营市场",
    "Jin90TianXunJiaCiShu": "近90天内询价次数",
    "Jin90TianDingDanLiang": "近90天内订单量",
    "RenZhengXinXi": "认证信息",
    "GuanLianPinPai": "关联品牌",
    "GongChangZhanShi": "工厂展示",
    "ESSAZhanTing": "商品专柜",
    "DianJiShu": "点击数",
    "ShangPinZhengShu": "商品证书",
    "JiangXuanZhongShangPinJiaRuGouWuChe": "确定将选中的商品加入购物车吗？",
    "ZhanTingXuanPin": "展厅选品",
    "NinHaiMeiYouZhanTingXuanPin": "您没有展厅选品",
    "NinHaiMeiYouShiChangShangPin": "您没有市场商品",
    "XuanPinShiJian": "选品时间",
    "XiaoLiang": "销量",
    "LiShiJiaoYi": "历史交易",
    "PiLiangJiaRu": "批量加入",
    "ReDu": "热度",
    "NCiGuanZhu": "<b>{0}</b>次关注",
    "QiZhongYouKuanXuYaoSheZhiMaiTou": "其中有{0}款需要设置唛头信息",
    "QiZhongYouKuanXuYaoSheZhiTieZhi": "其中有{0}款需要设置贴纸信息",
    "DanKuanShangPinBuShiYongMaiTou": "单款商品不使用唛头",
    "DanKuanShangPinBuShiYongTieZhi": "单款商品不使用贴纸",
    "DengLuChaJia": "登录查价",
    "JiZhuMiMa": "记住密码",
    "QingXuanZeQuYuZhanDian": "请选择区域站点",
    "DengLuZhuanXiang": "登录ESSA会员特权专享",
    "ChaKanChuChangJiaGe": "查看<b>真实</b>工厂出厂价格",
    "SuiShiZhiJieYiJia": "随时跟工厂进行<b>直接议价</b>",
    "KeJiShiChaKanXinPin": "可以及时查看到每天更新的<b>2000多款新品</b>",
    "ShiFouSuoYouShangPinBuShiMaiTou": "是否所有商品不使用唛头",
    "ShiFouSuoYouShangPinDouShiYongMaiTou": "是否所有商品都使用{0}唛头",
    "ShiFouSuoYouShangPinBuShiYongTieZhi": "是否所有商品不使用贴纸",
    "ShiFouSuoYouShangPinDouShiYongTieZhi": "是否所有商品都使用{0}贴纸",
    "Ci": "次",
    "XinPinXuDengLuHouFangKeChaKan": "新品需登录后方可查看",
    "JinRuGongChang": "进入工厂",
    "XinPinYuShouShuYuGongChang": "新品预售属于工厂未开始量产的商品，请您登录essa认证后的账号进行查看",
    "XinPinYuShouMeiYue": "新品预售每月1号会更新1次，定期为您提供市面上最新的商品",
    "WoYaoDiJia": "我要低价",
    "DengLuHouKeJian": "登录后可见",
    "QingTianXieZhenShiJiaGeWuEYiYaJia": "请您填写真实的采购量及价格，恶意压价会导致工厂不愿接受您的订单",
    "ZhanShiXinXiHuoQuYouHuiJiaGe": "议价时我们会对工厂展示您的信息，方便工厂给予更加优惠价格",
    "GongChangBaoJia": "工厂报价",
    "YiXiangJiaGe": "意向价格",
    "CaiGouXiangShu": "采购箱数",
    "QuXiaoShouCang": "取消收藏",
    "ChaKanQianKuanMingXi": "查看欠款明细",
    "JieSuanDanHao": "结算单号",
    "JieSuanRiQi": "结算日期",
    "ChuHuoRiQi": "出货日期",
    "HuoGuiTiJi": "货柜体积",
    "ShangPinHeJi": "商品合计",
    "CaiGouShangBianHao": "采购商编号",
    "POBiZhang": "PO币种",
    "BenDanYingShouFeiYongMingXi": "本单应收费用明细",
    "FeiYongRiQi": "费用日期",
    "FeiYongXiangMu": "费用项目",
    "FeiYongJinE": "费用金额",
    "DaiZhiFu": "待支付",
    "CaiGouShangLeiJiDaiZhiFuFeiYongHeJi": "采购商累计待支付费用合计",
    "MeiYuanDaiZhiFu": "美元待支付",
    "RenMinBiDaiZhiFu": "人民币待支付",
    "PODanShangPinMingXi": "PO单商品明细",
    "ShangPinID": "商品ID",
    "GongChangBianHao": "工厂编号",
    "DingGouXiangShu": "订购箱数",
    "ZongShu": "总数",
    "DengJiRiQi": "登记日期",
    "YiShouKuan": "已收款",
    "QianKuanJinE": "欠款金额",
    "YuJiFuKuanShiJian": "预计付款时间",
    "YiBianDong": "已变动",
    "BuHuoChiShangPinYouYiChang": "补货池商品有异常",
    "POShangPinShengChanZhongYouYiChang": "PO商品生产中有异常",
    "WoYaoBuHuo": "我要补货",
    "WoYaoDiaoRuShangPin": "我要调入商品",
    "YouGongChangFanKuiShangPin": "有工厂反馈的商品",
    "WoDeDingDanYaoQiu": "我的订单要求",
    "ShouJiPaiWanJuZhaoGongChang": "手机拍玩具，随时找工厂",
    "LiJiTiYan": "立即体验",
    "PaiTuZhaoYang": "拍图找样",
    "ZhaoDaoWanJuYangPinZhaoPian": "在展会或其他地方拍到玩具样品的照片",
    "SuiShiSuiDiShangChuanTuPianChaZhao": "随时随地，在手机浏览器输入m.essa.cn，点击以图搜图，上传图片进行查找",
    "ShangChuanHouTuiJianXiangSiKuan": "上传后，系统自动寻找到商品的信息或ESSA推荐的一些相似款",
    "HaiKeYiJingXingRenGongZhaoYang": "如果您觉得拍图找样还不能找到您想要的商品，您可以提交您的需求，让我们专业的团队帮您进行人工找样",
    "KeHuZongQianKuan": "客户总欠款",
    "DaiZhiFuDingJin": "待支付订金",
    "BuManGuiTxt": "不满柜",
    "HongSeDaiBiaoWeiDu": "红色代表未读",
    "MeiYouZhaoDaoFuHeTiaoJianSP": "抱歉没有找到符合条件的商品，请重新搜索或者更换其他产地",
    "BaoHanDuanTuYunFei": "包含短途运费",
    "WeiHuoZhongMeiYouZhaoDao": "尾货中没有找到与{0}相关的商品",
    "GouWuCheZhongMeiYouZhao": "您的购物车没有找到与{0}相关的商品，如您想补货该商品，可以添加该商品到购物车，询价完成后再补货",
    "GouWuCheZanWuShangPin": "购物车暂无商品，您可以先找商品，然后加入购物车询价",
    "ChongDanZhongMeiYouZhao": "满足装柜日期的商品中没有找到与{0}相关的商品",
    "ChongDanZanWuShangPin": "暂无满足装柜日期的商品",
    "QiTeXinPin": "奇特新品",
    "WeiNinJingXuan": "为您精选",
    "ShouFaMingYouPinPai": "首发名优品牌",
    "DaoDiLaKanKanQiTaShangPin": "到底啦，看看其他商品吧",
    "GongNeng": "功能",
    "BaoQianNinXuanZeDeShiJian": "抱歉，您选择的时间段内没有符合条件的商品",
    "WoMenWeiNinTuiJianZuiJinY": "我们为您推荐最近一个月的上架新品",
    "ZuiJinLiangGeYue": "最近两个月",
    "WoMenWeiNinTuiJianZuiJinYiZhou": "我们为您推荐最近一周的上架新品",
    "GenJuShangMianDeShangPinJ": "您可能会喜欢的商品",
    "ShangPinBianMaGongChangHu": "编号搜索",
    "XiaoShouDiQu": "销售地区",
    "DiYiShiJianTuiJianXinPinReXiaoPin": "第一时间向您推荐所选地区和采购类型的新品及热销商品",
    "NinDangQianHaiWeiYouErJiYongHu": "您当前还未有二级用户",
    "YiChengGongFuZhiWoDeYaoQingLianJie": "已成功复制我的专属有邀请链接",
    "TuiGuangYaoQing": "推广邀请",
    "ChengNuoBuHuiDuiWaiGongKaiXinXi": "开具正规收发票等票据，ESSA平台承诺不会对外公开信息，且遵守ESSA平台保密协议规定",
    "ShenFenZhengHaoHuoHuZhao": "大陆输入身份证号;大陆外输入其国内护照号码",
    "FenXiaoShangDengLu": "分销商登录",
    "Wo": "我",
    "JiangYaoQingMaGaoZhiHaoYou": "将邀请码告知好友",
    "ShangESSAZhuCeBingTianRuYaoQingMa": "上essa注册并填入邀请码",
    "WeiBaoZhengZhangHaoYanZheng": "为了保证您的账号安全，先进行绑定手机号验证",
    "SheZhiXinDeDengLuMiMa": "设置新的登录密码",
    "WoDeFenXiaoZhongXin": "我的分销中心",
    "LeiJiYiTiCheng": "累计已提成",
    "LeiJiTiCheng": "累计提成",
    "WuFaYanZhouQingLianXi": "如无法用手机验证，请联系客服处理，我要<a id=\"udesk_container_btn\" class=\"a-link\" href=\"javascript:void(0);\">联系客服</a>",
    "WoDeTiCheng": "我的提成",
    "BenYueTiCheng": "本月提成",
    "WanChengZhuCeGuanXiBangDing": "完成注册，关系绑定",
    "YaoQingHaoYouXinXiC": "你的客户朋友注册成功之后，您可以在“推广用户查询”列表中查看你客户朋友信息，如果出现客户您邀请的客户朋友注册成功之后没有在您的推广用户列表中，请您联系essaone.cn的在线客服进行咨询。（必须是绑定成功之后，您才能享有您客户朋友的成交提成。)",
    "TiChengTongJi": "提成统计",
    "TiChengJinE": "提成金额",
    "TiChengDianLv": "提成点率",
    "YuJiTiCheng": "预计提成",
    "DingDanHuoKuan": "订单货款",
    "YuJiTiChengJinE": "预计提成金额",
    "YongHuDengJi": "用户等级",
    "YuJiDingDanHuoKuan": "预计订单货款",
    "HeJiFanTiJinE": "合计返提成额",
    "WoDeTuiGuangYongHu": "我的推广用户",
    "HiJiYuJiTiChengJinE": "合计预计提成金额",
    "YiJiYongHu": "一级用户",
    "ErJiYongHu": "二级用户",
    "ZhuYaoChuHuoFangShi": "主要出货方式",
    "WoDeTuiGuangYaoQingMa": "我的推广邀请",
    "GongShangZhiZhaoHao": "营业执照号",
    "ShuiWuHao": "纳税人识别号",
    "WoDeZhuanShuYaoQingLianJie": "我的专属邀请链接",
    "QingTianXieShuiWuHao": "请填写纳税人识别号",
    "FuZhiWoDeZhuanShuYaoQingLJ": "复制我的专属邀请链接",
    "QingTianXieGongShangZhiZhaoHao": "请填写营业执照号",
    "WoDeYaoQingMa": "我的邀请码",
    "YaoQingMaMoRenBangDingShouJi": "邀请码默认为您的绑定手机",
    "QingXuanZheZhuYaoChuHuoFangShi": "请选择主要出货方式",
    "GuoJiDiQu": "国籍/地区",
    "FenXiang": "分享",
    "ShangPinXinXiJiLianJieYiJingFuZhi": "商品信息及连接已经复制",
    "ZhengJianHaoMa": "证件号码",
    "NinKeYiZhanTieFaSongGeiPenYou": "您可以在聊天软件或邮件中粘贴发送给朋友",
    "ZhengJianZhaoPian": "证件照片",
    "JinJiLianXiRenXinXi": "紧急联系人",
    "WoShiCaiGouShang": "我是采购商",
    "NinTiGongDeJinJiLianXiRenYaoQiuMiaoShu": "您所提供的紧急联系人，应当是在不能及时跟你取得联系时的最佳人选，尽量与您经常联系、关系亲密的好友",
    "WoShiFenXiaoShang": "我是分销商",
    "WoDeTuiGuangXinXi": "我的推广信息",
    "TuiGuangYaoQingJieShao": "推广邀请介绍",
    "YaoQingHaoYouWoKeDe": "邀请好友我可得",
    "WoDeSuoYouTuiGuangYongHu": "我的所有推广用户",
    "WoXiaJiaYaoQingHaoYouWoKeDe": "我下家邀请好友我可得",
    "DingDanWanJieFanYong": "订单完结返佣",
    "WoHaoYouKeDe": "我好友可得",
    "NZheKou": "{0}折",
    "ShouDanZheKouQuan": "首单折扣券",
    "LianXiDianHua": "联系电话",
    "YaoQingTiXing": "邀请提醒",
    "YaoQingHaoYouXinXiA": "您可以复制邀请链接，通过手机的社交媒体软件、邮件等方式分享给你的客户朋友。让他们注册成为essaone会员。",
    "YaoQingHaoYouXinXiB": "您需要提醒您的客户朋友在注册的时候注意填写您的手机邀请码，这样会跟您的账号进行绑定，您将享有客户朋友在essaone平台上成交金额的提成。",
    "EPLUSHuiYuan": "E-PLUS会员",
    "YaoQingLiuCheng": "邀请流程",
    "LeiJiXiaDanShu": "累计下单数",
    "TongGuoLianJieYaoQingKeHuPengYou": "通过链接邀请客户朋友",
    "LeiJiChengJiaoJinE": "累计成交金额",
    "FuZhiYaoQingLianJie": "复制邀请链接",
    "ZuiHouYiCiChengJiaoShiJian": "最后一次成交时间",
    "TongGuoIMFenXiang": "通过社交APP分享",
    "NinDangQianHaiWeiTuiGuangYao": "您当前还未有推广邀请用户",
    "HuoTongGuoYouJianFenXiang": "或通过邮件分享",
    "HaoYou": "好友",
    "QuTuiGuang": "去推广",
    "DianJiLianJieWanChengZhuCe": "点击链接完成注册",
    "NinDangQianHaiWeiYouTiCheng": "您当前还未有提成",
    "GuanXiBangDing": "关系绑定",
    "FenXiaoZhongXinShouYe": "分销中心首页",
    "TongGuoYaoQingMaYaoQingKeHu": "通过邀请码邀请客户朋友",
    "TuiGuangYongHuChaXun": "推广用户查询",
    "ContactQueryError": "联系人查询出错",
    "AccountQueryError": "分销商账号查询出错",
    "DistributorQueryError": "分销商查询出错",
    "BankAcountQueryError": "获取银行帐号信息出错",
    "ShouJiHaoMaBuNengXiangTong": "主账号手机号码不能与紧急联系人手机号码相同",
    "ShouJiHaoMaError": "手机号码出错",
    "YanZhengShiBai": "验证失败，请重试",
    "ChongXinHuoQuYanZhengMa": "重新获取验证码",
    "YiJi": "一级",
    "ErJi": "二级",
    "SheZhiXinMiMa": "设置新密码",
    "ShenFenYanzheng": "身份验证",
    "GenHuanXinDeShouJiHao": "更换新的手机号",
    "GenHuanChengGong": "更换成功",
    "GengHuanBangDingShouJi": "更换绑定手机",
    "ChongXinDengLu": "重新登录",
    "QingYongShouJiHaoChongXinDengLu": "请用新手机号码重新登录",
    "NinDeZhangHaoYiQieWeiXinShouJiHaoMa": "您的账号已经切换为新手机号码",
    "BangDingDeShouJiGengHuanChengGong": "绑定的手机更换成功",
    "DangQianYiBangDingShouJiHaoMa": "当前已绑定手机号码",
    "TiJiaoRenZheng": "提交认证",
    "DangQianShouJiHao": "当前手机号",
    "MiMaZuHeGuiZe": "6-20位字符，由数字、字母和符号两者以上组合",
    "KaiJuFaPiaoBingQieZunShouBaoMiXieYi": "开具正规税收发票等票据，essa平台承诺不会对外公开信息，且遵守essa平台保密协议规定。",
    "JinJiLianXiRenXingMing": "紧急联系人姓名",
    "JinJiLianXiRenHaoMa": "紧急联系人手机号码",
    "KaiHuHang": "开户行",
    "KaiHuMing": "开户名",
    "YinHangZhangHao": "银行账号",
    "QingTianXieXingMing": "请填写姓名",
    "QingTianXieZhengJianHaoMao": "请填写证件号码",
    "QingTianXieJinJiLianXiRenXingMing": "请填写紧急联系人姓名",
    "QingTianXieJinJiLianXiRenHaoMa": "请填写紧急联系人手机号码",
    "MiaoHouZiDongTiaoZhuanDengluYeMian": "{0}秒后自动跳转登录页面",
    "QingBangDingShouJiHao": "请绑定手机号",
    "TouXiang": "头像",
    "YouHuiQuan": "优惠券",
    "WeiShiYongYouHuiQuan": "未使用优惠券",
    "YiShiYongYouHuiQuan": "已使用优惠券",
    "YiGuoQiYouHuiQuan": "已过期优惠券",
    "ZanWuWeiShiYongYouHuiQuan": "暂无未使用优惠券",
    "ZanWuYiShiYongYouHuiQuan": "暂无已使用优惠券",
    "ZanWuYiGuoQiYouHuiQuan": "暂无已过期优惠券",
    "ShouHuoRenXinXi": "收货人信息",
    "MianDingJinXiaDan": "免定金下单",
    "ReMaiShangPinTuiJian": "热卖商品推荐",
    "GenJuDaShuJuFenXiAnDiQuAn": "根据大数据分析，按地区按时间段给E-plus会员推荐热卖商品",
    "ZhuanShuKeFu": "专属客服",
    "ZaiFuWuGuoChengZhongYuDao": "在服务过程中遇到任何疑问，ESSA会为E-plus优先处理解决",
    "XinZengShouHuoRen": "新增收货人",
    "XinZengShouHuoRenXinXi": "新增收货人信息",
    "BianJiShouHuoRenXinXi": "编辑收货人信息",
    "ShanChuShouHuoRenXinXi": "删除收货人信息",
    "ShiFouShanChuShouHuoRenXi": "是否删除收货人信息？",
    "GengDuoLianXiRen": "更多联系人",
    "ZanWuShouHuoRenXinXiNinKe": "暂无收货人信息，您可以先新增",
    "ShouHuoRen": "收货人",
    "QingShuRuShouHuoRen": "请输入收货人",
    "QingShuRuShouJi": "请输入手机",
    "MuDeDiChengShi": "收货城市",
    "QingXuanZeMuDeDiChengShi": "请选择收货城市",
    "XiangXiDiZhi": "详细地址",
    "QingShuRuXiangXiDiZhi": "请输入详细地址",
    "WeiLeXiangHeXinKeHuTiGong": "ESSA为了向核心客户提供更优质的购物体验，特别推出ESSA会员E-plus，E-plus包含免定金下单、专属优惠商品、热卖商品推荐、专享折扣、专属客服等权益，全方位提升和丰富您的购物特权",
    "LaiYuanYongTu": "来源/用途",
    "HuoDeGengDuoQuanYi": "获得更多权益",
    "MaiJiaChengJiaoDingDan": "买家成交LTD订单",
    "LianXiKeFu": "联系客服",
    "WanChengYiXiaQiZhongYiGeT": "完成以下其中一个条件，即可成为E-plus",
    "YaoQingManRenZhuCeBingRen": "邀请满{0}人注册并认证 或 邀请{1}位好友并成交 即成为E-Plus享免定金",
    "JiaRuXiangZhuanShuTeQuan": "加入E-Plus · 享专属特权",
    "QingShangChuanZhaoPinHeDuiXinXi": "请上传您的证件照片，方便我们验证您的真实信息；我们承诺按照essa保密协议规定，对您个人信息进行保护。",
    "YinHangKaXinXi": "银行卡账号信息",
    "FenXiaoShangYinHangZhangHaoYongYuFanLi": "分销商的银行卡账户信息，用于后续的返利，务必请分销商提供正确的账号信息",
    "QueRenQiYeXinXi": "确认企业信息",
    "QueRenShouHuoDiZhi": "确认收货地址",
    "SheZhiDingDanYaoQing": "设置订单要求",
    "ZhuCeZhengShuBianHao": "营业执照号",
    "QingTianXieZhuCeZhengShuBianHao": "请填写营业执照号",
    "TiGongZhengGuiDePiaoJu": "请您务必填写以下真实的信息。您填写的信息将用于开具正规合同、发票等票据信息，我们将为您提供正规的票据及税务发票等票据。",
    "ZunXunPingTaiBaoMiXieYi": "ESSA承诺严格遵循ESSA平台保密协议，对您的信息进行保护。",
    "DDPFuWuGuoJia": "DDP收货国家",
    "YuJiDaoGangShiJian": "预计到达时间",
    "ShangPinHuoKuan": "商品货款",
    "WuLiuQingGuanFei": "物流清关费",
    "WeiBuYingXiangDingDanYuJiDaoGangShiJian": "注意：为不影响订单预计到达时间，请尽快支付定金，预计到达时间将根据定金实际到账日期而做相应推迟。",
    "Zhou/Sheng": "州/省",
    "ChengShi": "城市",
    "GaiChengShiZanWuShouHuoDiZhi": "该城市暂无收货地址，您可以先新增",
    "QiTaGuoJiaTuoZhanZhongHouXuKaiFang": "其他国家和城市拓展中，后续开放",
    "GaiYouHuiQuanYiBeiQiTaZhangHaoXuanYong": "该优惠券已被其他子账号选用",
    "BuShiYongYouHuiQuan": "不使用优惠券",
    "ManN": "满{0}",
    "YuJiDingJin": "预计定金",
    "ZongHuoKuan": "总货款",
    "ShiYongYouHuiQuan": "使用优惠券",
    "ZanWuKeYongYouHuiQuan": "暂无可用优惠券",
    "XuanZeYouHuiQuan": "选择优惠券",
    "DDPBuZhiChiPinWeiHuo": "DDP报价暂不支持拼尾货和包含客版物料的商品，更换报价将自动移除对应商品，您确定更换吗？",
    "ZanShiMeiYouChangYongBaoJiaFangShi": "暂时没{0}的常用报价方式",
    "SanDanJiChuJianJie": "散单集出是一种每天自动把小订单进行合并，每周统一发货，快速运往客户仓库，并同步完成了通关与付税的全程服务。实现让国外小批发商可以通过ESSA平台，直接向中国工厂采购玩具商品",
    "WoYiYouZhangHaoDengLu": "我已有账号，<a class=\"red\" href=\"/login\">马上登录</a>",
    "XiaYiBuQueRenShouHuoXinXi": "下一步，确认收货信息",
    "GengHuanMuDiDiZhiYingXiangJiaGe": "更换收货城市相关物流费价格和预计到达时间可能发生变化请留意！",
    "QingTianXieXiaDanRenXingMing": "请填写下单人姓名",
    "QingTianXieXiaDanRenShouJi": "请填写下单人手机",
    "QingXuanZeShouHuoRenXinXi": "请选择收货人信息",
    "QingXinZengBingXuanZeShouHuoRen": "请新增并选择收货人信息",
    "XiaDanRenXinXi": "下单人信息",
    "ShouJiHaoMao": "手机号码",
    "MuDiDiXinXi": "收货城市信息",
    "JinZuoWeiShouHuoRenWuFaLianXiShi": "如后续订单发生异常需联系下单人进行沟通处理，请补充或确认下单人信息",
    "LiaoJieGengDuo": "了解更多",
    "SanDanJiChuFuWuJianJie": "散单集出服务：让您用最少的成本来中国直接采购玩具。",
    "GenJuZhuXiaoShouDiQuPiPeiFuWuGuoJiaHeChengShi": "根据您注册选择的销售地区为您匹配当前的收货国家，请您选择收货城市以便提供更为准确的报价。",
    "QingZaiGongSiXinXiZhongXiuGaiDDPMuDiChengShi": "您此次选择的收货城市将作为DDP报价的依据，如需调整请到会员中心-公司信息中进行修改。",
    "GengDuoChengShiKaiTongDDPFuWu": "更多城市正在开通，敬请期待",
    "BaoJiaGuiZe7": "DDP标准报价规则：",
    "BaoJiaGuiZe8": "商品产地报价+物流通关费报价（DDP报价不包含商品从收货仓配送到收货城市所产生的物流费用，该部份费用需自行承担）",
    "MetaMiaoshu": "ESSA is a China factory toys sourcing & trading platform covering with over 20,000 factories and including 1 million non-repetitive SKU.",
    "FuWuGuoJia": "收货国家",
    "BianJiMuDiDiXinXi": "编辑收货信息",
    "QingXuanZeMuDiChengShi": "请选择收货城市",
    "YuJiDaoGangShiJianTuiChiT": "预计到达时间推迟通知",
    "ZhuYiLiShiYuJiDaoGangShiJ": "注意：历史预计到达时间日期变更请在订单跟踪中查阅",
    "XinYuJiDaoGangShiJian": "新预计到达时间",
    "YuanShiYuJiDaoGangShiJian": "原预计到达时间",
    "NiHaoWoShiNiDeFuWuGuWen": "你好!我是你的服务顾问{0}",
    "ShouHuoXinXi": "收货信息",
    "XinDingDanDouShiYongGaiBaoJiaZuHe": "新订单都使用该报价组合",
    "QingJinKuaiZhiFuDingJinYu": "请尽快支付定金，预计到达时间将根据我们收到定金的时间发生变化,可能会引起推迟。",
    "YouYuWeiShouDaoDingJinDin": "由于未收到定金，订单还无法向工厂下单，导致订单预计到达时间推迟至{0}号（原{1}），请尽快支付定金（定金以到账时间为准）",
    "YouYuWeiShouDaoHuoKuanZao": "由于未收到货款，造成无法按计划收货，导致订单预计到达时间推迟至{0}号（原{1}），请尽快支付货款（货款以到账时间为准）",
    "ShangPinShengChanGuoCheng": "商品生产过程未能按原计划生产完成，订单预计到达时间推迟至{0}（原{1}），请知悉。",
    "ShiHuo": "时货",
    "NinDeDingJinYiShouDaoBing": "您的定金已收到，确认PO单后工厂开始生产",
    "NinDeDingDanYiTiJiaoQingZ": "您的订单已提交，请及时支付定金以确认订单！",
    "QueRenPO2": "确认PO",
    "NinDeDingDanShangPinYiJin": "您的订单商品已经生产完成，请尽快支付订单货款，以免影响正常发货",
    "NinDeDingDanYiJingZhuangJ": "您的订单已经装柜发出，请及时支付尾款，以免影响正常收货。",
    "FuKuanZhiYin": "付款指引",
    "YiZhiFuDingJin": "已支付定金",
    "DanHaoFaSongDaoShouJi": "PO单号发送到手机",
    "DanHaoYiJingFuZhi": "PO单号已经复制",
    "DanHaoYiJingFaSongDaoShou": "PO单号已经发送到手机",
    "FaSongDaoShouJi": "发送到手机",
    "ZheHe": "折合",
    "GongXiNin_Shi": "恭喜您，已经成功提交PO，定金已收到，请尽快点击确认PO“确定”按钮后工厂开始生产。",
    "GongXiNin_ShiYi": "恭喜您，已经成功提交PO，工作人员稍后会联系您，与您确认商品无误后请支付定金到下面银行账号并确认PO，剩下的尾款将于货到目的港前支付；如有疑问，请咨询您的销售顾问。",
    "ShouKuanRen": "收款人",
    "YouHuiJinE": "优惠金额",
    "ShouBiDingDanDingJinWei": "首笔DDP订单定金为{0}",
    "ShouBiDingDanQieDingDanZo": "首笔DDP订单且订单总额{0},定金为{1}",
    "QingZaiNTianNeiZhiFuDingJin2": "请尽快支付定金，预计到达时间将根据我们收到定金的时间发生变化,可能会引起推迟",
    "BuHaoYiSiGuiSiDangQianWeiTiJiaoDdp": "不好意思，贵司当前有未提交的DDP订单，不允许修改销售地区，请先把未提交的DDP订单提交或修改报价方式为非DDP",
    "ChaKanShiLi": "查看示例",
    "FaSong": "发送",
    "HuiKuanZhongXieDanHao": "请在汇款信息中写上对应的PO单号，方便确认定金，安排生产。",
    "YiXiangKuaiChu": "一箱快出",
    "XianShangZhanTing": "猜您喜欢",
    "GuangYiGuang": "逛一逛",
    "ShouDanYuFuZhiXuN": "首单预付只需<b>10%</b>",
    "XuanZeDDPKeYiXiangWiDing": "选择DDP，可一箱起订，并享受ESSA全程物流清关、快运到家服务。",
    "NNianDiNQi": "{0}年第{1}期",
    "JuLiHuoDongJieShu": "距离结束时间",
    "WanJuGaiBan": "改版服务",
    "NGeJieGuo": "{0}个结果",
    "BangNinZhaoYangRuKouYiDong": "帮您找样入口移到这里啦",
    "NinDeDingDanShuJuYiFaShengBian": "您的订单数据已发生变动，请刷新页面后再提交",
    "WeiNinTiGongZuiJiaDeDingZhiJieJueFangAn": "为您提供最佳的定制解决方案",
    "ZhuanYeDeGaiBanTuanDui": "专业改版团队",
    "ChuSeDeChanPinTuanDuiNNianJingYan": "出色的产品团队，10年改版经验，无数品牌成功案例",
    "YouZhiDeGaiBanFuWu": "优质的改版服务",
    "QiangDaDeGongYingLianZhiChi": "强大的供应链支持，为您提供有利的改版条件",
    "GaiBanShangPinYanMiBoaHuQiTaKeHuBuKeJian": "改版商品严密保护，其他客户不可见",
    "KuaiSuXiangYingNinDeXuQiu": "快速响应您的需求",
    "YiJianTiJiaoKuaiSuXiangYing": "一键提交，24小时快速响应",
    "YiXiangChuHuoDeShuoMingNeiRong": "所有“一箱快出”商品均满足“MOQ=1”及“货期≤10天”的特定要求。“一箱快出”保证1箱可买，10天快速出货。",
    "ZaiGouWuCheZhongTianJiaShangPin": "在购物车中添加商品",
    "ChuHuoShiJian": "最快出货时间",
    "MeiGePoDanZuiDuoKeFa": "七天内最多可发送三次短信",
    "ZhangHuMingCheng": "账户名称",
    "ShouKuanRenDiZhi": "公司地址",
    "YinHangMingCheng": "银行名称",
    "YinHangHaoMa": "银行号码",
    "YinHangDiZhi": "银行地址",
    "KeHuYinHang": "客户银行",
    "DaiLiZhangHao": "代理账号",
    "YinHangTongYiDaiMa": "银行统一代码",
    "ShangPinBuZhiChiDDP": "该商品不支持DDP报价方式出货",
    "QingTianXieLianXiFangShi": "请填写联系方式",
    "LianXiFangShiBiXuWeiShuZi": "联系方式必须为数字",
    "LianXiFangShiYiCunZai": "联系方式已存在，请重新输入",
    "DuanXinYiFaSong": "短信已发送",
    "ChaKanDingDanXiangQing": "查看订单详情",
    "ShangPinKuanShu": "商品款数",
    "ShuLiangZongJi": "数量总计",
    "DingDanSuoXuHuoKuanDanBaoEDu": "订单所需货款担保额度",
    "PiLiangFuZhiPODanHao": "复制订单号",
    "PiLiangFaSongPODanDaoShouJi": "发送订单号到手机",
    "PiLiangFuZhiPoDanDeShuoMing": "请在付款单上填入发送到手机上的PO单号",
    "XuZhiFuDingJinHeJi": "需支付定金合计",
    "FuKuanXinXi": "付款信息",
    "ChaKanGuDingBaoZhengJinDengJi": "查看固定保证金等级",
    "QueDingDingDan": "确定订单",
    "DingDanYingFuZongJinE": "订单应付总金额",
    "GongXiNinYiTiJiaoPOQingJiShiQueRenPO": "恭喜您，已成功提交PO。我们已根据您选购的商品货期将本次下单拆分为{0}个订单，以便您尽快收到货物。您当前的保证金担保额度充足，请点击“确定”订单。",
    "YiTiJiaoPOQingLinXiZhuZhangHaoTiShengDengJiChaiDan": "恭喜您，已成功提交PO。我们已根据您选购的商品货期将本次下单拆分为{0}个订单，以便您尽快收到货物。但您当前的保证金担保额度不足，请联系主账号并提升固定保证金等级。",
    "YiTiJiaoPOQingTiShengDengJiYiMianYanWuShengChan": "恭喜您，已成功提交PO。我们已根据您选购的商品货期将本次下单拆分为{0}个订单，以便您尽快收到货物。但您当前的保证金担保额度不足，请尽快提升保证金等级",
    "QingXuanZeKeDanBaoDeDingDanHuZeTiShenDengJi": "恭喜您，已成功提交PO。我们已根据您选购的商品货期将本次下单拆分为{0}个订单，以便您尽快收到货物。但您当前的保证金担保额度不够担保所有订单，请选择可担保的订单进行担保或请尽快提升保证金等级。",
    "QingBuQiBaoZhengJinEDuYiMianYanWuShengChanChaiDan": "恭喜您，已成功提交PO。我们已根据您选购的商品货期将本次下单拆分为{0}个订单，以便您尽快收到货物。但您当前的保证金担保额度不足，请尽快充值，补全保证金。",
    "YIBianNinJinKuaiShouDaoHuoWuQingJIShiZhiFuDingJin": "恭喜您，已成功提交PO。我们已根据您选购的商品货期将本次下单拆分为{0}个订单，以便您尽快收到货物。请您及时支付定金。",
    "NinDanQianWeiVIPMianDingJinKeHuQingZhiJieQueRenPOChaiDan": "恭喜您，已成功提交PO。我们已根据您选购的商品货期将本次下单拆分为{0}个订单，以便您尽快收到货物。您当前为VIP免定金客户，请直接点击“确定”订单",
    "ShouYeGuanJianCi": "ESSA.CN，玩具与礼品，婴童用品，热销，新，玩具供应商，中国工厂",
    "SouSuoYeBiaoTi": "玩具、礼品和婴儿用品中国直采",
    "PinPaiYeBiaoTi": "品牌区-寻找中国优质工厂、制造商、供应商",
    "PinPaiYeGuanJianCi": "ESSA.CN，玩具和礼品供应商，中国工厂，制造商",
    "ShouYeBiaoTi": "ESSA.CN-玩具和婴童用品在线采购，中国直采",
    "ChaKanDaTu": "查看大图",
    "ShuRuPinPaiMingChengShaiX": "输入品牌名称筛选",
    "QingKongSouSuo": "清空搜索",
    "ZhaoBuDaoFuHeTiaoJianDePi": "找不到符合条件的品牌",
    "NinKeNengHuiXiHuanDePinPa": "您可能会喜欢的品牌",
    "PingTaiRenZheng": "平台认证",
    "GongChangRenZheng": "工厂认证",
    "SouSuoBenPinPaiShangPin": "搜索本品牌商品",
    "XiaZaiBaoJiaDan": "下载报价单",
    "LianXiGongChang": "联系工厂",
    "DengLuHouChaKanGongChangL": "登陆后查看工厂联系方式",
    "MingXingShangPin": "明星商品",
    "PinPaiShouZiMu": "品牌首字母",
    "GuoLvJieGuo": "过滤结果",
    "ShaiXuanXiang": "筛选项",
    "QingXuanZe2": "请选择",
    "ChanPin": "产品",
    "XuanZeZhengShu": "选择证书",
    "ChaKan": "查看",
    "NinYouZhangDaiDanBaoDeDinWuDengJiPiPei": "您有{0}张待担保的订单，现保证金等级只能担保部分订单，是否前往确认部分订单？或联系销售顾问继续提升等级以担保全部订单。",
    "NinHaiKeYiLianXiPingTai": "您还可以联系平台{0}",
    "ZaiXianKeFu": "在线客服",
    "XinPinDengLuHouKeJian": "新品登录可见",
    "ZhaoBuDaoFuHeTiaoJianDeSh": "找不到符合条件的商品，您可以返回查看",
    "PinPaiQuanBuShangPin": "品牌全部商品",
    "WuLiuShiJian": "物流时间",
    "TuiGuangDeKeHuSuoYouYiWan": "推广的客户所有已完成订单的提成总额",
    "TuiGuangDeKeHuBenZiRanYue": "推广的客户本自然月所有完成订单的提成总额，已收到尾款为准",
    "ZhiYaoYaoQingZhuCeDeKeHu": "只要邀请注册的客户",
    "XiaShuYongHuYaoQingZhuCeD": "下属用户邀请注册的客户",
    "GaiKeHuWanChengDingDanDeH": "该客户完成订单的货款，完成订单以收到尾款为准，货款是指工厂价格，不包含物流清关等费用",
    "GaiKeHuWanChengDingDanKeY": "该客户完成订单可以获取的提成金额，完成订单以收到尾款为准",
    "GaiKeHuYiFuDingJinWeiFuWe": "该客户已付定金未付尾款订单的货款，货款是指出厂价格，不包含物流清关等费用",
    "GaiKeHuYiFuDingJinWeiFuWe2": "该客户已付定金未付尾款订单可获取的提成金额",
    "GaiKeHuYiJingXiaDanDeDing": "该客户已经下单的订单数量",
    "GaiKeHuYiJingXiaDanDeHuoK": "该客户已经下单的货款金额，货款是指出厂价格，不包含物流清关等费用",
    "DiQuShiChang": "地区",
    "ShiPin": "视频",
    "QingWuBiTianXieZhenShiDeD": "请务必填写真实的电话号码，后期我们工作人员会联系您进行认证",
    "DDPBuZhiChiYiJia": "不支持议价",
    "YongHuBianHao": "用户编码",
    "ZhuCeShiJian": "注册时间",
    "DengLuTianShu": "登录天数",
    "ZuiHouDengLuShiJian": "最后登录时间",
    "XuanPinKuanShu": "选品款数",
    "ZuiHouXuanPinShiJian": "最后选品时间",
    "YongHuXiaDanXinXi": "客户行为信息",
    "KeHuXingWeiXinXi": "用户下单信息",
    "TuiGuangDeKeHuSuoYouYiJin": "推广的客户所有已经付定金未付尾款的订单提成总额，最终提成以完成订单为准",
    "ZhuCeFuWuShang": "注册贸易商",
    "TianXieZhangHaoXinXi": "填写账户信息",
    "TianXieGongSiXinXi": "填写公司信息",
    "TiJiaoZhuCeRenZheng": "提交注册认证",
    "ZiShaoNGeZiFuBuNengChunShuZi": "至少8个字符，不能为纯数字",
    "ShangChuanGongSiMenTou": "上传公司门头",
    "ShiLiTuPian": "示例图片",
    "ShangChuanGongSiYingYeZhiZhao": "上传公司营业执照",
    "ZhiChiDeWenJianGeshi": "支持 jpg、png、文件大小 ≤ 5m",
    "GongSiJianCheng": "公司简称",
    "GongSiDiZhi": "公司地址",
    "XiangXiDiZhiJieDaoMenPaiHao": "详细地址街道门牌号",
    "SuoZaiSheng": "所在省",
    "SuoZaiShi": "所在市",
    "SuoZaiQu": "所在区",
    "GongSiDianHua": "公司电话",
    "QuHao": "区号",
    "TongYiBingZhunShou": "同意并遵守",
    "ESSAPingTaiFuWuShangTiaoKuan": "ESSA平台贸易商注册及服务条款",
    "ZhuCeZhangHao": "注册账号",
    "QingZhuYi": "请注意",
    "WeiQueBaoXinXiZhenShiXingPingTaiJiangDuiNinXXXX": "为确保信息真实性，平台将对您的公司信息进行审核认证，并在1个工作日内完成。",
    "RenZhengShenHeJieGuoHuiYiXXXX": "认证审核结果，会以短信方式通知。请您留意平台短信。",
    "ZhiYouRenZhengTongGuoXXXX": "只有认证通过，您的账号才享有认证特权。否则，账号权限会受限制。",
    "RuYouYiWenKeYuPingTaiXXXX": "如有疑问，可与平台客服联系咨询。",
    "ChaKanShangPinBaoJia": "查看商品报价",
    "HuoQuGongChangXinXi": "获取工厂信息",
    "XiangYongJiSuZhaoYanng": "享用极速找样",
    "DuoYuYanDaoBaoJia": "多语言导报价",
    "GengDuoTeQuanTiYan": "更多特权体验",
    "FuWuShangDengLu": "贸易商登录",
    "WoShiFuWuShang": "我是贸易商",
    "TuiJianChi": "选品池",
    "YiXiaShangPinWeiTuiJianChiL": "选品池商品会自动向工厂询最新价",
    "WoDeTuiJianChi": "您的选品池",
    "JiaRuTuiJianChi": "选品",
    "NKuanShangPinYiJiaRuTuiJianChi": "{0}款商品已加入选品池",
    "ChaKanTuiJianChi": "查看选品池",
    "TuiJianChiZhongYiYouNKuanFuGai": "选品池中已有 {0}{1}，确定将以当前数量覆盖选品池中数量",
    "CiKuanHuoDongShangPinNinYiQueRenGouMaiTuiJianChi": "此款活动商品您已确认购买，请到购物车查看或调整箱数",
    "RenZhengYongHuCaiKe": "认证用户才可以参与活动，认证如有疑问请联系客服",
    "YuanGongDianHua": "员工电话",
    "YuanGongDengLuMiMa": "员工登录密码",
    "QingTianXieYuanGongDengLu": "请填写员工登录密码",
    "YuanGongXingMing": "员工姓名",
    "QingTianXieYuanGongXingMi": "请填写员工姓名",
    "WaiYu": "熟悉语言",
    "ShuXiShiChang": "熟悉市场",
    "QingXuanZeWaiYu": "请选择熟悉语言",
    "QingXuanZeShuXiShiChang": "请选择熟悉市场",
    "GongSiMenTou": "公司门头",
    "QingShangChuanGongSiMenTo": "请上传公司门头",
    "YingYeZhiZhao": "营业执照",
    "QingShangChuanYingYeZhiZh": "请上传营业执照",
    "XiangXiDiZhiJieDaoMenPai": "详细地址街道门牌",
    "QingTianXieGongSiSuoZaiDi": "请填写公司所在地区、所在市、所在区、详细地址",
    "QueRenTiJiao": "确认提交",
    "DengDaiShenHe": "等待审核",
    "BianGengZhongYaoXinXiHouX": "变更重要信息后需要审核之后才能生效",
    "YuanGongLieBiao": "员工列表",
    "ChuangJianShiJian": "创建时间",
    "SheZhiBossZhangHao": "设置BOSS账号",
    "QingXuanZeShuXiShiChangZu": "请选择熟悉市场,最多{0}个",
    "QingXuanZeWaiYuZuiDuoGe": "请选择熟悉语言,最多{0}个",
    "BianJiYuanGongZhangHao": "编辑员工账号",
    "XinZengYuanGongZhangHao": "新增员工账号",
    "TiShengCiZhangHaoWeiZhang": "提升此账号为BOSS账号，您将会被降级，无法再进行公司信息和员工信息管理",
    "ShanChuZhangHaoJiangWuFaH": "删除账号将无法恢复，确定要删除吗？",
    "FuWuShangGuanLi": "贸易商管理",
    "QingTianXieYuanGongDianHua": "请填写员工电话",
    "WeiDengLuHuoWeiRenZhengQingRenZhengHouChaKanJiaGe": "未登录或未认证的用户，请先登录或等待认证之后，才能查看商品价格",
    "QingXianYueDuBingTongYiXXXX": "请先阅读并同意平台相关协议才可以注册",
    "TuiJianChiNeiZanShiMeiYouSh": "选品池内没有商品，您可以添加商品到选品池",
    "QueDingCongTuiJianChiZhongS": "确定从选品池中删除所有选中的商品？",
    "QueDingCongTuiJianChiZhongQ": "确定从选品池中清除所有失效商品？",
    "QingTianXieZhengQueDeShouJi": "请填写正确的手机号码",
    "QingTianXieZhengQueDeQQ": "请填写正确的QQ",
    "QingXuanZeMoBanYuYan": "请选择模板语言",
    "MeiZhongTuiJianDanMoBanDo": "每种推荐单模板都支持中、英、俄三种语言，您可以根据需要选择对应语言",
    "ShangPinChuChangJiaGeSuiShiChaXunXXXX": "商品出厂价格随时查询，方便快捷",
    "ChangJiaLianXiFangShiQuanBuKaiFangXXXX": "厂家联系方式全部开放，轻松可得",
    "BaiWanShangPinKuZaiXianChaZhaoXXXX": "百万商品在线查找，协同线下专人服务",
    "ZhiChiDaoQuZhongYingEBaoJiaDanXXXX": "支持导取中英俄语言报价单，满足您所需",
    "GengDuoQuanYiLuXuKaiFangXXXX": "更多权益陆续开放，优先体验",
    "RenZhengTongGuoHouNinJiangHuoDe": "认证通过后您将获得",
    "KanGuoDeRenYeKan": "大家都在看",
    "YiTuZhaoXiangSiKuan": "以图找相似款",
    "GaiGongYingShangDeChanPinLeiBie": "该供应商的产品类别",
    "AnLeiBieChaZhaoChanPin": "按类别查找类似产品",
    "DaJiaDouZaiSou": "大家都在搜",
    "ChangJianZiXun": "常见咨询",
    "XunJiaJiLu": "询价记录",
    "ZanWuChangJianZiXun": "暂无常见咨询",
    "ZanWuXunJiaJiLu": "暂无询价记录",
    "YongHu": "用户",
    "XunJiaShiJian": "询价时间",
    "NGeChanPin": "{0}个产品",
    "ChaKanDuiBiShangPin": "查看对比商品",
    "ChaKanDuiBiJieGuo": "对比结果",
    "CanShuChongFu": "参数重复",
    "DuiBiShuJuYiJingDaDaoShangXian": "对比数据已经达到上限5个,请清除后在加入",
    "YiJiaRuDuiBi": "已加入对比",
    "YuGongChangTanJia": "与工厂谈价",
    "HeZuoNian": "合作{0}年",
    "GongChangZiZhi": "工厂资质",
    "XunJiaHuiFuLv": "询价回复率",
    "JiaRuDuiBi": "加入对比",
    "ChaKanPinPai": "查看品牌",
    "QiWangJiangJia": "期望降价",
    "JiangJiaHouJiaGe": "降价后价格",
    "KuanShiXuanZe": "款式",
    "BaoZhuangXinXi": "包装信息",
    "GaiBanXinXi": "改版信息",
    "CiKuanZhiChiGaiBan": "此款支持改版",
    "ZanWuDuiBiShangPin": "暂无对比商品",
    "GongChangZaiPingTaiZhanSh": "工厂在平台展示的价格低于其他渠道",
    "YiXiangKuaiChuChanPinJiMa": "一箱快出产品，即满足“MOQ=1”及“货期≤10天”的特定要求",
    "ReXiaoChanPin": "热销产品",
    "XunJiaHuiFuShiJian": "询价回复时间",
    "ShangPinChiCun": "商品尺寸",
    "PingTaiXinPin": "最新上架",
    "WoDeBianHao": "我的编号",
    "ZanWuGouWuZiXun": "暂无购物咨询",
    "GouWuZiXun": "购买咨询",
    "ChiCunBaoZhuang": "尺寸&包装",
    "XunJia": "加入询价",
    "QiDingLiang2": "起订量",
    "EYuZhuanQu": "俄文包装",
    "XiangYaoGengDiDeQingDianJ": "想要更低的MOQ，请点击【与工厂谈价】",
    "XiangYaoGengDiDeQingDianJ2": "最小起订量为{0}",
    "MeiYouZhangHao": "没有账号",
    "ZhuCeFuWuShangZhangHao": "注册贸易商账号",
    "EWenBaoZhuang": "俄文包装",
    "ChaKanGongSiZiZhi": "查看公司资质",
    "BoFangShiPin": "播放视频",
    "YiXiangQiDing": "一箱可订",
    "NTianFaHuoQi": "10天出货",
    "KuaiSuFaHuo": "快速配送",
    "MeiYueTuanGou": "每月团购",
    "RenZheng": "认证",
    "MeiYouZhaoDaoXXPiPeiNinKeYi": "没有找到“{0}”匹配的产品。您可以",
    "JianChaPinXie": "检查拼写",
    "ShiYongJiaoShaoDeGuanJianZi": "使用较少关键字",
    "ShiYongBuTongDeDeGuanJianZi": "使用不同关键字",
    "TianXieCaiGouXuQiu": "填写采购需求",
    "HuoZheGaoSuWoMenGengDuoXX": "或者告诉我们更多有关该产品的信息，24小时内获得报价或匹配供应商！",
    "MeiYouZhaoDaoPiPeiChanPinNinKeYi": "没有找到匹配的产品。您可以考虑",
    "ShiDangJianShaoShaiXuanTiaoJ": "适当减少筛选条件",
    "GengHuanQiTaGuanJianZi": "更换其他关键字",
    "FanHuiShangYiBu": "返回上一步",
    "MeiYouZhaoDaoPiPeiGongYingShangN": "没有找到匹配的供应商。您可以考虑",
    "BangNiZhaoYang": "帮你找样",
    "GongYingShangTuiJianShangPin": "供应商推荐商品",
    "WoDeZuJi": "我的足迹",
    "ChaKanSuoYouZuJi": "查看所有足迹",
    "MeiZhaoDaoXiangYaoDe": "没找到想要的",
    "HuoQuChanPinGongChangZiXu": "获取产品&工厂资讯",
    "GuanZhuWoMenSuiShiLeJieZu": "关注我们，随时了解最新产品，工厂信息和市场流行资讯",
    "JingZhunZhaoYang": "精准找样",
    "DengLuHouFaBuJingZhunZhao": "登录后发布精准找样信息，采购专家（5年+经验）为你找样",
    "FaBuZhaoYangXinXi": "发布找样信息",
    "AnLeiBieLiuLan": "按列表浏览",
    "PaiXu": "排序",
    "ZhaoDaoGeShangPin": "找到<b> {0} </b>个商品",
    "GeGongYingShangZhaoDao": "找到<b> {0} </b>个供应商",
    "TuiJianGongYingShang": "推荐供应商",
    "BaoJia": "报价",
    "GaoJiShaiXuan": "高级筛选",
    "GengDuoGuoLv": "更多过滤",
    "ShengYuNTian": "剩余{0}天",
    "XianHuo": "现货",
    "DiQuBuZhiChiZhiJieXiaDanJ": "<b>{0}</b>地区不支持直接下单交易，如要在 {1} 交货，请联系客服处理订单。",
    "XiTongJianCeDaoYouWeiWanC": "系统检测到有未完成拼柜，是否切换到： <a>{0}</a> 继续操作。",
    "DangQianKaiTongBaoQingGua": "当前开通包清关物流直达国家：{0}。",
    "KaiTongDiQuZhiChiXiaDanBa": "开通地区，支持下单包清关物流直送到目的地仓库，可以自提或者额外支付当地物流费用配送到指定目的地。",
    "WeiKaiTongDeGuoJiaHeDiQu": "未开通的国家和地区",
    "TiJiaoDingDanShiQingLianX": "提交订单时，请联系客服处理，在中国交货，或者能提供相对的物流。",
    "FaHuoDiQu": "发货地区",
    "JiaoHuoDiQu": "交货地区",
    "请选择城市": "请选择城市",
    "SuoXuanJiaoHuoDiQuBuZhiCh": "选择不到您的国家，请<a href=\"https://www.essa.cn\" rel=\"nofollow\">点击此处</a>或 咨询客服",
    "ZhongGuo": "中国",
    "ShipTo": "ship to",
    "XuanZeJiaoHuoDiQu": "选择交货地区",
    "BaoQingGuanWuLiuZhiSongXi": "包清关物流直送，详细？",
    "GengGaiJiaoHuoGuoJiaDiQu": "更改交货国家/地区",
    "GengHuanJiaoHuoGuoJiaDiQu": "更换交货国家/地区后，商品价格、配送方式及商品品类也会发生变化。",
    "JiaGeQueRenZhong": "工厂确认中",
    "JiaoHuoChengShi": "交货城市",
    "FanHuiDingBu": "返回顶部",
    "XianShiTeHui": "1箱闪购",
    "XiangShanGou": "限时特惠",
    "ZuiJinShangXin": "最近上新",
    "FaXianHaoHuo": "发现好货",
    "XianDaoXianDe": "先到先得",
    "PaiXingBang": "排行榜",
    "RenQiShangPin": "人气商品",
    "ReXiaoShangPin": "热销商品",
    "DangDiWangDian": "当地网点",
    "NiShangWeiSheZhiJiaoHuoDi": "你尚未设置交货地区。不同的交货国家/地区，商品价格、配送方式及商品品类也会发生变化。",
    "ChangJiaXianHuo": "厂家现货",
    "TuanGouYouHui": "团购优惠",
    "ZhuanXiangYouHuiHuoYuan": "专享优惠货源",
    "ZaiShouJiChaKan": "在手机查看",
    "QieHuanGuoJiaDiQu": "切换国家地区",
    "DingGouYuJiaoHuo": "订购与交货",
    "RuHeXiaDan": "如何下单",
    "FaHuoFangShi": "发货方式",
    "GenZongHuoWu": "跟踪货物",
    "GuanYuESSAONE": "关于ESSAONE",
    "FanHuiQuanBuShangPin": "返回全部商品",
    "PinJuCaoZuoZhiYunXuXiuGai": "拼柜操作只允许修改收货城市，如需要修改收货国家，请 {0} 修改交货地区后，再进行拼柜操作",
    "GuanZhuWoMen": "关注我们",
    "HuanYingLaiDaoESSAONE": "欢迎来到ESSA ONE",
    "DangQianJiaoHuoDiQuBuZhiC": "当前交货地区不支持拼柜操作或尚有未完成的拼柜，请返回购物车重新操作。",
    "QingXuanZeChengShi": "请选择城市",
    "ZhuCeTiaoJian2ONE": "《ESSAONE平台采购商注册及服务条款》",
    "DengLuXinLaiONE": "New To ESSAONE?",
    "ZhengDanCaiGou": "整柜采购",
    "NinYeKeYiZhuDongLianXiKeF": "您也可以联系客服人员快速完成认证",
    "SanDanCaiGou": "散单采购",
    "PinGuiXiuGaiShouHuoGuoJia": "您如果需要修改收货国家，请返回购物车页面进行修改",
    "FanHuiXiuGai": "返回修改",
    "ZhuCeESSAONE": "注册成为ESSAONE会员，您将可获得:",
    "ZhongGuoGCZhiCai": "中国工厂直采",
    "ZuiDiYiXiang": "最低一箱起订",
    "YouLiCaiGouJiaGe": "更有利的采购价格",
    "QingGuanPeiSong": "清关配送门到门",
    "Essaone_ShouYeGuanJianCi": "ESSAONE.CN,Toys & Gifts,Baby items,Hot sale,New,Toys Suppliers, China Factory",
    "Essaone_MetaMiaoshu": "ESSAONE is a China factory toys sourcing & trading platform covering with over 20,000 factories and including 1 million non-repetitive SKU.",
    "QieHuanBuTongDeGuoJiaDiQu": "切换不同的国家地区",
    "Essaone_ShouYeBiaoTi": "ESSAONE.CN-玩具和婴童用品在线采购，中国直采",
    "SuiShiZhiJieYiJia2": "随时跟工厂进行直接采购",
    "KeJiShiChaKanXinPin2": "可以及时查看到每天更新的<b>2000多款新品</b>",
    "ShouCiDengLuXuYaoXuanZeJiaoHuoDiQu": "首次登录需要选择交货地区.更换交货国家/地区后，商品价格、配送方式及商品品类也会发生变化",
    "NinKeYiZaiShouYeYouShangJiao": "您可以在首页右上角菜单或者个人中心更改",
    "ZyWenXinTiShiONE": "温馨提示：essaone目前提供精准找样服务，客户可将认知的商品通过找样发布服务获取到商品详细信息",
    "Essaone_WeiZhaoDaoShangPin": "ESSA暂时未找到您心爱的宝贝，请稍后…",
    "Essaone_YiJingZhaoDaoShangPin": "ESSA为您找到心爱的宝贝",
    "Essaone_KuaGuoCaiGouPingTai": "ESSAONE.CN 一个玩具跨国采购平台",
    "Essaone_DianJiChaKanGengDuoYouZhi": "点击查看更多优质商品 —essaone.cn，一个玩具跨国采购平台",
    "Essaone_ChengNuoBuHuiDuiWaiGongKaiXinXi": "开具正规收发票等票据，ESSAONE平台承诺不会对外公开信息，且遵守ESSA平台保密协议规定",
    "Essaone_ZhuCeTiaoJian2": "<Buyer registration on ESSAONE and terms of service>",
    "Essaone_PingTaiZhuCeJiFuWuTiaoKuan": "Buyer registration on ESSAONE and terms of service",
    "ShouHuoDiZhi": "收货地址",
    "ZiTiDianXinXi": "货物自提地点",
    "DaoHuoGangKouChengShi": "到货港口城市",
    "DingDanZongJiXinXi": "订单总计信息",
    "YouYiWenLianXiKeFu": "如有疑问，可联系客服",
    "XiaZaiHeTongFanBen": "下载合同范本",
    "FaSongFuKuanXinXiDaoShouJi": "发送付款信息到手机",
    "ChaKanDingDanLieBiao": "查看订单列表",
    "YinHangHuiKuan": "银行汇款",
    "QueRenFuKuanXinXi": "确认付款信息",
    "AnPaiShengChan": "安排生产",
    "GongNDan": "共{0}单",
    "RuCaiGouShangPinSheJi": "如采购商品涉及到以下功能，可以指定生产标准。如果不涉及到以下功能，可以忽略。",
    "QingGouXuanYaoXiaDanDeSha": "请勾选要下单的商品，点击【去下单】",
    "YiXiaShangPinGongChangYiQ": "以下商品工厂已确认",
    "QuXiaDan": "去下单",
    "ZhangJiaShangPin": "涨价商品",
    "PiLiangQueRen": "重新确认价格",
    "QueRenShengChanYaoQiuZhon": "确认生产要求中",
    "YiQueRenKeXiaDan": "可下单",
    "ChaKanKeXiaDanShangPin": "查看可下单商品",
    "ZiXun": "咨询",
    "PiLiangZiXun": "批量咨询",
    "YiRuShouZang": "移入收藏",
    "DangQianJiaoHuoGuoJiaBuZh": "当前交货国家不支持直接交易，请在页面头部切换切换国家后继续。如果要在当前国家地区收货，请联系客服处理。",
    "YiXuanKuanShangPinGongXia": "已选<b>{0}</b>款商品，共<b>{1}</b>箱，<b>{2}</b>PCS",
    "YiXiaShangPinJiaGeYuNinJi": "以下商品，价格与您加入购物车时有变化，请知悉。",
    "YiXiaShangPinJiaGeYiZhang": "以下商品价格已涨价",
    "CaiGouShangPinQingDan": "采购商品清单",
    "FanHuiGouWuCheXiuGai": "返回购物车修改",
    "ZongGongKuanShangPinZongJ": "总共{0}款 ({1} PCS) ,商品总价: {2}",
    "WenXinTiShiQieHuanBuTongD": "温馨提示：切换不同国家地区的收货地址，商品价格会有变化。部分国家未开通门到门服务，暂不支持直接下单。如有疑问请联系客服。",
    "GengDuoDiZhi": "更多地址",
    "MoRenDiZhi": "默认地址",
    "XinZengShouHuoDiZhi": "新增收货地址",
    "DingDanXinXiTongZhiRen": "订单信息通知人",
    "DingDanFaShengBianHuaYouY": "若订单发生变化, 或有异常信息等, 通知联系以下",
    "JieSuanYe": "结算页",
    "ShangPinBianHaoHuoMingCheng2": "商品编号或名称或工厂货号",
    "XinXiYiGuoQi": "信息已过期",
    "TianXieHeDuiDingDanXinXi": "填写核对订单信息",
    "SheWeiMoRenDiZhi": "设为默认地址",
    "QueRenZhong": "确认中",
    "ShouKGSi": "公司名称",
    "ShouKZHao": "收款账号",
    "ShouKDZi": "公司地址",
    "YHanMC": "开户行",
    "YHangHMa": "银行号码",
    "YHangDZ": "银行地址",
    "YHangDM": "银行固定对应账户",
    "ShuiWHao": "纳税人识别号",
    "DaiLZHao": "代理账号",
    "ShouHuoRenXinXiChuangJianShangXian": "收货人信息最多创建20个",
    "ShouDanDingJinJinXuN": "首单定金仅需{0}",
    "WuKeXiaDanShangPin": "无可下单商品",
    "GouWuCheNeiZanShiMeiYouSh2": "购物车内暂时没有商品，您可以去添加商品",
    "DangQianJiaoHuoGuoJiaXuYa": "当前交货国家需要补充以下信息，才能继续交易",
    "FuKuanTiXing": "付款提醒",
    "YouYuHuiLvBianDongPinFan": "1.在您尚未完成定金支付之前，您的订单总价可能会因为汇率变动而变动（支付更多或更少）。\n2.避免订单总价因汇率波动而变化，请您尽快支付定金。支付定金后代表您的订单已确认，订单总价不会再发生变化。\n3.如果您支付定金后出现订单总价因汇率变动而发生变化了，那么尾款会根据已付定金做相应改变（减少或增加）。\n4.我们将在收到您的定金后才开始处理您的订单。",
    "GongChangYuJiXiaoShiNeiQu": "工厂预计24小时内确认",
    "QueDingShanChuXunJiaShangPinOne": "重新确认所有选中的商品？",
    "XiangQingYeWuQuanXianTiShiOne": "该商品属于新品，需要进行账户认证才能查看详情，认证会在1-3个工作日内完成，请保持您的联系方式通讯正常，ESSAONE将尽快联系您进行认证审核。",
    "GuoQiShangPinQingJinKuaiPOne": "过期商品请重新确认再下单",
    "QingGouXuanXuYaoXiaDanDeS": "请勾选需要下单的商品",
    "GuoJiaChengShi": "国家城市",
    "QingTianJiaShouHuoDiZhi": "请添加收货地址",
    "BuZhou": "步骤",
    "BuZhou1": "步骤1",
    "XunJiaZhuangTaiOne": "确认状态",
    "NingDePODanOne": "我的订单",
    "NinYouZhangDingDanDaiZhiFOne": "您有{0}张订单待支付定金，为能正常提交至工厂生产，请尽快支付定金，有问题请联系您的客服",
    "HuiLvTiXing1": "在您尚未完成定金支付之前，您的订单总价可能会因为汇率变动而变动（支付更多或更少）",
    "HuiLvTiXing2": "避免订单总价因汇率波动而变化，请您尽快支付定金。支付定金后代表您的订单已确认，订单总价不会再发生变化",
    "HuiLvTiXing3": "如果您支付定金后出现订单总价因汇率变动而发生变化了，那么尾款会根据已付定金做相应改变（减少或增加）",
    "HuiLvTiXing4": "我们将在收到您的定金后才开始处理您的订单",
    "ZanWuQuanXian": "暂无权限",
    "NinDeZhangHaoZanShiMeiYou": "您的账号暂时没有浏览该工厂商品的权限，请联系工厂申请查看权限。",
    "YiGuoQi": "已过期",
    "SouSuoGuanJianZi": "搜索找样商品关键字",
    "KaiShiRiQi": "开始日期",
    "JieShuRiQi": "结束日期",
    "FaBuXinDeZhaoYang": "发布新的找样",
    "ZhaoYangXiangQing": "找样详情",
    "QuXiaoZhaoYang": "结束找样",
    "ShengYuShiJian": "剩余时间",
    "BuJieShouXiangSiKuanYangP": "不接受相似款样品反馈，如有质量较差的反馈，可以对样品反馈差评",
    "QueRenYaoQuXiaoZhaoYangQu": "确认要取消找样？取消后，此找样将不再收到工厂的反馈。",
    "ZhaoYangZhuTi": "找样任务名",
    "QingShuRuZhaoYangZhuTi": "请输入找样任务名",
    "QingShuRuZhaoYangZhuTiFan": "名字不影响实际效果，只方便您查找",
    "TiGongGongChangHuoHaoKeJi": "提供工厂货号可精准找样",
    "ZuiDiJia": "最低价",
    "ZuiGaoJia": "最高价",
    "ZhaoYangShuoMing": "找样说明",
    "MiaoShuXuYaoZhaoDeShangPi": "描述需要找的商品, 例如: 样子、功能、销售区域等",
    "ZhiJieShouGengJingZhunPiP": "「精准找样」希望反馈的商品与我的图片/货号完全一致",
    "XuTiGongTuPianHuoGongChan": "需提供图片或工厂货号，才会生效",
    "GaoSuGongChangNiXuYaoShen": "告诉工厂你需要什么",
    "ZhaoYangYouXiaoQiFaBuHouX": "找样有效期：发布后48小时",
    "XinXiYueJuTiNiDeDaoDeJieG": "填写信息项越多，你得到的结果就会越精准",
    "XuRenZhengCaiNengFaBuZhaoYang": "需认证才能发布找样",
    "XuDengLuCaiNengFaBuZhaoYang": "需登录才能发布找样",
    "GongChangTuiJian": "工厂推荐",
    "PingTaiYiYouYangPin": "平台已有样品",
    "GongChangXinZengYangPin": "工厂新增样品",
    "JiangGenJuSuoTiJiaoDeZhao": "essa.cn将根据所提交的找样需求自动匹配到最优工厂。一般1~2个工作日内会有结果，请留意相关反馈信息通知。",
    "ChaKanWoDeZhaoYang": "查看我的找样",
    "JiXuFaBuZhaoYang": "继续发布找样",
    "FanHuiHuiYuanZhongXinShou": "返回会员中心首页",
    "WeiXinGuanZhuGongZhongHao": "微信关注公众号:【宜采有货】",
    "ShiShiHuoQuFanKuiTongZhi": "实时获取反馈通知",
    "ShangPinSuoShuLeiMu": "商品所属类目",
    "QingXuanZeShangPinSuoShuL": "请选择商品所属类目",
    "YiBan": "一般",
    "Hao": "好",
    "FeiChangHao": "非常好",
    "ZhaoYangXuQiuPingFen": "找样需求评分",
    "FenShuYueGaoNiDeDaoDeFanK": "分数越高，你得到的反馈就越精准，太低分可能会导致反馈的样品太泛。",
    "KeDuoXuan": "可多选",
    "TianXieGengDuoXinXi": "填写更多信息",
    "MoHuZhaoYang": "模糊找样",
    "ShiYongFanYi": "使用Google翻译",
    "ZheiGeZhaoYangMeiYouZhaoY": "这个找样没有找样说明",
    "ZhuCeTianXieXinXiWeiWanZheng": "请填写注册信息再提交",
    "LiuXiaFanKui": "留下反馈",
    "RuGuoNinZaiShiYongPingTai": "如果您在使用ESSAONE平台时，有什么好或不好的地方，请告诉我们！我们会关注您的反馈，不断优化产品，为您提供更好的服务！",
    "HenManYi": "很满意",
    "FeiChangBuMan": "非常不满",
    "NinDuiPingTaiShouYeDeZhen": "您对 ESSAONE.CN平台首页的整体满意度如何？",
    "DuiNinDePeiHeHeZhiChiBiao": "对您的配合和支持表示衷心感谢！",
    "WeiLeJiNinTiGongGengHaoDe": "为了给您提供更好的服务，我们希望收集您使用ESSAONE平台时的看法或建议。",
    "YongHuTiYanFanKuiDiaoCha": "用户体验反馈调查",
    "DengLuHouCaiNengTiJiaoFan": "登录后才能提交反馈，是否现在去登录？",
    "RuGuoNinYouTeDingYiWenQin": "如果您有特定疑问，请联系 {0} 或访问我们的 {1}",
    "KeHuFuWuTuanDui": "ESSAONE客户服务团队",
    "KaiShiLiaoTian": "开始聊天",
    "XuanGou": "选购",
    "XuanGouLe": "选购了",
    "OneCartonFromChina": "从中国工厂一箱起订！首单定金仅需10%！",
    "FanHShouY": "返回ESSAONE首页",
    "GanXieFanK": "Thank you for your time. We appreciate your feedback.",
    "YiGuanZhu": "已关注",
    "GuanZhu": "关注",
    "GongChangShouYe": "工厂首页",
    "XinYong": "信用",
    "GongChangShangPinFenLei": "工厂商品分类",
    "ShangPinGuiGeCanShu": "商品规格参数",
    "ShouJiShangChaKanFenXiang": "手机上查看分享",
    "GongChangHuoYuan": "100%工厂货源",
    "ZhenShiKeKao": "对工厂实地认证，真实可靠",
    "DingJinKeTuiChengNuo": "定金可退承诺",
    "HeLiTuiDan": "合理退单，部份定金可退",
    "JiaoHuoShiXiaoBaoZhang": "交货时效保障",
    "DingDanQuanChengGenZong": "订单全程跟踪，延期交货必赔",
    "ZhiBaoTuiHuan": "15天质保退换",
    "TiGongWanShanDe": "提供完善的更换退货服务",
    "CongZhongGuoFaHuoJiaGeHan": "从中国发货，价格含清关、物流费用",
    "ZhongGuoFaHuo": "中国发货",
    "TongGuoHangYunDaoNiDeChen": "通过航运到你的城市",
    "TiGongSongHuoShangMenFuWu": "物流时间（生产时间{0}天，运输时间{1}天），不含货物在边境等待的时间",
    "WuLiu": "物流",
    "CanJiaJiaGe": "DDP参考价格",
    "JinGeYueYouRenXiHuan": "近{0}个月有 {1} 人喜欢",
    "ChuangJianZhangHao": "创建帐号",
    "QingShuRuNiDeDian": "请输入你的电子邮件作为帐号",
    "GongSiSuoZaiChengShi": "公司所在城市",
    "GongSiXiangXiDiZhi": "公司详细地址",
    "XiaoShouQuDaoone": "销售渠道",
    "Essaone_ZhuCeTiaoKuanPrefix": "创建账户的同时，我愿意遵守",
    "Essaone_ZhuCeTiaoKuan": "ESSAONE平台采购商注册及服务条款",
    "GongXiNiYiChengGongZhuCe": "恭喜你已成功注册！<br/>我们的客户经理将在工作日48小时内与您联系，帮助您寻找合适的产品和最好的折扣。",
    "NiDeZhangHao": "你的账号",
    "XianZaiQuGouWu": "现在去购物",
    "DiYiCiDingDanKeXiangShou": "第一次订单可享受",
    "HuoQuESSAONEGengDuoXinXi": "要获取有关ESSAONE的更多信息，请转到",
    "QingNinDengLuYouXiangJinXinYanZheng": "提交成功,请您登录邮箱进行验证",
    "YanZhengYouJianYiFaSongDaoYouXiang": "验证邮件已发送到邮箱",
    "QingDengLuYouXiangWanChengYanZheng": "请在24小时内登录并按邮件提示完成验证",
    "MeiShouDaoYouJian": "没收到邮件",
    "QingXianJianChaShiFouZaiLaJiXiangZhong": "请先检查是否在垃圾邮箱中",
    "RuGuoHaiWeiShouDao": "如果还未收到",
    "ChongXinFaSongYouJian": "重新发送邮件",
    "YiZhiShouBuDao": "一直收不到",
    "QingGengHuanQiTaYouXiang": "请更换其他邮箱",
    "XinYongHuZhuanShuLiPin": "Exclusive Gifts For New Users",
    "XinYongHuDeReMenXuanZe": "Hot Picks for new user",
    "GangGangJIaGou": "刚刚加购了该商品",
    "GangGangShouCang": "刚刚收藏了该商品",
    "GangGangGuanZhu": "刚刚关注了该品牌",
    "GongChangWeiWanShan": "工厂未完善",
    "GongXiNiYiChengGongZhuCe2": "恭喜你已成功注册",
    "DiYiCiDingDanKeXiangShouD": "第一次订单可享受<b>10%的定金</b>",
    "ZhongGuoZhiCai": "中国直采",
    "QuanBaoJia": "全包价",
    "MenDaoMen": "门到门",
    "JiaoYiBaoZhang": "交易保障",
    "BaoHu": "100%保护",
    "NinDeZhangHaoZanShiMeiYou2": "账号暂时没有权限，如有疑问请联系在线客服",
    "QingXuanZeXiaoShouQuDao": "请选择销售渠道",
    "QingShuRuYingYeZhiZhaoHao": "请输入营业执照号",
    "GaiLianXiDianHuaYiCunZai": "该联系电话已存在",
    "GeiNinZuiJingZhunDeTuiJian": "请选择您意向的采购商品分类，给您最精准的推荐",
    "QingShuRuChengSh": "请输入城市",
    "LingQuChengGong": "领取成功",
    "XinShouLuoDiYe": "新手专区",
    "JingZhunZhaoYangXuYaoTian": "精准找样需要添加商品图片或填写工厂货号",
    "QingShuRuDianZiYouXiangZu": "请输入电子邮箱作为您的账户",
    "QingShuRuShouJiHaoMaZuoWe": "请输入你的手机号码作为账号",
    "LiuDaoErShiGeZiFu": "6-20个字符",
    "ZhiNengBaoHanZiMuShuZi": "只能包含数字、字母以及标点符号",
    "ZiMuShuZiHeBiaoDianFuHaoZhiShao": "字母、数字和标点符号至少包含2种",
    "EssaOneZhiShao6GeZiFu": "密码设置不符合要求",
    "RuGuoNinSouBuDao": "如果您搜不到想要的商品，推荐您使用在线发布找样",
    "ZhiDaYuanChang": "直达原厂，精准寻源",
    "AnTiaoJianGuoLv": "按条件过滤，快速响应",
    "ShuBaiJiaZhiMingMaoYi": "数百家知名贸易公司都在用",
    "FaBuZhaoYangXuQiu": "发布找样需求",
    "XiTongZiDongPiPei": "系统自动匹配对应类目的工厂，短信微信通知工厂",
    "HeBeiCha": "喝杯茶，稍作等候",
    "GongChangZaiShouDaoXinXiHou": "工厂在收到信息后，最快30分钟内回复",
    "ChaKanFanKui": "查看反馈，完成需求",
    "TiaoXuanHeShiDeShangPin": "挑选合适的商品，选品并直接联系工厂",
    "NinTianDeXuanXiangYueDuo": "您填的选项越多, 得到的结果就会越精准",
    "ZhaoYang": "找样",
    "RuGuoNinSouBuDaoShangPin": "如果您搜不到想要的商品，推荐您使用在线发布找样",
    "YiCaiYouHuoJiangGenJuNinSuoTiJiaoDe": "ESSA将根据您所提交的找样需求自动匹配和触达最优工厂",
    "YiBan30FenZhongZuoYou": "一般30分钟左右，工厂会给到回复结果",
    "RangGongChangGeiNinHuiFu": "让工厂给您回复，最快30分钟有结果",
    "TuiJianRenShouJi": "推荐人手机号",
    "ShouJiHaoMaGeShiBuZhengQu": "手机号码格式不正确，请重新输入",
    "RuHeRangShiTu": "如何让识图找货更精准",
    "ShangChuanBeiJing": "上传背景简单的图片，建议为纯色背景",
    "XuanZeQingXiDuJiaoGao": "选择清晰度较高的图片",
    "ChangShiCaiJianTuPian": "尝试裁剪图片，尽量让图片的主体只有一个",
    "RuGuoFenBieYouDaiBaoZhuang": "如果分别有带包装和不带包装的图片，建议可以都尝试",
    "JiaRuGouWuChe2": "加入购物车",
    "HuoDongGuiZe1": "1、 活动期间，邀请者可通过生成个人专属优惠券代码，分享给好友。好友通过您的邀请在ESSAONE注册成为新用户并下单成功，即为成功邀请。",
    "HuoDongGuiZe2": "2、邀请的好友需要符合以下有效条件：",
    "HuoDongGuiZe201": "（1）从来没有在ESSAONE平台注册使用并下单成功的新用户，用户提交订单并支付定金才视为下单成功。",
    "HuoDongGuiZe202": "（2）好友只有通过您的邀请链接注册或在注册页面填写您分享的优惠券代码才能生效。",
    "HuoDongGuiZe3": "3、活动期间，邀请者每成功邀请1人，即可获得5000卢币奖金。邀请不限人数，奖金不设上限。",
    "HuoDongGuiZe4": "4、奖金由平台ESSAONE提供，奖金将于好友下单成功当天算起3个工作日内发放到您的账户。",
    "HuoDongGuiZe5": "5、邀请者可以登录essaone.cn，通过会员中心“邀请好友”查看您所邀请的好友及奖金信息。",
    "HuoDongGuiZe6": "6、本次活动最终解释权在法律允许范围内归本平台所有。",
    "YaoQingDeJiangLi": "邀请好友得现金奖励",
    "YaoQingFanLi": "邀请好友",
    "YaoQingMingXi": "邀请明细",
    "FuZhiChengGong": "复制成功",
    "WoDeYaoQing": "我的邀请",
    "ChaKanMingXi": "查看明细",
    "JiangLiZongJinE": "奖励总金额",
    "YaoQingZongRenShu": "邀请总人数",
    "XiaDanRenShu": "下单人数",
    "ShengChengZhuanShuTuiJianMa": "生成专属优惠券代码",
    "FenXiangTuiJianMaG": "分享优惠券代码给好友",
    "HaoYouZhuCeBingXD": "好友注册并下单",
    "HuoDeJiangJin": "获得奖金",
    "WoDeYaoQingLianJie": "我的邀请链接",
    "DianJiFuZhi": "点击复制",
    "WoKeHuoDe": "我可获得",
    "ShouDanChengJiaoKeDe": "首单成交可得",
    "HaoYouKeHuoDe": "好友可获得",
    "ShouDanDingJinYouHuiQ": "首单定金优惠券",
    "WoDeXianJinJiangLi": "我的现金奖励",
    "ZhangHuBianHao": "账户编号",
    "HaoYouYouXiang": "好友邮箱",
    "HaoYouDianHua": "好友电话",
    "DiYiCiXiaDanSJ": "第一次下单时间",
    "JiaGeBaoHuQiShengYuNTian1": "商品价格工厂已确认，但会受汇率的波动发生变化",
    "GaiShangPinYiGuoJiaGeBaoH1": "该商品价格已过期，如需下单请重新确认",
    "GaiShangPinYiGuoJiaGeBaoHuNC1": "该商品价格已过期，如需下单请重新确认",
    "QingXuanShuRuFOBFeiYong": "请输入FOB费用",
    "QingXuanZeBiZhong": "请选择币种",
    "QingShuRuHuiLv": "请输入汇率",
    "QingXuanZeHuoGuiLeiXing": "请选择货柜类型",
    "QingXuanShuRuTiJi": "请选输入体积",
    "ShangChuanLogo": "报价单LOGO",
    "GongSiLogoJianYi": "公司logo建议尺寸80x80",
    "FOBFeiYong": "FOB费用",
    "JiaJiaLv": "加价率",
    "FanYi": "翻译",
    "YiWen": "译文",
    "MeiYuanDuiHuanRenMinBi": "美元兑换人民币汇率",
    "HuoQiESSAONE": "交货时间",
    "FanYiXiaoGongJuJiangGongC": "翻译小工具，将工厂圈内容翻译为",
    "XuanZeYuYan": "选择语言",
    "ZuiJinShiYong": "最近使用",
    "ZhiYunXuPingLunYiCi": "只允许评论一次",
    "QingShuRuPingLunNeiRong": "请输入评论内容",
    "ShanChuPingLun": "删除评论",
    "YiPingLun": "已评论",
    "PingLun": "评论",
    "YiZan": "已赞",
    "Zan": "赞",
    "KuanChanPin": "{0}款产品",
    "ChaKanShangPinXiangQing": "查看商品详情",
    "GuanZhuChengGong": "关注成功",
    "YiQuXiaoGuanZhu": "已取消关注",
    "NinHaiMeiYouGuanZhuGongChang": "您还没有关注工厂，请先关注至少一个工厂",
    "YouZhiGongChangTuiJian": "优质工厂推荐",
    "GuanZhuChaKan": "关注查看商品更新动态",
    "GuanZhuQuanBuTuiJian": "关注全部推荐",
    "GuanZhuGongChangZuiXinDongTai": "关注工厂最新动态",
    "NinGuanZhuDePinPaiZanWuDongTai": "您关注的品牌暂无动态,关注更多品牌",
    "GuanZhuGengDuoGongChangPinPai": "关注更多工厂品牌",
    "GongChangShangXinKuan": "工厂上新{0}款",
    "GongChangJiangJiaKuan": "工厂降价{0}款",
    "GongChangXinZengShiPinKuan": "工厂新增视频{0}款",
    "ChaKanShangXin": "查看上新",
    "ChaKanJiangJia": "查看降价",
    "ChaKanShiPin": "查看视频",
    "QuXiaoGuanZhu": "取消关注",
    "BenCiShangXinKuan": "本次上新{0}款",
    "BenCiJiangJiaKuan": "本次降价{0}款",
    "BenCiGengXinShiPinKuan": "本次更新视频{0}款",
    "TuiJianGongChang": "推荐工厂",
    "ZuiJinShangXinKuan": "最近上新{0}款",
    "LiuLanGengDuoGongChang": "浏览更多工厂",
    "XuanZeBaoJiaFangShi": "选择报价方式",
    "XuanZeBaoJiaMoBan": "选择报价模板",
    "ZuiJinGengXin": "最近更新",
    "ShiPinQuan": "小视频",
    "GongChangQuan": "工厂圈",
    "JuLiKaiBoHaiYou": "距离开播还有",
    "Fen": "分",
    "Miao": "秒",
    "ZhiBoShangPin": "直播商品",
    "HuiFang": "回放",
    "ZhiBo": "直播",
    "ZhaoBuDaoGaiShiPin": "找不到该视频",
    "ZhiBoHuiFang": "直播回放",
    "ZhiBoZhong": "直播中",
    "KanHuiFang": "看回放",
    "JiJiangKaiShi": "即将开始",
    "Shi2": "时",
    "LiJiLingQu": "立即领取",
    "ShouDan3ZheKou": "获赠₽35000优惠券礼包",
    "ZhiXianYuXinKeHu": "只限于新客户",
    "DeDaoYouHuiQuan": "领取优惠券",
    "LaXinGuiZe1": "<p>1. 只有已在ESSAONE注册但未下第一笔订单的买家才能享受此优惠。</p>\n<p>2. 每位新用户只能领取一次优惠券礼包。</p>",
    "LaXinGuiZe2": "<p>3. 新人优惠券礼包包含4张优惠券，分2次赠送：注册完成即可获得2张优惠券；首单支付定金后再得2张优惠券。</p>\n<p>4. 所有优惠券均不能叠加使用，每笔订单仅限使用一张优惠券。下单时系统会根据当前你可使用的优惠券，默认使用优惠额度最大的一张；或者你有权选择使用其他优惠券。</p>",
    "LaXinGuiZe3": "<p>5. 订单使用优惠券后产生取消，如果是享受优惠的商品全部取消，系统自动返还相应的优惠券。但如果只是部份取消，部分享受了优惠，则优惠券不作返还。</p>\n<p>6. 新用户首单享受定金预付10%特权，但仅对第一笔订单有效。</p>",
    "XinYongHuTeBieCuXiao": "New Buyer Promotion",
    "ZhiDiYiGeDingDan": "Just for the first order",
    "EssaBanQuan": "ESSAONE reserves all rights",
    "YXV0b19tYXJrZXRpbmdfZW1haWw=": "商品推荐/商品优惠",
    "YXV0b19tYXJrZXRpbmdfZW1haWw=_remark": "定期给您推荐新品、热销商品及有优惠的商品时发送的邮件",
    "cmVndWxhcl9tYXJrZXRpbmdfZW1haWw=": "网站最新动态/促销活动通知",
    "cmVndWxhcl9tYXJrZXRpbmdfZW1haWw=_remark": "不定期给您通知网站最新资讯、功能动态及近期举办的促销活动时发送的邮件",
    "Y29uX2NvbnRhaW5lcl9sb2FkX2RvbmVfZW1haWw=": "装柜完成",
    "Y29uX2NvbnRhaW5lcl9sb2FkX2RvbmVfZW1haWw=_remark": "订单商品装柜完成时发送的邮件",
    "Y29uX2NvbnRhaW5lcl9iYWxhbmNlX2VtYWls": "尾款支付提醒",
    "Y29uX2NvbnRhaW5lcl9iYWxhbmNlX2VtYWls_remark": "订单即将到港前提醒支付订单尾款时发送的邮件",
    "b2xkX2J1eWVyX3JlY29tbWVuZF9lbWFpbA==": "订单完成",
    "b2xkX2J1eWVyX3JlY29tbWVuZF9lbWFpbA==_remark": "订单已成功交货后发送的邮件",
    "c3BsaXR0aW5nX25vdGljZV9lbWFpbA==": "订单商品货期变化通知",
    "c3BsaXR0aW5nX25vdGljZV9lbWFpbA==_remark": "订单商品货期变化拆分订单发货时发送的邮件",
    "GengDuoLianXiXinXi": "更多联系信息",
    "GongSiGuHua": "公司固话",
    "TianJiaShangPinZhiXuanYan": "添加商品至选品池，查看联系方式",
    "YiJianJiaRuXuanYangChiCha": "一键加入【选品】，生成报价单给客户做精准推广",
    "HuoQuBuDaoZhangHaoZiJinDeSuo": "获取不到账号资金的锁",
    "WeiSheZhiZhiFuMiMa": "你尚未设置支付密码，将无法使用资金支付订单，请先设置支付密码",
    "ZhiFuMiMaBuZhengQue": "支付密码不正确",
    "ChaXunBuDaoZhangHaoZiJinXinxi": "查不到账号资金信息",
    "ZhangHaoZiJinBuZu": "账号可用资金不足",
    "JiuZhiFuMiMaBuZhengQue": "旧支付密码不正确",
    "PoDanYiZhiFuQinWuChongFuZhiFu": "PO单已支付请勿重复支付",
    "WoDeZiJin": "我的资金",
    "MingXi": "明细",
    "QuHuiKuan": "去汇款",
    "DaiFuKuan": "待支付",
    "ShenMeShiESSAONE": "什么是ESSAONE定金模式",
    "AnDingDanJinE": "按订单金额收取定金比例",
    "NianChuHuoJinE": "{0}年出货金额",
    "XinYongHuShouCiXiaDan": "新用户首次下单，定金比例为10%！",
    "DingDanEDuBuChaoGuo": "没有订单额度限制",
    "TiJiaoDingDanHouQingJiShi": "提交订单后请及时支付定金。平台收到定金后，订单才算正式确认并生效。",
    "XuYaoSheZhiZhiFu": "需要设置支付密码才能使用资金支付",
    "SheZhiZhiFuMiMa": "设置支付密码",
    "XiuGaiZhiFuMiMa": "修改支付密码",
    "ZhaoHuiZhiFuMiMa": "找回支付密码",
    "ShiYongGuiZe": "使用规则",
    "ZiJinMingXi": "资金明细",
    "GuanYuZhiFuZhangHu": "关于支付账户",
    "RuHeHuiKuanChongZhi": "如何汇款充值",
    "RuHeZhiFuDingJin": "如何支付定金",
    "RuHeZhiFuWeiKuan": "如何支付尾款",
    "ShenMeShiZhiFu": "什么是支付账户？",
    "ZheShiYongHuZaiESSAONE": "这是用户在ESSAONE平台上进行订单交易的时候存款、扣款、退款账户，通过支付账户可实现订单在线支付，方便快捷。凡是在ESSAONE平台上成功注册的用户，均拥有一个支付账户。",
    "ZhangHuDeGongNeng": "账户的功能",
    "MuQianZhangHuZhiChi": "目前账户支持汇款充值、订单支付、取消退款. 您所有的汇款、订单退款都会进入到您的支付账户中.",
    "HuiKuanChongZhi": "汇款充值: 将银行卡的资金汇款至ESSAONE平台在当地的指定银行, 即为充值到您在ESSAONE的支付账户. 向平台汇款成功后, 资金将在2个工作日内才显示到账.",
    "DingDanZhiFu": "订单支付：可以使用账户上的资金向平台支付订单定金和尾款。",
    "QuXiaoTuiKuan": "取消退款：订单取消后产生退款将直接退回您的支付账户。",
    "ZhiFuLiuCheng": "支付流程",
    "ZhangHuZhiFuShiYongHu": "账户支付是用户先通过银行汇款将资金寄存在ESSAONE平台上。当支付账户显示有可用资金时，用户可以自由分配账户上资金去支付订单货款。",
    "ZhangHuDeShiYongGuiZe": "账户的使用规则",
    "WeiLeQueBaoYongHuZiJin": "为了确保用户资金的使用安全，启用前用户必须先设置资金支付密码。否则将无法使用支付账户。而且每次支付，都需要用户输入支付密码确认交易。",
    "DangNinShiYongZhangHu": "当您使用账户资金进行支付定金/尾款时，请您务必确认清楚。一旦支付成功，资金将无法退还。",
    "YongHuZhiFuZhangHuBuShe": "用户支付账户不设限额。用户可以通过“我的资金”查看当前资金账户的金额，汇款充值记录，使用资金明细等信息。",
    "RuoDuiZiJinShiYong": "若对资金使用或记录信息有疑问，请联系在线客服处理。",
    "DangNinDeZhangHuMeiYou": "当您的账户没有可用资金或可用资金不足时，您需要通过银行汇款充值，使您的账户有可用资金。具体操作请遵循以下步骤",
    "QingAnZhaoYiXia": "请按照以下信息进行汇款，并在汇款时填写备注您的平台ID:",
    "HuiKuanHou": "汇款后，ESSAONE将在2个工作日内确认到款情况。",
    "XianShiDaoZhangJinE": "【我的资金】显示到账金额",
    "QueRenDaoKuanHou": "确认到款后，用户将在“我的资金”查看自己汇款的到账记录金额",
    "NinXuYaoXianJianCha": "您需要先检查您的支付账户是否有足够的可用资金。",
    "ZhiYouDangNinDeZhiFu": "只有当您的支付账户有足够的可用资金时，您才能使用账户上的可用资金去支付订单的定金。以下为支付定金的3种途径",
    "DangNiChengGongTiJiao": "当你成功提交订单后，直接点击页面{0}按钮。",
    "QuZhiFuDingJin": "去支付定金",
    "XuanZeYaoZhiFu": "进入{0}选择要支付定金的订单，点击{1}按钮。",
    "QuZhiFu": "去支付",
    "DaiZhiFuMingXi": "待支付明细",
    "DangNinDeDingDanYiDao": "当您的订单已到达目的地，您需要先把订单尾款支付完毕才能提取货物。",
    "TongYangZhiYouDang": "同样，只有当您的支付账户有足够的可用资金时，您才能使用账户上的可用资金去支付订单的尾款。以下为支付尾款的2种途径：",
    "ZhiFuWeiKuanDe": "进入{0}选择要支付尾款的订单，点击{1}按钮。",
    "ZhiFuZhangHuDeShiYong": "支付账户的使用指南",
    "DanJuHao": "单据号",
    "ShouRu": "收入",
    "JinNTian": "近{0}天",
    "QuanBuJiaoYiLeiXing": "全部交易类型",
    "DaiZhiFuJinE": "待支付金额",
    "ZuiChiFuKuanShiJian": "最迟付款时间",
    "FanShiZaiESSAONEPingTai": "凡是在ESSAONE平台上成功注册的用户，均拥有一个资金账户。目前支持汇款充值、订单支付、取消退款功能。",
    "HuiKuanChongZhi2": "汇款充值：将银行卡的资金汇款至ESSAONE平台在当地的指定银行，即为充值到您在ESSAONE的资金账户。向平台汇款成功后，资金将在2个工作日内才显示到账。",
    "DingDanZhiFu2": "订单支付：可以使用资金向平台支付订单定金和尾款。",
    "QuXiaoTuiKuan2": "取消退款：订单取消后产生退款将直接退回资金账户。",
    "WeiLeQueBaoYongHuZiJin2": "为了确保用户资金的使用安全，启用前用户必须先设置资金支付密码。否则将无法使用资金支付。",
    "YongHuZiJinZhangHuBuSheXianE": "用户资金账户不设限额。用户可以通过“我的资金”查看当前资金账户的金额，汇款充值记录，使用资金明细等信息。",
    "ZhiFuMiMa": "支付密码",
    "ZhiFuMiMaWei6WeiShuZi": "支付密码为6位数字",
    "QueRenZhiFuMiMa": "确认支付密码",
    "ShuRuZhiFuMiMaQueRenZhiFu": "输入支付密码，确认支付",
    "QingXianShuRuYuanZhiFuMiMaYiYanZhengShenFen": "请先输入原支付密码以验证身份，新支付密码设置成功后立即生效",
    "WoDeDianZiYouXiang": "我的电子邮箱",
    "JiuZhiFuMiMa": "旧支付密码",
    "HeJiDaiZhiFu": "合计待支付",
    "ZhangHaoZiJinChongZu": "账号资金充足",
    "BuZuYiZhiFu": "不足以支付",
    "DingDanYiShengXiaoZanBuZhiChiQuXiao": "订单已生效，暂不支持取消",
    "WoZaiXiangXiang": "我再想想",
    "QingXuanZeQuXiaoYuanYin": "请选择取消原因",
    "QuXiaoShangPin": "取消商品",
    "QueRenQuXiaoHouGaiDingDanDuiYing": "确认取消后该订单对应的总金额及应付定金将发生变化。",
    "DingDanYiChaiFenBenDingDanJinE": "订单已拆分，本订单金额",
    "BenDingDanJinE": "本订单金额",
    "DingDanZhengZaiJiaZaiZhong": "订单正在加载中...",
    "ZhanShiGengDuo": "展示更多",
    "ShouQiGengDuo": "收起更多",
    "ZiDingDan": "子订单",
    "BenDingDanDeGeZiDingDanYiDaoHuo": "当前有{0}个订单即将到港，请支付尾款。同时您也可以把其他订单的尾款一起支付。",
    "YiXiaDingDanYuJiDaoGang": "以下订单预计<i>{0}</i>到港，合计尾款：{1}",
    "ZhiFu": "支付",
    "DingJin": "定金",
    "GeXingYaoQiu": "个性要求",
    "YiQuXiaoShangPin": "已取消商品",
    "BenChaiFenDingDanShangPinQingDan": "本拆分订单商品清单",
    "ZongGongKuanXiangShangPinZongJia": "总共{0}款，{1}箱 ,商品总价: {2}",
    "QueRenQuXiaoHouWuFaHuiFu": "确认取消后无法恢复",
    "QuXiaoDingDan": "取消订单",
    "ZaiCiCaiGou": "再次采购",
    "ChaKanZongDingDan": "查看总订单",
    "ZuiJinNTian": "最近{0}天",
    "ZuiJinNNian": "最近{0}年",
    "DingDanZhengZaiChuLiZhongQing": "订单正在处理中，请稍后查看",
    "YouYuShangPinDeHuoQiBuTong": "由于商品的货期不同，为了让您尽快收到货，我们将该订单拆分为{0}个子订单，分开发货。",
    "DaiZhiFuTiHuo": "待支付提货",
    "YouDingDanDaiZhiFuTiHuo": "有订单待支付提货",
    "QingJinKuaiZhiFuYiMianYingXiangTiHuo": "请尽快支付，以免影响提货",
    "YouYuWeiShouDaoDingJinDingDanHaiWuFa": "由于未收到定金，订单还无法向工厂下单，导致订单预装柜日期推迟至<i>{0}</i> （原{1}），请尽快支付定金（定金以到账时间为准）",
    "JinXingZhong": "进行中",
    "DaiZhiFuWeiKuan": "待支付尾款",
    "YiWanCheng": "已完成",
    "DingJinDaiZhiFu": "定金待支付！",
    "DingDanYouYiChangXuChuLi": "订单有异常需处理",
    "BenDingDanShuYuChaiFenDingDanDeYiXiang": "如果该订单为被拆分的子订单，支付时需同时支付其他关联的子订单的定金。",
    "QingJinKuaiFuKuan": "请尽快付款，以免影响你提货。",
    "DingJinJiaoYiMoShi": "定金交易模式，就是买家下订单，需要先支付一定比例的钱给平台作为订单担保，平台收到买家定金后再安排订单生产。等到买家收货前再支付尾款就可以了。一般原则，预付定金不接受无理由退还，除非因平台或工厂原因导致您的订单无法正常进行，我们才将定金100%退还给您。",
    "ZheShiZhiYongHuJiCun": "这是指用户寄存在ESSAONE平台上，可供用户支配的资金。目前支持汇款充值、订单支付功能，所有收到的汇款、订单退款都会进入到资金账户",
    "yanZhengMaBuNengWeiKong": "验证码不能为空",
    "QingXianSheZhiZhiFuMiMa": "请先设置支付密码",
    "ZhiFuMiMaYuQueRenZhiFuMiMaBuYiZhi": "支付密码与确认支付密码不一致",
    "QueRenZhiFuMiMaBuNengWeiKong": "确认支付密码不能为空",
    "ZhiFuMiMaBuNengWeiKong": "支付密码不能为空",
    "JiuMiMaBuNengWeiKong": "旧密码不能为空",
    "JiuMiMaBuZhengQue": "旧密码不正确",
    "BenDingDanBaoHanNGeZiDingDanDingJin": "本订单包含{0}个子订单，定金不可分开支付",
    "ShangPinYiJingChongXinTianJiaDaoGouWuChe": "商品已经重新添加到购物车",
    "ZhaoXiangSi": "找相似",
    "ZaiCiJiaRuGouWuChe": "再次加入购物车",
    "QuXiaoShuoMing": "取消说明",
    "ShangPinShengChanZhongChuXianYiChang2": "商品生产中出现异常",
    "ZhiFuMiMaSheZhi": "支付密码设置",
    "SheZhiNinDeZhiFuMiMaBaoZhangZiJinAnQuan": "设置您的支付密码保障资金安全。当使用可用资金进行支付时，需要验证此支付密码。",
    "QingNinZaiNTianNeiJiShiZhiFuDingJin": "请您在<i>{0}天</i>内及时支付定金",
    "DangNinDeDingDanTiJiaoWanGongHouWoMen": "1、当您的订单提交完功后，我们会联系您并与您签订采购合同。",
    "TiJiaoHouNinDeDingDanJiaGeJiangShouDaoJiaGeBaoHuYu": "2、提交后，您的订单价格将受到价格保护，为期{0}天。保护期内，订单价格不会发生变化。逾期该订单的价格保护将失效，订单以实际最终变化后的价格为准。",
    "WoMenJiangZaiShouDaoNinDeDingJinHouCaiKaiShiChuLiNinDeDingDan": "4、我们将在收到您的定金后才开始处理您的订单。",
    "JiaoYiBiZhongYuZhangHaoZiJinBiZhongBuYiZhi": "交易币种与账户资金不一致",
    "QingJinKuaiZhiFuDingJinYuJiDao": "请尽快支付定金，避免订单价格超出价格保护期会发生变化。",
    "BenDingDanDeGeZiDingDanYiDaoHuo2": "当前有{0}个订单即将到港，请于提货前支付尾款。",
    "DaoESSAPingTai": "汇款到ESSAONE平台",
    "DangQianNinDeZhangHuYouZuGouDeKeYongZiJin": "当前您的账户有足够的可用资金，直接点击支付即可使用账户上的可用资金去支付该订单的定金。定金支付完毕，订单立即确认生效，安排生产。",
    "DangQianNinDeZhangHuMeiYouZuGouDeKeYongZiJin": "当前您的账户可用资金不足，您需要汇款到您的账户来进行支付",
    "XinZhiFuMiMa": "新支付密码",
    "LianXiGongChangKaiFang": "联系工厂开放权限",
    "DaiChuLiYiChangLieBiao": "待处理异常列表",
    "WeiBiMianDingDanJinDu": "为避免影响订单进度，请尽快处理异常",
    "JieShouBianDong": "接受变动",
    "QuanBuJieShouBianDong": "全部接受变动要求",
    "TiJiaoChuLi": "提交处理",
    "BenCiZhiFuHeJi": "本次支付合计",
    "FanHuiDingDanLieBiao": "返回订单列表",
    "GongNDanDanYouYiChangDaiChuLi": "（共{0}单, <i>{1}</i>单有异常待处理）",
    "QingWuChongFuTiJiao": "请勿重复提交",
    "DingJinMoShi": "定金模式",
    "AnQuan": "安全",
    "ShangPinYiTingShou": "商品已停售",
    "ShangPinYiTingShou1": "对不起，商品已停售",
    "HenYiHanYouKuanShangPinYi": "很遗憾，有{0}款商品已停售，剩余{1}款商品已添加到购物车。",
    "DaoChuShuJu": "导出数据",
    "ZhangHaoZiJinBuZu1": "账户资金不足",
    "TongJi": "统计",
    "c3VibWl0X3BvX2RlcG9zaXRfZGRwX3NwbGl0": "订单提交成功",
    "c3VibWl0X3BvX2RlcG9zaXRfZGRwX3NwbGl0_remark": "订单提交完成时发送的邮件",
    "ZGRwX2RlcG9zaXRfb3ZlcmR1ZQ==": "定金逾期提醒",
    "ZGRwX2RlcG9zaXRfb3ZlcmR1ZQ==_remark": "订单定金已超过约定时间未支付时发送的邮件",
    "cG9fcGF5X2RlcG9zaXRfZGRw": "订单确认生效",
    "ZGRwX3BvX2NhbmNlbA==_remark": "订单超时未支付定金而失效时发送的邮件",
    "cG9fcGF5X2RlcG9zaXRfZGRw_remark": "订单定金支付成功后确认生效时发送的邮件",
    "ZGRwX3BvX2NhbmNlbA==": "订单失效",
    "GaiShangPingBuYunXuJiaGou": "此商品暂无权限加购",
    "QingShuRu6WeiShuZiDeZhiFuMiMa": "请输入6位数字的支付密码",
    "1006ARG1000000": "很抱歉，页面出问题了！",
    "WeiKuan": "尾款",
    "TuPianChaoGuo4M": "很抱歉，您上传的图片大小已超过了限制（<4M），请调整后再上传！",
    "QingXuanZeNinDingDanDeFaHuoFangShi": "请选择您订单的发货方式",
    "ChaiDanTiShi": "拆单提示",
    "DingDanChaiFenFaHuo": "订单拆分发货",
    "WoMenJiangGenJuNiDingDanZhongBuTong": "我们将根据你订单中不同商品的货期进行订单拆分，先后安排分批发货，到货后需分批提取，目的让您尽快收到货物。",
    "BenCiDingDanGenJuShangPinHuoQi": "本次订单根据商品货期，可拆分为{0}个子订单，分别发货",
    "DingDanGongNKuanYuJiDaoGangShiJi": "订单{0}，共{1}款，{2}㎡，<i>预计到达时间：{3}</i>",
    "DingDanTongYiFaHuo": "订单统一发货",
    "DingDanBuChaiFenDengDingDanZhongSuo": "订单不拆分，等订单中所有商品都生产完毕后，统一安排发运，方便统一收货。",
    "JiaGeBaoHuQiShengYuNTian2": "商品价格保护还剩 {0} 天，期间价格不会改变。",
    "bG9hZF9jb250YWluZXJfZG9uZV9lbWFpbA2==": "整单已完成",
    "MeiZhouTeHui": "每周特惠",
    "RuGuoChaoGuoNTian": "3、如果超过{0}天未支付定金，该订单将失效，平台会自动取消该订单。",
    "DingYue": "订阅",
    "RenQi": "人气",
    "KuanShi": "款式",
    "ChuangXinJingXuan": "创新精选",
    "ReXiaoPaiHangBang": "热销排行",
    "QuanBuXinPin": "全部新品",
    "YiXiangKeMai": "一箱可买，10天出货，不要错过！",
    "YXV0b19tYXJrZXRpbmdfZW1haWw1": "商品推荐/商品优惠/活动信息",
    "QueDingTiJiao": "确定提交",
    "NinQueDingYaoTuiDing": "您确定要退订邮件吗?",
    "WoBuXiangZaiJieShou": "我不想再接收{0}的邮件通知，谢谢",
    "TeHuiShangPin": "特惠商品",
    "YouXiangDingYueZuiXin": "填写邮箱订阅新品趋势信息",
    "Zhe": "折",
    "ManShiYong": "满{0}使用",
    "LingQu": "领取",
    "YiLingQu": "已领取",
    "XiangXi": "详细",
    "LiJiChaKan": "立即查看",
    "GongXiHuoDeYouHuiQuan": "恭喜获得优惠券",
    "YiJiangLi": "已奖励",
    "WeiJiangLi": "未奖励",
    "ZhiDaoLe": "知道了",
    "DingDanManKeYongZuiDuoZheKou": "满{0}可用，最高优惠{1}",
    "DingDanManKeYongZheKouJinEBuXian": "满{0}可用，上不封顶",
    "ManKeYong": "满{0}可用",
    "ZengSongNiYouHuiQuanKeYongYuXiaCiXiaoFei": "赠送你优惠券，可用于下次消费",
    "GaiPinPaiQuanBu": "该品牌全部商品适用",
    "YaoQingYouLi": "邀请有礼",
    "MeiYaoQing1WeiHaoYouZhuCeJiKeHuo": "每邀请1位好友注册即可获得1级奖励。好友完成首单，继续获得现金礼券。而被您邀请的好友注册也可获得最高优惠₽20000的新人专享大礼包。",
    "YaoQingJiangLi": "邀请奖励",
    "ZhiJieDianJiNinYaoFenXiangDeSheJiaoMeiTi": "分享一：直接点击您要分享的社交媒体",
    "FuZhiLianJieFaSongHaoYou": "分享二：复制链接发送好友",
    "FaXianYiGeHaoWangZhanessaone": "发现一个好网站essaone，从中国批发，1箱起订！邀请你来注册，点击链接注册即可领取新人优惠{0}",
    "FenXiangHuoDongGeiHaoYou": "分享活动给好友",
    "HaoYouZhuCeWanChengShouDan": "好友注册得一级奖励",
    "JiangLiLiQuanDaoZhang": "好友下单得二级奖励",
    "WoDeJiangLi": "我的奖励",
    "ChaKanWoDeYouHuiQuan": "查看我的优惠券",
    "ZhuCeJiangLi": "注册奖励",
    "XiaDanJiangLi": "下单奖励",
    "WoDeYouHuiQuan": "我的优惠券",
    "YaoQingJiLu": "邀请记录",
    "YouHui2": "已优惠",
    "XinRenYouHuiQuan": "新人优惠券",
    "LiJiShiYong": "立即使用",
    "BaoHanShuiFei": "包含增值税费",
    "DaoChuDingDanShangPin": "导出订单商品",
    "PODanDaoChu": "PO单导出",
    "BaoHanDingDanShangPinXiangQingXinXi": "包含订单商品详情信息",
    "DaoChuShangPinTuPian": "导出商品图片",
    "JinBaoHanDingDanDeShangPinTuPian": "仅包含订单的商品图片",
    "NZengZhiShuiE": "{0}%增值税额",
    "WeiShiYongYouHuiQuan2": "可使用优惠券",
    "ZanWuWeiShiYongYouHuiQuan2": "暂无可使用优惠券",
    "XinDaoZhang": "新到账",
    "JiJiangGuoQi": "即将过期",
    "GuiZeShuoMing": "规则说明",
    "YouHuiQuanLieBiaoShuoMin11": "优惠券基本使用说明",
    "YouHuiQuanLieBiaoShuoMin12": "1. ESSAONE平台会不定期推出优惠券活动，但优惠券仅限在平台上使用。",
    "YouHuiQuanLieBiaoShuoMin13": "2. 目前优惠券有三种：折扣券、满减券、现金券。",
    "YouHuiQuanLieBiaoShuoMin14": "3. 优惠券获取方式：通过平台自动派发，下单后返赠、参与活动领取等形式获取。",
    "YouHuiQuanLieBiaoShuoMin15": "4. 通常每笔订单限用一张优惠券，每张优惠券限用一次。如有特殊情况，需详见当次优惠券活动使用说明。",
    "YouHuiQuanLieBiaoShuoMin16": "5. 订单使用优惠券后产生取消，如果是享受优惠的商品全部取消，系统自动返还相应的优惠券。但如果只是部份取消，部分享受了优惠，则优惠券不作返还。",
    "YouHuiQuanLieBiaoShuoMin17": "6. 优惠券是不能进行兑现、出售、转让或其他用途。",
    "YouHuiQuanLieBiaoShuoMin21": "各类优惠券具体使用规则",
    "YouHuiQuanLieBiaoShuoMin22": "1. 全部通用优惠券：平台上所有商品通用，不受用户、品类、区域限制，订单中所购商品总额需达到用券限额才能使用。每笔订单限用1张全场通用优惠券，按订单金额进行减免。",
    "YouHuiQuanLieBiaoShuoMin23": "2、品类优惠券：该优惠券受品类限制，只能购买特定品类商品。每笔订单限用1张品类优惠券，按订单金额进行减免。",
    "YouHuiQuanLieBiaoShuoMin24": "例如：玩具品类5%折扣券，所下订单中的商品必需包含玩具品类下商品且该品类商品总金额达到用券限额才可以使用。",
    "YouHuiQuanLieBiaoShuoMin25": "3、活动商品优惠券：该优惠券受商品限制，只能购买特定活动商品，每张订单限用1张商品优惠券，按活动商品的总金额进行减免。",
    "YouHuiQuanLieBiaoShuoMin26": "例如：$1000元一箱快出商品满减券，所下订单中的商品必须包含一箱快出的商品且该商品总金额达到用券限额才可以使用。",
    "YouHuiQuanLieBiaoShuoMin27": "4、新人优惠券：该优惠券限新客户使用，新客户是指在ESSAONE从未下过单的注册客户。只有符合了新客户的资格，所下的订单达到用券要求才可以使用。",
    "HaoYouKeDeZuiGaoYouHui": "好友可得：价值40000卢布的优惠券礼包，单笔订单最高优惠",
    "YaoQingYeGuiZeShuoMing1": "1. 活动时间：2021年4月9日起生效。",
    "YaoQingYeGuiZeShuoMing2": "2. 活动期间，您的好友可通过您分享的邀请链接进行注册并且下单，即为成功邀请1人。",
    "YaoQingYeGuiZeShuoMing3": "3. 您每邀请1人注册并下单成功，您即可获得即可获得一张价值₽20000优惠券。",
    "YaoQingYeGuiZeShuoMing4": "4. 您邀请的好友完成注册后您先获得一张待激活的₽20000优惠券，该优惠券暂未生效。好友下首单后，该优惠券才被激活，可以使用。",
    "YaoQingYeGuiZeShuoMing5": "5. 优惠券将会根据规则自动发放至您的账户中。",
    "YaoQingYeGuiZeShuoMing6": "6. 您可在“我的优惠券”页面查看所得的优惠券。优惠券的有效期为发放后180天内有效。",
    "YaoQingYeGuiZeShuoMing7": "7. 任何关于此活动的相关疑问可咨询在线客服，活动解释权归ESSAONE所有。",
    "YiJiJiangLi": "一级奖励",
    "ErJiJiangLi": "二级奖励",
    "HaoYouZhuCeChengGongKeDe": "好友注册成功可得",
    "HaoYouWanChengShouBiDingDanKeDe": "好友完成首笔订单可得",
    "ZanWuShuJu": "暂无数据",
    "QuShiYong": "去使用",
    "BuKeShiYong": "不可使用",
    "SuiFei": "增值税费",
    "YouHuiQuanZheGou": "优惠券/折扣",
    "YiShiYongZuiYouZuHe": "已使用最优优惠券",
    "XuanZeZuiYouZuHe": "选择最优优惠券",
    "ChongXinXuanZeQiTaYouHuiQuan": "重新选择其他优惠券",
    "QuanBuShangPinKeYong": "全部商品可用",
    "ZhiDingLeiMuKeYong": "指定类目可用",
    "ZhiDingPinPaiKeYong": "指定品牌可用",
    "ZhiDingShangPinKeYong": "指定商品可用",
    "YouYouHuiQuanKeYong": "有优惠券可用",
    "NiYouNZhangYouHuiQuanKeYong": "你有{0}张优惠券可用",
    "JinTianGuoQi": "今天过期",
    "HaiShengNTian": "还剩{0}天",
    "HuoQuYouHuiQuan": "获取优惠券",
    "FaXianYiGeHaoWangZhanessaone2": "发现一个好网站essaone，从中国批发，1箱起订！邀请你来注册，点击链接注册即可领取新人优惠。",
    "XinRenTeHui": "新人特惠",
    "ShouDanJiKeShiYong": "首单即可使用",
    "ShouDanWanChengHou": "首单完成后再送",
    "LingQuanHouNTianNeiYouXiao": "领券后{0}天内有效",
    "YiPaiWan": "已派完",
    "DingDanZhengZaiJiSuanZhong": "订单正在计算中，预计5分钟内完成，请耐心等候！",
    "totalDdpTaxesCost": "包含增值税费",
    "ChaKanYouHuiQuan": "   查看优惠券",
    "YiZhuCe": "已注册",
    "Ren": "人",
    "WuShiYongMenKanZuiDuo": "{0}以下可用",
    "WuShiYongXianZhi": "无使用限制",
    "RuHeYaoQing": "如何邀请",
    "CongZhongGuoFaHuoJiaGeHan2": "从中国发货，价格包括运输费用，关税和{0}增值税。",
    "ZanWeiShengXiao": "暂未生效",
    "YaoQingYongHuMingXi": "邀请用户明细",
    "DianZiYouJian": "电子邮件",
    "JiangLiJinE": "提成金额",
    "RenZhengZhuangTai": "认证状态",
    "RenZhengZhong": "认证中",
    "RenZhengChengGong": "认证成功",
    "RenZhengShiBai": "认证失败",
    "WoDeYaoQingJiangLi": "我的提成",
    "LeiJiYaoQingYongHuShu": "累计邀请用户数",
    "RenZhengTongGuoShu": "通过认证客户数",
    "TiCheng": "提成",
    "ShouYeBiaoTi2": "ESSA-全球贸易的数字化交易平台",
    "YongHuXingWei1": "近30天",
    "YongHuXingWei2": "近60天",
    "YongHuXingWei3": "近90天",
    "YongHuXingWei4": "全部",
    "MeiYaoQing1WeiHaoYouZhuCeJiKeHuo2": "欢迎加入我们的分享奖励计划！邀请您的朋友（非竞争对手）并与他们分享奖励！<br>\n每邀请1位好友注册并下单即可获得一张价值₽20000优惠券，而被您邀请注册的好友也可获得价值₽40000的新人优惠券大礼包。",
    "NiKeHuoDe": "你可获得",
    "HaoYouWanChengShouBiDingDanKeYong": "好友注册成功即可获得<br>好友下单成功即可使用",
    "HaoYouKeDe": "好友可得",
    "HaoYouZhuCeChengGongKeHuoDe": "好友注册成功即可获得价值₽40000优惠券礼包。",
    "NiKeDeYiZhangDaiJiHuoJuan": "好友注册后您即可获得一张待激活的₽20000优惠券，该优惠券暂未生效。好友下首单后，该优惠券才被激活，可以使用。",
    "HaoYouZhuCeDeDaiJiHuoYouHuiJuan": "好友注册得待激活优惠券",
    "YiXiaDan": "已下单",
    "YiZhuCeWeiXiaDan": "已注册未下单",
    "HaoYouXiaDanYouHuiJuanKeYong": "好友下单后优惠券生效可用",
    "YiJiHuo": "已激活",
    "DaiJiHuo": "待激活",
    "YiJiHuoYouHuiJuan": "已激活优惠券",
    "RenZhengBuTongGuoYuanYin": "非平台目标客户",
    "DaiJiHuoYouHuiJuan": "待激活优惠券",
    "YongHuXingWei": "用户使用数据",
    "TuiGuangDeKeHuSuoYouYiWan1": "累计所有完成注册并通过认证的新客户提成金额",
    "TuiGuangDeKeHuBenZiRanYue1": "累计本自然月内完成注册并通过认证的新客户提成金额",
    "TuiGuangDeKeHuSuoYouYiJin1": "累计当前已注册未认证的新客户提成金额",
    "YaoQingHaoYouXinXiE": "您可以复制邀请链接，通过手机的社交媒体软件、邮件等方式分享给新客户。让他们注册成为essaone会员。",
    "YaoQingHaoYouXinXiF": "您邀请的新客户只有通过您提供的注册链接或在注册时填写了您的手机邀请码，他才会跟您的账号进行绑定，这样您才有机会获得新客户成功注册的提成。",
    "YaoQingHaoYouXinXiG": "您最终所获得的提成均以新客户成功注册并通过认证为准。",
    "YaoQingHaoYouXinXiH": "您邀请的新客户注册成功之后，您可以在“我的提成”列表中查看所有已注册的新客户信息，如果出现您邀请的新客户注册成功之后没有在您的邀请用户列表中，请您联系essaone.cn的在线客服进行咨询。",
    "KeHuXinXi": "客户信息",
    "DianZiYouXiang": "电子邮箱",
    "FenXiaoShang": "分销商",
    "FenXiaoShangLeiXing": "分销商类型",
    "KeHuGenJinXinXi": "客户跟进信息",
    "LianXiRenZhiWu": "联系人职务",
    "GongSiLeiXing": "公司类型",
    "JingYingLeiMu": "经营类目",
    "NianXiaoShouE": "年销售额",
    "XianXiaMenDianShuLiang": "线下门店数量",
    "ZaiShouSKUShu": "在售SKU数",
    "GenJinRenYuan": "跟进人员",
    "ShouCiGenJin": "首次跟进",
    "QuanBuYongHu": "全部用户",
    "YiGenJinYongHu": "已跟进用户",
    "XinYongHu": "新用户",
    "GongSiMingChengLianXiFangShi": "客户名称/客户编号/联系方式",
    "QingXuanZeQuDao": "请选择渠道",
    "QingXuanZeFenXiaoShang": "请选择分销商",
    "QingXuanZeGenJinRen": "请选择跟进人",
    "YongHuDeGongSiMingChengHeChengShiXinXi": "用户的公司名称和城市信息",
    "YongHuDeLianXiYouXiangHeShouJiHaoMa": "用户的联系邮箱和手机号码",
    "ZhuCeQuDao": "注册渠道",
    "YongHuDeZhuCeQuDaoLaiYuanHeFenXiaoShangXinXi": "用户的注册渠道来源和分销商信息",
    "GenJinRen": "跟进人",
    "GenJin": "跟进",
    "QingXuanZeZhuangTai": "请选择状态",
    "GangWei": "岗位",
    "YiGenJinKeHu": "已跟进客户",
    "ZhangHaoZhuangTai": "账号状态",
    "TingYong": "停用",
    "XinZengKeHuXinXi": "新增员工信息",
    "BianJiKeHuXinXi": "编辑员工信息",
    "QingShuRuYuanGongXingMing": "请输入员工姓名",
    "QingSheZhiYuanGongDengLuZhangHao": "请设置员工登录账号",
    "DengLuZhangHao": "登录账号",
    "DengLuMiMa": "登录密码",
    "QingSheZhiYuanGongDengLuMiMa": "请设置账号登录密码",
    "QingXuanZeGangWei": "请选择岗位",
    "QingSheZhiYuanGongLianXiDianHua": "请输入员工联系电话",
    "ShiFouQiYongGaiZhangHao": "是否启用该账号？",
    "XinZengYuanGong": "新增员工",
    "ShiFouTingYongGaiZhangHao": "是否停用该账号？",
    "QingShuRuYuanGongZhangHuXinMiMa": "请输入员工账户新密码",
    "MuBiaoYongHu": "目标客户",
    "GuanLiHouTai": "管理后台",
    "KeHuLieBiao": "客户信息",
    "KeHuXinXiBuChong": "客户信息补充",
    "FeiMuBiaoYongHu": "非目标用户",
    "QingShuRuGongSiWangZhi": "请输入公司网址",
    "QingShuRuKeHuLianXiRen": "请输入客户联系人",
    "QingShuRuZhengQueDeLianXiDianHua": "请输入正确的联系电话",
    "QingTianXieMenDianShuLiang": "请填写门店数量",
    "QingXuanZeGenJinRenYuan": "请选择跟进人员",
    "QingXuanZeGongSiLeiXing": "请选择公司类型",
    "QingXuanZeJingYingLeiMu": "请选择经营类目",
    "QingXuanZeLianXiRenZhiWu": "请选择联系人职务",
    "QingXuanZeNianDuXiaoShouE": "请选择年度销售额",
    "QingXuanZeZaiShouSKUShu": "请选择在售SKU数",
    "QuDao": "渠道",
    "ShiFouMuBiaoKeHu": "是否目标客户",
    "TuiGuangFangShi": "推广方式",
    "YongHuGenJin": "客户跟进",
    "YuanGongZhangHaoGuanLi": "账号管理",
    "ZhangHaoXiangQing": "客户详情",
    "YouYeWuYuanZhengZaiGenJin": "有业务员正在跟进，请勿重复操作",
    "QingShuRuZhangHao": "请输入账号",
    "LiJiDengLu": "立即登录",
    "EGuoYunYingPingTai": "ESSAONE运营平台",
    "BuShiLingShouKeHu": "平台暂时没有客户主营类目的商品",
    "BuShiBenGuoYongHu": "不是本国用户",
    "QingShuRuYongHuMing": "请输入用户名",
    "QingShuRuMiMa": "请输入密码",
    "QingShuRuShuiWuHao": "请输入纳税人识别号",
    "QingShuRuYingYeZhiZhao": "请输入营业执照",
    "NinCaoZuoTaiKuaiLeQingTin": "您操作太快了，请停下喝口水吧",
    "DaoChuShuJuShaiXuan": "导出数据筛选",
    "QingShuRuCaiGouShangBianMaHuoMingCheng": "请输入客户编码或名称",
    "KeHuShuJu": "客户行为数据",
    "ZuiJinJiaGouShiJian": "最近加购时间",
    "JiaGouKuanShu": "加购款数",
    "ZuiJinFangWenShiJian": "最近访问时间",
    "LeiJiDingDanShu": "累计订单数",
    "ZuiJinXiaDanShiJian": "最近下单时间",
    "CaiGouShangHangWeiShuJu": "客户行为数据",
    "JiaRuShiJian": "下单时间",
    "QingShuRuJiGuiDanHaoHuoGuiHao": "请输入集柜单号或柜号",
    "DengLuRenShu": "登录人数",
    "XinKeHuChengJiaoRenShu": "新客户成交人数",
    "ZongChengJiaoRenShu": "总成交人数",
    "WeiChengJiaoKeHu": "未成交客户",
    "YiChengJiaoDeKeHu": "已成交的客户",
    "KeHuLeiXing": "客户类型",
    "JiaGouShangPinShu": "加购商品数",
    "KeXiaDanShangPinShu": "可下单商品数",
    "WeiZhiFuDingJinDingDanShu": "未支付定金订单数",
    "JinNianCaiGouZongJinE": "今年采购总金额",
    "JinNianDingDanShu": "今年订单数",
    "WeiZhiFuWeiKuanDingDanShu": "未支付尾款订单数",
    "LeiJiCaiGouZongJinE": "累计采购总金额",
    "ShouCiChengJiaoShiJian": "首次成交时间",
    "ZuiJinChengJiaoShiJian": "最近成交时间",
    "QingShuRuDingDanBianMaHuoShangPinBianMa": "请输入订单编码或商品编码",
    "ShuJuTongJi": "数据统计",
    "CaiGouShang": "客户编码",
    "MaiJiaBaoZhang": "买家保障",
    "MaiGuiBiPei": "买贵必赔",
    "WanDaoBiPei": "晚到必赔",
    "PoSunBiPei": "破损必赔",
    "ZhengGuiQingGuan": "正规清关",
    "XinKeYouHui": "新客优惠",
    "GouWuCheGaiShangPinZaiXunPanZhong": "购物车已有该商品在询盘中",
    "YiGengXinWeiGongChangZuiXinTuiJianJia": "已更新为工厂最新推荐价",
    "GongChangYouHaoTuiJian": "工厂有好推荐",
    "JiaGeYouXiaoQi": "价格有效期",
    "TuiJianLiYou": "推荐理由",
    "JiaRuXuanYangChi": "选品",
    "PaiYiPaiTiXingShangXin": "拍一拍，邀请工厂上新品",
    "JinQiYiTiXingShangXin": "近期已邀请上新",
    "ChaKanGongChangDongTai": "可以前往我的关注查看工厂上新动态",
    "JiaRuXuanYangChiChengGong": "已成功加入选品池",
    "JiaRuGouWuCheChengGong": "加入购物车成功",
    "GuanZhuGongChangDongTai": "关注工厂动态",
    "CLAIM_DAMAGE_001": "每天的退款金额计算错误",
    "CLAIM_DAMAGE_002": "总退款金额计算错误",
    "CLAIM_DAMAGE_003": "退款金额不能超过总货款的10%",
    "CLAIM_DAMAGE_004": "成交价没有比其他渠道的采购价贵",
    "CLAIM_DAMAGE_005": "协商后差价不能小于0",
    "CLAIM_DAMAGE_006": "总数量不正确",
    "CLAIM_DAMAGE_007": "总退款金额有误",
    "ShangPinZaiDaiGongChangQueRenZuiXinJiaZhong": "选品池商品在待工厂确认最新价中",
    "WuTuiJianShangPin": "无推荐商品",
    "HenBaoQianNinDeDingDanBiYuQi": "很抱歉！您的订单比预期晚到了{0}天，您可获得赔偿 {1}。",
    "ShenQingWanDaoBiPei": "申请晚到必赔",
    "ShiFouShenQingSuoPei": "是否申请索赔？",
    "ShenQingSuoPei": "申请索赔",
    "NinDeDingDanBiYuQiWanDaoLe": "您的订单比预期晚到了{0}天，您可获得赔偿{1}。",
    "PoSun": "破损",
    "MaiGui": "买贵",
    "TiJiaoShenQing": "提交申请",
    "ShenHe": "审核",
    "SuoPeiJieGuo": "索赔结果",
    "ChanPinWenTi": "产品问题",
    "QingXuanZeChanPinWenTi": "请选择产品问题！",
    "QingTiGongYouXiaoZhengMing": "请提供有效证明 (可支持验证)",
    "GongHuoQuDao": "供货渠道",
    "QingTianXieGongHuoQuDao": "请填写供货渠道！",
    "GongHuoJiaGe": "供货价格",
    "QingTianXieGongHuoJiaGe": "请填写供货价格！",
    "QingTianXieZhengQueDeGongHuoJiaGe": "请填写正确的供货价格！",
    "ShangChuanPingZheng": "上传凭证",
    "ZhiChiTuPianShiPinWenDang": "图片/视频/文档 (mp4,flv,jpeg,jpg,png,bmp,doc,docx,xls,xlsx,pdf)，单个文件不能超过20M，最多5个",
    "TianXieShuoMing": "填写说明",
    "QingTianXieShuoMing": "请填写说明！",
    "JianYiBuChongGengXiangXiDe": "建议补充更详细的问题描述，这有助于平台更快更好地处理您的问题。",
    "LianXiRenXinXi": "联系人信息",
    "QingTianXieZhengQueYouXiao": "请填写正确有效的联系信息，必要时我们将与您电话沟通，更好地处理您的问题。",
    "SuoPeiShenQingJiLu": "索赔申请记录",
    "DingDanWanDaoTianShu": "订单晚到天数",
    "YuJiPeiChangJinE": "预计赔偿金额",
    "TiJiaoChengGongQingNaiXinDengDai": "提交成功，请耐心等待",
    "ShenHeJieGuoJiangYu7GeGong": "审核结果将于7个工作日内完成，请留意邮件通知。",
    "FanHuiDingDanXiangQing": "返回订单详情",
    "ShenQingXinXi": "申请信息",
    "LeiXing": "类型",
    "ShouHouDanHao": "售后单号",
    "CheXiaoShenQing": "撤销申请",
    "PingZheng": "凭证",
    "NinDeSuoPeiZhengZaiShen": "您的索赔正在审核处理中，请耐心等候。审核结果将于15个工作日内完成。",
    "ShenHeTongGuoYiHuoPei": "审核通过，已获赔成功。赔偿金额 {0}",
    "NinDePeiChangKuanYiTui": "您的赔偿款已退回您的资金账户中，请到 <a href=\"/member/funds-detail\">资金明细</a> 查看记录。",
    "ShenHeBuTongGuo": "审核不通过",
    "ShenHeZhong": "审核中",
    "ShiBaiYuanYin": "失败原因",
    "DengDaiPingTaiShenHeChuLi": "等待平台审核处理",
    "NiSuoTiJiaoDeXinXiZhengZai": "你所提交的信息正在等待平台审核处理，7个工作日内确认，请留意邮件信息。",
    "ShenQingYiCheXiao": "申请已撤销！",
    "NinYiCheXiaoCiCiSuoPeiShenQing": "您已撤销此次索赔申请，若您的问题未解决，可以在有效期内再次申请。",
    "TuiKuanDanJiaPCS": "退款单价/PCS",
    "ShiJiQueShaoSunHuaiShuLiang": "实际缺少/损坏数量",
    "ZongTuiKuanJinE": "总退款金额",
    "JieGuoShuoMing": "结果说明",
    "XieShangHouChaJia": "协商后差价",
    "ZongShuLiang": "总数量",
    "TuiKuanJinE": "退款金额",
    "QingShuRuChaJia": "请输入差价",
    "QingShuRuShiJiQueShaoSunHuaiShuLiang": "请输入实际缺少/损坏数量",
    "QingShuRuZongTuiKuanJinE": "请输入总退款金额",
    "ShouHouGuanLi": "售后管理",
    "ShouHouXiangQing": "售后详情",
    "KeHuShenQing": "客户申请",
    "ShenHeChuLi": "审核处理",
    "ShouHouBianHao": "售后编号",
    "ShenQingKeHu": "申请客户",
    "JuTiWenTi": "具体问题",
    "ShenQingShuoMing": "申请说明",
    "ChaJia": "差价",
    "ZongChaJia": "总差价",
    "ChengNuoDaoHuoShiJian": "承诺到货时间",
    "RuKuQueRenShiJian": "入库确认时间",
    "WanDaoTianShu": "晚到天数",
    "YuJiTuiKuanJinE": "预计退款金额",
    "LaiKuanDengJi": "来款登记",
    "JinQiLaiKuan": "近期来款",
    "ChaKanLaiKuanJiLu": "查看来款记录",
    "YinHangLiuShuiHao": "银行流水号",
    "DaoKuanRiQi": "到款日期",
    "ShiJiDaoZhangJinE": "实际到账金额",
    "DengJiRen": "登记人",
    "FuKuanFangShi": "付款方式",
    "LaiKuanXiangQing": "来款详情",
    "KeHuBianMa": "客户编码",
    "KeHuMingCheng": "客户名称",
    "QingShuRuCaiGouShangBianMa": "请输入客户编码",
    "XuanZeKeHu": "选择客户",
    "KeHu": "客户",
    "QingXuanZeDaoKuanRiQi": "请选择到款日期",
    "QingShuRuYinHangLiuShuiHao": "请输入银行流水号",
    "QingXuanZeFuKuanFangShi": "请选择付款方式",
    "DaoZhangJinE": "到账金额",
    "QingShuRuDaoZhangJinE": "请输入到账金额",
    "QingShuRuBeiZhuXinXi": "请输入备注信息",
    "LaiKuanJiLu": "来款记录",
    "QingQueRenLuRuDeDaoZhangJinEShiFouZhengQue": "请确认录入的到账金额是否正确？",
    "QingShuRuTianShu": "请输入天数",
    "PeiChangJinEZuiGaoBuChaoHuoWuJinEDe": "赔偿金额最高不超货物金额的{0}%",
    "ChuHuoDan": "出货单",
    "JiGuiDanHao": "集柜单号",
    "HuoGuiXinXi": "货柜信息",
    "GuiHao": "柜号",
    "CaiWuGuanLi": "财务管理",
    "XiaoShouShuJu": "销售数据",
    "ShouHouSuoPei": "售后索赔",
    "DingDanShu": "订单数",
    "KeHuShu": "客户数",
    "FenXiaoShangTiCheng": "分销商提成",
    "FenXiaoShangXingMing": "分销商姓名",
    "ZongGong": "总共",
    "YiZhiFuWeiKuan": "已支付尾款",
    "QingShuRuKeHuBianMaHuoShangBinBianMa": "请输入客户编码或商品编码",
    "QingShuRuPODanHao": "请输入PO单号",
    "QingShuRuShouHouDanHao": "请输入售后单号",
    "ChaXun": "查询",
    "SuoPeiFuWuLeiXing": "索赔服务类型",
    "FuWuLeiXing": "服务类型",
    "ChuLiRen": "处理人",
    "YingShouWeiKuan": "应收尾款",
    "WeiChuLi": "未处理",
    "YiChuLi": "已处理",
    "QingXuanZeDingDanZhuangTai": "请选择订单状态",
    "ChuLiZhuangTai": "处理状态",
    "ZhiFuWeiKuanShiJian": "支付尾款时间",
    "TiChengBiLi": "提成比例",
    "EXWZongJia": "EXW总价",
    "QuanXianSheZhi": "权限设置",
    "QingXuanZeTuiKuanZhuangTai": "请选择退款状态",
    "TuiKuanZhuangTai": "退款状态",
    "TuiKuanShuJuTongJi": "退款数据统计",
    "DaiTuiKuan": "待退款",
    "YiTuiKuan": "已退款",
    "ChuLiShiJian": "处理时间",
    "QuChuLi": "去处理",
    "ShaoHouZaiChuLi": "稍后再处理",
    "QingQueRenGaiBiTuiKuanXianXiaYiWanChengDengJi": "请确认该笔退款线下已完成登记",
    "QingShuRuFenXiaoShangMingCheng": "请输入分销商名称",
    "DingDanQingDan": "订单清单",
    "RuKuDengJi": "入库登记",
    "QueRenHuoWuRuKuShiJian": "确认货物入库时间",
    "RuKuShiJian": "入库时间",
    "ShenHeJieGuo": "审核结果",
    "ShenHeTongGuo": "审核通过",
    "QianZaiCaiGouShang1": "电子邮件中的价格比较。",
    "QianZaiCaiGouShang2": "我们有很多惊喜！",
    "QianZaiCaiGouShang3": "您可以在这里留下联系方式，我们将很快与您联系。",
    "QianZaiCaiGouShang4": "得到报价",
    "QianZaiCaiGouShang5": "预约回电",
    "QianZaiCaiGouShang6": "请输入WhatsApp/ Telegram",
    "ShangChuanBaoJiaLogo": "上传报价LOGO",
    "QianZaiCaiGouShang7": "请输入账号",
    "QingShuRuShenHeJieGuo": "请输入审核结果",
    "GangGangBoFang": "刚刚播放",
    "XuanPin": "选品",
    "YiYouGuanZhu": "已有{0}人关注",
    "GouWuCheYiYouWaiXiang": "购物车中已有{0}外箱，确定以{0}外箱覆盖购物车中现有数量",
    "QuanXianXinXi": "权限信息",
    "ShiJiQueShao/SunHuaiDeShuLiangBuNengDaYuXiaDanShuLiang": "实际缺少/损坏的数量不能大于下单数量",
    "MaiGuiTuiKuan": "买贵退款",
    "WanDaoTuiKuan": "晚到退款",
    "PoSunTuiKuan": "破损退款",
    "QingShangChuanPingZheng": "请上传凭证",
    "QiTaGongHuoShangJiaGe": "其他供货商价格",
    "DingDanYiWanDaoNTianYu": "订单已晚到{0}天，预计赔付 {1}。",
    "ShenHeTongGuoDengDaiPeiFu": "审核通过，等待赔付。",
    "NinDePeiChangKuanJiangZaiXiaYiGeGong": "您的赔偿款{0}将在下一个工作日打入您的资金账户。",
    "QingShuRuKeHuBianMa": "请输入客户编码",
    "PoSuiBiPei": "破损必赔",
    "BuZhiChiGaiGeShiShangChuan": "暂不支持该格式上传",
    "HuoWuJinE": "货款金额",
    "PeiFuBiLi": "赔付比例",
    "ZongGongNGeXiangMu": "总共{0}个项目",
    "DingDanWanDaoShiJianChaoGhuNian": "订单晚到时间超出20天（含）以内，属于免责范围，不提供赔付服务",
    "NinDePeiChangKuanJiangZaiXiaYiGeGong2": "您的赔偿款{0}将在订单尾款支付完成后的下一个工作日打入您的资金账户。",
    "CLAIM_DAMAGE_120": "商品因侵权或跟单取消，不允许审核通过",
    "DaiRuKu": "待入库",
    "YiRuKu": "已入库",
    "QingShuRuDingDanHao": "请输入订单号",
    "XiaoShouTongJiBiao": "销售统计表",
    "CLAIM_DAMAGE_100": "订单不存在",
    "CLAIM_DAMAGE_101": "已申请索赔，请勿重复申请",
    "CLAIM_DAMAGE_102": "抱歉，您已经超过申请赔偿时间",
    "CLAIM_DAMAGE_103": "当前订单货物尚未出库，需到出库后才允许申请",
    "CLAIM_DAMAGE_104": "订单晚到天数小于20",
    "CLAIM_DAMAGE_105": "凭证不能为空",
    "CLAIM_DAMAGE_106": "凭证最多5个",
    "CLAIM_DAMAGE_107": "说明不能为空，且长度最多600",
    "CLAIM_DAMAGE_108": "联系人不能为空",
    "CLAIM_DAMAGE_109": "联系人号码不能为空",
    "CLAIM_DAMAGE_110": "渠道价格必须大于0小于商品单价",
    "CLAIM_DAMAGE_111": "破损数量超过商品总数",
    "CLAIM_DAMAGE_112": "产品问题参数无效",
    "CLAIM_DAMAGE_113": "订单状态未处于审核中",
    "CLAIM_DAMAGE_114": "操作失败",
    "CLAIM_DAMAGE_115": "服务类型参数无效",
    "CLAIM_DAMAGE_116": "订单已处理，请勿重复操作",
    "CLAIM_DAMAGE_117": "索赔申请未通过",
    "CLAIM_DAMAGE_118": "请支付定金后再申请买贵必赔",
    "CLAIM_DAMAGE_119": "订单尚未完成，暂时无法申请！",
    "ShenQingYiShiXiao": "申请已失效",
    "NinDeShenQinYinShangPinQuXiao": "因商品取消订购，您申请的“买贵必赔”服务赔偿将失效。",
    "DaiShenHe": "待审核",
    "YiShenHe": "已审核",
    "ZhuangGuiShiJian": "装柜时间",
    "ZhaoShangPinJieShao": "汇聚<b>30000+</b>澄海义乌工厂的<b>150万</b>商品，找商品、找工厂、找品牌！一键上传图片，极速识图搜索",
    "KanXinPinJieShao": "看新品，来宜采！每日<b>1000+</b>新品上线，玩具、餐具、文具、节庆用品，各类新品等你来挑",
    "XuanBaoKuanJieShao": "水枪、泡泡、积木、机器人...行业最新最热商品，<b>每周不定时更新</b>，带你掌握流行趋势！",
    "DaoBaoJiaJieShao": "选样池商品可批量导出报价单：英汉俄多语言可选，自行设置加价率，商品信息全，带公司Logo，导出就能直接发给客户做推荐用！",
    "QuXuanYangChi": "去选样池",
    "QuXuanBaoKuan": "去选爆款",
    "QuKanXinPin": "去看新品",
    "QuZhaoYang": "去找样",
    "KanXinPin": "看新品",
    "zhaoGongChang/PinPai": "找工厂/品牌",
    "ShiPinXuanPin": "视频选品",
    "XuanBaoKuan": "选爆款",
    "DaoBaoJia": "导报价",
    "YiXiangKeCai": "一箱可购",
    "GuoNeiZhuanGong": "内销专区",
    "MeiZhouBaoKuan": "每周爆款",
    "XinQiTe": "新奇特",
    "CaiNiXiHuan": "猜你喜欢",
    "DingBu": "顶部",
    "QuanBuJiaRuXuanPinChi": "全部加入选品池",
    "PiLiangXuanPin": "批量选品",
    "QuXiaoPiLiang": "取消批量",
    "JiaRuXuanPinChi": "加入选品池",
    "QingXuanZeLeiMuHouZaiJinXingShaiXuan": "请选择类目后再进行筛选",
    "ShiWuYuanReXiao": "15元热销",
    "GaiYeMianShangPinYiQuanBuJiaRuXuanPinChi": "该页面暂无可加购的商品",
    "QingXianXuanPin": "请先选品",
    "RenQiBaoPin": "人气爆品，实时上新",
    "PingJiaZhuanChang": "平价专场，等你来看",
    "ChaoJiXinPin": "超级新品，不容错过",
    "JingXuanPinPai": "精选品牌，为你推荐",
    "YinYiQingHeCaiGouWangJiYingXiang": "近期国际运力紧张，物流无法如期安排",
    "WuLiuYanQiTiXing": "温情提示：确认你的商品和收货信息准确无误，提交订单后尽快付款，我们会尽快安排生产和发货",
    "ChaKanGuiZe": "查看规则",
    "DDPStatus40": "定金支付成功，您的订单已在安排生产，请留意异常通知",
    "DDPStatus41": "订单已完成生产，等待质检",
    "DDPStatus110": "尾款支付成功，订单已完成",
    "DDPStatus90": "您的订单已发出，正发往<D/>",
    "DDPStatus100": "你的订单已进入<D/>境内，提货前请支付尾款",
    "DDPStatus105": "您的订单已达到<D/>，等待提货",
    "WuLiuXinXi": "物流信息",
    "WuLiuYanQiTiShi": "近期国际运力紧张，物流无法如期安排，预计到达时间推迟至 {0}(原{1})",
    "YiYouHuiN": "已优惠{0}",
    "JiXuChouDan": "继续凑单",
    "ZhaiGouNKeYouHui": "再购{0}可优惠{1}",
    "ShangPinBiaoQian": "商品标签",
    "NPaiHangBanDiNMin": "{0}排行榜第{1}名",
    "NCaiGouBanDan": "{0}采购榜单",
    "JinXuanHaoHuoYiWangDaJin": "精选好货 一网打尽",
    "ZhaoGongChang": "找工厂",
    "ChongZhi": "重置",
    "QuanBuJieGuo": "全部结果",
    "NinKeYi": "您可以",
    "SKUPinMing": "商品品名",
    "GuanJianZi": "关键字",
    "ShangJiaRiQi": "上架时间",
    "XiaoShouMOQ": "销售MOQ",
    "BaoZhuangTiJi": "包装体积",
    "Tian": "天",
    "GongChangChanDiQuYu": "工厂产地区域",
    "RenZhengBiaoZhun": "认证标准",
    "MeiZhaoDaoNiXiangYaoDeShangPin": "没找到你想要的商品？留下产品或品牌的信息。",
    "ShangPinTeZhengBiaoTi": "您可以指定指向产品、供应商数据、产品特征、件数和其他信息的链接，以帮助找到最佳条件",
    "ShuRuNinXiangZhaoDeShangPinTeZheng": "输入你想找的商品特征",
    "YouXiangBiaoTi": "你的邮箱，我们将通过邮件通知你结果",
    "ShuRuNinDeYouXiang": "请输入你的邮箱",
    "TuXingYanZhengBiaoTi": "图形验证码",
    "ShuRuYanZhengMa": "输入验证码",
    "MeiYouZhaoDaoNinXiangYaoDeShangPinMa": "没有找到您想要的东西吗？",
    "ShouManQiangGuangLe": "手慢了，抢光了",
    "KuCunBuZu": "库存不足",
    "GaiShangPingXianGouXXiang": "该商品限购{0}箱",
    "NinZhangHaoBuFuHeTiaoJian": "当前活动仅限指定用户，你账号不符合条件",
    "GaiHuoDongJinXianYouHuiYiDanNinYiXiaDan": "该活动仅限优惠一单，你已下单",
    "GaiHuoDongZhiNengXuanGouXKuanMeiKuanXianGouXXaing": "该活动只能选购{0}款，每款限购{1}箱",
    "HuoDongYiJieJieSuQingShuaXinYeMian": "当前城市的活动已结束，查看规则或刷新页面",
    "NinXuanGouDeShangPingYiQuanBuQiangGuangXiaCiQingZaoDianXiaDan": "你选购的商品已全部抢光，下次请早点下单",
    "NCaiGouBanDan2": "{0}热销排行榜",
    "JinXuanHaoHuoYiWangDaJin2": "精选好货 一网打尽",
    "ReMenSouSuo": "热门搜索",
    "MeiYouZhaoDaoXiangGuanShangPin": "没有找到相关商品",
    "HuoZheTianXieFanKuiBiaoDan": "或者填写反馈表单",
    "FanKuiGeiKeFu": "反馈给客服",
    "GaoJiSouSuo": "高级搜索",
    "ShangJiaShiJianShengXu": "按上架时间远到近",
    "ShangJiaShiJianJinDaoYuan": "按新品排序",
    "GaoJi": "高级",
    "MeiZhaoDaoXiangGuanGongChang": "没找到相关工厂",
    "NiKeYi": "你可以",
    "BenDingDanDe3GeZiDingDanYiDaoHuo": "当前有{0}个订单待支付，请于提货前支付。",
    "YouHuiYiQiangGuang": "优惠已抢光",
    "HuoDongShengYuYouHui": "活动剩余优惠",
    "MeiKuanXianZhi": "每款限制",
    "YiYouHui": "已优惠",
    "QuJieSuan": "去结算",
    "YiQiangGuang": "已断货",
    "BuyGoodsTipTitle": "你选购的以下商品已抢光。是否剔除以下商品，继续结算？",
    "NinYouWeiZhiFuDeXinYongHuDingDan": "您有未支付的新用户订单",
    "QingXianJiaGouShangPin": "请先加购商品",
    "KuCunYouXianJinKuaiXiaDan": "库存有限,尽快下单",
    "ChuKuGuanLi": "出库单管理",
    "DaiChuKu": "待出库",
    "YiChuKu": "已出库",
    "KeHuBianHao": "客户编号",
    "ShouHuoRenXingMing": "收货人姓名",
    "ShouHuoRenShouJi": "收货人手机",
    "DingDanHao": "订单号",
    "PiLiangChuKu": "批量出库",
    "ChuKuShiJian": "出库时间",
    "CaoZuoRen": "操作人",
    "ChuKuXiangQing": "出库详情",
    "QueRenChuKu": "确认出库",
    "AnPaiChuHuo": "安排出货",
    "ChuHuo": "出库",
    "ShengYuZhiFuShiJian": "剩余支付时间",
    "MeiZhaoDaoXiangGuanShangPin": "没找到相关商品",
    "JiangBenYeShangPinPiLiangJiaRuXuanYangChi": "将本页商品批量加入选品池",
    "QuXiaoQuanXuan": "取消全选",
    "TuiChuPiLiangXuanPin": "退出批量选品",
    "JiJiangShouQing": "即将售罄",
    "KuCun": "库存",
    "XinYongHuTeJiaXianHuo": "新人特价现货",
    "YiJieSuan": "去结算",
    "XinYongHuYouHuiZhuanXiang": "新人优惠券",
    "DaiZhiFuQuanKuan": "待支付全款",
    "DinDanJinE": "订单金额",
    "QuanKuan": "全款",
    "ZhuangTaiShuoMin1": "您支付全款后，ESSAONE将立即为您安排发货",
    "ZhuangTaiShuoMin2": "订单支付成功，请于3天内前往莫斯科仓库提货",
    "ZhuangTaiShuoMin3": "提货完毕，订单已完成",
    "QuanKuanHeJiN": "全款合计",
    "SouSuoGongChang": "搜索工厂",
    "YuJiFaHuoShiJian": "预计发货时间",
    "KeHuQuXiaoDengJi": "客户取消登记",
    "XinZengDengJi": "新增登记",
    "DengJiShiJian": "登记时间",
    "DingDanDanHao": "订单单号",
    "DengJiDanHao": "登记单号",
    "DanHao": "单号",
    "GuanLianDanHao": "订单编号",
    "JiXuJieSuan": "继续结算",
    "CaiGouJia": "采购价",
    "DengJiXinXi": "登记信息",
    "ZhengChangDengJi": "正常登记",
    "PoSunDengJi": "破损登记",
    "KeHuQuXiaoDengJiXiangQing": "客户取消登记详情",
    "DingDanChuKuXiangQing": "订单出库详情",
    "ShengChengDengJiDan": "生成登记单",
    "YuanDingDanJinE": "原订单金额",
    "GaiHuoDongZhiNengXuanGouXKuanZuiDuoGouMaiXXaing": "该活动只能选购{0}款，最多购买{1}箱",
    "QingXianShuRuDingDanHaoChaXun": "请先输入订单号查询",
    "QingXuanZeQuXiaoYuanYin2": "请选择取消原因",
    "WoMenJiangZaiShouDaoNinDeDing": "3、订单将在您支付后才开始处理",
    "PiLiangChuHuo": "批量出货",
    "QueRenSuoXuanDingDan": "确认所选{0}个订单",
    "YingFuJinEZongJi": "应付金额总计",
    "DingDanYuanJia": "订单金额",
    "DengJiZongXiangShuBuNengDaYuDingDanShangPinShu": "登记总箱数不能大于订单商品数",
    "XinZengChengGong": "新增成功",
    "GaiHuoDongYiJieShu": "该活动已结束",
    "ChuKu": "出库",
    "KuCunChaXun": "库存查询",
    "GongSiKuCun": "公司库存",
    "KeHuKuCun": "客户库存",
    "ShangPinZongJi": "商品总计",
    "ShangPinZongKuCun": "商品总库存",
    "ZhengChangKuCun": "正常库存",
    "PoSunKuCun": "破损库存",
    "KeYongKuCun": "可用库存",
    "ShengYuKuCun": "剩余库存",
    "ZongKuCun": "总库存",
    "ZhengChangXiangShu": "正常箱数",
    "PoSunXiangShu": "破损箱数",
    "ShangPinKuanChu": "商品款数",
    "DingDanXiangQing": "订单详情",
    "ShangPinXiangShu": "商品箱数",
    "NEWBORN_ZONE_006": "搜索不到此订单",
    "NEWBORN_ZONE_007": "此订单已经登记过",
    "YiChengGongTiJiaoDingDanQingJiShiZhiFu": "已成功提交订单，请及时支付",
    "GongNXiang": "共{0}箱",
    "MeiKuanXianGou": "每款限购",
    "ChuKuChengGong": "出库成功",
    "NEWBORN_ZONE_001": "商品明细未入库不能做取消登记",
    "NEWBORN_ZONE_002": "取消PO明细的箱数(正常+破损)不能大于PO明细总箱数",
    "NEWBORN_ZONE_003": "取消PO明细的箱数(正常+破损)不能大于库存锁定箱数",
    "NEWBORN_ZONE_004": "活动订单的全款应收未支付不能取消登记",
    "NEWBORN_ZONE_005": "请填写要取消商品的箱数",
    "ZhiShaoTianXieYiGeShangPinDengJi": "至少填写一个商品登记",
    "HeJiYingShouKuan": "合计应收款",
    "DingDanJinE": "订单金额",
    "DaiShouKuanJinE": "待收款金额",
    "ZuiJinCuiKuan": "最近催款",
    "JiLuCuiKuanShiJian": "记录催款时间",
    "YiXuanZhuanXiangShangPin": "已选专享商品",
    "QingTianXieYaoQuXiaoShangPinDeXiangShu": "请填写要取消商品的箱数",
    "LaoRenGuiZe": "<p>1.会员定义：已在ESSAONE完成了第一笔订单的买家视为会员。</p>\n<p>2.每位会员每月均可参与“超级会员日”活动。</p>\n<p>3.每位会员在每月活动期间最多可购买共5箱的特惠商品，款式不限，购买次数不限。</p>\n<p>4.特价商品均为现货，库存数量有限，先到先得。</p>\n<p>5.特价商品提交订单后3天内需完成支付，逾期系统将会自动取消该订单。</p>\n<p>6.特价商品不能使用优惠券。</p>",
    "GouMaiShuLiang": "购买数量",
    "LaXinGuiZe": "<p>1. 只有已在ESSAONE注册但未下第一笔订单的买家才能享受此优惠。</p>\n<p>2. 每位新用户只能领取1次优惠券礼包以及购买1次特价商品。</p>\n<p>3. 每位新用户选择使用了优惠券后，无法再购买特价商品。</p>\n<p>4.新人优惠券礼包包含4张优惠券，分2次赠送：注册完成即可获得2张优惠券；首单支付定金后再得2张优惠券。</p>\n<p>5.所有优惠券均不能叠加使用，每笔订单仅限使用一张优惠券。下单时系统会根据当前你可使用的优惠券，默认使用优惠额度最大的一张；或者你有权选择使用其他优惠券。</p>\n<p>6.订单使用优惠券后产生取消，如果是享受优惠的商品全部取消，系统自动返还相应的优惠券。但如果只是部份取消，部分享受了优惠，则优惠券不作返还。</p>\n<p>7.新用户首单享受定金预付10%特权，但仅对第一笔订单有效（特价商品订单除外）。</p>",
    "XinRenGuiZe": "<p>1. 只有已在ESSAONE注册但未下第一笔订单的买家才能享受此优惠。</p>\n<p>2. 每位新用户只能领取1次优惠券礼包以及购买1次特价商品。</p>\n<p>3. 每位新用户选择使用了优惠券后，无法再购买特价商品。</p>\n<p>4.新用户1次最多可同时购买3款特价商品，每款限量1箱。</p>\n<p>5.特价商品均为现货，库存数量有限，先到先得。</p>\n<p>6.特价商品提交订单后3天内需完成支付，逾期系统将会自动取消该订单。</p>\n<p>7.新用户提交订单后即视为1次购买，不论订单最终是否取消。</p>\n<p>8.特价商品不能使用优惠券。</p>",
    "JiaGeShengXu": "按价格从低到高",
    "JiaGeJiangXu": "按价格从高到低",
    "HuoQiShengXu": "按货期短到长",
    "HuoQiJiangXu": "按货期长到短",
    "NEWBORN_ZONE_008": "取消登记处理异常,请联系管理员",
    "CanShengTuiKuan": "产生退款",
    "CangKuGuanLi": "仓库管理",
    "ChuKuDan": "出库单",
    "ChuKuWuLiuXinXi": "出库跟踪",
    "CuiWeiKuan": "催尾款",
    "QuXiaoDengJi": "取消登记",
    "ZhuanGuanShiJian": "转关时间",
    "TiJiaoHouNinDeDingDanJiaGeJiangShouDaoJiaGeBaoHuYu2": "2、提交订单后请在3天内支付订单全款，否则逾期系统将会自动取消该订单。",
    "RenQiShengXu": "按少人选择",
    "RenQiJiangXu": "按热门商品",
    "GouWuCheWuShangPinKeXiaDan": "购物车无商品可下单",
    "YiTuiKuanBingGengXinDingDanJine": "已退款并更新订单金额",
    "GongXiHuoDe": "恭喜获得",
    "PinPaiZhuanShuYouHuiQuan": "品牌专属优惠券",
    "LingYongChengGong": "领用成功",
    "LingYongShiBai": "领用失败，请重新操作",
    "LingYong": "领取",
    "YiLingYong": "已领取",
    "YiLingWan": "已领完",
    "YiZiDongShiYongZuiYouYouHuiQuan": "已自动使用最优优惠券，优惠金额将在尾款结算时候抵扣优惠金额。",
    "ChaKanQuanBuYouHuiQuan": "查看全部优惠券",
    "DingDanHeJi": "订单合计",
    "YouHuiQuanGuiZeShuoMing": "优惠券规则说明",
    "HuoKuanHeJi": "货款合计",
    "XinYongHuZhuCeLuoDiYeShuoMing1": "新用户注册即可获得6张优惠券（总价值1500美金）",
    "XinYongHuZhuCeLuoDiYeShuoMing2": "选购商品下单",
    "XinYongHuZhuCeLuoDiYeShuoMing3": "满足优惠券使用条件即可使用,将在订单尾款自动计算抵扣优惠金额",
    "XinYongHuZhuCeLuoDiYeShuoMing4": "一张订单只能使用一张优惠券",
    "HaiChaJiKeShiYongYouHuiJuanJian": "还差{0}即可使用优惠券减{1}",
    "ShangPinJinE": "商品合计",
    "KeYouHui": "预计可优惠",
    "ZhiDingKeYong": "指定柜型可用",
    "DangQianDingDanYiShiYongManXiangZheYuJiKeYouHui": "当前订单已使用{0}，满{1}享{2}折，预计可优惠{3}",
    "DangQianDingDanYiShiYongManJianYuJiKeYouHui": "当前订单已使用{0}，满{1}减{2}，预计可优惠{3}",
    "HaiChaJiKeShiYongYouHuiJuanXiangZhe": "还差{0}即可使用优惠券享{1}折",
    "XinShouZhiYin1": "ESSA信息隐私及重要保护说明",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong1": "优惠券基本使用说明",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong2": "1. ESSA平台会不定期推出优惠券活动，但优惠券仅限在平台上使用。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong3": "2. 目前优惠券有三种：折扣券、满减券、现金券。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong4": "3. 优惠券获取方式：通过平台自动派发，下单后返赠、参与活动领取等形式获取。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong5": "4. 通常每笔订单限用一张优惠券，每张优惠券限用一次。如有特殊情况，需详见当次优惠券活动使用说明。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong6": "5. 订单使用优惠券后产生取消，如果是享受优惠的商品全部取消，系统自动返还相应的优惠券。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong7": "6. 优惠券是不能进行兑现、出售、转让或其他用途。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong8": "各类优惠券具体使用规则",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong9": "1. 全部通用优惠券：平台上所有商品通用，不受用户、品类、区域限制，订单中所购商品总额需达到用券限额才能使用。每笔订单限用1张全场通用优惠券，按订单金额进行减免。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong10": "2、品类优惠券：该优惠券受品类限制，只能购买特定品类商品。每笔订单限用1张品类优惠券，按订单金额进行减免。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong11": "例如：玩具品类5%折扣券，所下订单中的商品必需包含玩具品类下商品且该品类商品总金额达到用券限额才可以使用。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong12": "3、活动商品优惠券：该优惠券受商品限制，只能购买特定活动商品，每张订单限用1张商品优惠券，按活动商品的总金额进行减免。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong13": "例如：$1000元一箱快出商品满减券，所下订单中的商品必须包含一箱快出的商品且该商品总金额达到用券限额才可以使用。",
    "YouHuiQuanGuiZeShuoMingXiangQingNeiRong14": "4、新人优惠券：该优惠券限新客户使用，新客户是指在ESSA从未下过单的注册客户。只有符合了新客户的资格，所下的订单达到用券要求才可以使用。",
    "DingDanShangPinYinNiDeTiaoZheng": "订单商品因你的调整(取消/调货/转尾货等)，已不满足使用优惠券，请补货或调入商品等操作，以满足优惠券条件。",
    "YouHuiQu": "优惠券",
    "WeiManZuTiaoJian": "未满足条件",
    "sili1": "广东**贸易有限公司成立于1989年，是一家专注于**产品外贸的企业，公司设立于**地区，实力雄厚，积累了众多优质海外客户，长期耕耘**地区市场，拥有**个专业外语员工，获得客户多次优秀评价。",
    "sili2": "本公司已经营3年，积累众多优质客户，订单多。2021年度，向奥**钻玩具工厂下了一个大单，10款商品，金额超过10万元； 同时与某某工厂、某某工厂进行深度合作。",
    "ReMaiDanPin": "热卖单品",
    "YiLingQuChengGongQingWuChongFuLingQu": "已领取成功，请勿重复领取",
    "ZhiDingNGePinPaiKeYong": "指定{0}个品牌可用",
    "DangQianDingDanYiShiYongManXiangZheYuJiKeYouHui_NEW": "当前订单已使用优惠券,满{0}享{1}折,预计可优惠{2}",
    "DangQianDingDanYiShiYongManJianYuJiKeYouHui_NEW": "当前订单已使用优惠券,满{0}减{1},预计可优惠{2}",
    "ZaiMaiKeYouHuiJinE": "再买{0}可优惠金额{1}",
    "HaiChaTiJiJiKeShiYongYouHuiJuanJian": "还差体积{0}即可使用优惠券减{1}",
    "HaiChaTiJiJiKeShiYongYouHuiJuanXiangZhe": "还差体积{0}即可使用优惠券享{1}折",
    "HeTongZhuangTai": "合同状态:",
    "ChaKanHeTong": "查看合同",
    "JieShuHeTong": "结束合同：",
    "HeTongBianJi": "合同编辑:",
    "QianDingRiQi": "签订日期:",
    "HeTongWenJian": "合同文件：",
    "DianJiHuoJiangWenJianTuoZhuaiDaoZheLiShangChuan": "点击或将文件拖拽到这里上传：",
    "ZhiChiKuoZhanMing": "支持扩展名：",
    "ShuRuSouSuo": "输入搜索：",
    "FuKuanPingZheng": "付款凭证",
    "WeiFuKuanPingZheng": "未付款凭证",
    "YiFuKuanPingZheng": "已付款凭证",
    "PingZhengLeiXing": "凭证类型:",
    "YingFuZongJinE": "应付总金额：",
    "FuKuanPingZhengShengChengShiJian": "付款凭证生成时间",
    "ChaKanFuKuanPingZheng": "查看付款凭证",
    "ShouKuanShouJu": "收款收据:",
    "ZanWuWenJian": "暂无文件:",
    "QingShuRuPODanHaoHuoZheJiGuiDanHao": "请输入PO单号或者集柜单号:",
    "XinZengHeTong": "新增合同",
    "HeTongQiXian": "合同期限：",
    "HeTongJieShuRiZi": "合同结束日期:",
    "HeTongBianMa": "合同编码:",
    "HeTongYiCunZai": "合同已存在",
    "HeTongGuanLi": "合同管理",
    "WangZhanDiTu": "网站地图",
    "XinWenZhongXin": "新闻中心",
    "WeiWanShanWuFaJiaGou": "未完善无法加购",
    "ZheGeGongChangHenJiuMeiShang": "这个工厂很久没上新品了。",
    "Jin3TianYongHuHangWei": "近3天行为",
    "Jin3TianDengLuTianShu": "近3天登录天数:",
    "Jin3TianLiuLanXiangQingShangPinKuanShu": "近3天浏览详情商品款数:",
    "Jin3TianJiaGouKuanShu": "近3天加购款数:",
    "QuanBuXinWen": "全部新闻",
    "ShangYiPian": "上一篇",
    "XiaYiPian": "下一篇",
    "30TianMianFeiCangChu": "30天免费仓储",
    "YiChangHaoShiPaiXu": "异常耗时排序",
    "YiChangShangPinShu": "异常商品数",
    "ChaKanYiChang": "查看异常",
    "YiChangShiJian": "异常时间",
    "YiChangHaoShi": "异常耗时",
    "QianZaiKeHuDengJiDanChuangBiaoTi": "新客户送 1500 USD优惠券",
    "BaoGuanTieZhiGuanLi": "订单贴纸处理",
    "QinQuanQueRen": "侵权确认",
    "QinQuanShenHe": "侵权审核",
    "TianXieHaiGuanBianMa": "填写海关编码",
    "ZhengShuShenHe": "证书审核",
    "SheZhiTieZhiPinPai": "设置贴纸品名",
    "WuZhengShuGuanLi": "无证书管理",
    "DingDanTiJiaoShiZhang": "订单提交时长",
    "ShangPinShu": "商品数",
    "HaiGuanBianMa": "海关编码",
    "ShangChuan2": "上传",
    "BaoGuanPinMingJinDuGenZong": "报关品名进度跟踪",
    "DingDanShiJian": "订单时间",
    "YouZhengShu": "有证书",
    "WuZhengShu": "无证书",
    "certificateEncoding": "证书编码",
    "ZuiJinShenHeShiJian": "最近审核时间",
    "ShangYiJiShenHeRen": "上一位审核人",
    "ShenHeShiJian": "审核时间",
    "TieZhiMoBan": "贴纸模板",
    "PinMing": "品名",
    "TieZhiPinMing": "贴纸品名",
    "QingTianXieWuZhengShuShuoMing": "请填写无证书说明",
    "XuanZeTieZhiMoBan": "选择贴纸模板",
    "ChaKanYingWenPinMing": "查看英文品名",
    "ChaKanEWenPinMing": "查看俄文品名",
    "WuZhengShuShangPin": "无证书商品",
    "ShenHeRen": "审核人",
    "ShangPinJiangYuHouGuXiaoCaiGou": "商品将于<b>{0}</b>后取消采购",
    "DangQianJieDian": "当前节点",
    "DangQianChuLiRen": "当前处理人",
    "LiKaiDangQianYeHouSuoBianJiDeShuJuJiangBuKeHuiFu": "离开当前页后所编辑的数据将不可恢复",
    "DaiChuLi": "待处理",
    "ZhengChang": "正常",
    "QinQuan": "侵权",
    "ShangYiGe": "上一个",
    "XiaYiGe": "下一个",
    "BuQinQuan": "不侵权",
    "QueRenXiaYiGe": "确认侵权",
    "XiaYiDan": "下一单",
    "GaiDingDanQuanBuShangPinYiChuLi": "该订单全部商品已处理",
    "QingTianXieWeiShuDeHaiGuanBianMa": "请填写{0}位数的海关编码",
    "NaShuiRenDengJiDaiMa": "组织机构代码",
    "YinHangDaiMa": "银行固定对应账户",
    "ZuiJinChuLiShiJian": "最近处理时间",
    "LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu": "离开当前页后，所编辑的数据将不可恢复",
    "QinQuanShangPinShu": "侵权商品数",
    "QingQueRenShiFouDuiXuanZeDeShangPinQuXiaoCaiGou": "请确认是否对选择的商品取消采购",
    "QingXuanZeShangPinHouZaiDaoChu": "请选择商品后再导出",
    "DangQianWuKeXiaZaiShangPin": "暂不支持无证书商品下载",
    "ShangPinPiPeiShiBai": "商品匹配失败，请检查修改后重新上传。",
    "ShangChuanChuLiJieGuo": "上传处理结果",
    "WenJianGeShiBuZhengQue": "文件格式不正确，不能上传",
    "QingXuanZeShangPinHouZaiXiaZai": "请选择商品后再下载",
    "QingTianXieZhengShuBianMa": "请填写证书编码",
    "WeiShu": "位数",
    "QueRenJieGuo": "确认结果",
    "SuoShuLeiMu": "所属类目",
    "QinQuanQueRen2": "侵权确认",
    "TuCaoYiXia": "吐槽一下",
    "ShangShiShiJian": "上市时间",
    "ChuHuoDanGuanLi": "出货单管理",
    "YuJiChuHuoDingDan": "预计出货订单",
    "YiChuHuoDingDan": "已出货订单",
    "ZongTiJiM3": "总体积m³",
    "XiaZaiLiuMianTu": "下载包装六面图",
    "ChaKanTieZhiPaiBanTu": "查看贴纸排版图",
    "XiaZaiZhiJianTuPian": "下载质检图片",
    "BaoZhuangLiuMianTu": "包装六面图",
    "ZhuangGuiFaYunShiJian": "装柜发运时间",
    "ChaKanZhuangGuiTuPian": "查看装柜图片",
    "YiChuHuoDingDanYouDaiQueRenDeSuiCheDan": "已出货订单有待确认的随车单，请尽快下载随车单确认",
    "ChuangJianYu": "创建于",
    "QueRenSuiCheDan": "确认随车单",
    "ZhongXinShangChuan": "重新上传",
    "YuZhuangXiangDan": "预装箱单",
    "XuanZeBaoBiaoMoBan": "选择报表模板",
    "DingDanGuanLi": "订单管理",
    "KeHuGuanLi": "客户管理",
    "ZanWeiShangChuan": "暂未上传",
    "ChuHuoHouQuXiao": "出货后取消",
    "Jin7TianYouBianHuaDingDan": "近7天有变化订单",
    "YiChuHuoDingDanYiQueRenSuiCheDan": "已确认随车单",
    "ChuHuoHouQuXiaoShangPin": "出货后取消商品",
    "DDPStatus101": "已支付尾款",
    "DDPStatus102": "已入库，待支付尾款",
    "SuiCheDanQRueRenHouJiangWuFaZaiCiSiuGai": "随车单确认后将无法再次修改，将按照确认的随车单进行报关",
    "KeHuGouWuChe": "客户购物车",
    "KeHuDingDan": "客户订单",
    "ZongGongNKuanNXiang": "总共{0}款，{1}箱",
    "DaiTiHuo": "待提货",
    "YuJiChuHuoDingDanXiangQing": "预计出货订单详情",
    "CLAIM_DAMAGE_012": "订单需先完成转关操作后才能进行入库登记",
    "ShangPinBianMa2": "商品编码",
    "Jin3TianYouBianHuaDingDan": "近3天有变化订单",
    "PODingDan": "PO单号",
    "WanChengShiJian": "完成时间",
    "YuJiChuHuoShiJian": "预计出货时间",
    "DaiQueRenSuiCheDan": "待确认随车单",
    "YiChuHuoDingDanXiangQing": "已出货订单详情",
    "QingShuRuJiGuiDanHaoHuoKeHuBianHao": "请输入集柜单号或客户编号",
    "ShangPinShengChanYaoQiu": "商品生产要求",
    "DingDanTieZhiXinXi": "订单贴纸信息",
    "TieZhiPaiBan": "贴纸排版",
    "GongZhangTieZhiPaiBanTu": "共{0}张贴纸排版图",
    "XiaZaiPaiBanTu": "下载排版图",
    "PaiBanYouWenTi": "排版有问题",
    "QueRenWuWu": "确认无误",
    "MiaoShuNiDeWenTi": "描述你的问题",
    "QuanBuYiJianCha": "全部已检查，确认无误？",
    "ShangPinDanDuTieZhi": "商品单独贴纸，此部分贴纸费用需要额外加收",
    "MaTouYaoQiu": "唛头要求",
    "MiaoShuPaiBanCunZaiWenTi": "描述排版存在问题",
    "ZanBuSheZhi": "暂不设置",
    "QueRenBianGeng": "确认变更",
    "BeiZhuDingDanGeXingHuaYaoQiu": "备注订单个性化要求",
    "GongChangJiangAnZhaoNinDeYaoQiuGenJinShengChan": "例如：电池规格，打包要求等关于商品在生产过程中药注意事项，工厂将按照您的要求跟进生产",
    "TeBieYaoQiu": "跟单、质检、装柜特别要求",
    "ShangPinQingDan": "商品清单",
    "QingZaiTianNeiZhiFuDingJin": "请在{0}天内支付定金，并确认订单",
    "ShangChuanWenJianYaoQiu": "支持{0}，最大支持{1}",
    "PaiBanYouWenTiYiFanKui": "排版有问题：已反馈",
    "CHANGE_SALE_PO_ITEM_PRODUCT_REQUIRE_ERROR": "订单生产中，如需变更请联系业务员",
    "GongNZhangTieZhiPaiBanTu": "共{0}张贴纸排版图",
    "ShanɡPinShenɡChanYaoQiu": "商品生产要求",
    "HuoQuZiXun": "获得咨询",
    "LiuXiaNiDeLianXiFangShi": "留下你的联系方式",
    "YiXiangCaiGouXiangShu": "意向采购箱数",
    "QiWangJiaGe": "期望价格",
    "BiGongChangBaoJiaJiangJia": "比工厂报价降价{0}",
    "ChaKanDianHua": "查看电话",
    "ZhongXinHuoQu": "重新获取",
    "JinTianQianBoDaYouXiao": "今天{0}前拨打有效",
    "YiChaoShiShiXiao": "已超时失效",
    "Zhuan": "转",
    "YinSiHao": "隐私号",
    "ZhuCeESSAONEBiaoTi": "注册ESSAONE",
    "DuanXinYanZhengMa": "短信验证码",
    "QingShuRuDuanXinYanZhengMa": "请输入短信验证码",
    "TianXieGengDuo": "填写更多",
    "GongSiXinXiZhiYongYuYanZheng": "公司信息只用于验证，我们会保障你的隐私信息",
    "LianXiZaiXianKeFu": "联系在线客服",
    "QingShuRuDianZiYouJian": "请输入电子邮件",
    "QingXuanZeQuYu": "请选择区域",
    "DiYuGongChangZuiXiaoCaiGouShuLiang": "低于工厂最小采购数量，工厂可能会拒绝交易。",
    "DiYuMOQ": "低于MOQ",
    "ZhengZaiXiangGongChangQueRenShengChanYaoQiu": "正在向工厂确认生产要求，工厂确认后即可进行下单",
    "NiDeZhangHuShangWeiRenZheng": "你尚未填写公司信息，因此无法下单。",
    "MaShangQuWanShan": "马上去完善",
    "XuYaoBangZhuMa": "需要帮助吗？",
    "RuGuoNiYouRenHeWenTiXuYaoBanZhu": "如果你有任何问题需要帮助，留下手机号码，我们会主动与你联系，解答你的疑问",
    "ZhaoBuDaoShangPin": "找不到商品？",
    "LiuXiaNiDeDianHua": "留下你的电话，客服会联系，帮助你解决你的问题或联系我们 8-800-550-3301",
    "YiTuSouSuo": "以图搜图",
    "ChaKanGongChang": "查看工厂",
    "GaiShangPinYouShengChanJiaoFu": "该商品由{0}生产交付",
    "2ZhouNianHuoDongGuiZe": "1. 活动时间：2022年5月11日至2022年6月11日。<br />\n2. 所有在essaone已注册的用户（新老用户）均可参与该活动。<br />\n3. 活动期间内每位用户仅能享受一次3.3%折扣，即该折扣仅适用于1个订单。该折扣不适用于已有的促销商品，也不能同时与其他优惠券叠加使用。<br />\n4. 活动期间内累计订单实付金额达到规定金额，网站将于6月12日给满足条件的用户额外回赠一张最高折扣的优惠券。<br />\n1）累计实际支付金额：<br />\n• 超过100,000卢布，您将获得一张2,000卢布的优惠券。<br />\n• 超过500,000卢布，您将获得一张6,000卢布的优惠券。<br />\n• 超过1,000,000卢布，您将获得一张10,000卢布的优惠券。<br />\n2）每位用户只能获得一张优惠券。该优惠券仅适用于订单超过 20,000 卢布。<br />\n3）回赠的优惠券有效期为2022.06.12至2022.07.12，逾期将失效。<br />\n5. 本活动所有领取的优惠券均可在您的账户“我的优惠券”中查看。<br />\n6. 如对本活动有任何问题，请随时联系在线客服进行咨询。该活动解释权归ESSAONE所有。",
    "DingDanXiangGuanYaoQiu": "订单相关要求",
    "NiKeYiChangShiJiaRuGouWuCheDingGouYiXiang": "你可以尝试加入购物车订购一箱",
    "MiMaTiShi": "密码提示",
    "ZiMuYuShuZiZhuHe": "字母与数字组合，不能全为数字",
    "ZiShaoNGeZiFu": "至少{0}个字符",
    "YanZhengYouJianYiFaSongDaoYouXiang2": "验证邮件已发送到邮箱{0}",
    "DianJiJiangTongBu": "点击【我要询价】将同步通知贸易公司你想要购买此商品和意向购买数量",
    "WoYaoXunJia": "我要询价",
    "QuanBuXunJia": "全部询价",
    "DaoChuTuPian": "导出图片",
    "ShangPinShuLiang": "商品数量",
    "TuiJianZhuTiMingCheng": "搜索主题名称",
    "QingShuRuFangWenMiMa": "请输入访问密码",
    "FanHuiLiShiLieBiao": "返回历史列表",
    "XiaoShou": "销售顾问",
    "TongZhiChengGong": "通知成功",
    "YiGaoZhiMaoYiGongSi": "已把意向商品和采购数量告知贸易公司",
    "WoDeTuiGuang": "我的推广",
    "TuiGuangYaoQingJiaoCheng": "推广邀请教程",
    "ZhangHuZiLiaoWeiWanShan": "账户资料未完善，不能推广邀请客户。",
    "LiJiQuWanShanZhuanQuTiCheng": "立即去完善，赚取提成",
    "TuiGuangKeHuNaTiCheng": "吸引和激励客户在 ESSAONE 网站上订购产品\n每笔订单均可获得现金奖励",
    "TuiGuangKeHuNaTiChengJieShaoNeiRong": "吸引俄罗斯不同地区的客户，地理位置并不重要，每笔订单均可获得保证奖励。\n与 ESSAONE 一起发展电子商务 - 获得实际收入",
    "FaSongNiDeZhuanShuLianJieGeiKeHu": "发送你的专属链接给客户",
    "ShouJiDuanFenXiang": "手机端分享",
    "KeHuZhuCeShiTianXieNiDeYaoQingMa": "客户注册时填写你的邀请码",
    "FaZhanFenXiaoShangNaTiCheng": "发展分销商拿提成",
    "FaZhanFenXiaoShangNaTiChengJieShaoNeiRong": "发展分销商拿提成介绍内容",
    "ChaKanFenXiaoShang": "查看分销商",
    "XinZengFenXiaoShang": "新增分销商",
    "QingXianWanShanZiLiaoQuBuChong": "请先完善资料，去补充 >>",
    "MoRenNiDeShouJiHaoMa": "默认你的手机号码",
    "BenZhouYuJiShouRu": "本周预计收入",
    "YaoQingKeHuShouRu": "邀请客户收入",
    "XiaJiFenXiaoShangYaoQingKeHuHuoDeShouRu": "下级分销商邀请客户获得收入",
    "DaiJieSuan": "待结算",
    "LeiJiYiJieSuan": "累计已结算",
    "BianJiZhangHaoXinXi": "编辑账号信息",
    "ShiYongShouJiSaoMiao": "使用手机扫描, 在手机端分享你的注册链接",
    "ChaKanJiaoCheng": "查看教程",
    "FaSongYaoQingLianJieYaoQingKeHuZhuCe": "发送邀请链接，邀请客户注册，系统认证客户注册账号后，即可获得提成。还可以发展下级分销商，同样可以获得奖励。",
    "MeiZhouSanQianShenQingDeTiXianShenQing": "每周三前申请的提现申请，ESSA将在下周三前完成汇款。如遇节假日可能会有延迟，如有疑问，请咨询客服人员。",
    "YaoQingHaoYouXinXiI": "您邀请的新客户只有通过您提供的注册链接或在注册时填写了您的手机邀请码，他才会跟您的账号进行绑定，这样您才有机会获得新客户成功注册的提成。",
    "YaoQingHaoYouXinXiK": "您最终所获得的提成均以新客户成功注册并通过认证为准。",
    "TongGuoYaoQingYouXiaoZhuCeYongHuHuoDeTiCheng": "通过邀请有效注册用户获得提成",
    "TongGuoYaoQingYouXiaoZhuCeYongHuHuoDeTiChengJieShaoNeiRong": "通过邀请有效注册用户获得提成介绍内容",
    "TongGuoFaZhanFenXiaoShangHuoDeTiCheng": "通过发展分销商获得提成",
    "TongGuoFaZhanFenXiaoShangHuoDeTiChengJieShaoNeiRong": "通过发展分销商获得提成介绍内容",
    "JieSuanZhong": "结算中",
    "YiTiJiaoTiXianShenQingZhengDengDaiPingTaoHuiKuan": "已提交提现申请，正等待平台汇款",
    "YaoQingDeKeHu": "邀请的客户",
    "KeHuZhangTai": "客户状态",
    "LeiJiYaoQingRenYiRenZhengTongGuoRenHuoDeTiCheng": "累计邀请{0}人，已认证通过{1}人，获得提成{2}",
    "XiaJiFenXiaoShang": "下级分销商",
    "CaiGouShangRenZhengZhuangTai": "采购商认证状态",
    "QingXuanZeCaiGouShangRenZhengZhuangTai": "请选择采购商认证状态",
    "YaoQingKeHuShu": "邀请客户数",
    "LeiJiJiangLi": "累计奖励",
    "Nan": "男",
    "Nu": "女",
    "ShiLi": "示例",
    "QingShuRuDengLuMingZi": "请输入登录名字",
    "ShouRuMingXi": "收入明细",
    "TiXianMingXi": "提现明细",
    "TiXianXianJin": "提现现金",
    "YinHangKaXinXi2": "银行卡信息",
    "YinHangKaXinXiShuoMing": "银行卡信息说明",
    "XiuGaiDengLuMiMa": "修改登录密码",
    "QueRenTiXian": "确认提现",
    "RuGuoYouWuQingJiShiGengXin": "如果有误，请及时更新",
    "QuXiuGai": "去修改",
    "QuBuChong": "去补充",
    "HaiMeiYouZhangHuXingXi": "还没有账户信息",
    "ShouJiDengLuMing": "手机（登录名）",
    "ChuShiMiMa": "初始密码",
    "QingXuanZeGuoJia2": "请选择国家",
    "JiuMiMa": "旧密码",
    "LiuKongBuXiuGaiMiMa": "留空不修改密码",
    "FuZhiZhangHaoMiMa": "复制账号和密码",
    "FenXiangZhangHao": "分享账号",
    "ZanWuQuanXianXinZengFenXiaoShang": "暂无权限新增分销商",
    "ChengGongYaoQingYiGeKeHuHou": "成功邀请一个客户后，可以获得新增分销商权限",
    "XinMiMaBuYiZhi": "新密码不一致",
    "FenXiaoShangGuanLi": "分销商管理",
    "FenXiaoShangJieSuan": "分销商结算",
    "TiXianShenQingChengGongQingDengDaiPingTaiJieSuen": "提现申请成功，请等待平台结算",
    "ZuiDaZhiChiShangChuanWenJianYaoQiu": "最大支持{0}，支持{1}格式",
    "TuiGuangKeHuShu": "推广客户数",
    "LeiJiYongJin": "累计佣金",
    "TuiJianRen": "推荐人",
    "LeiXingZhuangTai": "类型&状态",
    "TuiGuangXiangQing": "推广详情",
    "XiaoShouQuYu": "销售区域",
    "FenXiaoLeiXing": "分销类型",
    "ZhangHuZhuangTai": "账户状态",
    "YiJieSuan2": "已结算",
    "FenXiaoShangZhangHao": "分销商账号",
    "DaiJieSuanJinE": "待结算金额",
    "HeXiao": "核销",
    "ShenQingShiJian": "申请时间",
    "SouSuoLiuShuiHaoFenXiaoShangZhangHaoXinMing": "搜索流水号/分销商账号/姓名",
    "TuiHuiShiJian": "退回时间",
    "YiJieSuanJinE": "已结算金额",
    "JieSuanShiJian": "结算时间",
    "TuiHui": "退回",
    "QueRenHeXiaoGaiBiDaiJieSuanMa": "确认核销该笔待结算吗",
    "TuiHuiJieSuanShenQing": "退回结算申请",
    "QingGouXuanTuiHuiJieSuanShenQingYuanYin": "请勾选退回结算申请原因",
    "JiuFenXiaoShangTongJi": "旧分销商统计",
    "FenXiaoShangTuiGuangXiangQing": "分销商推广详情",
    "FenXiaoShangChengGongYaoQingKeHuLeiJiJiangLiTiShi": "分销商成功邀请客户，你累计获得的提成。",
    "ShengChengFenXiaoShang": "生成分销商",
    "ShengChengChengGong": "生成成功",
    "FenXiaoShangChengGongYaoQingKeHuLeiJiJiangLiTiShi2": "分销商成功邀请客户，他累计获得的提成。",
    "BianJiZiLiao": "编辑资料",
    "XiaJiTuiGuangKeHu": "下级推广客户",
    "AnChangJianShiJianDaoXu": "按创建时间倒序",
    "AnTuiGuangKeHuShuDaoXu": "按推广客户数倒序",
    "AnTuiGuangKeHuShuShunXu": "按推广客户数顺序",
    "AnXiaJiFenXiaoShangDaoXu": "按下级分销商用户数倒序",
    "AnLeiJiYongJinDaoXu": "按累积佣金倒序",
    "AnLeiJiYongJinShunXu": "按累积佣金顺序",
    "YaoQingKeHu": "邀请客户",
    "YouXiaoKeHu": "有效客户",
    "DengTongShouJiHaoMa": "等同手机号码",
    "QingShangChuanFenXiaoShangDeZhengJianZhaoPian": "请上传分销商的证件照片",
    "FenXiaoShangDeYinHangZhangHuXinXiTiShi": "分销商的银行账户信息，用于后续的返利，务必请分销商提供正确的账户信息。",
    "MiMaGuiZe": "请输入6-20位字符，由数字、字母和符号两者以上组合",
    "ShiFouYaoTingYongGaiFenXiaoShangMa": "是否要停用该分销商吗",
    "YiTuiHuiJinE": "已退回金额",
    "XiaJiYongHuDingDanHaiMeiChuHuo": "下级用户%s订单还没出货",
    "FenXiaoShangHaiYouDaiJieSuanJieSuanZhongDeJinE": "分销商还有待结算/结算中的金额",
    "TuiHuiYuanYin": "退回原因",
    "FenXiaoShangXiangQing": "分销商详情",
    "ZiJinZhangHaoYiChang": "资金账号异常",
    "TiXianQingQiuYiChang": "提现请求异常",
    "QingShuRuZhengQueDeXiuGaiQianMiMa": "请输入正确的修改前密码",
    "FenXiaoShangYouDaiJieSuanJinE": "分销商有待结算或者结算中金额,不允许停用",
    "BianJiFenXiaoShang": "编辑分销商",
    "FenXiaoShangMingChengZhangHao": "分销商名称/账号",
    "MiMaGuiZe2": "请输入6-20位字符",
    "QieHuan": "切换",
    "TuiJianJiLu": "推荐记录",
    "TuiJianXiangQing": "推荐详情",
    "YaoQingHaoYouXinXiJ": "您最终所获得的提成均以新客户成功注册并通过认证为准。",
    "QingDengDaiWenJianZhengZaiDaBaoZhong": "请等待，文件正在打包中",
    "JianChaZhiJianTuPian": "检查质检图片",
    "ZhiJianTuPianQueRen": "质检图片确认",
    "BiaoJiCiShangPin": "标记此商品",
    "QuanBuZhuangTai2": "全部状态",
    "ZhiJianYouWenTi": "质检有问题",
    "ZhiJianMeiWenTi": "质检没问题",
    "ZhiJianDaiChuLi": "质检待处理",
    "JinRuXiaYiKuan": "进入下一款",
    "YiBiaoJi": "已标记",
    "YouWenTi": "有问题",
    "QuXiaoBiaoJi": "取消标记",
    "ChuHuoShiJianiYouGaiBian": "出货时间有改变",
    "ShangYiCi": "上一次",
    "ShangYiZhang": "上一张",
    "XiaYiZhang": "下一张",
    "NinLiuLanDeYeMianYiGuoQi": "您浏览的页面已过期，稍后跳转至首页，浏览查找更多商品！",
    "WanJuCaiGouXuanZe": "玩具采购选择",
    "NiLaiDuiDiFangLe": "你来对地方了",
    "ZhuanYePingTai": "专业平台",
    "WanJuGengQingSong": "让玩具采购更轻松",
    "XuanZeGengRongYi": "使产品选择更快更容易",
    "ChanPinZhiNengChaZhao": "产品只能查找",
    "YiZhanShiJieJue": "选择问题的一站式解决方案",
    "ZhuZhaZhongGuoGongChang": "驻扎着2万多家中国工厂",
    "WanZhengDeChanPinKu": "最新最完整的玩具类产品库",
    "ZhuanYeMaiJiaTuiJian": "专业买家推荐",
    "ShiHeNiMenDeChanPin": "最适合你们市场的产品",
    "JiaGeTouMing": "价格透明度",
    "QuanPingTaiJiaGeWei": "全平台价格为",
    "GongChangDuLiBaoJia": "工厂独立报价",
    "CaiGouDeFuWuChengBen": "透明的采购服务成本",
    "GengHaoDeKongZhiChengBen": "使您能够更好地控制采购成本",
    "GengQingSongDeGouMaiTiYan": "更轻松的购买体验",
    "YiDuiYiDeZhuanMenFuWu": "一对一的专业客户服务",
    "ZhuLiuFuWuJingLi": "100名主流语言服务经理",
    "GenZongDinDanChuLi": "在整个过程中跟踪订单的处理",
    "GaoJiCaiGouTuanDui": "一线供应链高级采购团队",
    "WeiNiTiGongDingZhiHeQiTa": "为您提供OEM定制和其他",
    "GeXingHuaFuWu": "个性化服务",
    "WoMenDeBaoZheng": "我们的保证",
    "ChanPinZhiLiangBaoZheng": "产品质量保证",
    "PingTaiQueBaoAnBiaoZhunPeiChang": "平台确保工厂将按照货物损坏或短缺的赔偿标准见详细标准。",
    "HuoWuPeiChangBiaoZhun": "货物赔偿标准",
    "JiaoHuoShiJianBaoZheng": "交货时间保证",
    "BaoZhengTiaoJian": "如果不能按时交货，延迟7天后开始计算赔偿，然后每延迟1天按延迟订单金额的0.1%罚款。 除因客户原因造成的延误外（如订舱延误、客户要求未按时发货、付款未按时到达等）以及其他不可抗力造成的延误。",
    "FuKuanBaoZhengJin": "付款保证金",
    "QueBaoHuoKuanAnQuan": "我们只向可靠且合格的工厂下订单并付款，确保您的付款安全。",
    "RuHeGongZuo": "玩转ESSA",
    "YouXvQiuHuoJiaRu": "有采购需求或只是看看新品",
    "ChaKanTuiJianShangPin": "来essa查看智能推荐的商品 / 把需求告诉您的essa专属买手",
    "ZhaoDaoHeShiDeShangPin": "essa为您找到最适合的一盘商品",
    "XuanZeZhiJieCaiGou": "你可以选择直接在essa采购，签订采购合同",
    "QueRenDinDanLiJiShengChan": "确认采购订单后，工厂即刻为您生产",
    "ZhiJieCaiGou": "ESSA将为您提供严格的平台质检，为您完成中转托运",
    "RuGuoNiYouWenTi": "如果您有问题，请联系",
    "DinYueChengGong": "订阅成功",
    "YouXiangYouWu": "填写的邮箱有误，请填写正确的邮箱",
    "WhatsAppLianXiRen": "WhatsApp联系人",
    "DinYue": "订阅",
    "HuiYuanZhongXin": "会员中心",
    "KaiShiXuanGou": "开始选购",
    "WanJuHuiChang": "玩具会场",
    "ShiLiGongChang": "实力工厂",
    "WenJu": "文具",
    "TiYuYongPing": "体育用品",
    "JieRiYongPing": "节日用品",
    "RiYongPingHeCanChuJu": "日用品和餐厨具",
    "GengDuoXinPin": "查看新品",
    "RuMenZheKou": "入门折扣",
    "BenRi": "昨日",
    "BenZhou": "本周",
    "BenYue": "本月",
    "MiaoZiDongShouQi": "{0}秒 自动收起",
    "TongGuoShiBieTuPianShouSuo": "通过识别图片搜索商品，尽量保持图片的主体清晰，背景简单",
    "MeiRiXinPin": "每日新品",
    "LiaoJieXiangQing": "了解详情",
    "BaoQingGuanWuLiuMenDaoMen": "包清关物流门到门服务，",
    "ZongGongKuanXiangShangPinZongJia2": "总共{0}款，{1}箱",
    "QingTianXieYouXiaoYouXiang": "注册会发送验证邮件，请填写有效邮箱",
    "WoYiYouZhangHao": "我已有账号",
    "QuDengLu": "去登录",
    "QingShuRuMiMaJiShuZhi": "请输入8位以上密码，需包含字母与数字",
    "YaoQingMa": "优惠券代码",
    "ZhengZaiShenHeZhong": "正在审核中，工作人员将在24小时内完成审核",
    "ShengHeZhong": "审核中",
    "WeiRenZhengZhiNengChaKan": "未认证只有3天查看价格的权限，选购商品不会向工厂发起询价。通过认证将获得更完整的体验。",
    "QingTianXieZhenShiShouJi": "请填写真实手机号码，客服稍候会电话联系你验证",
    "QingShuRuShouJiHaoMa": "请输入手机号码",
    "ZhuyYaoXiaoShouQuYu": "主要销售区域",
    "ZhengGui": "整柜",
    "ZhuYaoCaiGouPinLei": "主要采购品类",
    "DiYiShiJianTuiJianXinPin": "第一时间推荐新品与热销商品",
    "XuanZePinLei": "选择品类",
    "QingXuanZeCaiGouPinLei": "请选择意向采购品类，最多选择五个",
    "NinTianXieDeDianZiYouXiangYouWu": "您填写的电子邮箱有误",
    "YaoQingMaWuXiao": "当前邀请码无效，请检查您的邀请码",
    "QingTongYiTiaoKuan": "请阅读并选择是否同意上述注册条款",
    "QingShuRuLianXiRen": "请输入联系人名称",
    "QingShuRuNinDeGongSiMing": "请输入您的公司名称",
    "QingXuanZeChuHuoFangShi": "请选择出货方式",
    "QingXuanZeGuoJiaHeQuYu": "请选择销售区域和国家",
    "QingShuRuNinDeDianZiYouXiang": "请输入您的电子邮箱",
    "QingShuRuNinDeMiMa": "请输入您的密码",
    "ZhangHaoJiHuoChengGong": "账号激活成功",
    "QuRenZheng": "去认证",
    "YouXiangLianJieShiXiao": "邮箱验证链接已失效",
    "YouXiangYanZhengChongXinZhuCe": "邮箱验证链接24小时内有效，请重新注册",
    "QianWangDianZiYouXiang": "前往您的电子邮箱",
    "ChaShouYouJian": "查收邮件，按邮件内容激活账户",
    "RuGuoMeiYouShouDaoYouJian": "如果没有收到邮件",
    "ZhuCeWanCheng": "注册完成",
    "FaSongChengGong": "发送成功",
    "QingJianChaNinTianXieDeXinXi": "请检查您填写的信息",
    "ZhuCeHouChaKanGengDuoJieGuo": "注册后查看更多结果",
    "MianFeiZhuCeZhangHao": "免费创建账号",
    "ZhaoDaoNKuanShangPin": "找到 {0} 款商品",
    "ZhuCeGongSi1": "达尼亚进出口有限公司",
    "ZhuCePinLun1": "在中国，很少见到有垂直于玩具类目的采购平台。ESSA是我目前见过最专业的。现在去中国采购很难，没办法去展厅。而ESSA的商品很全，图片非常清晰，给我们很好地解决选品看样品的问题。",
    "ZhuCeGongSi2": "汕头科创有限公司",
    "ZhuCePinLun2": "ESSA样品库的产品很齐全，在手机登录就能随时随地查找样品，非常的方便！",
    "ZhuCeGongSi3": "ALISA TOYS",
    "ZhuCePinLun3": "与ESSA合作多年，非常愉快。我非常看好这个公司。他们的团队非常有活力，每个人都很聪明，非常有干劲。他们用互联网来改革这个外贸流程都想法，我非常欣赏，而他们现在也逐步做到了！",
    "ZhuCeGongSi4": "欣可玩具公司",
    "ZhuCePinLun4": "ESSA团队非常热情，平台品类十分齐全，操作也非常简单，我可以在上面轻松地找到我想要的商品。",
    "RenZhengBuTongGuo": "认证不通过",
    "EWen": "俄文",
    "YingWen": "英文",
    "HaiMeiYouZhangHao": "还没有账号？",
    "WeiRenZhengZhiNengChaKan2": "未认证只有3天查看价格的权限，选购商品不会向工厂发起询价",
    "HuoDeWanZhengDeTiYan": "认证账户将获得更完整的体验",
    "ChangShiChongXinFaSongYouJian": "如果还未收到，尝试重新发送邮件",
    "YiZhiShouBuDaoQingLianXiKeFu": "一直收不到，请联系客服",
    "DengLuChengGong": "登录成功",
    "RuGuoMeiYouKeYiBuTianXie": "如果没有，可以不填写",
    "DanJuGuanLi": "单据管理",
    "SuiCheDan": "随车单",
    "BiaoJi": "标记",
    "ChanPinTiaoMa": "产品条码",
    "ZhongWenPinMing": "中文品名",
    "YinWenPinMing": "英文品名",
    "ErWenPinMing": "俄文品名",
    "NeiHe": "内盒",
    "DDPDanJia": "DDP单价",
    "DDPZongChengJiaoJia": "DDP总成交价",
    "EXWDanJia": "EXW单价（CNY）",
    "EXWZongChengJiaoJia": "EXW总成交价（CNY）",
    "FOBDanJia": "FOB单价（RUB）",
    "FOBZongChengJiaoJia": "FOB总成交价（RUB）",
    "XiaDanLuBuHuiLv": "下单卢布汇率",
    "CIFJiaGe": "CIF价格(CNY)",
    "TieZhiBianHao": "贴纸编号",
    "BanBen": "版本",
    "ShengChanGuo": "生产国",
    "JianShu": "件数",
    "MaoZhong": "毛重",
    "ZhongJia": "总价",
    "LiShiJiLu": "历史记录",
    "XiaZaiExcel": "导出报价单",
    "XiaZaiGaiZhangPDF": "下载盖章PDF",
    "ShiZhuangGuiRiQi": "实装柜日期",
    "FaPiaoHao": "发票号",
    "HeTongBianHao": "合同编号",
    "JiaoHuoTiaoKuan": "交货条款",
    "MaiFang": "买方",
    "MuDiDiGuoJia": "目的地国家",
    "JiGui": "集柜",
    "MuDiDiCheZhan": "目的地车站",
    "FaJianRen": "发件人",
    "TuoYunRen": "托运人/卖方",
    "WeiQueRen": "未确认",
    "PinPaiReMen": "品牌热门",
    "TongLeiMuPaiHangBang": "同类目排行榜",
    "ShangCiBuTongGuo": "上次不通过",
    "GongChangJiaGe": "工厂价格",
    "ESSAJiaGe": "交易价",
    "ZaiYeMianYouShangJiaoKeYiQieHuan": "在页面右上角可以切换报价方式EXW / FOB，工厂价 / 交易价",
    "ChaKanJiaGe": "查看价格",
    "ShangPinJiaGe": "商品价格",
    "ZhangHaoWeiRenZheng": "账号未认证，未能向工厂发起询价",
    "DengLuHouXianShiJiaGe": "登录后显示价格",
    "GenGongChangZhiJieCaiGou": "免费注册账号，跟工厂直接采购，每天更新的2000多款新品",
    "KaiPiaoXinXi": "开票信息",
    "ESSAPingTaiChengNuo": "ESSA平台承诺不会对外公开信息，且遵守ESSA平台保密协议规定",
    "QueRenHouBuYunXuQieHuan": "确认后不允许切换，请谨慎选择！不影响页面价格展示，仅用于下单交易。",
    "QueRenJiaoYiXinXi": "确认交易信息",
    "QueRenSuoXuanJiaoYiBiZhong": "请再次确认你所选交易币种为",
    "YangPinZhuangXiangDan": "样品装箱单",
    "YangPinSuiCheDan": "样品随车单",
    "YunFeiDan": "运费单",
    "YunFeiHuiKuanDan": "运费汇款单",
    "HaiGuanXinHan": "海关信函",
    "JiaGeBiao": "价格表",
    "ShangPinBiao": "商品表",
    "YangPinShangPinBiao": "样品商品表",
    "MaiJia": "卖家",
    "FuWuMiaoShu": "服务描述",
    "JiaoHuoYongShi": "交货用时",
    "FaHuoDian": "发货点",
    "MuDiDian": "目的点",
    "LuXian": "路线",
    "FuKuanTiaoJian": "付款条件",
    "OuYaJingJiLianMengLuXianYunFei": "欧亚经济联盟路线运费",
    "ZongJiYunFe": "总计运费",
    "YunFeiDanLuXianMiaoShu": "<p>1.到{0}海关关卡通行检查站：{1}（{2}公里）;</p> <p>2.欧亚经济联盟路线：{3}（{4}公里）;</p> <p>百分比：</p> <p>中国 -{5}%; 俄罗斯 - {6}%。</p>",
    "ShangPinYuanChanGuo": "商品原产国",
    "ZhiZaoShang": "制造商",
    "QingYueDuJiaChaDanJuShuJu": "请阅读检查单据数据，确认此单据无问题？",
    "HeTongHaoHeRiQi": "合同号和日期",
    "MiaoShu": "描述",
    "ZongYunFei": "总运费",
    "YunFeiHuiKuanDanGuiHaoLiZi": "EX:85/003",
    "YunFeiHuiKuanDanHeTongHaoHeRiQiLiZiRu": "EX:ESSA-TR 003 от «26» мая 2022 г.",
    "YunFeiHuiKuanDanRiQiLiZiRu": "EX:«02» Августа 2022 г.",
    "YunFeiHuiKuanDanMiaoShuLiZiRu": "EX:Доставка товара по маршруту1.в т/п ПП Забайкальск: Гуанчжоу – т/п ПП Забайкальск (2652.2 км); 2. по ЕАЭС: т/п ПП Забайкальск – Белый Раст (5125.7 км), контейнер № OOLU8357922, инвойс № RU20220012 от 22.06.2022 на сумму 10,000.00 USD",
    "YunFeiHuiKuanDanZongYunFei": "10,000.00",
    "YunFeiHuiKuanDanHeTongHaoHeRiQiLiZiEn": "EX:ESSA-TR 003 dated May 26, 2022",
    "YunFeiHuiKuanDanRiQiLiZiEn": "EX:«02» August 2022",
    "YunFeiHuiKuanDanMiaoShuLiZiEn": "EX:Delivery of goods along the route 1.to the P/P Zabaikalsk: Guangzhou – P/P Zabaikalsk (2652.2 km); 2. on the EAEU: P/P Zabaikalsk – Beliy Rast (5125.7 km), container no. OOLU8357922, invoice no. RU20220012 dated 22.06.2022 in the amount of 10,000.00 USD",
    "HuiFuCiBanBen": "恢复此版本",
    "DangQianBanBen": "当前版本",
    "PiLiangBianJiEWenPinMing": "批量编辑俄文品名",
    "PiLiangBianJiYingWenPinMing": "批量编辑英文品名",
    "WeiQueRenWuFaXiaZaiPdf": "未确认，无法下载含盖章PDF",
    "BianJiYunFeiHuiKuanDan": "编辑运费汇款单",
    "BianJiHaiGuanXinHan": "编辑海关信函",
    "BianJiJiaGeBiao": "编辑价格表",
    "BianJiShangPinBiao": "编辑商品表",
    "BianJiYangPinShangPinBiao": "编辑样品商品表",
    "JiZhangXiangHuoHao": "集装箱货号",
    "ZongGeShuZhuangLiang": "总个数（装量）",
    "DaoHaiGuanGuanKaJianChaZhanYunFei": "到{0}海关关卡检查站运费",
    "DiZhi": "地址",
    "DaiQueRenDanJu": "待确认单据",
    "QueRenDanJu": "确认单据",
    "MiaoShuNiYaoZhaoDeShangPin": "描述你要找的商品",
    "GaoSuWoMenShangPinDeXinXi": "告诉我们商品的信息，例如功能、颜色、材质、指定的品牌、包装要求等",
    "ShangChuanWenJianZhiChi": "上传文件，支持图片/压缩包/Excel，单文件最大支持200M，最多上传5个文件",
    "XuYaoYuTuPianShangPinYiZhi": "需要与图片商品一致",
    "JinZhunFanKui": "精准反馈",
    "JinKeNengDuo": "尽可能多",
    "JinkeNengJinZhunDe": "尽可能推荐精准的",
    "JiaGeYaoQiu": "价格要求",
    "ChanPinXuYaoYongYouYiXiaZhengShu": "产品需要拥有以下证书",
    "XiaoShouGuoJia": "销售国家",
    "QingXuanZeXiaoShouGuoJia": "请选择销售国家",
    "QingMiaoSuNiYaoZhaoDeShangPin": "请描述你要找的商品",
    "KeJieSouLeiShi": "可接受类似",
    "QingXuanZeZhengShu": "请选择证书",
    "BuXianZhiShuLiang": "不限制推荐数量，尽可能多推荐",
    "GengDuoDeYaoQiu": "更多的要求",
    "GengShaoDeYaoQiu": "更少的要求",
    "YiYouZhiLiao": "已有资料/图片",
    "ZhengZaiZhaoYang": "正在找样",
    "FanKuiShuLiang": "反馈数量",
    "TuiJianDeShangPin": "推荐的商品",
    "PiLiangJiaRuGouWuChe": "批量加入购物车",
    "QueRenYaoQuXiaoZhaoYangQu2": "取消后，将不再收到商品推荐。是否取消找样？",
    "ZhaoYangYouXinDeFanKui": "找样有新的反馈",
    "QiTianNeiBuZaiDanChu": "7 天内不再弹出",
    "QuanBuZhaoYang": "全部找样",
    "TiJiaoNiDeXuQiu": "找不到商品？试试帮你找样",
    "TuiJian": "推荐",
    "LiShiTuiJian": "历史推荐",
    "TuiJianLiangDian": "推荐亮点",
    "JiaRu": "加入",
    "XiangZhao": "想找",
    "DengLuHouFaBuZhaoYangXuQu": "登录后发布找样需求",
    "JiaoYiJia": "交易价",
    "ZhaoYangJiLu": "找样记录",
    "ZhaoYangZhong": "找样中",
    "YouXinYangPin": "有新样品",
    "SouSuoZhaoYangMiaoSu": "搜索找样描述",
    "EWenMiaoShu": "俄文描述",
    "HaiYouKuanShangPinMiaoShuWeiWanShan": "还有{0}款商品未完善，是否需要继续确认？",
    "KuanShangPinMiaoShuWeiWanShan": "{0}款商品描述未完善",
    "PiLiangBianJiMiaoShu": "批量编辑描述",
    "PiLiangBianJiEWenMiaoShu": "批量编辑俄文描述",
    "ChanPinYiTingShou": "产品已停售",
    "ZanWuQuanXianChaKan": "暂无权限查看",
    "ZiXunChanPin": "咨询产品",
    "NiXiangZiXunShenMeWenTiNe": "你想咨询什么问题呢？",
    "GongChangYiBanHuiZai1GeGongZuoRiNeiHuiFuNi": "工厂一般会在1个工作日内回复你。你可以前往购物车查看工厂的回复",
    "QingShuRuNiDeWenTi": "请输入你的问题",
    "FaSongTiWen": "发送提问",
    "XianShiYuanWen": "显示原文",
    "QingXuanZeQinQuanYuanYin": "请选择侵权原因",
    "QinQuanYuanYin": "侵权原因",
    "QinQuanQuXiao": "侵权取消",
    "DengLuHouShiTuZhaoYang": "请登录后开始识别图片搜索商品",
    "NeiBuGuiHao": "内部柜号",
    "WuLiuGuiHao": "物流柜号",
    "GongChangMOQ": "工厂MOQ",
    "KouJianDengJi": "扣减登记",
    "JinQiTuiKuan": "近期扣减登记",
    "TuiKuanDengJi": "扣减登记",
    "QingQueRenLuRuDeKouJianJinEShiFouZhengQue": "请确认录入的扣减金额是否正确？",
    "SuoYouKouJianJiLu": "所有扣减记录",
    "KouJianJinE": "扣减金额",
    "QingShuRuKouJianJinE": "请输入扣减金额",
    "HuiKuanRiQi": "汇款日期",
    "QingXuanZeHuiKuanRiQi": "请选择汇款日期",
    "TuiKuanFangShi": "退款方式",
    "QingXuanZeTuiKuanFangShi": "请选择退款方式",
    "GaiCaoZuoJiangKouJianKeHuDeYuE": "该操作将扣减客户的余额",
    "QuanBuKouJianJiLu": "全部扣减记录",
    "KouJianJiLu": "扣减记录",
    "SouSuoKeHuBianHao": "搜索客户编号",
    "KeHuYuE": "客户余额",
    "BianDongJinE": "变动金额",
    "BianDongHouYuE": "变动后余额",
    "QingXuanZeLeiXing": "请选择类型",
    "KeHuZaiDengJiLeiTongYangDeJinE": "客户 {0} 在 {1} 登记了一笔同样的金额 {2}",
    "ShiFouJiXuDengJi": "是否继续登记？",
    "KouJianJinEYiChaoChuKeHuYuE": "操作失败，扣减金额已超出客户余额 {0}",
    "ZanWuWuLiuShuJu": "暂无物流数据",
    "DangQianKeHuYuE": "当前客户余额 {0}",
    "LianXiWoMen2": "联系我们",
    "PiPeiShangPin": "匹配商品",
    "NiYaoZhaoShenMeShangPin": "你要找什么商品",
    "LiuXiaNiDeYouXiang": "留下你的邮箱",
    "YiGeQingQiu": "一个请求，多个报价",
    "QinMiaoSuNiYaoZhaoDe": "请描述你要找的商品，例如名称、颜色、材质等",
    "GongChang": "工厂",
    "WoMenYiShouDaoNiDeXunJiaQingQiu": "我们已收到你的询价请求，将在1~2个工作日内给你回复，请留意查收邮件。",
    "XunJia2": "询价",
    "RuGuoNinYouWenTi": "如果您有问题，可以请客户经理帮助您",
    "XueXi": "学习",
    "Zi2006NianYiLai": "自2006年以来",
    "ShiYuChengHai": "ESSA成立于2006年，始于澄海",
    "ZhongGuoWanJuHeLiPinZhiDou": "中国玩具和礼品之都",
    "JingGuoDuoNianDeFaZhan": "经过多年的发展",
    "YiWuGuangZhouHeXiangGang": "义乌广州和香港",
    "WeiWanJuTiGongCaiGouFuWu": "为玩具提供采购服务",
    "TiYuYongPinWenJuRiYongPin": "体育用品、文具、日用品",
    "YiJiXuDuoQiTaLeiBie": "以及许多其他类别",
    "WeiQuanQiuKeHuTiGongDeChanPin": "为全球客户提供的产品",
    "ZhouNianJiNianRi": "周年纪念日",
    "ZhouNianJiNianHuoDong": "ESSA大型家庭周年纪念活动",
    "GanXieNinFangWen": "感谢您访问ESSACHIA在线采购平台。您可以给我们留下任何意见或建议",
    "WoMenJiangZai24XiaoShiNeiHuiFuNin": "通过电子邮件或左下角的在线客服。我们将在24小时内回复您。",
    "WoMenHuanYingNinDangDiGongSiGouTong": "我们也欢迎您与我们当地的公司沟通。",
    "GuangDongESSA": "广东ESSA科技有限公司",
    "GuangZhouShiNanShaQu": "广州市南沙区双山大道5号2320室6室",
    "XiangGangFanRongDianZiShangWu": "香港凡融电子商务有限公司",
    "XiangGangJiuLongHongKanMaTouWeiDao": "香港九龙红磡码头围道21号易达工业大厦9楼A37",
    "ShanTouShiChengHaiQuGuangYiJieDao": "汕头市澄海区广义街道登封路广丰工业区1楼01号",
    "ShanTouESSAGongYingLian": "汕头ESSA供应链管理有限公司",
    "YiWuESSAMaoYiYouXianGongSi": "义乌ESSA贸易有限公司",
    "ZheJiangShengYiWuShiFuTianJieDao": "浙江省义乌市福田街道银海路399号国际商务中心17楼1708室",
    "RenShiWoMenDeTuanDui": "认识我们的团队",
    "YeWuTuanDui": "运维团队",
    "CaiGouTuanDui": "采购团队",
    "YunYingTuanDui": "运营团队",
    "JiShuTuanDui": "技术团队",
    "ZhanTing": "展厅",
    "CangKu": "仓库",
    "YiZhanShiCaiGou": "一站式采购",
    "WeiNinTiGongZhuLiuLeiBie": "ESSACHINA.COM 为您提供8个主流类别。ESSA广泛的产品库包含来自我们合作的20000多家中国工厂的200万件产品。",
    "WeiNinTiGongHangYeYiXianXinXi": "ESSACHINA.COM 为您提供行业内新产品的一线信息，这样您就不会错过任何具有市场潜力的新产品。",
    "ZhaoBuDaoChanPinXiWangTiGongJianYi": "找不到产品或希望ESSA提供产品建议？没问题，我们将在1个工作日内回复您！",
    "GaoXiaoDi": "高效的",
    "ESSACongShiWaiMaoHangYeYiYou16Nian": "ESSA从事外贸行业已有16年，服务于不同类型的客户，如传统批发商、大型超市和品牌所有者。因此，我们可以提供最佳的报价和服务解决方案，以满足买家的个性化需求。",
    "ZaiXianPiFaCaiGouPingTai": "您的24/7在线批发采购平台",
    "TiChuBaoJiaQingQiu": "您可以随时在我们的网站上提出报价请求。ESSA将在24小时内处理您的查询。",
    "YouJingZhengLiDeJiaGe": "有竞争力的价格",
    "GongYingShangShiYuanGongChang": "ESSACHIA的供应商是100%的源工厂。",
    "ESSADeJiaGeShiTouMingHeGongKaiDe": "先比较价格，然后购买。ESSA的价格是透明和公开的。我们也欢迎客户比较产品价格，以确保ESSA客户始终能从我们那里获得有竞争力的报价。",
    "WeiNinTiGongJiaGeTanPanFuWu": "ESSA拥有专业的成本计算人员，为您提供价格谈判服务。",
    "JiLeiLeYiZhiHeXinTuanDui": "多年的行业积累使ESSA积累了一支核心团队",
    "TiGongGongYingShangHeZuoHuoBan": "为ESSA的客户提供优惠价格的供应商合作伙伴。",
    "RuHeCongQiTaGongSiZhongTuoYingErChu": "我们如何从其他采购公司中脱颖而出",
    "QueBaoGongChangJiangGenJu": "ESSACHINA确保工厂将根据",
    "RuGuoHuoWuSunHuaiHuoQueShao": "如果货物损坏或缺少，赔偿标准。",
    "LiJiFaBuWoDeXuQiuRenWu": "立即发布我的需求任务！",
    "JiaoFuShiJianBaoZheng": "交付时间保证",
    "essaDeChengNuo": "ESSACHIA保证您的货物交付时间，如果无法按时交货，7天后开始计算补偿延迟天，然后按延迟订单金额的0.1%罚款再延迟1天。除了客户的延误情况原因（如预订延迟、客户要求不发货时间、付款未按时到达等）和其他不可抗力导致延迟。",
    "GuanYuESSAUrl": "关于宜采国际",
    "GuanYuESSAUrlSub": "快速了解essachina.com是如何在玩具贸易行业中脱颖而出的",
    "GuanYuESSASub": "深耕行业16年，来见见我们的团队吧！期待与您合作！",
    "BangZhuZhongXinSub": "在使用中遇到了困难？不妨可以看看这里",
    "BoKe": "博客",
    "BoKeSub": "玩具行业的最新动态，由我们平台的行业一线人员为你分享",
    "ESSADeGongZuo": "了解ESSA",
    "XinKeShouNianYouHui": "新客首年优惠",
    "ZaiYeMianYouShangJiaoKeYiQieHuanDuiBiJia": "在页面右上角可以切换报价方式EXW / FOB。 当前价格为新客首年专享",
    "LaiKuanMingXi": "来款明细",
    "KouKuanMingXi": "扣款明细",
    "KeHuYuEMingXi": "客户余额明细",
    "MaiShouGuanLi": "客户经理管理",
    "HaiMeiYouKeHuJingLiWeiNiFuWu": "还没有客户经理为你服务",
    "TiaoXuanKeHuJingLi": "挑选客户经理",
    "ShiFouBuXuYaoKeHuJingLiLe": "是否不需要客户经理了",
    "ZongHePingFen": "综合评分",
    "GeRenTeSe": "个人特色",
    "WoBuXiangYaoKeHuJingLiLe": "我不想要客户经理了",
    "KuHuJingLiYinGeRenYuanYinWuFaJiXiFuWu": "客户经理因个人原因无法继续服务，你需要重新挑选客户经理",
    "KuHuJingLiYinGeRenYuanYinWuFaJiXiFuWu2": "客户经理因个人原因无法继续服务",
    "HenBaoQianGaiKeHuJingLiYiFuWuDuoGeKeHu": "很抱歉！该客户经理已经服务多个客户，暂时无法为你服务，请尝试其他客户经理",
    "XianZaiYouXinKeHuJinLiWeiNiFuWu": "现在由新客户经理为你服务",
    "KeHuJinLiJiangWeiNiTiGongFuWu": "客户经理将为你提供服务",
    "WenJianGeShuBuZhengQue": "文件个数不能超过10个",
    "NiQuXiaoLeFuWu": "你取消了服务",
    "NiDuiGaiKeHuJingLiPingJiaBuTaiYouHao": "你对该客户经理评价不是太好，是否更换一个新的客户经理为你服务？",
    "KuHuJingLiQuanChengFuZeGenJin": "客户经理全程负责跟进。如不满意客户经理服务，可以取消该客户经理服务，重新选择新的客户经理。",
    "NinYouJinXinZhongDePoDanWuFaJieBanMaiShou": "您有进行中的PO单无法解绑买手",
    "LiShiKeHuJingLi": "历史客户经理",
    "XiangXiZiLiao": "详细资料",
    "XiTongZiDongFenPei": "系统自动分配",
    "YiXiaKeHuJingLiBuFenPiPei": "看看其他客户经理",
    "XiTongWeiNinXuanZeMaiShou": "是否确认让系统为您选择客户经理",
    "FenPeiChengGong": "分配成功",
    "KeHuJingLiXiangQing": "客户经理详情",
    "JiNengTeChang": "技能特长",
    "ZhuPinLei": "主品类",
    "ShanChangPinLei": "擅长品类",
    "WaiMaoCongYeShiChang": "外贸从业时长",
    "ShiChang": "市场",
    "KeHuXiaoShouQuDao": "客户销售渠道",
    "FuWuKeHuShu": "服务客户数",
    "XuanZeGaiKeHuJingLi": "选择该客户经理",
    "ShuoLiangJu": "说两句",
    "PingJiaYiXiaKeHuJingLi": "评价一下客户经理，只会提供给平台内部查看，目的是为了及时发现问题和提升客户经理的服务质量",
    "XiTongJiangDuiNiDePingJiaNiMingChuLi": "评价将会匿名处理，希望收到你的真实评价，以便我们为您提供更好的服务！",
    "ChaKanPingJia": "查看评价",
    "PingFenBuNengWeiKong": "评分不能为空",
    "ShiFouQueRenTiJiaoPingLun": "是否确认提交评论",
    "QuTiaoXuan": "去挑选",
    "PingLunChengGong": "评论成功",
    "YiPingJia": "已评价",
    "PingJiaKeHuJingLi": "评价客户经理",
    "TiJiaoPingJia": "提交评价",
    "NiYiJingYouKeHuJingLiWeiNiFuWu": "你已经有客户经理为你服务，选择新的客户经理将替换掉原有的客户经理",
    "MaiShouXiangQing": "买手详情",
    "KeHuJingLi": "客户经理",
    "FuWuZhong": "服务中",
    "QingQianWangRenZheng": "你的账号尚未认证，需认证后才能选择客户经理。",
    "KeYiKanKanYiXiaBuFenPiPeiDe": "没找到与你信息完全匹配的客户经理，可以看看以下部分匹配的",
    "KeHuJingLiQuanChengFuZeGenJin": "客户经理全程负责跟进。如不满意客户经理服务，可以取消该客户经理服务，重新选择新的客户经理。",
    "TiHuan": "替换",
    "MianFei": "免费",
    "KeHuJingLiFuWuZhong": "客服经理服务中",
    "KeHuPingTaiJingLi": "客户经理",
    "HaiMeiZhuCe": "还没注册",
    "ZhuCeChengGong": "注册成功",
    "DiYiDanZheKouYouHuiTiShi": "第一次订单可享受10%的定金",
    "KaiShiCaiGou": "开始采购",
    "HuoDeJiangLi": "获得奖励",
    "ShangPinZhanShi": "商品展示",
    "SouSuoShangPinGongChang": "搜索商品/工厂",
    "PinPaiZhuYe": "品牌主页",
    "ChaKanGouWuCheTiShiM": "<a style=\"color:#fff\" href=\"https://www.essaone.com/cart\">查看购物车，目前只支持在PC端查看。 https://www.essaone.com/cart</a>",
    "GouWuCheYiYouWaiXiang2": "购物车中已有{0}外箱，是否覆盖购物车中的数量",
    "JiaGeShuoMing": "价格说明",
    "ESSAONEJiaGeShuoMingNeiRong": "ESSAONE 以外箱单位的价格来交易，其他价格仅作为采购时的成本参考。",
    "LiRuMouShangPin": "例如某商品",
    "ZhanShiXiang": "展示盒",
    "ShangYiYe": "上一页",
    "XiaYiYe": "下一页",
    "GongXiNiYiChengGongZhuCe3": "我们的客户经理将在工作日48小时内与您联系，帮助您寻找合适的产品和最好的折扣。",
    "HuoQuZuiZhunQueZhao": "获取最准确照片搜索结果的方法",
    "ShangChuanDeZhaoPian": "上传的照片质量必须清晰。",
    "ShiYongChunSeBeiJing": "使用纯色背景，产品外观与背景对比明显。",
    "KeYiQieGeChanPinDe": "可以切割产品的主要部分。",
    "RuYouBaoZhuang": "如有包装，可以尝试去掉包装搜索产品。",
    "ShiBieTuPianSouSuoTongKuan": "识别图片搜索同款或相似商品",
    "ShiYongCtrlV": "或使用 Ctrl+V / Cmd+V 粘贴",
    "KuangXuanZhuTi": "框选主体",
    "JieGuoBuZhun": "结果不准",
    "DianJiKeQieHuanSouSuoTuPian": "点击可切换搜索图片",
    "QingKongBingChongXinShangChuan": "清除全部",
    "HuiYuanShouYe": "会员首页",
    "WoDeJiFen": "我的积分",
    "YouXiaoDingDan": "有效订单 ≥{0}",
    "LeiJiChengJiaoE": "累计成交额 {0}{1} {2}",
    "GouWuXiaDan": "购物下单",
    "ChengWeiHuiYuan": "成为会员",
    "XiangShouQuanYi": "享受权益",
    "ShengJiJiangLiJiFen": "升级奖励积分",
    "DingDanJiangLi": "订单奖励",
    "ZuiGaoDiKou": "最高抵扣",
    "WoDeDengJi": "我的等级",
    "JiFenMingXi": "积分明细",
    "HuoQuJiFen": "获取积分",
    "100%WanShanGongSiXinXi": "100% 完善公司信息",
    "QuWanShan": "去完善",
    "GuanZhuGuanFangSheMeiPingTai": "关注官方社媒平台",
    "GuanZhuHouJieTuFaSongGeiKeFuShenHeHouJiangLiJiFen": "关注后截图发送给客服审核后奖励积分",
    "ChaKanShangPinXiangQingYeMian": "查看商品详情页面，每天可奖励一次",
    "JiaGouShangPin": "加购商品",
    "BaShangPinJiaRuDaoGouWuChe": "把商品加入到购物车，每款可奖励",
    "QuXuanGou": "去选购",
    "WanChengDingDan": "完成订单",
    "ShiFuDingDanJinE": "实付订单金额 1~5% （根据会员等级奖励）",
    "LianXuXiaDan": "连续下单",
    "DuiBiShangYueXiaDan": "对比上月下单（有效订单），额外奖励",
    "HaiMeiYouJiFenJiLu": "还没有积分记录",
    "KeDiKouN": "可抵扣 {0}{1}",
    "YuJiJiJiangDaoZhang": "预计即将到账 {0}",
    "ZuiJinNTianJiFenTongJi": "最近 {0} 天积分统计",
    "WanChengXiaDan": "完成下单",
    "JiFenZhiFuDingDanShu": "积分支付订单数",
    "JiFenDiKouJieSheng": "积分抵扣节省",
    "ZuiJinJiFenMingXi": "最近积分明细",
    "ChaKanQuanBuMingXi": "查看全部明细",
    "XinZhuCeYongHu": "新注册用户",
    "DingDanJiangLiJiFen": "订单奖励积分",
    "JiFenZuiGaoDiKou": "积分最高抵扣",
    "ZhuanShuKeHuFuWu": "专属客户服务",
    "YouXiaoDingDanZhiDeShiXiaDan": "* 有效订单指的是下单并已支付定金，累计成交额只计算有效订单的订单总金额",
    "DengJiJiSuanYuBianGeng": "等级计算与变更",
    "DengJiJiSuanYuBianGeng1": "1. 网站的会员等级将于每月1日00：00更新。",
    "DengJiJiSuanYuBianGeng2": "2. 系统会计算会员最近6个月的订单次数和总成交金额，若6个月内的订单次数和总成交金额达到对应的会员等级门槛，会员等级将自动升级或降级。",
    "DengJiJiSuanYuBianGeng3": "3. 若6个月内都没有成交，会员等级会直接降为V1。",
    "DengJiJiSuanYuBianGeng4": "4. 会员等级更新后，会员享有新等级对应的所有会员权益。",
    "HanMeiMei01YueZhuCeZhangHao": "韩梅梅01月注册账号",
    "HanMeiMei01YueZhuCeZhangHao1": "01~06 月，成交金额 ≥ 50 000,00 ₽，2月1日等级升级到 Lv.3",
    "HanMeiMei01YueZhuCeZhangHao2": "02~07 月，成交金额 ＜ 50 000,00 ₽，8月1日将等级降到 Lv.1",
    "HuiYuanYuJiFen": "会员与积分",
    "JiFenShiYongHuDingGouHuoWanCheng": "积分是用户订购或完成了平台指定任务后而获得的一种奖励，积分可用于下一个订单的交易。俄罗斯联邦：1积分=1卢布；白俄罗斯：30积分=1白卢布。",
    "SuoYouYongHuDouKeYiCanYuJiFenDe": "所有用户都可以参与积分的获取，但只有会员才能使用积分。会员等级与积分的获取及使用密切相关。等级越高，积分获取的比例及可用于交易的比例越高。同时会员升级也奖励积分。",
    "LiaoJieJiFenGengDuoXinXi": "了解积分更多信息",
    "HuiYuanChangJianWenTi": "会员常见问题",
    "HuiYuanChangJianWenTi1": "1. 如何晋升会员等级？",
    "HuiYuanChangJianWenTi2": "系统每月1日00：00计算会员近6个月的订单次数和总成交额，若6个月内的订单次数和总成交金额达到更高等级标准，则自动升级。",
    "HuiYuanChangJianWenTi3": "2. 会员等级会下降吗？",
    "HuiYuanChangJianWenTi4": "会的。系统会每月进行等级的变更，若6个月内的订单次数和总成交金额没能达到当前等级的标准，则自动降级。若6个月内都没有交易，等级会直接降为最低等级V1.",
    "HuiYuanChangJianWenTi5": "3. 会员等级的有效期是多长？",
    "HuiYuanChangJianWenTi6": "会员等级的有效期与会员的交易相关，它不存在固定的有效期，最长的有效期为6个月。系统会每月更新数据，重新确认会员等级。",
    "HuiYuanChangJianWenTi7": "4. 会员权益是否会调整？",
    "HuiYuanChangJianWenTi8": "会员权益与会员等级相关，等级越高，权益越大。因此，会员权益会随会员等级的变化而变化。",
    "HuiYuanChangJianWenTi9": "5. 会增加新的权益吗？",
    "HuiYuanChangJianWenTi10": "会的。我们会不断给会员提供更多有价值的权益，敬请期待！",
    "YouXiaoDingDanLeiJiChengJiaoE": "有效订单{0},累计成交额{1}{2}",
    "QuXiaDanChengWeiHuiYuan": "去下单成为会员",
    "DengJiShuJuMeiYue1Ri0DianGengXin": "等级数据每月1日0点更新",
    "RuGuoBaoChiDangQianDeChengJiaoLiang": "如果保持当前的成交量，下个月的等级会变成Lv.{0}",
    "XinKeHuShouCiXiaDanKeXiangShou": "新客户首次下单可享受特别优惠！ 查看>>",
    "TaiBangLeNiYiJingManJiLe": "太棒了！你已成为顶级会员。",
    "GongXiNiXiaYueJiangShengJiDaoN": "恭喜你！下月将升级到 Lv.{0}",
    "ShengJiDaoLvNHaiXuXiaDanNCi": "升级到 Lv.{0}，本月还需下单 <b>{1} 次</b></span>",
    "ShengJiDaoLvNHaiXuXiaDanN": "升级到 Lv.{0}，本月还需下单 {1} {2}",
    "NiHaiBuShiHuiYuan": "你还不是会员，成为会员只需下单 <b>{0} 次</b>",
    "ESSAONEShouY": "ESSAONE 首页",
    "JiFenBianDong": "积分变动",
    "JiFenYuE": "积分余额",
    "DangQianYiXiaDanNCi": "当前已下单 {0} 次，{1} {2}",
    "JiFen": "积分",
    "ShengJiHuiYuanXiangShouGengDuoQuanYi": "升级会员享受更多权益",
    "DingDanJiangLiZuiGaoDiKou": "订单奖励 {0}，最高抵扣 {1}",
    "ZengJia": "增加",
    "DangQianJiFen": "当前积分",
    "JiFenXiang": "积分项",
    "QingXuanZeJiFenXiang": "请选择积分项",
    "JiFenGuanLi": "积分管理",
    "JiFenZhi": "积分值",
    "JiFenTiXiWanShanGongSiXinXiKeYiHuoDeJiFen": "积分体系，完善公司信息，可以获得积分。",
    "NinDeDingDanYiTiJiaoQingZ2": "您的订单已提交，请在<i>{0}</i>天内支付定金以确认订单!",
    "XuZhiFuDingJin": "需支付定金",
    "JiFenDiKou": "积分抵扣",
    "DangYueHeQian5Yue": "当月和前5月的累计成交额",
    "DangQianJiFenNBenDanWeiKuan": "当前积分 {0}，本单尾款预计使用 {1} 积分抵扣 {2} {3}",
    "ZhiFuWeiKuanShiShiYongJiFen": "支付尾款时，使用积分抵扣对应金额",
    "ShiJiDiKouJiangYiZhiFuWeiKuan": "注意：实际能使用多少积分抵扣，以支付尾款时的积分余额为准",
    "ZhiFuDinDanXianYiZhiChiJiFen": "现在订单可以用积分来支付订单，最高可抵扣8%的订单金额。",
    "QianWangJiFenZhongXin": "前往积分中心",
    "NDan": "{0} 单",
    "JiFenChangJianWenTi": "有关积分",
    "JiFenChangJianWenTi1": "1. 积分是什么？",
    "JiFenChangJianWenTi2": "积分是用户订购或完成了平台指定任务后而获得的一种奖励，积分可用于支付下一个订单的尾款。俄罗斯联邦：1积分=1卢布；白俄罗斯：30积分=1白卢布。",
    "JiFenChangJianWenTi3": "2. 如何获取积分？",
    "JiFenChangJianWenTi4": "用户可以通过下单或完成平台指定任务获得积分。",
    "JiFenChangJianWenTi5": "3. 积分什么时候发放？",
    "JiFenChangJianWenTi6": "积分的发放存在以下2种情况：",
    "JiFenChangJianWenTi7": "（1）通过完成平台指定任务，会员升级奖励的积分为系统自动发放。该部分积分发放后用户即可使用。",
    "JiFenChangJianWenTi8": "（2）来自订单的积分，须等到订单完成，即支付完尾款后才会发放。当用户提交订单后系统会显示即将发放的积分，此时该积分处于不可用状态，直到订单完成后积分才会发放，变成可用积分。",
    "JiFenChangJianWenTi9": "4. 每个订单可以使用多少积分？",
    "JiFenChangJianWenTi10": "每个订单可用多少积分与会员等级、用户当前持有多少积分有关。",
    "JiFenChangJianWenTi11": "订单最高可用积分 =订单总金额 x 用户当前会员等级对应的积分可支付比例，若用户当前持有的可用积分小于订单最高可用积分，则按当前持有的积分进行扣减。",
    "JiFenChangJianWenTi12": "5. 如何使用积分？",
    "JiFenChangJianWenTi13": "用户须在提交订单时自行决定该订单是否使用积分。不选择的情况下，系统默认不使用积分。若用户在下单时选择使用积分，订单将自动减去积分最多可抵扣的金额，同时账户上的积分也相应被扣除。",
    "JiFenChangJianWenTi14": "6. 积分使用后还可以退回吗？",
    "JiFenChangJianWenTi15": "积分一旦使用，只在非客户原因，订单全部商品取消的情况下才会退回。其他情况均不予退回。",
    "XuZhiFu": "需支付",
    "JiFenKeDiKou": "积分可抵扣",
    "QingGouXuanDingDan": "请先勾选订单",
    "ShiYongJiFenDiKou": "使用 {0} 积分，抵扣 {1}",
    "XiuGaiGongSiXinXiChengGongJiFen": "成功完善公司信息，获得积分+{0}",
    "WanChengGaiDingDanYuJiKeYiJiangLiJiFen": "完成该订单预计可以奖励 <b>+{0}</b> 积分",
    "WoMenTiGong30TianMianFeiCangChu": "我们提供 30 天免费仓储",
    "LiuLanShangPinJiFen": "浏览商品，获得积分+{0}",
    "JiFenChangJianWenTi16": "7. 积分什么时候会失效？",
    "JiFenChangJianWenTi17": "网站将于每个年度固定2个时间统一进行积分清算。",
    "JiFenChangJianWenTi18": "- 6月30日，清除上年度下半年未使用的可用积分。例如2023年6月30日，统计2022年7月1日至2022年12月31日未使用的可用积分，该部份积分变为失效。",
    "JiFenChangJianWenTi19": "- 12月31日，清除本年度上半年未使用的可用积分。例如2023年12月31日，统计2023年1月1日至2023年6月30日未使用的可用积分，该部份积分变为失效。",
    "JiFenChangJianWenTi20": "8. 只有会员才能使用积分吗？",
    "JiFenChangJianWenTi21": "是的，只有成为会员才能使用积分支付订单的尾款。",
    "JiFenChangJianWenTi22": "9. 积分规则是否会调整？",
    "JiFenChangJianWenTi23": "网站会根据业务发展情况调整积分规则，并予改规则调整之日予以公布，调整后的新规则生效时间以公布为准。如有疑问可联系客服进行咨询。",
    "JiaRuGouWuCheChengGongJiFen": "加入购物车成功，积分 +{0}",
    "GongXiNiShengJiDao": "恭喜你升级到",
    "DuiBuQiShangPinYiTingShou": "对不起，商品{0}已停售",
    "XuanZeLiNiZuiJinDeTiHuoCangKu": "选择最近的提货仓库",
    "CangKuDiZhi": "仓库地址：",
    "ShiHe": "推荐地区：",
    "HuoWuSongDaoCangKuHou": "货物达到仓库后，你可以选择自提，或自费配送到指定地点。",
    "YouYuYunShuFangShiHeLuTuBuTong": "由于运输方式和路途不同，切换仓库会影响商品价格、配送方式及商品品类。",
    "BaoQingGuanWuLiuMenDaoMenFuWu": "包括增值税、关税和从中国的制造商到莫斯科/海参崴仓库的交付。",
    "QueRenTiHuoCangKu": "确认提货仓库",
    "XiaDanFanJiFen": "下单返积分",
    "JiFenDangQianHua": "积分当钱花",
    "ShengJiYouJiangLi": "升级有奖励",
    "ZhuanShuKeFu1": "专属客服 1 VS 1",
    "JuTiQuanYiShiHuiYua": "* 具体权益视会员等级而定。会员等级越高，权益越大。更多权益敬请期待！",
    "JiaoYiChengGong": "交易成功",
    "YiCiDingGouZhongShenHuiYuan": "一次订购，终身会员",
    "RuHeChengWeiHuiYuan": "如何成为会员",
    "HuiYuanJiFen": "会员积分",
    "WanShanXinXiSongJiFen": "完善信息送积分",
    "GuanZhuSheJiaoZhangHaoSongJiFen": "关注社交账号送积分",
    "MeiTianLiuLanShangPinSongJiFen": "每天浏览商品送积分",
    "MeiCiJiaGouSongJiFen": "每次加购送积分",
    "MeiBiDingDanFanJiFen": "每笔订单返积分",
    "MeiYueXiaDanJiangJiFen": "每月下单奖积分",
    "LiaoJieGengDuoJiFenXinXi": "了解更多积分信息",
    "TeBieShuoMing": "特别说明",
    "TeBieShuoMing1": "1. ESSAONE会员制度自发布日起正式生效。",
    "TeBieShuoMing2": "2. 会员制度及积分规则详情可登录“{0}”和“{1}”查询了解。",
    "TeBieShuoMing3": "3. 网站会根据业务发展情况调整会员制度与积分规则，并在改规则调整之日予以公布。调整后的新规则生效时间以公布为准。",
    "TeBieShuoMing4": "4. 如有疑问可联系客服进行咨询。活动最终解释权归ESSAONE所有。",
    "TeBieShuoMing5": "欢迎成为ESSAONE会员，让您更有利可图",
    "HuiYuanDengJi": "会员等级",
    "LeiJiJiaoYiEWeiQueRen": "* 累计交易额为确认支付的订单金额。",
    "Lv1YaoQiu": "<div><p>成功交易</p><p>1笔</p></div>",
    "Lv2YaoQiu": "<div><p>成功交易</p><p>3笔</p></div>",
    "Lv3YaoQiu": "<div><p>累计交易</p><p>≥500,000₽</p></div>",
    "Lv4YaoQiu": "<div><p>累计交易</p><p>≥1000,000₽</p></div>",
    "L51YaoQiu": "<div><p>累计交易</p><p>≥2000,000₽</p></div>",
    "Lv6YaoQiu": "<div><p>累计交易</p><p>≥3500,000₽</p></div>",
    "Lv7YaoQiu": "<div><p>累计交易</p><p>≥5000,000₽</p></div>",
    "ChaXunWoDeHuiYuanDengJi": "查询我的会员等级",
    "EssaOneVip": "ESSAONE VIP-CLUB",
    "CangKuTuiJian1": "莫斯科仓—适合中央联邦管区、西北联邦管区、南部联邦管区、伏尔加河沿岸联邦管区、乌拉尔联邦管区、北高加索联邦管区的所有客户",
    "CangKuTuiJian2": "海参崴仓—适合西伯利亚联邦管区和远东联邦管区的所有客户",
    "MskCangKu": "莫斯科仓库1",
    "HswCangKu": "海参崴仓库地址",
    "KouJian": "扣减",
    "JiFenXiangYiChaoChuShangXian": "积分项已超出上限",
    "JiFenXiangPeiZhiYouWu": "积分项配置有误",
    "WoDeHuiYuanDengJi": "我的会员等级",
    "NiHaiBuShiHuiYuan2": "你还不是会员",
    "YaoQingYouLi2": "邀请有礼",
    "ShiFu": "实付",
    "1059PR10027": "po存在异常",
    "QingXuanZeCangKu": "请选择仓库",
    "NiDeWenTiDeDaAnKeYiZaiZheLiZhaoDao": "你的问题的答案可以在这里找到",
    "ReMenNeiRong": "热门内容",
    "ESSAONEJianJie": "ESSAONE简介",
    "ZhongGuoB2BZaiXianJiaoYiPingTai": "中国批发市场",
    "DingGou": "订购",
    "FuKuan": "付款",
    "QianBaoShiYongZhiNan": "钱包使用指南",
    "BaoZhang": "保障",
    "JiaGeShiXiaoZhiLiangBaoZhang": "价格/时效/质量保障",
    "FenXiaoTuiGuang": "分销推广",
    "ShouDanZuiGaoYouHui": "首单定金仅需10%！",
    "MeiGeRenDouKeYiTongGuoESSAONEZhengQian!": "每个人都可以通过ESSAONE挣钱!",
    "ZhaoBuDaoWenTiDeDaAnMa": "找不到问题的答案吗？",
    "ZaiXianLiaoTianGeiWoMenLiuYan": "在线聊天给我们留言，我们会及时回复。",
    "PingTaiYuHeZuo": "平台与合作",
    "ShangPinYuJiaGe": "商品与价格",
    "DingGouYuZhiFu": "订购与支付",
    "JiaoFuYuShouHou": "交付与售后",
    "HelpTab1Question1": "ESSAONE.COM是一个网站! 是哪家公司？它的位置在哪里？",
    "HelpTab1Question2": "我从来没有听说过你，你怎么能被信任？",
    "HelpTab1Question3": "平台在莫斯科有实体办公室，仓库吗？",
    "HelpTab1Question4": "ESSAONE有商品证书吗？",
    "HelpTab1Question5": "ESSAONE是通过灰关交付商品吗？",
    "HelpTab1Question6": "如何保证我可以收到货？",
    "HelpTab1Answer1": "ESSAONE.COM平台是由中国公司GUANDONG ESSA TECHNOLOGY CO. 我们的总部设在中国广州。但在莫斯科也有常驻公司-代表机构。",
    "HelpTab1Answer2": "ESSAONE平台成立以来已有8年，我们一直是俄罗斯联邦儿童用品的主要供应商之一，致力于给中小客户提供直接与中国工厂合作的机会，能获得更优惠的价格和更新颖实用的商品 作为新渠道的补充，在这个渠道可以看到和原来渠道没有的东西，让你的品类更加丰富，更具有竞争力。",
    "HelpTab1Answer3": "有的。",
    "HelpTab1Answer4": "有的，每次交货都有完整的结账文件包，包括TR TS 008/2011的相关证书的义务包。",
    "HelpTab1Answer5": "我们只交付有正式清关、缴税和结算文件的白领货物。",
    "HelpTab1Answer6": "根据该项目，买方与ESSAONE.COM在俄罗斯联邦的代表机构，即与驻地公司签署供应合同。因此，所有的商业活动都在俄罗斯联邦的两个实体之间进行，因此，所有的活动都在俄罗斯联邦的适用法律范围内进行。",
    "HelpTab2Question1": "订单的价格中包括什么？",
    "HelpTab2Question2": "价格真的是卢布结算吗？",
    "HelpTab2Question3": "价格是最终的吗？需要支付其他费用？",
    "HelpTab2Question4": "我怎样才能快速找到我想要的产品？",
    "HelpTab2Question5": "如果我在网站上找不到我想要的产品，我应该怎么做？",
    "HelpTab2Question6": "什么是一箱？这是1件吗？",
    "HelpTab2Question7": "可以寄送样品吗？",
    "HelpTab2Answer1": "一个出口箱的价格从中国运送到莫斯科/海参崴仓库出口手续和清关（包括增值税）。 符合性证书没有额外费用。",
    "HelpTab2Answer2": "是的，所有价格均以卢布为单位。",
    "HelpTab2Answer3": "是的，网站上列出的价格是最终价格。交付是到我们的仓库，然后有自行交付或由运输公司交付（费用由买方承担）。",
    "HelpTab2Answer4": "快速搜索位于网站的顶部。 你可以通过产品编号、产品名称、甚至产品图片进行搜索。 你也可以按类别搜索。",
    "HelpTab2Answer5": "进入类目，点击 “找不到你想要的产品”，提供产品资料、供应商详情、产品规格、零件数量和其他信息，我们将通过电子邮件让您知道结果。",
    "HelpTab2Answer6": "这是一个出口箱。网站上的产品页面都标明了每个玩具的装量。",
    "HelpTab2Answer7": "不能寄样品, 但我们的工厂都是经过挑选认证的，我们也会在出货前有相关的质检部门检查商品。我们为货物及其从中国到莫斯科仓库的运输提供担保。",
    "HelpTab3Question1": "如何下订单？",
    "HelpTab3Question2": "我可以订购几支吗？",
    "HelpTab3Question3": "有些商品显示起订量是2-3箱的，可不可以只订一箱？",
    "HelpTab3Question4": "如何付款？",
    "HelpTab3Question5": "你们是否使用延期付款？",
    "HelpTab3Question6": "我下了订单，没有付定金，我想取消订单。怎么做？",
    "HelpTab3Question7": "我可以在付定金后更改订单吗？",
    "HelpTab3Question8": "支付定金后，我何时能收到我的订单？",
    "HelpTab3Question9": "今天付款，什么时候从中国发货？",
    "HelpTab3Answer1": "在网站上选择你想要的产品，指定数量、颜色、尺寸，加入购物车等待工厂确认，完成询价后点击购买按钮。在订单页面，填写您的信息并点击“发送订单”按钮。",
    "HelpTab3Answer2": "不。最小起订量是一箱。",
    "HelpTab3Answer3": "你可以在加购时选择数量为1箱，如果工厂回复同意，你便可以订购。",
    "HelpTab3Answer4": "<div>         <p>1.在付款之前，您将与ESSAONE.COM在俄罗斯联邦的代表机构，即与驻地公司签署一份供应合同。</p>         <p>2.我们向您发送一张付款发票，并等待您的转账。</p>         <p>3.收到您的转账后，我们将钱充值到您在ESSAONE的支付账户（即“钱包”），你需要使用“钱包”支付订单定金和尾款。</p>     </div>",
    "HelpTab3Answer5": "不，所有订单在支付定金后转为生产，并在全额付款后转给客户。",
    "HelpTab3Answer6": "可以直接在“我的订单”里取消订单。",
    "HelpTab3Answer7": "不，因此您需要在预付款前非常仔细地检查所有项目。",
    "HelpTab3Answer8": "预付款项后订单即被确认，订单会显示一个最新的预计到达时间。",
    "HelpTab3Answer9": "这取决于生产时间和交付到装货仓库的时间。大致的生产和交货时间可以在产品页中找到。",
    "HelpTab4Question1": "如何交付货物？我怎样才能收到货物？",
    "HelpTab4Question2": "网站能否跟踪我的订单状态？",
    "HelpTab4Question3": "有什么保障？",
    "HelpTab4Question4": "质量有保证吗？如果你对质量不满意，应该怎么做？",
    "HelpTab4Question5": "结案文件将是什么？",
    "HelpTab4Answer1": "集装箱通过2条路线运送：经中国-莫斯科的高速列车或经中国-海参崴的海运。货物到达仓库后，可自行交付或由运输公司收取（由客户支付）。",
    "HelpTab4Answer2": "可以。 ESSAONE平台允许您在线查看有关订购流程的信息。 你可以点击首页右上角的 \"我的账户\"-\"我的订单\"。在订单列表页，你可以看到你的订单的当前状态。如果你点击订单状态，会出现额外的信息。",
    "HelpTab4Answer3": "<div>         <p>我们为货物及其从中国到莫斯科/海参崴仓库的运输提供担保。</p>         <p>最佳价格保证：如果你买得更便宜，我们将向你支付差价</p>         <p>保证交付：延迟交货的补偿</p>         <p>质量保证：退款或退货</p>     </div>",
    "HelpTab4Answer4": "我们有质量保证，如果有质量问题，我们将根据详细情况进行赔偿或退款。如果你发现故障或短缺，你应该在网站上发起索赔申请，附上适当的图片和视频证据，以考虑并找到最佳解决方案来满足其需求。",
    "HelpTab4Answer5": "我们提供以下文件：转交文件和电子格式的证书，并且转交文件中会注明“货物报关单号”。",
    "PingTaiJiaoYiShuJu": "平台交易数据",
    "YiZhiFuDingJinDingDanTongJi": "已支付定金订单统计",
    "WeiZhiFuDingDanTongJi": "未支付订单统计",
    "WeiFuKuanJinE": "未付款金额",
    "WeiFuKuanYongHuShu": "未付款用户数",
    "BenYueYongHuTongJi": "本月用户统计",
    "XiaDanKeHu": "下单客户",
    "ZhuCeYouXiaoKeHu": "注册有效客户",
    "DangJi": "当季",
    "DangNian": "当年",
    "ChengJiaoXinKeHu": "成交新客户",
    "DaiWanShan": "待完善",
    "YiWanShan": "已完善",
    "ShouSouShangPinBianHao": "搜索商品编号",
    "XinYiPi": "新一批",
    "ShuXin": "属性",
    "ZhiFuWeiKuan": "支付尾款",
    "QingShuRuShangPinPinMin": "请输入商品品名",
    "JiaFu": "交付",
    "YunShuYuPeiSong": "运输与配送",
    "HuiYuanTiXi": "会员体系",
    "JiaRuHuiYuanZunXiangTeQuan": "加入会员，尊享特权",
    "HuoWuGenZong": "货物跟踪",
    "QuChaXun": "去查看",
    "GengXinShiJian": "更新时间",
    "TiDanXinXi": "提单信息",
    "DianFang": "电放",
    "DianFangDanYuanZheng": "电放原单证",
    "KuaiDi": "快递",
    "KuaiDiDanSaoMiaoJian": "快递扫描件",
    "YiQueRenZengJiaGouMaiXiangShuKeXiaDan": "已确认，增加购买箱数可下单",
    "ManJianMianQiSongFei": "满 {0} 箱，免起送费 {1}",
    "BuManJianGongYingShangXuJiaShouQiSongFei": "不满 {0} 箱，供应商需加收 {1} 起送费。采购该供应商商品满 {0} 箱免起送费。",
    "HunPiCaiGou": "混批采购",
    "YiJiangJia": "已降价",
    "GouMaiXiangShuXiaoYuGongChangYaoQiu": "购买箱数小于工厂要求，等待工厂确认中",
    "ShangPinYiShiXiao": "商品已失效",
    "GaiShangPinYiGuoJiaGeBaoH2": "商品已没有价格保护，你可以重新咨询工厂确认价格",
    "SouSuoGouWuShangPin": "搜索购物商品",
    "YouHaoTuiJian": "有好推荐",
    "JiaGeYouXiaoQiZhi": "价格有效期至",
    "YiZaiGouWuChe": "已在购物车",
    "GaiGongYingShangDeShangPinBuManJian": "该供应商的商品不满 {0} 箱，下单会加收 {1} 起送费",
    "JiXuXiaDanHuiChanShengEWaiDeQiSongFei": "只勾选这部分商品下单，将会加收起送费",
    "HanZengZhiShuiFei": "含增值税费",
    "QiSongFei": "起送费",
    "GaiGongYingShangDeShangPinBuManJian2": "供应商需加收{0} 送货费。采购该供应商满 {1} 箱，可免送货费",
    "LianHeDingGou1": "以更少装量拼团采购，需等待{0}天才能确定是否拼团成功",
    "LianHeDingGou2": "参与拼团",
    "GongYingShangHunPinQiYunFeiTiShi": "供应商混拼起运费提示",
    "GongYingShangSuoYouChanPin": "供应商所有产品",
    "ManMianQiSongFei": "满{0}箱免起送费",
    "HuanYingDengLuGongZuoTai": "欢迎登录工作台",
    "JiFenYuJiKeDiKou": "积分预计可抵扣",
    "HanQiSongFei": "含起送费",
    "PinTuanChengGongHouFanHui": "拼团商品可使用积分作为抵押。当你支付定金后，将返还该部分积分。",
    "JiFenDiYa": "积分抵押",
    "JiFenDiKouWeiKuan": "积分抵扣尾款",
    "ZengZhiShuiE": "增值税额",
    "YiDingGou": "已订购",
    "YiGengShaoZhuangLiangLianHeDingGou": "以更少装量联合订购，需等待 {0} 天才能确定是否拼团成功",
    "CanYuLianHeDingGou": "参与联合订购",
    "GroupTip": "为保证大家能联合订购成功，系统以7天为周期，周期内达到活动要求人数，即联合订购成功，工厂接单生产。逾期未达活动要求，则联合订购失败，退还积分或定金，你不会有任何资金损失。",
    "ManJianMianQiSongFei2": "满 {0} 箱，免起送费 {1}",
    "ChaoJiYouHui": "超级优惠",
    "XinKeHuZhuanXiang": "新客户专享",
    "XinKeHuZhuanXiangBiaoTi1": "注册就送{0}张优惠券。首单最低享受4%折扣！",
    "XinKeHuZhuanXiangFuBiaoTi1": "该优惠券从注册成功后发放，有效期为30天。",
    "XinKeHuZhuanXiangBiaoTi2": "首单只需{0}的定金！无风险试单。",
    "XinKeHuZhuanXiangFuBiaoTi2": "该特权仅对第一个订单有效（特价商品订单除外）。每位新客户只能享受1次",
    "XinKeHuZhuanXiangBiaoTi3": "首次下单后，再赠送{0}张优惠券",
    "XinKeHuZhuanXiangFuBiaoTi3": "该优惠券从第一个订单支付定金后发放，有效期为90天。",
    "XinKeHuZhuanXiangBiaoTi4": "首次下单后，次月即可成为会员。",
    "XinKeHuZhuanXiangFuBiaoTi4": "一次订购，终身会员。会员享受更多积分折扣，订购更优惠！",
    "MaShangXiaDan": "充分利用所有的优惠，马上下单吧！",
    "ZhuYiShiXiang": "注意事项",
    "XinKeHuZhuanXiangZhuYiShiXiangNeiRong": "1. 只有已在ESSAONE注册但未下第一笔订单的用户能享受此优惠。<br /> 2. 所有优惠券均不能叠加使用，每笔订单仅限使用一张优惠券。下单时系统会根据当前可使用的优惠券，默认使用优惠额度最大的一张。<br />  3. 优惠券一旦使用，只有在订单全部商品取消的情况下才会退还。如果只是部份商品被取消，则优惠券不作退还。",
    "DiYiBiDingDanBaoZhengJin": "第一笔订单保证金",
    "DingDanJinEBuXian": "订单金额不限",
    "YiZeKou": "积分抵扣",
    "XianShiXiaoShouJia": "显示销售价",
    "XiaoShouJiaGeSheZhi": "销售价格设置",
    "WoDeXiaoShouJia": "我的销售价",
    "MaoLiLv": "毛利率",
    "ZengZhiShuiLv": "增值税率",
    "HaiGuanShuiLv": "海关税率",
    "ShaoHouZaiShi": "稍后再试",
    "MaShangSheZhi": "马上设置",
    "SheZhiWoDeJiaGe": "设置我的价格",
    "ShiShiYuLanXiaoShouJiaGe": "实时预览销售价格，此价格仅你可见，且对你的采购价格不会产生任何影响",
    "XiaoShouJiaGongShi": "销售价=(FOB价格+海运费/PCS+清关费/PCS) × (1+海关税率) × (1+毛利率) × (1+增值税)",
    "GenJuZhongGuoRenMinYinHangDeHuiLvMei24XiaoShiGengXin": "汇率每24小时更新",
    "MeiYuan": "美元",
    "HaiYunFei / LuYunFei": "海运费 / 陆运费（美元）",
    "ZaiYeMianXianShiWoDeXiaoShouJia": "在页面显示我的销售价",
    "QingGuanFei（HuoDaiFeiYong）": "清关费（货代费用）（美元）",
    "YuJiXiaoShouJia": "预计销售价",
    "QingTianXieWanZhengDeBiTianXiang": "请填写完整的必填项",
    "KaiQiShiShiYuLanWoDeYuJiXiaoShouJia": "开启实时预览我的预计销售价",
    "ShiYongJiFenDiKouMaShangShengQian": "使用积分抵扣，马上省钱",
    "DangQianJiFenKeShiYong": "当前积分{0}，可使用 {1} 积分抵扣 {2} {3}",
    "DanQianHuiYuanDengJiZuiDaDiKou": "当前会员等级 Lv.{0}，最大抵扣{1}%",
    "DingJinBiLi": "定金比例",
    "GouXuanDeShangPinHanYouPinTuanShangPin": "勾选的商品含有拼团商品，无法发起咨询。",
    "BuManZuGongChangQiDingLiangYaoQiu": "不满足工厂起订量要求",
    "PinTuanShangPinBuNengChongXinXunJia": "拼团商品不能重新询价",
    "JiFenBuZu": "积分不足",
    "ShiYongJiFen": "使用积分",
    "YiDingJinDeFangShi": "以定金的方式",
    "XuDiYaNJiFenChengGongShiBaiFanHui": "本订单含拼团商品，下单需抵押 {0} 积分。如拼团失败或当你支付定金后会退还积分。",
    "XuNJiFenJiFenBuZuN": "订单含联合订购的商品，下单需抵押{0}积分。当前积分不足{1} ，不能进行超额抵押，你可以在3天内完成支付定金继续参与联合订购。'",
    "WoMenJinTiGong30TianMianFeiCangChu": "请尽快支付尾款，我们仅提供30天免费仓储",
    "TiHuoCangKu": "提货仓库",
    "DangQianJiFenNBenDanDiYa": "当前积分 {0}，本单需抵押 {1} 积分",
    "ZanWuFaQueRen": "暂无法确认",
    "DinDanTongJi": "订单统计",
    "SouSuoKeHuBianHaoHuoMinCheng": "搜索客户编号或名称",
    "ShengChangZhongDinDan": "生产中订单",
    "DaiFuWeiKuanDinDan": "待付尾款订单",
    "YiTiHuoDinDan": "已提货订单",
    "KeHuDeYuE": "客户的余额",
    "ShengChanZhongDingDan": "生产中订单",
    "DaiFuWeiKuanDingDan": "待付尾款订单",
    "YiTiHuoDingDan": "已提货订单",
    "ShouDan": "首单",
    "JiFenMeiXiangKeDiKou": "积分每箱预计可抵扣 {0}",
    "RuGuoYouSanCuWenJian": "如果有删除文件，确定后将无法撤销或恢复",
    "JiGuiWenJianGuanLi": "集柜文件管理",
    "ZhiCiWenJianGeShi": "支持{0}文件格式，最大支持{1}M",
    "HuanGuiWenJian": "还柜文件",
    "YiHuanGui": "已还柜",
    "YunDanWenJian": "运单文件",
    "QiTaWenJian": "其他文件",
    "ShangChuanWenJian": "上传文件",
    "DangQianJiFenNBenDanDiYaJiFenBuZhu": "当前积分 {0}，本单需抵押 {1} 积分 ，当前积分余额不足以抵押，请使用定金方式参与。",
    "QueRenShengChanYaoQiuZhon2": "正在确认生产要求中，不能调整数量",
    "WoTongYi": "我同意",
    "YiZhiFuDingJinDaiChengTuan": "已支付定金，待成团",
    "GouMaiXiangShuXiaoYuGongChangYaoQiu2": "正在确认生产要求，不能调整数量",
    "SouSuoKeHuDingDanJiGui": "搜索客户/订单/集柜",
    "JiFenShuoMing": "积分说明",
    "GenJuYongHuZhuYaoShiYongYuYanShuRuJiKe": "根据用户主要使用语言输入即可",
    "FaPiaoShangDeBianHao": "发票上的编号",
    "HaiGuanDaiMa": "海关代码",
    "ChanPinMiaoShu": "产品描述",
    "ShangBiao": "商标",
    "XingHao": "型号",
    "DaiMaDanWei": "代码单位",
    "JiLiangDanWei": "计量单位",
    "ZongXiangShu": "总箱数",
    "ChengBen": "成本",
    "JiaGeZhuanHuan": "价格转换",
    "YunShuChongXinJiSuan": "运输重新计算",
    "ZengZhiShui(ChongXinJiSuan)": "增值税(重新计算)",
    "XuKeZhengWenJian": "许可证文件",
    "ShangChuanTianCong": "上传填充",
    "FeiYongChongXinJiSuan": "费用(重新计算)",
    "YuanYuJiZhuangGuiRiQi": "原预计装柜日期",
    "MingSKCangKu": "明斯克仓库地址",
    "CangKuTuiJian3": "明斯克仓库的描述",
    "BaiEXinRenYouHuiQuanTiShi1": "新客户专享",
    "BaiEXinRenYouHuiQuanTiShi2": "注册就送{0}张优惠券。首单最高享受5%折扣！",
    "BaiEXinRenYouHuiQuanTiShi3": "该优惠券从注册成功后发放，有效期为30天。",
    "MaShangXiaDan2": "限时优惠，马上下单吧！",
    "XinKeHuZhuanXiangZhuYiShiXiangNeiRong2": "1. 本次优惠活动仅限从10月1日起在ESSAONE完成注册的新用户享受。<br />2. 所有优惠券均不能叠加使用，每笔订单仅限使用一张优惠券。下单时系统会根据当前可使用的优惠券，默认使用优惠额度最大的一张。<br />3. 优惠券一旦使用，只有在订单全部商品取消的情况下才会退还。如果只是部份商品被取消，则优惠券不作退还。",
    "BaiEGouWuCheAnNiu": "6月1日接受订购",
    "BaiEMeiYaoQing1WeiHaoYouZhuCeJiKeHuo": "欢迎加入我们的分享奖励计划！邀请您的朋友（非竞争对手）并与他们分享奖励！<br>1.每邀请1位好友注册并下单即可获得一张价值750 BYN优惠券，而被您邀请注册的好友也可获得新客户优惠券。",
    "BaiEHaoYouZhuCeChengGongKeHuoDe": "好友注册成功即可获得价值750 BYN优惠券。",
    "BaiENiKeDeYiZhangDaiJiHuoJuan": "好友注册后您即可获得一张待激活的750 BYN优惠券，该优惠券暂未生效。好友下首单后，该优惠券才被激活，可以使用。",
    "ZuiJin": "最近",
    "GongZuoShiJian": "工作时间",
    "YiChang": "异常",
    "DingDanXiaoXi": "订单消息",
    "SouSuoDingDanBianHao": "搜索订单编号",
    "XiaDan": "下单",
    "DingDanYiQuXiao": "订单已取消",
    "NKuanNXiang": "{0} 款，{1} 箱",
    "YiShangWeiBenDingDanXinXi": "以上信息为本订单信息",
    "DingGouShuLiang": "订购数量",
    "ZengZhiShui": "增值税",
    "JinEHanShui": "金额 (含税)",
    "QingGuanDanHao": "清关单号",
    "SuoYouCangKu": "所有仓库",
    "SheZhiQuanXian": "设置权限",
    "KeYiShiYongNaXieGongNeng": "可以使用哪些功能",
    "KeYiCaoZuoNaXieGuoJiaDeShuJu": "可以操作哪些国家的数据",
    "CanYuNaXieRenWuFenPei": "参与哪些任务分配",
    "MuDiCangKu": "目的仓库",
    "QueRenRuKu": "确认入库",
    "QingGuanDanDanHao": "清关单单号",
    "SuoZaiCangKu": "所在仓库",
    "ShengChengDanJu": "生成单据",
    "DiaoBo": "调拨",
    "DaiDiaoBo": "待调拨",
    "DiaoBoZhong": "调拨中",
    "SouSuoPODanHaoHuoKeHuBianHao": "搜索PO单号或客户编号",
    "DangQianCangKu": "当前仓库",
    "YiDaoDaiChuKu": "移到待出库",
    "HeJiNGeKeHuNGeDingDan": "合计 {0} 个客户，{1} 个订单",
    "SouSuoGuoJia": "搜索国家",
    "PiLiangDiaoBoDeDingDanCangKuShuJuXuYaoYiZhi": "批量调拨的订单，仓库数据需要一致！",
    "QueDingYiDaoDaiChuKu": "确定移到待出库",
    "DiaoBoShiJian": "调拨时间",
    "CheXiaoDiaoBo": "撤销调拨",
    "QueDinCheXiaoDiaoBo": "确定撤销调拨",
    "RuKu": "入库",
    "QueRenDiaoBoRuKu": "确认调拨入库",
    "RuKuRiQi": "入库日期",
    "RuKuChengGong": "入库成功",
    "JiFenZhangHu": "积分账户",
    "WoYaoZhaoYang": "我要找样",
    "MiaoShuNiYaoZhaoDeShangPin2": "描述要找的商品",
    "MiaoShuXuYaoZhaoDeShangPi2": "请输入描述",
    "YiYouZhiLiao2": "提供资料/图片",
    "JieZhiRiQi": "截止日期",
    "QingXuanZeJieZhiRiQi": "请选择截止日期",
    "NGeGongZuoRi": "{0}个工作日",
    "SheDingRenWuBiXuZaiDuoShaoGeGong": "设定任务必须在多少个工作日完成，单位(天)",
    "JiXuFaBu": "继续发布",
    "ZhaoYangRenWuYiFaBuChengGong": "找样任务已发布成功，可前往我的找样查看。",
    "DangQianZhangHuWeiRenZheng": "当前账户未认证，任务不会得到回复，请前往认证。",
    "QianWangRenZheng": "前往认证",
    "DangQianZhangHuDaiRenZheng": "当前账户待认证，找样任务无法获得回复。",
    "RenWuFenPeiZhong": "任务分配中",
    "YiGuaQi": "已挂起",
    "QingXuanZeYaoCaoZuoDeShuJu": "请选择要操作的数据",
    "KeHuQianBao": "客户钱包",
    "KeHuDangQianQianBaoSuoShuGuoJia": "客户当前钱包所属国家",
    "ZanMeiQueRen": "暂没确认",
    "SuoShuGuoJia": "所属国家",
    "WuQuanXian": "无权限",
    "ZhangHuGuoJia": "账户国家",
    "YiChuHuoJiGui": "已出货集柜",
    "YuChuHuoJiGui": "预出货集柜",
    "DengLuMing": "登录名",
    "JiFenDuiHuan": "积分兑换",
    "ShangPingZhengShuBianHaoChongFu": "商品证书编号重复",
    "QingShuRuZhengShuBianHao": "请输入证书编号/备注搜索",
    "YouXiaoQiZhi": "有效期至",
    "QingXuanZeShiFouYouShangPinZhengShu": "请选择是否有商品证书",
    "QingXuanZeShangPinZhengShu": "请选择商品证书",
    "HaiGuanShangPinBiaoMiaoShu": "海关商品表描述",
    "ShiYongLeiMu": "适用类目",
    "ZhengShuBianHao": "证书编号",
    "ZhengShuBeiZhu": "证书备注",
    "ZhengShuWenJian": "证书文件",
    "ZuiDuoShangChuan5Zhang": "最多上传5张,小于10M .pdf, .jpg, .jpeg, .png",
    "QingXuanZeShiFouYouZhengShu": "请选择是否有证书",
    "NinShangWeiXuanZeZhengShu": "您尚未选择证书",
    "WuZhengShuChuHuo": "无需证书",
    "ZhengShuGuanLi": "证书管理",
    "XinZengZhengShu": "新增证书",
    "ShuXing": "属性",
    "SouSuoShangPinBianHao": "搜索商品编号",
    "ZuiDuoZhiNengShangChuan5GeWenJian": "最多只能上传5个文件",
    "ChongXinSheZhiTieZhi": "重新设置贴纸",
    "HuanYingDengLu": "欢迎登录",
    "ZhuCeXinZhangHao": "注册新账号",
    "PinTuanShuoMing": "拼团说明",
    "HuaGengShaoDeQianCaiGouGengDuoKuanShi": "花更少的钱采购更多款式",
    "QuXiaoZhaoYang2": "取消找样",
    "ZhaoDaoDeShangPin": "找到的商品",
    "DaoChuQuanBuShangPin": "导出全部商品",
    "DaoChuSuoXuanShangPin": "导出所选商品",
    "QuXiaoXuanZe": "取消选择",
    "BuChongZiLiaoTuPian": "补充资料/图片",
    "YanQiZhi": "延期至 {0}",
    "JueDeDangQianJieGuoBuGouManYi": "觉得当前结果不够满意",
    "BuChongMiaoShu": "补充描述",
    "QingBuChongMiaoShu": "请补充描述",
    "ShangChuanWenJian2": "上传文件，支持图片/压缩包/Excel，单文件最大支持200M，最多上传5个文件",
    "YanQi": "延期",
    "QingXuanZeYanChiDuoShaoGeGongZuoRi": "请选择延迟多少个工作日",
    "YanQiXinXi": "延期信息",
    "RenWuYanQi": "任务延期",
    "YanQiChengGong": "延期成功!",
    "MeiYouTuiJianShangPin": "没有推荐商品",
    "NTianHouRenWuJieShu": "{0} 天后任务结束",
    "YiZhaoDao": "已找到",
    "KuaJingB2BXinPinCaiGouPingTai": "跨境B2B新品采购平台-中国制造，玩具，文体用品，户外活动用品，节庆用品",
    "XinYongHuMianFeiZhuCeZhangHao": "新用户免费注册账号",
    "QingShuRuYouXiang": "请输入邮箱",
    "YouXiang2": "邮箱",
    "YiYouZhangHao": "已有账号？",
    "YouXiangYanZhengMa": "邮箱验证码",
    "YiFaSong": "已发送",
    "QingShuRuYouXiaoDeGongSiMingCheng": "请输入有效的公司名称",
    "FaQiZhaoYang": "发起找样",
    "TuiJianZhuTiMingCheng2": "搜索主题",
    "JinTian": "今天",
    "YiZhaoWan": "已找完",
    "HaiGuanGuanQiaTongXingJianChaZhan": "<p>1.到 {0} 海关关卡通行检查站：{1}（{2} 公里）;</p>",
    "HangXianMingCheng": "航线名称",
    "BuManYiYuanYin": "不满意原因",
    "QingTianXieBuManYiYuanYin": "请填写不满意原因",
    "JieGuoBuManYi": "结果不满意",
    "FaQiRenDuiZhaoYangJieGuoBuManYi": "发起人对找样结果不满意",
    "KeYuYueTiHuo": "可预约提货",
    "YiFaHu": "已发货",
    "DaiYuYue": "待预约",
    "YuYueTiHuo": "预约提货",
    "NiZhunBeiRuHeTiHuo": "请选择从仓库提货的方式",
    "TiJiNZhongLiangN": "体积 {0} , 重量 {1}",
    "NGeDingDan": "{0}个订单",
    "ZiJiYuYueWuLiuGongSiDaoCangKu": "自行预约物流公司从仓库提货",
    "ZiTiFangShi": "自提方式",
    "GeRenZiTi": "个人自提",
    "ZiJiKaiCheQianWangCangKu": "自己开车前往仓库",
    "ShiYongWoMenHeZuoDeWuLiuGongSi": "使用我们合作的物流公司",
    "QianWangTiHuoShiJian": "前往提货时间",
    "LianXiRenXingMing": "联系人姓名",
    "WuLiuGongSiMingZi": "物流公司名字",
    "ShangPinShiFouXuYaoDaMuJia": "是否需要额外的保护性包装？",
    "DaMuJiaTiShi": "请根据货物的性质说明是否需要额外的保护性包装（如打木架）。根据货物是否打木架，货物的体积/重量和运输成本可能会相应增加。",
    "XuYaoDaMuJia": "需要额外的保护性包装",
    "MeiGeMuJiaFeiYongTiShi": "请说明额外包装的要求",
    "QuanBuBuXuYao": "全部不需要",
    "YinWuLiuHuoSunZiJiChengDan": "请注意，对于货物在进一步运输过程中可能出现的损坏，我们概不负责。",
    "XuanZeWuLiuGongSi": "选择物流公司",
    "WuFaJiaZaiDiTuZuJian": "无法加载地图组件",
    "PiLiangYuYue": "批量预约",
    "PiLiangYuYueTiHuo": "批量预约提货",
    "YuXiaMianDingDanYiQiTiHuo": "与下面订单一起提货",
    "DingDanSongZhi": "订单送至",
    "PinTuanShengYuShiJian": "拼团剩余时间",
    "ZanBuYuYue": "暂不预约",
    "YiXiaDingDanYiRuKu": "以下订单已入库，请尽快预约提货",
    "YiXiaDingDanYiZhiFuWeiKuan": "以下订单已支付尾款，正在运输中，预计 {0} 到达，是否要一起预约？",
    "XuanZeDingDan": "选择订单",
    "TiJiaoYuYue": "提交预约",
    "RuKuTingCangTiShi": "入库后有 {0} 免费停仓期，逾期收费 {1}/m³/天。",
    "ChaKanDingDan": "查看订单",
    "WoMenHeZuoDeWuLiuGongSiYou": "我们合作的物流公司有",
    "GenJuNiDeDingDan": "根据你的订单，以下物流公司可能合适",
    "ZiJiDaoCangKuTiHuoMianFei": "自己到仓库提货，免费！",
    "WuLiuGongSiXinXi": "物流公司信息",
    "ZiJiLianXiDiSanFangWuLiuGongSiDaoCangKuTiHuo": "自己联系第三方物流公司到仓库提货",
    "WuLiuDanHao": "物流单号",
    "WuLiuGongSiLianXiBuShangKeYiLianXiYiXiaRenYuan": "如无法联系物流公司请联系以下人员",
    "ShiYongPingTaiZhiDingDeWuLiuGongSi": "使用平台指定的物流公司，可以享受送货服务，省钱！",
    "HuoSunFeiYongXieYi": "《关于各方责任协议》",
    "PoSunZiFuXieYi": "关于各方责任协议",
    "DaMuJiaTiShi2": "若不打木架，易碎商品在运输过程中遭受损坏，请自行负责。",
    "HuoSunFeiYongXieYiNeiRong": "1. 供应商（ESSAONE）承诺将货物交付至买方在下订单时指定的运输公司的仓库，并在约定的时间将货物交给物流公司运输。\n2.\t供应商应按照买方预约单的要求正确告知买方指定的物流公司是否对货物进行额外的保护性包装。供应商不提供对货物进行额外的保护性包装服务，不参与支付包装费用，不承担包装责任。\n3.\t如买方要求不对货物进行额外的保护性包装，那么在运输过程中发生货物灭失、损坏、变质、污染等情况，买方应自行承担由此造成的经济损失或自行与物流公司协商解决。供应商对此不承担任何赔偿责任。",
    "BuTongYi": "不同意",
    "XuanZeShouHuoDiZhi": "选择收货地址",
    "ZuiZhongYiWuLiuGongiShouFeiWeiZhun": "价格仅供参考，最终以物流公司收费为准",
    "WuLiuFaChuRiQi": "物流发出日期",
    "ShiYongSongHuoFuWu": "使用送货服务",
    "QingXuanZeDingDan": "请选择订单",
    "ZhunBeiYuYueDeDingDan": "准备预约的订单",
    "CangKuGongZuoShiJian": "仓库工作时间",
    "TiHuoDan": "提货单",
    "TiHuoXinXi": "提货信息",
    "QuXiaoYuYue": "取消预约",
    "YiWanChengTiHuo": "已完成提货",
    "ZaiCiYuYue": "再次预约",
    "TiHuoFangShi": "提货方式",
    "MianFeiTingCangQi": "免费停仓期",
    "KaiShiShouFeiYiChanShengNTianFeiYong": "开始收费，已产生{0}天费用",
    "RuKuTingCangTiShi2": "{0} 至 {1}。{2} m³ 已产生 {3}停仓费用（{4}/m³/天）。",
    "NZhiN": "{0} 至 {1}",
    "RuKuTingCangTiShi3": "{0} 前免费停仓，往后每延迟 1 天收费 {1}",
    "XuSongChe": "需送货到物流点",
    "YiTiHuo": "已提货",
    "QuanBuLeiXing": "全部类型",
    "MianFeiTingCangZhi": "免费停仓至",
    "TiHuoShiJianShengYu": "提货时间剩余 {0}，不提货将继续产生停仓费用",
    "YiChanShengNTianFeiYong": "已产生{0}天费用",
    "QingGuanDengJi": "清关登记",
    "QingGuanZhuangTai": "清关状态",
    "KaiShiQingGuan": "开始清关",
    "QingGuanWanCheng": "清关完成",
    "QingGuanBeiChaGui": "清关被查柜",
    "GengXinQingGuanXinXi": "更新清关信息",
    "YiDaDao": "已到达",
    "WuLiuGenJin": "物流跟进",
    "GengXinWuLiuXinXi": "更新物流信息",
    "GengXin": "更新",
    "JiGuiJuLiCangKu": "集柜距离仓库",
    "WuLiuXinXiGuanLi": "物流信息管理",
    "ZhiChiSouSuoFuWuChengShiWuLiuGongSi": "搜索城市/物流公司",
    "WuLiuGongSi": "物流公司",
    "FuGaiChengShi": "覆盖城市",
    "XinZengWuLiuGongSi": "新增物流公司",
    "BianJiWuLiuGongSi": "编辑物流公司",
    "WuLiuGongSiMingCheng": "物流公司名称",
    "LianXiRenMinCheng": "联系人名称",
    "LianXiRenDianHua": "联系人电话",
    "ChePaiHao": "车牌号",
    "SiJiXingMing": "司机姓名",
    "QueRenWuLiuGongSi": "确认物流公司",
    "ESSAONETiGongMianFeiSongCheFuWu": "ESSAONE提供免费送货到点服务，即我们会把你的货物送到物流点，让你节省从我们仓库到物流点的运输费用。但我们的送货时间只有每周三一次。如你勾选了，则代表接受并同意。",
    "XinZengLianXiRen": "新增联系人",
    "ShanChuHouBuYingXiangYiTuiJianDeDingDan": "请确认是否要删除该物流公司，删除它不会影响已被推荐的订单？",
    "DangQianJiGuiYouBuTongCangKuDeDingDan": "当前集柜有不同仓库的订单",
    "QingXuanZeQingGuanZhuangTai": "请选择清关状态",
    "KaiShiQingGuanHouCaiNengCaoZuoQingGuanWanCheng": "开始清关后才能操作清关完成",
    "XinZengJiLuChengGong": "新增记录成功",
    "QingShuRuJuLiCangKuGongLiShu": "请输入距离仓库公里数",
    "QingGuanJiLu": "清关记录",
    "JiGuiYiQingGuanWanCheng": "集柜已清关完成",
    "YiQingGuanWeiRuKu": "已清关未入库",
    "WuLiuTuiJian": "物流推荐",
    "YiGuoZhongGuoBianJingNTian": "已过中国边境 {0}天",
    "TiJiZhongLiang": "体积重量",
    "BuNengChongFuKaiShiQingGuan": "不能重复开始清关",
    "ChuHuoFangShi": "出货方式",
    "TuiJianWuLiuGongSi": "推荐物流公司",
    "TianXieYuJiWuLiuFeiYong": "填写预计1 m³的物流费用（{0}）",
    "YiTuiJian": "已推荐",
    "WeiTuiJian": "未推荐",
    "QingXuanZeWuLiuGongSi": "请选择物流公司",
    "QingShuRuDaYuLingDeShuZi": "请输入大于0的数字，最多两位小数",
    "HuoWuDaoNiSuoZaiChengShiWuLiuFeiYong": "货物到你所在城市（{0}）,物流费用大概 {1}",
    "SongZhiNiZhiDingShouHuoDiZhi": "送至你指定收货地址",
    "FeiYongWeiZhiFu": "费用未支付",
    "XinZengJiLu": "新增记录",
    "QinShuRuYouXiangYanZhengMa": "请输入邮箱验证码",
    "MeiZhaoDaoJieGuo": "没找到结果",
    "WuLiuGongSiGuanWang": "物流公司官网",
    "JiSuanWuLiuFeiYongQingZhuanDao": "计算物流费用请转到",
    "ChengGongGengXinNTiaoShuJuNTiaoShiBai": "成功更新{0}条数据，{1}条失败",
    "XuanZeDiZhi": "选择地址",
    "XinZengHouWuFaXiuGaiQingQueRen": "新增后无法修改，请确认",
    "MeiYouGaiChengShiShiPeiDeWuLiu": "没有该城市适配的物流",
    "YuYueXinXi": "预约信息",
    "TuiJianWuLiu": "推荐物流",
    "HeZuoWuLiu": "合作物流",
    "GenJuNiSuoZaiChengShiKeNengHeShi": "根据你所在城市，可能合适",
    "TongYiPiCiYuYueZhiNengXuanZeTongYiGeMuDiCangKu": "同一批次预约只能选择一个目的仓库",
    "JiSuanCuoWUJinEWei0": "计算错误,金额为 0",
    "YiZhiFuGuoFeiYongBuNengQuXiao": "费用已支付不能取消",
    "GongSiMingChengYiCunZai": "公司名称已存在",
    "YiJingQingGuangWanCheng": "清关已完成",
    "QingWuChongFuDengJi": "请勿重复登记",
    "CunZaiWeiZhiDeTingCangFeiYong": "存在未支付的停仓费用不允许出货",
    "YiCunZaiYuYueBuXuYaoJiXuTuiJian": "已存在预约不需要继续推荐",
    "RuKuTingCangTiShi4": "{0} 至 {1}。{2} m³ 已产生 {3}停仓费用（{4} /m³/天），请尽快预约提货。",
    "QingXuanZeRenWu": "请选择任务",
    "PeiSongFuWuZhiNengYuYueZhouSan": "配送服务只能预约周三",
    "DingDanYiJingYuYue": "订单已经预约，请到待提货列表操作出货",
    "XiaoShouJiaGongShi2": "我的销售价=FOB价格+海运费+清关费+关税+利润",
    "QingKong": "清空",
    "XiaoShouJiaGongShi3": "销售价=(FOB价格+海运费/PCS+清关费/PCS) × (1+海关税率) × (1+利润) × (1+增值税)",
    "XianShiDeBiZhong": "显示的币种",
    "XiuGaiBiZhong": "修改币种",
    "XiuGaiXiaoShouGuoJia": "修改销售国家",
    "ZuiHouGenJinShiJian": "最后跟进时间",
    "ChaKanGongChang2": "查看工厂",
    "GengDuoChanPin": "更多产品",
    "GenJinXinXi": "跟进信息",
    "QinShuRuGenJinXinXi": "请输入跟进信息",
    "GenJinJiLu": "跟进记录",
    "ShuiWuHao2": "税务号",
    "ShouJiHao": "手机号",
    "FaSongShiJian": "发送时间",
    "YouXiaoZhi": "有效至",
    "TongGongChangChanPin": "同工厂产品",
    "QiTaPinPaiXiangSiChanPin": "其他品牌相似产品",
    "LiJiHuoQuBaoJia": "立即获取报价",
    "ZuiZao12XiaoShiNeiDaFu": "最早12小时内答复",
    "ZhiJieCongYuanTouWeiNinXuanZeZuiZhunQueDeChanPin": "ESSA直接从源头为您选择最准确的产品。",
    "ShouYeXunJiaBiaoTi": "获取询价",
    "SouSuoTuPianTongKuanChanPin": "搜索图片同款产品",
    "1080MSG0001": "验证码校验不通过",
    "1080MSG0002": "手机号码不正确",
    "1063MSG0004": "国家电话区号不正确，或为空",
    "1080MSG0003": "验证码已失效，请重新获取",
    "ZhiFuShiBai": "支付失败",
    "DaBaoYaoQiu": "打包要求",
    "CLAIM_DAMAGE_130": "订单尚未入库,无法发起赔偿",
    "SuoPeiYouHuiJuanShiBai": "索赔优惠券失败",
    "ChuangJianYouHuiJuanShiBai": "创建优惠券失败",
    "XieShangZhongXuYaoBuTongYiJiLuCaiNengGuanBi": "协商中需要不同意记录才能关闭",
    "CLAIM_DAMAGE_131": "该商品已经无可索赔数量",
    "CLAIM_DAMAGE_132": "该商品未入库或已出库，无法发起售后操作",
    "YiXiaShangPinYiPoSun": "以下商品已破损",
    "YiXiaShangPinMaiGuiLiao": "以下商品买贵了",
    "PoSunShuLiang": "破损数量",
    "TianXiePoSunChanPinShuLiangQingLiuYiDanWei": "填写破损产品数量，请留意计量单位",
    "BuChongXinXi": "补充信息",
    "MiaoShuChanPinPoSunQingKuang": "请描述产品破损详情，并上传相关照片(要求照片能清楚看到产品和破损情况)",
    "SuoPeiFangShi": "索赔方式",
    "ShouXuMaFanXuYaoTianXieFuZaDeShenQingBiaoGe": "手续麻烦，需要填写复杂的申请表格，等待财务审核通过后打款。",
    "XiaZaiShenQingBiaoGe": "下载申请表格",
    "ShouXuJianDanShenHeTongGuoHou": "手续简单。审核通过后，将发送同等金额的优惠券到您的账户，优惠券最多可抵扣订单金额的50%。",
    "ShangChuanShenQingBiao": "上传申请表",
    "WenDang": "文档",
    "KeSuoPeiShuLiang": "可索赔数量 {0}",
    "LiShiYiShenQingPeiFuLe": "历史已申请赔付了 {0}",
    "FanHuiDingDan": "返回订单",
    "SuoPeiXiangQing": "索赔详情",
    "PeiChangJiangTongGuoYouHuiQuanFaFangDaoNiZhangHu": "赔偿将通过优惠券发放到你账户，有效期 {0} 天，申请即视为同意该赔偿方案",
    "PeiChangFangShi": "赔偿方式",
    "YouHuiQuanKeYiDieJiaShiYong": "优惠券可以叠加使用，最多可抵扣订单金额的50%。",
    "LingQuWanDaoPeiFuYouHuiQuan": "领取晚到必赔优惠券",
    "SuoPeiChengGong": "索赔成功",
    "WanDaoSuoPeiChengGongMiaoShu": "晚到必赔成功描述",
    "ShouHou": "售后",
    "JingPingTaJianChaFaXianNiDeHuoWuPoSun": "经平台检查发现你的货物破损，现已发起赔偿方案，请及时处理",
    "ShangPinYiPoSun": "商品已破损",
    "ShangPinMaiGuiLiao": "商品买贵了",
    "ShiFouYaoCheXiaoSuoPeiShenQing": "是否要撤销索赔申请",
    "ShouHouTuiKuan": "售后退款",
    "KeHuFaQi": "客户发起",
    "CangKuFaQi": "仓库发起",
    "FaQiShouHouTuiKuan": "发起售后退款",
    "DangQianShangPinYi PCSJiaGeWeiZhun": "当前以商品的PCS价格为准，ESSAONE 价格：{0} / PCS",
    "ShouHouTuiKuanChanPinShuLiang": "售后退款产品数量",
    "KeHuGouMaiGongN": "客户购买共 {0}",
    "GaiBuFenHuoWuKeHuBuYaoLeXuYaoTuiKuan": "客户放弃了这部分货物并要求退款。",
    "QueRenPoSunQingKuang": "确认破损情况（共 {0}）",
    "ZhengChangChanPin": "正常产品",
    "PoSunChanPin": "破损产品",
    "ZhengChangChanPinJiangZiDongZhuanKuCunShangPin": "正常产品将自动转库存商品，且会折算成整箱",
    "ShouHouFangAn": "售后方案",
    "ShouHouTuiKuanYiXianJinFangShiTuiGeiKeHu": "以现金方式赔偿给客户，并等客户上传申请表后再付款",
    "ShouHouTuiKuanYiYouHuiQuanFangShiTuiGeiKeHu": "以发放优惠券方式赔偿给客户，满 {0} 减 {1}",
    "TiJiaoChengGongQingDengDaiKeHuChuLi": "提交成功，请等待客户处理",
    "YiChuHuoJiGuiDanLieBiao": "已出货集柜单列表",
    "GuanBiPeiChang": "关闭赔偿",
    "ShiFouYaoGuanBiSuoPeiShenQing": "是否要关闭赔偿申请",
    "PeiShenChuLi": "赔偿处理",
    "ShouQuanPeiShen": "同意赔偿",
    "ZongPeiChangJiaZhiJinE": "总赔偿价值/金额",
    "QingShuRuJieGuoShuoMing": "请输入结果说明",
    "JuLiShangCiChuLiYiDengDaiNTian": "距离上次处理，已等待 {0} 天",
    "KeHuFaQiLieBiao": "客户发起列表",
    "CangKuFaQiLieBiao": "仓库发起列表",
    "QueRenYiJingHuiKuanGeiKeHuJiangSuoPeiDanBiaoShiWeiYiHuiKuan": "确认已经汇款给客户，将索赔单标识为已汇款？",
    "ZongShouHouTuiKuan": "总售后退款",
    "PeiFuJinE": "赔付金额",
    "QingShuRuJiaCha": "请输入差价",
    "QingShuRuJinE": "请输入金额",
    "TiaoZhengShouHouTuiKuan": "调整售后退款",
    "DengDaiKeHuChuLi": "等待客户处理",
    "QingXuanZeShouHouYuanYin": "请选择售后原因！",
    "ShouHouYuanYin": "售后原因",
    "ShouHouChanPinShuLiang": "售后产品数量",
    "DaiHuKuan": "待汇款",
    "QuanBuLeiXin": "全部类型",
    "PiLiangChuLi": "批量处理",
    "YiHuiKuanDaoNiTianXieDeYinHan": "已汇款到你填写的银行账户，请留意银行收款信息！",
    "YiPeiFuJiaZhiNDeYouHuiQuan": "已赔付价值 {0} 的优惠券，有效期 {1} 天，请尽快使用。",
    "YouWenTiChanPinShuLiangN": "有问题产品数量 {0} {1}， 已赔付价值 {2} 的优惠券，有效期 {3} 天，请尽快使用。",
    "YouWenTiChanPinShuLiangN1": "有问题产品数量 {0} {1}， 赔付价值 {2} 的优惠券，有效期 {3} 天。",
    "FaQiPeiChangFangAn": "发起赔偿方案",
    "YiTongYiPeiChang": "已同意赔偿",
    "YiHuiKuan": "已汇款",
    "YiTongGuoXianJin": "已通过现金方式赔付 {0}，请留意银行收款信息！",
    "XieShangLiShi": "协商历史",
    "TongYiPeiChangFanAn": "同意赔偿方案",
    "ShangChuanXianJinShenQinBiao": "上传现金申请表",
    "XiaZaiShenQinBiaoGe": "下载申请表格",
    "ShangChuanTip": "文档 (xls,xlsx,pdf)，单个文件不能超过20M",
    "ShenQinPeiChang": "申请赔偿",
    "ShangChuanTip2": "图片/视频/文档(mp4, flv, jpeg, jpg, png, bmp, doc, docx, xls, xlsx, pdf)，单个文件不能超过20M，最多5个",
    "ChengGongGengXinNTiaoShuJuNTiaoShiBai2": "本次处理数据{0}条，成功{1}条",
    "YouWenTiChanPinShuLiangN2": "赔偿产品数量 {0} {1}， 赔付 {2} 的现金，请上传现金申请表单。",
    "YouWenTiChanPinShuLiangN3": "有问题产品数量 {0} {1}，已通过现金方式赔付 {2}，请留意银行收款信息！",
    "GaiShangPinYiJingWuKeSuoPeiShuLiang": "该商品已经无可索赔数量",
    "DangQianShangPinYiQuanBuQuXiaoDengJi": "当前商品已全部取消登记，请 <span class=\"color-blue\">关闭赔偿</span>",
    "ChePaiHaoMa": "车牌号码",
    "TianXieLianXiXinXi": "填写联系信息",
    "ShouJianRenQuanMing": "收件人全名",
    "ShuiWuHaoHuZhaoXinXi": "税务号/护照信息",
    "ShouJianRenSuoZaiChengShi": "收件人所在城市",
    "YunShuGongSiZhongDianZhan": "运输公司终点站",
    "ChengShiJiaoHuoDiZhi": "城市交货地址",
    "ShuiWuHaoHuZhaoXinXiTiShi": "收件人是法人，填写税务号；是个人，填写护照信息",
    "QingShuRuChengShiMinCheng": "请输入城市名称",
    "QingZhuMingSuoXuDeYunShuGongSiZhongDianZhan": "请注明所需的运输公司终点站",
    "SongHuoShangMen": "送货上门",
    "ShangChuanChuHuoZhaoPianWenJianTiShi": "图片/视频 (mp4,flv,jpeg,jpg,png,bmp,zip)，单个文件不能超过50M，最多20个",
    "ShangChuanChuHuoZhaoPian": "上传出货照片",
    "IntroduceBanner1": "Factory direct supply platform in China",
    "IntroduceBanner2": "About ESSACHINA.COM",
    "IntroduceBanner3": "We serve more than 720 buyers worldwide, helping them to source their favorite products from Chinese factories efficiently and at a good price",
    "GongChangTuiJianTiDaiKuan": "工厂推荐替代款",
    "GongChangYouHaoTuiJian2": "工厂有新推荐 {0} 款",
    "FangYangZhanTing": "放样展厅",
    "ZaiBaiDuDiTuChaKan": "在百度地图查看",
    "AnShouZiMuShaiXuan": "按首字母筛选",
    "BuXian": "不限",
    "TanWei": "摊位",
    "DianJiFuZhiDiZhi": "点击复制地址",
    "DianJiFuZhiDiZhiDianHuaHaoMa": "点击复制电话号码",
    "BianJiZhengShu": "编辑证书",
    "JiaGeBaoKuoZengZhiShuiTiShi": "价格包括增值税、关税和从中国制造商到供应商仓库的运费。",
    "MianFeiDinYueESSA": "免费订阅 ESSA 商品月刊",
    "QinXuanZeGanXinQuDeChanPinLeiMu": "请选择感兴趣的产品类目",
    "BuZaiTiShi": "不再提示",
    "QueRenDinYue": "确认订阅",
    "DangQianYouXiangYiZhuCe": "当前邮箱已注册，请前往登录",
    "ChanPinYueKan": "产品月刊",
    "DenLuChaKanJiaGe": "登录查看价格",
    "YueKan": "月刊",
    "SuoXuanRiQiYChaoGuoMianFeiTingCangQi": "请注意，所选日期已超过免费停仓期（免费停仓至 {0}），大约产生 {1} 停仓费",
    "WeiZhiFuBuYunXuChuKu": "未支付，不允许出库",
    "JianMianFeiYong": "减免费用",
    "TiaoZhengDingDan": "调整订单",
    "QuanMian": "全免",
    "GouXuanDeDingDanBaoLiu": "勾选的订单保留，未勾选订单，需要客户重新预约后提货",
    "YiQuanMianFeiYong": "已全免费用",
    "ShiFouYaoQuanMian": "是否要全免？",
    "ShiFouYaoYouHuiJinE": "是否要优惠金额？",
    "QingShuRuYouHuiJinE": "请输入优惠金额",
    "QueDingYaoTiaoZhengDingDan": "确定要调整订单？",
    "ZhongGuoZhiDaDingDan": "中国直发订单",
    "QingLianXiKeFuWanChengFuKuan": "请联系客服完成付款",
    "QingXuanZeYaoQuXiaoDeShangPin": "请选择要取消的商品",
    "YuJiDaoGang": "预计到达",
    "QueDingYaoQuXiaoShangPinMa": "确定要取消商品吗？",
    "ZhengDanQuXiao": "整单取消",
    "HeJiQuXiao": "合计取消",
    "QingXuanZeDingDanFuKuanFangShi": "请选择订单付款方式",
    "QingXuanZeDingDanFuKuanKaHao": "请选择订单付款卡号",
    "KeYongEDu": "可用额度",
    "ChaoChuKeFanWei": "超出可用范围",
    "ZhiFuXinXi": "支付信息",
    "QueDingShiJian": "确定时间",
    "YiGuoNTian": "已过 {0} 天",
    "LeiJiDing": "累计",
    "ZhongGuoZhiFaDingDan": "中国直发订单",
    "SuoXuanXinXiShiFouYiJingYuKeHuQueRenGuo": "所选信息是否已经与客户确认过？",
    "ESSAChanPinYueKan": "ESSA 产品月刊",
    "MeiYueJinXuanYouZhiChanPin": "每月精选优质产品 助力你的采购",
    "DingYueYueKan": "订阅月刊",
    "ShangPinQinQuan": "商品侵权",
    "YiTianJia": "已添加",
    "MskCangKu2": "莫斯科仓库2",
    "ChanPinYiQinQuan": "产品已侵权",
    "QueRenDingDanChengGong": "确认订单成功",
    "YiZhengDanQuXiao": "已整单取消",
    "KeHuBuYaoLe": "客户不要了",
    "ZhongGuoZhiFa": "中国直发",
    "YouXiaoQi": "有效期",
    "KeJieSouTuiJianXiangShiKuan": "可接受推荐相似款",
    "QinShuRuDaBaoYaoQiu": "请输入打包要求",
    "JianDan": "简单",
    "SheZhiWoDeXiaoShouJia": "设置我的销售价",
    "XiaoShouJiaGongShi4": "我的销售价=FOB价格 × FOB加价 × 利润",
    "XiaoShouJiaGongShi5": "销售价=FOB价格 × (1+FOB加价率）× (1+利润率)",
    "LiRun": "利润",
    "FOBJiaJia": "FOB加价",
    "HuoBi": "货币",
    "GongZuoRi": "工作日",
    "ZhaoYangShenYuShiJianBuBaoHanZhouMo": "找样剩余时间，不包含周末",
    "DuoShaoGeGongZuoRiNeiXuHuiFu": "多少个工作日内需回复",
    "YiJianFaBu1": "一键发布",
    "YiJianFaBu2": "需求来源多？一键上传，快速统一找样询价！",
    "ZhuanYeTuiJian1": "专业推荐",
    "ZhuanYeTuiJian2": "识别需求信息，合适产品精准推荐",
    "YiJianJiaGou1": "一键加购",
    "YiJianJiaGou2": "优质商品批量加购，省时高效",
    "ZhongGuoZhiFaShangPin": "中国直发商品",
    "ZhongGuoZhiFaShangPinTiShi1": "中国直发商品，不提供发票和清关文件",
    "ZhongGuoZhiFaShangPinTiShi2": "中国直发商品，不提供发票和清关文件，如不采购这种商品，点击设置关闭",
    "ChanPinZanBuXiaoShou": "产品暂不销售",
    "TuiKuanMingXi": "退款明细",
    "DaiTuiKuanJinE": "待退款金额",
    "QueRenFaHuoFangShi": "确认发货方式",
    "LiangZhongFaHuoFangShi": "两种发货方式",
    "QuanBuShangPinZhongGuoZhiFa": "全部商品中国直发",
    "LiangZhongFaHuoFangShiDeXiangXiShuoMing": "如果订单中包含中国直发的商品，那么它将使用两种交付方式。一部分商品由平台常规方式交付，一部分商品直接由制造商交付。",
    "RuGuoXiaDanShangPinBaoHanLeZhongGuoZhiFaDeChanPin": "如果下单商品包含了中国直发的产品，该部分商品由平台审核后联系你确定，提交订单后请留意邮件和电话。",
    "QuanBuShangPinCaiYongZhongGuoZhiFaFangShiFaChu": "全部商品采用中国直发方式发出",
    "BuTiGongFaPiaoHeQingGuanWenJian": "不提供发票和清关文件",
    "DangQianXiaDanShangPinBaoHanLeZhongGuoZhiFaDeChanPin": "当前下单商品包含了中国直发的产品，该部分商品无法提供发票和清关文件。提交订单后，它们将被拆分成子订单并会通知您。您能接受这种处理方式吗？",
    "QueDingYaoShiYong": "确定要使用 {0} ？",
    "TuiKuanQueRen": "退款确认",
    "DaiTuiKuanQueRen": "待退款确认",
    "QueRenXinXi": "确认信息",
    "TuiKuanChanShengShiJian": "退款产生时间",
    "QueRenYiTuiKuan": "确定已退款",
    "DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi": "当前订单客户要求中国直发，请注意贴纸模板设置",
    "KeHuYaoQiuZhiFa": "客户要求直发",
    "DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi2": "当前订单客户要求中国直发，可直接提交",
    "DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi3": "当前下单商品包含了中国直发的产品，该部分商品无法提供发票和清关文件。提交订单后，它们将被拆分成子订单并会通知您。您能接受这种处理方式吗？",
    "JieShouBingJiXuS": "接受并继续 ({0}s)",
    "JieShouBingJiXu": "接受并继续",
    "GongZuoTaiZhuYe": "工作台主页",
    "XuanPinChi": "选品池",
    "WoDeKeHu": "我的客户",
    "TuiJianBaoJiaDan": "推荐报价单",
    "KeFu": "客服",
    "HuoDongZhuanQu": "活动专区",
    "KeHuDeZhaoYang": "客户的找样",
    "GongGongKeHuChi": "公共客户池",
    "ZhangHuXinXiSheZhi": "账户信息设置",
    "PingTai": "平台",
    "KeHuZhuYe": "客户主页",
    "KeHuDongTai": "客户动态",
    "WeiWanShan": "未完善",
    "BangDingKeHuDaoGaiFenXiaoShangMingXia": "将客户转到该分销商名下，此操作将改变客户原有的隶属关系",
    "ShangChuanShiBai2": "上传失败",
    "ZhengShuGuaKao": "证书挂靠",
    "ZhengShuGuaKaoGuiZe": "证书挂靠规则",
    "GuaKaoZunXunXianPiPei": "证书挂靠遵循先匹配，再排除的顺序。商品一旦被排除规则命中，则会被标识为“无证书”。",
    "PiPeiGuiZe": "匹配规则",
    "TianJiaGuiZe": "添加规则",
    "DuoGeGuiZeShiYongHuoDeGuanXi": "多个规则使用或的关系，命中任意一个规则都属于匹配到",
    "PiPeiDeShangPinShiYongYiXiaHaiGuanBianMa": "匹配的商品使用以下海关编码",
    "YiXingYiGeHaiGuanBianMa": "一行一个，海关编码为10位数的大小写英文或数字",
    "QingShuRuHaiGuanBianMa": "请输入海关编码",
    "QingShuRuZhengQueDeHaiGuanBianMa": "请输入正确的海关编码",
    "PaiChuGuiZe": "排除规则",
    "PaiChuDiaoZhiDingShangPinBianHao": "排除掉指定商品编号",
    "YiXingYiGeBianHao": "一行一个编号",
    "ShiFouQueDingBaoCun": "是否确定保存",
    "FuZhiPiPeiGuiZeChengGong": "复制 匹配规则{0} 成功",
    "FuZhiPaiChuGuiZeChengGong": "复制 排除规则{0} 成功",
    "ShiFouYaoShanChuTiaoJian": "是否要删除条件",
    "ShangPinShuYuYiXiaLeiMu": "商品属于以下类目",
    "QingXuanZeLeiMu": "请选择类目",
    "QieFuHeYiXiaShangPinShuXing": "且符合以下商品属性（如变更类目后，请检查一下属性条件）",
    "DianJiQieHuanTiaoJianZuHeFangShi": "点击切换条件组合方式",
    "Qie": "且",
    "TianJiaTiaoJian": "添加条件",
    "ZhengShuXiangQing": "证书详情",
    "ZhengShuXuanZe": "类目选择",
    "GuiZeLeiMuYuZhengShuLeiMuBuPiPei": "规则类目与证书类目不匹配，请检查后再保存",
    "FeiYongDan": "费用单",
    "ChaoShiNTian": "超时 {0} 天",
    "ShenNTian": "剩 {0} 天",
    "ZuiWanQueRen": "最晚确认",
    "QinHeShiXinXiHouQueRenFeiYongDan": "请核实信息后确认费用单。确认后将产生应收账款。如有疑问，可以咨询服务你的业务员",
    "WoDeFeiYongDan": "我的费用单",
    "XinFaPiao": "新发票",
    "XinFaPiaoPCS": "新发票PCS",
    "DaoChuShiBai": "导出失败",
    "FaPiaoXuCaiWuQueRenHouZaiDaoChu": "请联系您的客户经理确认发票后再导出",
    "ChuLiTuiKua": "处理退款",
    "QingQueDingYaoRuHeChuLiTuiKuan": "请确定要如何处理退款",
    "XianXiaHuiKuanGeiKeHu": "线下汇款给客户",
    "TuiHuiKeHuQianBao": "退回客户钱包",
    "YaoQingMaYiCunZai": "邀请码已存在,请重新编辑",
    "FenXiaoShangZhongXin": "分销商中心",
    "FenXiaoShangShouYe": "分销商首页",
    "YuJiShouRu": "预计收入",
    "ZiJiYaoQingKeHu": "我邀请的客户",
    "JinNianYaoQingMuBiao": "今年邀请目标",
    "XiaDanXinYongHu": "已下单的新用户",
    "JinNianChengJiaoXinKeHu": "今年成交新客户",
    "XiaJiFenXiaoShangGongXian": "下级分销商贡献",
    "FuZhiLianJie": "复制链接",
    "SaoMaFenXiang": "扫码分享",
    "FenXiangHaiBao": "分享海报",
    "QingShuRuYaoQingMa": "请输入邀请码，四位数字",
    "XiuGaiYaoQingMa": "修改邀请码",
    "LeiJiYaoQLeiJiYaoQingNRenXiaDanNRen": "累计邀请 {0} 人，下单 {1} 人",
    "SouSuoKeHuMinChengBianHao": "搜索客户名称/编号",
    "YaoQingShiJian": "邀请时间",
    "LeiJiDingDanTiCheng": "累计订单佣金",
    "YiBiaoPan": "仪表盘",
    "DingDanTiChengTiShi": "我们将在每月10日支付上月的佣金（例如，2月10日支付1月1日~31日的佣金）",
    "HeTongYiDaoQiHouDeDingDanJiangBuZaiChanShengShouYi": "合同已到期了。因此，{0} 之后的订单将没有佣金。",
    "DingDanTiCheng": "订单佣金",
    "SouSuoDingDanHao": "搜索订单号",
    "HuiKuanXianJin": "汇款佣金",
    "NNianYueYiWanJie": "{0} 已完结",
    "NNianYueTiChengYiHuiKuan": "{0} 佣金已汇款",
    "KeHuYiBiaoPan": "客户仪表盘",
    "SouTu": "搜图",
    "HeTongYouXiaoQiZhi": "合同有效期 {0} 至 {1}",
    "MoRenShiNiDeShouJiHao": "默认是你的手机号",
    "MiMaGuiZe3": "请输入8-16位字符，由数字、字母组合",
    "BianJiZhangHao": "编辑账号",
    "DingDanFenXiaoShang": "订单分销商",
    "XinZengDingDanTiChengFenXiaoShang": "新增订单提成分销商",
    "XinZengZhuCeTiChengFenXiaoShang": "新增注册提成分销商",
    "HeTongXinXi": "合同信息",
    "HeTongFuJian": "合同附件",
    "GuoJiaDiQu2": "国家地区",
    "MoRenShiShouJiHao": "默认是手机号",
    "QingShuRuYouXiaoQi": "请输入有效期",
    "ShangChuanWenJianTiShi": "支持jpg/png/Word/Excel/PDF格式，单文件最大支持10M，最多上传5个文件",
    "KeHuXiaDan": "客户下单",
    "XiaJiYongHu": "下级用户",
    "JinNianChengJiaoMuBiao": "今年成交额目标",
    "YiChengJiaoJinE": "已成交金额",
    "AnQuanTiShi": "安全提示",
    "ShouCiDengLuQingXiuGaMiMaHouJiXu": "首次登录请修改密码后继续",
    "QingShuRuXinMiMa": "请输入新密码",
    "QingZaiCiShuRuXinMiMa": "请再次输入新密码",
    "MiMaGuiZe4": "密码需要字母和数字组合，长度在8~16位之间",
    "FenXiangDao": "分享到",
    "XiaZaiHaiBaoFenXiang": "下载海报并分享",
    "YuJiShouRuBaoHanJinXingZhongDingDanTiShi": "总预计佣金包含【进行中订单的预计佣金】+【当月已完成订单的佣金】",
    "ShangYueTiChengTiShi": "我们将在每月1号统计上月佣金，并在10号支付。如遇周末或节假日将顺延支付。",
    "JianGeShangYiCiDengLuNTian": "间隔上一次登录 {0} 天",
    "JianGeShangYiCiDengLuNone": "间隔上一次登录 -",
    "ESSAONEFenXiaoShangDaiLiYaoQingYeBiaoTi": "ESSAONE分销商代理邀请页标题",
    "ESSAONEFenXiaoJieShaoYu1": "ESSAONE分销介绍语1",
    "ESSAONEFenXiaoJieShaoYu2": "ESSAONE分销介绍语2",
    "ESSAONEFenXiaoJieShaoYu3": "ESSAONE分销介绍语3",
    "ESSAONEFenXiaoJieShaoYu4": "ESSAONE分销介绍语4",
    "ESSAONEFenXiaoJieShaoYu5": "ESSAONE分销介绍语5",
    "ESSAONEFenXiaoJieShaoYu6": "ESSAONE分销介绍语6",
    "ESSAONEFenXiaoJieShaoYu7": "ESSAONE分销介绍语7",
    "ESSAONEFenXiaoJieShaoYu8": "ESSAONE分销介绍语8",
    "ESSAONEFenXiaoJieShaoYu9": "ESSAONE分销介绍语9",
    "ESSAONEFenXiaoJieShaoYu10": "ESSAONE分销介绍语10",
    "ESSAONEFenXiaoJieShaoYu11": "ESSAONE分销介绍语11",
    "ESSAONEFenXiaoJieShaoYu12": "ESSAONE分销介绍语12",
    "ESSAONEFenXiaoJieShaoYu13": "ESSAONE分销介绍语13",
    "ESSAONEFenXiaoJieShaoYu14HTML": "<li>您是个体企业</li> <li>想要获得额外收入</li> <li>积极与潜在客户合作</li> <li>旨在吸引和发展新客户</li> <li>正式合同工作</li>",
    "QinXuanZeYaoGengHuanDeMaiShou": "请选择要更换的买手",
    "FaSongZiXun": "发送咨询",
    "YiZiXun": "已咨询",
    "JiXuZiXun": "继续咨询",
    "WeiHuiFu": "未回复",
    "GongChangYouFanKui": "工厂有反馈",
    "GouMaiXiangShuShaoYuGongChangYaoQiu": "购买箱数小于工厂要求",
    "XunJiaZhongZanWuFaGengGaiShuLiang": "询价中，暂无法更改数量",
    "ZengJiaGouMaiXiangShuKeXiaDan": "增加购买箱数可下单",
    "FenXiaoShangZhiNengChaKanShouCang": "分销商只能查看收藏",
    "ChangAnTuPianKeBaoCunDaoXiangCe": "长按图片，可保存到相册",
    "XiaZaiBaoGao": "下载报告",
    "MeiYueJinTiGongShangYueJieSuanQiDeZhiXingQingKuangBaoGao": "每月仅提供上月结算期的执行情况报告",
    "ESSAONEFenXiaoJieShaoYu15": "ESSAONE分销介绍语15",
    "MingZi2": "名字",
    "YouJian": "邮件",
    "XiangQingQingZhiDianLianXiWoMenHuoDianZiYouJian": "详情请致电联系我们或电子邮件：",
    "ESSAONEFenXiaoJieShaoYu16": "ESSAONE分销介绍语16",
    "PeiXunZhiChi": "培训支持",
    "ESSAONEFenXiaoPeiXunZhiChiBiaoTi": "认识公司",
    "ESSAONEFenXiaoPeiXunZhiChiBiaoTi2": "代理商项目介绍",
    "TongYiGeKeHuWuFaChongFuBangDingTongYiGeMaiShou": "同一个客户无法重复绑定同一个买手",
    "FufilmentKey": "Fulfillment",
    "TongGuoXinFuWuTuoZhanNinDeYeWu": "通过新服务拓展您的业务",
    "XinDeKeHuJingLiShenQingWeiNiFuWu": "新的客户经理申请为你服务",
    "ShenQing": "申请",
    "ZhaoYangYouXinDeHuiFu": "找样有新的回复",
    "ZaiZengJiaYiWeiKeHuJingLi": "再增加一位客户经理",
    "BangDingKeHu": "绑定客户",
    "DingDanShouRu": "订单收入",
    "ShuJuYiFaShengBianDongQingShuaXinYeMian": "数据已发生变动，请刷新页面",
    "XiaZaiYongJinBaoGao": "下载佣金报告",
    "YunFeiBaoJiaDan": "运费报价单",
    "HuanYingNi": "欢迎你!",
    "XinDeKeHuJinLiWeiNiTiGongFuWu": "新的客户经理将为你提供服务！",
    "GengHuanMaiShou": "更换买手",
    "TuiJianXin": "推荐信",
    "WoDeKeHuJinLi": "我的客户经理",
    "QianWanGouWuCheChaKan": "前往购物车查看",
    "NiKeYiXuanZeBuTongDeKeHuJinLiGengJinXunJia": "你可以选择不同的客户经理进行跟进询价",
    "YiQieHuanKeHuJinLiGenJin": "已切换客户经理跟进",
    "NiDeZhaoYangJiangYouYiXiaKeHuJinLiGengJin": "你的找样将由以下客户经理跟进",
    "JieChuFuWu": "解除服务",
    "QuanXian": "权限",
    "TiHuanNaWeiXianYouKeHuJinLi": "替换哪位现有客户经理",
    "ShenQinDeKeHuJinLi": "申请的客户经理",
    "XuanZeDeKeHuJinLi": "选择的客户经理",
    "XunJiaZhong": "询价中",
    "YiJuJueLeGaiKeHuJinLiDeShenQing": "已拒绝了该客户经理的申请！",
    "GaiKeHuJinLiDeShenQinYiJinShiXiaoGuoQi": "该客户经理的申请已经失效/过期",
    "GaiXiaoShouJinLiShenQinWeiNiFuWu": "该销售经理申请为你服务，他希望为你提供更好的服务。",
    "JuJue": "拒绝",
    "XuanZeKeHuJinLiChengGong": "选择客户经理成功",
    "XinDeKeHuJINLi": "新的客户经理",
    "TiHuanDeKeHuJinLi": "替换的客户经理",
    "ShangPinYiZaiHaoHuoJuZhon": "商品已在 {0} 号货柜中、订单{1}中准备补货，请先从货柜和补货池中移除。",
    "WoZiJi": "我自己",
    "ZuiShaiXuanZeYiGeZhangHao": "最少选择一个账号",
    "NShangPinKeYiPinGui": "{0}m³ 商品可以拼柜",
    "DaoRuChengGong": "导入成功",
    "ChaKanQiTaZhangHaoDeShuJu": "查看其他账号的数据（仅查看）",
    "MaoShouYiJingBangDing": "买手已经绑定，请勿重复操作",
    "WeiBangDingMaiShou": "未绑定买手,请先绑定买手",
    "BangDingDeMaiShouShuLiangChaoXinaZhi": "绑定的买手数量超限制",
    "LingQuDaoNinDeJiFenZhangHu": "领取到您的积分帐户，可抵扣订单金额和兑换礼品。",
    "XuanPinJiangLiNJiFen": "奖励 {0} 积分",
    "ShiYongZhiNan": "使用指南",
    "DingDanYuZhaoYang": "订单与找样",
    "GongSiZiChan": "公司资产",
    "GeRenZiChan": "个人资产",
    "JinGongGeRenChaKan": "仅供个人查看",
    "GouWuQuan": "购物券",
    "SiRenChaKan": "私人查看",
    "MingTianJiangYouNJiFenDaoQi": "明天将有 {0} 积分到期。积分从获取时间开始有 {1} 天有效期。",
    "NiHaiMeiYouJiFen": "你还没有积分",
    "GongSiQiTaZhangHaoYuZhuZhangHaoJunWuFaChaKanTiShi": "公司其他账号与主账号均无法查看你的购物券和兑换的商品。购物券可以在提交订单时使用积分兑换，购物券有效期5年。",
    "DuiHuanShangPin": "兑换商品",
    "DuiHuanHouNiZhuanShuXiaoShouJingLiHuiZhuDongLianXiNi": "物品一般在30天内送达指定地址，兑换后，客户经理会主动联系你，请等待收货。部分产品可能无法配送到你的地区，可选择中国自提，或者重新兑换其他礼品。",
    "QiTaLiPinQingLianXiKeHuJingLi": "其他礼品，请联系客户经理",
    "LianXi": "联系",
    "XinZhengYiWei": "新增一位",
    "QinXuanZeTiHuanDeKeHuJinLi": "请选择替换的客户经理",
    "FuWuZhongDeKeHuJinLiQinXuanZeShiFou": "服务中的客户经理，请选择是否替换或新增",
    "ZhuDongShenQinDeKeHuJinLi": "主动申请的客户经理",
    "QueRenYaoJuJueGaiKeHuJinLiZheCiDeShenQin": "确认要拒绝该客户经理这次的申请",
    "JiFenQAWenTi1": "如何获取积分？",
    "JiFenQANeiRong1": "点击【加入询价】将产品放入购物车，或通过搜索栏旁边的【发起找样】寻找商品，即有概率获得积分。每天加购20款必得积分。",
    "JiFenQAWenTi2": "积分是每天都能获取吗？",
    "JiFenQANeiRong2": "每天进行选品/找样都能获取。加入100款产品到购物车时，最高可获得5000积分。",
    "JiFenQAWenTi3": "怎么使用积分？",
    "JiFenQANeiRong3": "在进行下单时可将积分用于抵扣订单金额或兑换成购物券获取礼品。最大抵扣/兑换金额为订单金额的1%。",
    "JiFenQAWenTi4": "积分有效期",
    "JiFenQANeiRong4": "自获取之日起的60天内。如果积分未在有效期内使用，将自动失效。已经成功使用的积分，如果因工厂原因导致订单被取消，将全额返还",
    "GouWuQuanQAWenTi1": "如何获取购物券？购物券何时开始生效？",
    "GouWuQuanQANeiRong1": "在下单时使用积分进行兑换。购物券将在订单出货的时候开始生效。",
    "GouWuQuanQAWenTi2": "怎么使用购物券？",
    "GouWuQuanQANeiRong2": "在个人资产购物券页面中，先确认购物券余额，在余额充值的情况下，可直接点击商品进行兑换。",
    "GouWuQuanQAWenTi3": "购物券有效期",
    "GouWuQuanQANeiRong3": "自获取之日起的5年内。如果未在有效期内使用，购物券将自动失效。",
    "GouWuQuanQAWenTi4": "兑换的礼品怎么送到我手中？",
    "GouWuQuanQANeiRong4": "当您兑换礼品之后，业务经理会与您跟进对接，有要求都可以和业务经理进行说明。",
    "ZuiHouGengXin": "最后更新",
    "FaQiZhaoYangChengGong": "发起找样成功!",
    "WoDeJiFenHeGouWuQuan": "我的积分和购物券",
    "MingTianJiangYouNJiFenDaoQi2": "积分从获取时间开始有 {0} 天有效期。每日您可以通过选品累积积分",
    "ZiJiTiaoXuan": "去挑选",
    "YouXiuKeHuJinLiJunJinGuoShenHe": "优秀客户经理均经过ESSACHINA审核筛选",
    "BuTongDeBaoJiaZuHeYingXiangShangPinJiaGe": "不同的报价组合影响商品价格，点击设置",
    "QingQueRenYiXiaXinXi": "请确认以下信息",
    "SheZhiBaoJiaZuHe": "设置报价组合",
    "KeXiaDanShangPin": "可下单商品",
    "QuanBuXuanBenYe": "全不选本页",
    "QuanXuanBenYe": "全选本页",
    "PiLiang": "批量",
    "YiXuanNKuanNXiangZongJiN": "已选 {0} 款，{1} 箱，总计 {2}",
    "QingXianXuanZeYaoXiaDanDeShangPin": "请先选择要下单的商品",
    "DangQianXuanLeNGeKeHuJingLi": "当前选了 {0} 个客户经理，请只选择一个后继续下单",
    "ChaoGuoZuiDaPiLiangCaoZuoTiaoShuN": "超过最大批量操作条数：{0}",
    "QingXuanZeBaoJiaFangShi": "请选择报价方式",
    "QingXuanZeChuHuoCang": "请选择出货仓",
    "QingXuanZeXiaShuiGang": "请选择下水港",
    "QingXuanZeHuoGui": "请选择货柜",
    "YiXiaBaoJiaZuHeKeSuiShiZaiGouWu": "以下报价组合可随时在购物车页面中设置",
    "JiaoYiBiZhongYiDanQueRenHou": "交易币种一旦确认后无法自行更改，如果需要变更交易币种，请联系客服",
    "QingXuanZeJiaoYiBiZhong": "请选择交易币种",
    "XuYaoYiQiXiaDanWeiHuo": "需要一起下单尾货，请点击",
    "TianJiaWeiHuo": "添加尾货",
    "ZhuYaoCaiZhi": "主要材质",
    "QinXuanZeJiaoYiBiZhong": "请选择交易币种",
    "DangQianGongYinShangQiSongLiangNWaiXiang": "当前供应商起送量 {0} 外箱，请勾选更多商品或增加数量",
    "JiaoHuoRiQi": "交货日期",
    "DingDanMeiYouShuJuFanHuiGouWuCheZhongXinXiaDan": "当前订单没有数据，请返回购物车重新下单。",
    "DingDanShuJuYiJingBianDongQingShuaXinHou": "当前订单数据已经变动，请刷新后，核实信息后重新提交订单。",
    "BuFenShangPinBuManZu": "当前所选去下单商品，继续提交将有商品被跳过处理，原因如下：",
    "QuanBuShangPinBuManZu": "当前所选去下单商品，没有满足下单要求的商品，原因如下：",
    "DingGouLiangDiYuMoqYaoQiu": "订购量低于MOQ要求",
    "JiXuTiJiao": "继续提交",
    "ShangPinBuManZuGongChangDeQiSongLiang": "商品不满足工厂的起送量。",
    "ShangPinBuManZuGongChangDeMOQYaoQiu": "商品不满足工厂的MOQ要求。",
    "DangQianPiLiangCaoZuoZhong": "当前批量操作中，有商品被跳过处理，原因如下：",
    "XunJiaZhongDiShangPinBuNeng": "询价中的商品不能重复询价。",
    "JiaBaoNeiShangPinBuNengChong": "价保内商品不能重复询价。",
    "CanYuHuoDongDeShangPinBuNeng": "参与活动的商品不能询价。",
    "ShiXiaoShangPinBuNengXunJia": "失效商品不能询价。",
    "ShangPinBeiXiTongSuoDing": "商品被系统锁定，暂无法操作，请等系统释放。",
    "ZhongGuoGongChang": "中国工厂",
    "PinPaiShangPinFenLei": "工厂商品分类",
    "1001CT1001": "下架商品不能加入购物车",
    "CanJianXiangXiBiaoZhun": "参见详细标准",
    "LiaoJieDuoKeHuJinLiJiZhi": "了解多客户经理机制",
    "DangQianJiaGouDeShangPinJiang": "当前加购的商品将由选中的客户经理跟进询价，你可以切换跟进的客户经理，如果对他们不满意，你可以随时更换。",
    "ShangPinYouYiXiaKeHuJinLiGenJin": "商品由以下客户经理跟进",
    "DangQianHaiMeiYouKeHuJinLi": "当前还没有客户经理，你最多可以选择两个客户经理同时提供服务，并随时可以更换。",
    "JingJinFuWuTiYan": "精进服务体验：TWO TO ONE 业务模式的创新",
    "WeiLeTiShengPingTaiDeFuWuHeCaiGouDeTiYan": "为了提升平台的服务和采购的体验，平台现已推出 TWO TO ONE 客户经理模式，您可以有两位客户经理协助您进行采购，享受更加细致的服务，或者您也可以继续保留一位经理为您服务。",
    "JingZhunDuiJie": "精准对接",
    "DangCaiGouBuTongDeChanPinXianShi": "当采购不同的产品线时，可以选择两位客户经理对应采购不同的产品",
    "TiGaoTiYan": "提高体验",
    "TiYanBuTongYeWuJingLiDeFuWu": "体验不同客户经理的服务，并比较处理需求的速度和质量，最终把订单下给合适的人。他们之间良性的竞争，将会大大提升对您的服务水准。",
    "JiangDiFengXian": "降低风险",
    "JiangDiZhiJieGengHuanYeWu": "降低直接更换客户经理时的采购风险，无需将订单需求信息交给新的业务经理，因为所有信息都存储在我们的 CRM 中，使您的采购习惯不会被遗忘",
    "DingDanBaoZhang": "订单保障",
    "ZaiYouWeiWanChengDeDingDanShi": "其中一位经理临时缺席（出差、休假或生病）不会影响处理申请和完成订单的速度。另外对于未完成的订单，在选择新的经理后，原来负责的经理仍然会持续跟进，直到订单完成。",
    "CaoZuoZhiNan": "操作指南",
    "XuanZeJingLi": "选择经理",
    "JinRuYeWuJingLiYeMianDianJi": "进入“客户经理”页面点击“+”按钮，添加新的客户经理；点击“管理”按钮，更换已选的客户经理",
    "YeWuJingLiGouWuChe": "客户经理购物车",
    "XuanZeLeLiangWeiJingLiShi": "选择了两位经理时，两个购物车分别对应不同的经理，他们单独跟进各自的购物车",
    "GouWuCheQieHuan": "购物车切换",
    "JiaGouShangPinQian": "加购商品前，在右上角选择对应的客户经理帮您跟进。可以两个经理同时选择",
    "YueFenChengJiaoFenBuTu": "月份成交分布图",
    "YiShenQingDengDaiKeHuQueRenZhong": "已申请，等待客户确认中。",
    "ShenQingXiangQing": "申请详情",
    "WoYiLiaoJieQuTiaoXuanKeHuJinLi": "我已了解，去挑选客户经理",
    "NiYiZhuDongFangQiGengJinGaiKeHu": "你已主动放弃跟进该客户，等待解绑中。客户已经进入半公开状态，可能会被其他销售经理跟进。",
    "KeHuYiJinRuBanGongKaiZhuangTai": "客户已经进入半公开状态，可能会被其他销售经理跟进。",
    "YeJiZuZhang": "业绩组长",
    "GengHuanKeHuJinLiChengGong": "更换客户经理成功！",
    "DangQianZiLiaoWanShanDu": "当前资料完善度{0}，完善信息资料有助提升形象和工厂对你的信任",
    "BuFenShuYuGuanJianXinXiWeiBaoZhangNinDeXinXiZhengQueXing": "部分属于关键信息为保障您的信息正确性，当您变更关键信息后需要我们再次审核之后才能生效。关键信息项在您提交变更时，我们会列出。",
    "GongSiJianJieShiLiXingXiang": "公司简介/实力/形象",
    "WanShanGongSiDeJieShao": "完善公司的介绍，可以证明你的实力和信任度，有助于工厂开放更多权限和商品信息给你",
    "WaiMaoZhuGongQuYuHeCiYaoQuYuYouChongFuDe": "外贸主攻区域和次要区域有重复的",
    "ZhuGongQuYuYiNianZiRanNianZhiYunXuXiuGaiYiCi": "主攻区域一年（自然年）只允许修改一次，上次修改时间为",
    "TiJiaoShiBaiQingShaoHouChongShi": "提交失败,请稍后重试！",
    "YouZhuYuZengJiaGongChangDuiNiDeXinRen": "有助于增加工厂对你的信任",
    "DaoChuBaoJiaDanShiKeYiZhanShiNiGongSilogo": "导出报价单时可以展示你公司logo",
    "ShangChuanLogo2": "上传报价单logo",
    "ZhuGongShiChang": "主攻市场",
    "ZhiChiDuoXuan": "支持多选",
    "QinXuanZeZhuGongShiChang": "请选择主攻市场",
    "WaiMaoZhuGongQuYu": "外贸主攻区域",
    "DanXuan": "单选",
    "QinXuanZeWaiMaoZhuGongQuYu": "请选择外贸主攻区域",
    "CiYaoQuYu": "次要区域",
    "ZuiDuoZhiNengXuanZeNGe": "最多只能选择{0}个",
    "QingTianXieGongSiDiZhi": "请填写公司地址",
    "QuWanShanGongSiJianJie": "去完善公司简介",
    "GongSiJianJie": "公司简介",
    "GongSiJianJieTiShi": "请介绍公司,工厂可以看到此简介,更好的介绍,总能带来好印象,最长支持800字",
    "QinXuanZeGongSiNianYingShouGuiMo": "请选择公司年营收规模",
    "GongSiNianYingShouGuiMo": "公司年营收规模",
    "GongSiRenYuanGuiMo": "公司人员规模",
    "QinXuanZeGongSiRenYuanGuiMo": "请选择公司人员规模",
    "GongSiHeZuoGuoDeHuoBan": "公司合作过的伙伴/成交过的大单",
    "GongSiXingXiang": "公司形象",
    "TuWenBingMaoZhanXianGongSiShiLi": "图文并茂展现公司实力,图片支持jpg/png/gif格式, 最多6张",
    "QingShangChuanYongHuTouXiang": "请上传用户头像",
    "QingTianXieZhenShiXingMing": "请填写真实姓名",
    "QingShangChuanShenFenZhengBeiMian": "请上传身份证背面",
    "QingShangChuanShenFenZhengZhengMian": "请上传身份证正面",
    "QingXuanZeShanChangYuYanBingQieZuiDuoXuanZeSanGe": "请选择擅长语言，并且最多选择三个",
    "QingXuanZeShanChangShiChangBingQieZuiDuoXuanZeLiangGe": "请选择擅长市场，并且最多选择两个",
    "QingTianXieWaiMaoCongYeShiChangBingQieBuNengWei0": "请填写外贸从业时长,并且不能为0",
    "QingXuanZeShanChangKeHuLeiXing": "请选择擅长客户类型",
    "QingXuanZeYiGeZhuYaoPinLei": "请选择一个主要品类",
    "QingXuanZeCiYaoPinLeiBingQieZuiDuoXuanZeLiangGe": "请选择次要品类,并且最多选择两个",
    "QingZuiShaoWanShanYiMenYuYanDeGeRenTeChang": "请最少完善一门语言的个人特长",
    "BuFenYuYanXinXiYiTianXieDanWeiTianXieWanQuan": "部分语言信息已填写，但未填写完全",
    "GengHuanTouXiang": "更换头像",
    "ShouJiZhangHaoMing": "手机（账号名）",
    "YuanGongDaiHao": "员工代号",
    "ZhenShiXingMing": "真实姓名",
    "ShuRuZhenShiXingMing": "输入真实姓名",
    "ShangChuanShenFenZheng": "上传身份证",
    "YongYuRenZhengHeHouXuQianDingHeTongXieYi": "用于认证和后续签订合同/协议，平台承诺绝不外泄",
    "ZhiChiTuPianGeShi": "支持图片格式",
    "GuoHuiMian": "国徽面",
    "RenMianXiang": "人面像",
    "QingShuRuWhatsApp": "请输入WhatsApp",
    "WeiXinWeChat": "微信WeChat",
    "QingShuRuWeiXinWeChat": "请输入微信WeChat",
    "ShanChangYuYan": "擅长语言",
    "ZuiDuoNGe": "最多{0}个",
    "QingXuanZeShanChangYuYan": "请选择擅长语言",
    "ShanChangShiChang": "擅长市场",
    "QingXuanZeShanChangShiChang": "请选择擅长市场",
    "QingShuRuWaiMaoCongYeShiChang": "请输入外贸从业时长",
    "ShanChangKeHuLeiXing": "擅长客户类型",
    "ShanChangZhuYaoPinLei": "擅长主要品类",
    "QingXuanZeShanChangZhuYaoPinLei": "请选择擅长主要品类",
    "HaiShanChangQiTaPinLei": "还擅长其他品类",
    "QingXuanZeShanChangQiTaPinLei": "请选择擅长其他品类",
    "GeRenTeChangJianJie": "个人特长简介",
    "ZhiShaoWanShanYiZhongWaiYuZiLiao": "至少完善一种外语资料",
    "XinZengQiTaYuZhongJieShao": "新增其他语种介绍",
    "WaiYuMingNiCheng": "外语名（昵称）",
    "ShuRuDuiYingYuYanDeXingMing": "输入对应语言的姓名",
    "JianDuanJieShaoZiJiDeLiangDian": "简短介绍自己的亮点，建议不超过240个字符。",
    "JieShaoZiJiGuoWangDeYiXieChengGongAnLi": "介绍自己过往的一些成功案例，和客户对你的评价等",
    "YiJuHuaLiangDian": "一句话亮点",
    "YuYanNengLi": "语言能力",
    "FuWuTaiDu": "服务态度",
    "FanKuiXiaoLU": "反馈效率",
    "JieJueWenTi": "解决问题",
    "ShiFouQueRenTiJiao": "是否确认提交",
    "QingGenJuZiShenShiJiQingKuangJinXingPingJia": "请根据自身实际情况进行评价",
    "NXing": "{0}星",
    "ZiWoPingJia": "自我评价",
    "GengXinTouXiang": "更新头像",
    "ShangChuanZhenShiGaoQingTouXiangLiKeHuXinRenGengJinYiBu": "上传真实高清头像，离客户信任更进一步！",
    "TuiJianShangChuanZhengFangXing1BiLiDeTouXiang": "推荐上传正方形1:1比例的头像",
    "ZanWuHuoDong": "暂无活动",
    "NKuanJiaRuXuanPinChi": "{0}款，加入选品池",
    "JiaRuXuanPin": "加入选品",
    "YiXuanPin": "已选品",
    "WeiWanShanWuFaXuanPin": "未完善无法选品",
    "JiaGeGengXin": "价格更新",
    "WoDeBaoJiaDan": "我的报价单",
    "SouSuoBiaoTi": "搜索标题",
    "WeiChaKan": "未查看",
    "KeHuChaKan": "客户查看",
    "KeHuJiaGou": "客户加购",
    "FenXiangLianJieGeiKeHu": "分享链接给客户",
    "FangWenMiMa": "访问密码",
    "WuFangWenMiMa": "无访问密码",
    "YiChongXinJiaRuXuanPinChi": "已重新加入选品池",
    "QingQianWangXuanPinChiChaKanShangPin": "请前往选品池查看商品",
    "WeiTianXieMiaoShu": "未填写描述",
    "YiJiaGou": "已加购",
    "LaoBan": "老板",
    "FuZhiFenXiang": "复制分享",
    "ChongXinJiaRuXuanPinChi": "重新加入选品池",
    "BianJiZhuTi": "编辑主题",
    "MeiYouGengDuoLe": "没有更多了",
    "ShanChuBaoJiaDanKeHuJiangBuNengZaiFangWenCiBaoJiaDan": "删除报价单，客户将不能再访问此报价单，删除不可恢复，是否继续删除？",
    "GengXinChengGong": "更新成功",
    "QingTianXieBaoJiaDanZhuTi": "请填写报价单主题",
    "BaoJiaDanZhuTi": "报价单主题",
    "ShangPinChaKanShenQing": "商品查看申请",
    "YiTiJiaoShenQingQingDengDaiGongChangShenHe": "已提交申请，请等待工厂审核",
    "YuanYin": "原因",
    "ChongXinShenQing": "重新申请",
    "MaiShouShenQingZhongWuFaJiaGou": "买手申请中，无法加购",
    "BaoJiaDanXiangQing": "报价单详情",
    "JiaGouChengGong": "加购成功",
    "KeHuFuWuFei": "客户服务费",
    "KeHuJiaJiaLU": "客户加价率",
    "ZaiXianFenXiang": "在线分享",
    "KeHuYouYiXiang": "客户有意向",
    "SouSuoShangPinHuoHao": "搜索商品/货号",
    "GongChangRangLiJia": "工厂让利价",
    "ZiDingYiBaoJia": "自定义报价",
    "YiXiangNXiang": "意向{0}箱",
    "ZanWuSouSuoShangPin": "暂无搜索商品",
    "QianBoDaYouXiao": "前拨打有效",
    "YuLanBaoJiaDan": "预览报价单",
    "GongChangMingCheng": "工厂名称",
    "YuLanMoShiXiaWuFaXunJia": "预览模式下无法询价",
    "YuLanMoShiXiaDaoChuBaoJiaDan": "预览模式下导出报价单",
    "DangQianChuYuYuLanMoShiXunJiaAnNiuWuFaCaoZuo": "当前处于预览模式，询价按钮无法操作",
    "YuLanMoShiXiaWuFaDaoChuTuPian": "预览模式下无法导出图片",
    "SouSuoShangPinBianHaoHuoHao": "搜索商品/编号/货号",
    "XunJiaShiBaiQingShaoHouChangShi": "询价失败，请稍后尝试！",
    "ShangPinBaoZhuang": "商品包装",
    "YuLanMoShiXiaWuFaXiuGaiQiDingLiang": "预览模式下无法修改起订量",
    "NiLaiWanLeFenXiangDeBaoJiaDanYiJingBeiQuXiaoLe": "你来晚了，分享的报价单已经被取消了",
    "TaRenTuiJian": "他人推荐",
    "YiXuanNKuan": "已选{0}款",
    "SheZhiFenZu": "设置分组",
    "DaoChuSuoXuanShangPinTuPian": "导出所选商品图片",
    "DaoChuGaiBanShenQingBiao": "导出改版申请表",
    "NKuanShangPinJiaGeWeiGengXinDaoZuiXinJia": "{0}款商品价格未更新到最新价",
    "ChongXinXunZuiXinJia": "重新询最新价",
    "DaoChuBaoJiaDanWuKeHu": "导出报价单（无客户）",
    "NKuan": "{0}款",
    "ChaKanLiShiDaoChu": "查看历史导出",
    "FanHuiXuanPinChi": "返回选品池",
    "SheZhiBingDaoChuBaoJiaDan": "设置并导出报价单",
    "YiJiaWoMenHuiDuiGongChangZhanShiNinDeXinXi": "议价我们会对工厂展示您的信息，方便工厂给与更加优惠价格",
    "BiGongChangBaoJiaN": "比工厂报价{0}",
    "JiangJiaN": "降价{0}",
    "PiLiangCaoZuo": "批量操作",
    "ZiDingXiangShuHeQiWangJiaGeXiangGongChangFaQiYiJia": "自定箱数和期望价格向工厂发起议价",
    "YiFaQiZhiNengYaJia": "已发起智能压价",
    "FaQiZhiNengYaJiaShiBaiQingShaoHouChongShi": "发起智能压价失败，请稍后重试！",
    "ZiDongXiangGongChangFaQiXunJiaBingYaJia": "自动向工厂发起询价并压价",
    "QingChuChengGong": "清除成功",
    "QingChuShiBaiQingShaoHouChongShi": "清除失败，请稍后重试。",
    "GongChangYuanJia": "工厂原价",
    "HuLüeGongChangBaoJiaYiZiJiBaoJiaZhanShiGeiKeHu": "忽略工厂报价，以自己报价展示给客户",
    "ShanChuShiBaiQingShaoHouChongShi": "删除失败，请稍后重试！",
    "JiaRuXuanPinChiChengGong": "加入选品池成功",
    "JiaRuXuanPinChiShiBai": "加入选品池失败",
    "30Tian": "30天",
    "GeiNiTuiJianQiTaXiangSiShangPin": "给你推荐其他相似商品",
    "NXiang": "{0}箱",
    "NTian": "{0}天",
    "QingXuanZeFenZu": "请选择分组",
    "WanZhuanXuanPinChiXiaoLUJiaBei": "玩转选品池，效率加倍",
    "XiaoLUJiaBei": "效率加倍",
    "ShangPinFenZu": "商品分组",
    "ZiDongZuiXinJia": "自动最新价",
    "JiaJiaYuLan": "加价预览",
    "ZhiNengYaJia": "智能压价",
    "ZiZhuYiJia": "自主议价",
    "ZaiXianBaoJiaDan": "在线报价单",
    "KeHuChaKanBaoJiaDan": "客户查看报价单",
    "LiShiBaoJiaDan": "历史报价单",
    "LingHuoChaKanXuanPinChiShangPin": "灵活查看选品池商品，可按照供应商分类或分组分类查看，购物车商品管理更清晰明了；",
    "DuoChongShaiXuanShangPin": "多重筛选商品：按照“加入时间”、“报价范围”，“询价状态”，“商品类目”等多重维度，对加购商品状态了如指掌；",
    "KeHuGuanLiWeiLeFangBianGuanLiKeHu": "客户管理：为了方便管理客户，您可新增客户信息，包括客户代号、客户昵称、报价币种、报价单语言、报价方式、询价利润分配，分配业务员等信息，新增客户信息后，可随时给客户分享商品或查看客户查看报价单状态。",
    "FenZuGongNengShangXianLa": "分组功能上线啦，可提高商品管理效率，马上试试吧！",
    "XinZengFenZuJieShao": "【新增分组】：方法1：选择商品加入选品池，点击“新增分组”，可自定义命名新的组别，在下方选中已建好的分组，即可加入指定分组；方法2：直接在选品池商品分组标签上，点击新增分组",
    "SouSuoFenZuJieShao": "【搜索分组】：当分组太多，可使用搜索功能，搜索分组，再加入选品",
    "ShanChuFenZuJieShao": "【删除分组】：在组别明细或搜索分组后，点击“X”，即可删除分组，分组内的商品也会一并删除，谨慎使用哦！",
    "ZiDongZuiXinJiaNinTiaoXuanShangPinJiaGouDaoXuanPinChiZhiHou": "自动最新价：您挑选商品加购到选品池之后，系统会自动发送商品信息给工厂，工厂尽快确认并回复商品的最新报价，马上加购试试吧！",
    "JiaJiaYuLanYiJianGeiShangPinSheZhiJiaJia": "加价预览：一键给商品设置加价，在线预览商品加价后价格，马上试试吧！",
    "ZhiNengYaJiaJieShao": "智能压价：系统根据供应商历史登记的商品价格自动为您压到历史最低价，马上试试吧！",
    "ZiZhuYiJiaZhiMaoYiShangGenGongChangQuYiJia": "自主议价：指贸易商跟工厂去议价",
    "XuanPinChiZaiXianBaoJiaDanJieShao": "在线报价单，快捷高效分享：选择购物车商品，新增分享客户或选择已有客户，填写报价单主题、推荐理由，定义报价单模板和显示信息，直接导出在线报价单，复制链接即可分享给客户，简单高效。",
    "XuanPinChiKeHuChaKanBaoJiaDanJieShao": "客户查看报价单，即时反馈意向选品：客户打开分享链接，输入分享链接中提示的密码，即可查看报价单，即时反馈意向选品。",
    "XuanPinChiGuanLiLiShiBaoJiaDanJieShao": "管理历史报价单：历史报价单可以看到历史给指定客户推荐生成的所有报价单明细，方便贸易商对客户的历史报价单进行复制分享、查看详情、预览报价单内容和重新将报价单商品加入选品池操作管理。",
    "QingChuFenZuChengGong": "清除分组成功！",
    "QingChuFenZuShiBaiQingShaoHouChongShi": "清除分组失败，请稍后重试！",
    "ShanChuZiDingYiBaoJiaChengGong": "删除自定义报价成功！",
    "ShanChuZiDingYiBaoJiaShiBaiQingShaoHouChongShi": "删除自定义报价失败，请稍后重试！",
    "WuFenZu": "无分组",
    "XunJiaWanCheng": "询价完成",
    "DengDaiGongChangHuiFuYuJiNGeGongZuoRi": "等待工厂回复，预计{0}个工作日",
    "GongChangHuiFuMOQ": "工厂回复MOQ",
    "FenZu": "分组",
    "DaiGongChangQueRenZuiXinJiaGe": "待工厂确认最新价格",
    "QingZhengQueDeJiaJiaLUZuiDuoBaoLiuLiangWeiXiaoShu": "请正确的加价率，(0-1000)最多保留两位小数！",
    "KuaiSuYuLanJiaGeHouDeJiaGe": "快速预览价格后的价格，不影响导出报价单的最终价格",
    "QingTianXieJiaJiaLU": "请填写加价率",
    "GuiLing": "归零",
    "QingZhengQueDeFOBFeiYongZuiDuoBaoLiuSiWeiXiaoShu": "请正确的FOB费用，最多保留四位小数",
    "QingTianXieMeiYuanDuiHuanRenMinBiHuiLU": "请填写美元兑换人民币汇率",
    "QingZhengQueDeMeiYuanDuiHuanRenMinBiHuiLU": "请正确的美元兑换人民币汇率，最多保留四位小数",
    "MeiYuanDuiHuanRenMinBiHuiLU": "美元兑换人民币汇率",
    "LianJie": "链接",
    "YuLan": "预览",
    "JiaoYiXinXi": "交易信息",
    "FuZhiDuanLian": "复制短链",
    "DaoChuBaoBiao": "导出报表",
    "DaoChuChengGong": "导出成功",
    "DaoChuChengGongZaiXianFenXiangGengGaoXiao": "导出成功，在线分享更高效",
    "RuYouFangWenMiMaJiuShiKeHuDaiHao": "如有访问密码，就是客户代号。可以前往【历史报价单】查看导出历史。",
    "HanYu": "汉语",
    "YingYu": "英语",
    "EYu": "俄语",
    "EXWBiaoZhunBaoJiaGuiZe": "EXW标准报价规则",
    "ShangPinChanDiWeiShanTouShiZuHeBaoJia": "商品产地为汕头时：汕头（出货仓）-汕头（下水港）-40HQ（货柜）组合报价",
    "ShangPinChanDiWeiGuangZhouShiZuHeBaoJia": "商品产地为广州时：广州（出货仓）-广州（下水港）-40HQ（货柜）组合报价",
    "ShangPinChanDiWeiYiWuShiZuHeBaoJia": "商品产地为义乌时：义乌（出货仓）-宁波（下水港）-40HQ（货柜）组合报价",
    "ZhuYiXiaDanShiRuoGuiZiChuHuoCang": "注意：下单时若柜子出货仓、下水港、货柜类型变化，可能会影响商品FOB均摊及产生短途运费（出货仓与产地不在同一区域时，将产生短途运费）。",
    "DaoChuZhong": "导出中",
    "FOBBaoJiaGenJuXuanZeDeChuHuoQuYu": "FOB报价：根据选择的出货区域、下水港、货柜类型计算；DDP报价：根据选择航线的标准的出货区域、下水港、货柜类型计算",
    "QingXuanZeChuHuoCangXiaShuiGangHeHuoGui": "请选择出货仓、下水港和货柜",
    "QingXuanZeHangXian": "请选择航线",
    "XuanZeJunTanFuWuFeiLUHeBiZhong": "选择均摊服务费率和币种",
    "JunTanFuWuFeiLU": "均摊服务费率",
    "FenZuFangShi": "分组方式",
    "PaiXuFangShi": "排序方式",
    "ShengXu": "升序",
    "BaoJiaDanWei": "报价单位",
    "DanGe": "单个",
    "ZhongBao": "中包",
    "DanGePCSRuGuoShangPinYiGeBaoZhuangZhongHanYouDuoGePCS": "单个PCS：如果商品一个包装中含有多个PCS，报价按单个PCS，比如展示盒中有多个PCS，报价以单个PCS",
    "ZhongBaoRuGuoShangPinYiGeBaoZhuangZhongHanYouDuoGePCS": "中包：如果商品一个包装中含有多个PCS，报价按整个中包，比如展示盒中有多个PCS，报价以1个展示盒",
    "TongYongDaYin": "通用打印",
    "ChongXinXunJiaShiBaiQingShaoHouChongShi": "重新询价失败，请稍后重试！",
    "QueDingChongXinXunJiaXuanZhongDeShangPin": "确定重新询价选中的商品",
    "QingXuanZeBaoZhuangYuYan": "请选择包装语言",
    "QingXuanZeTuiJianRen": "请选择推荐人",
    "QingXuanZeTuiJianZhuTi": "请选择推荐主题",
    "ShangPinLeiMu": "商品类目",
    "SouSuoShangPinBianHaoHuoHaoGongYingShangMingZi": "搜索商品/编号/货号/供应商名字",
    "AnGongYingShang": "按供应商",
    "AnFenZu": "按分组",
    "ZhuYiHeBingDaoXinFenZuDeShangPinJiangCongYuanFenZuYiChu": "注意：合并到新分组的商品将从原分组移除",
    "XuanZeYiYouFenZuHuoShuRuKeTianJiaXinFenZu": "选择已有分组，或输入可添加新分组",
    "QingTianXiefobFeiYong": "请填写fob费用",
    "QingXuanZeShuRuHuiLU": "请选择输入汇率",
    "QingXuanZeYuYan": "请选择语言",
    "QingShuRuJiaJiaLU": "请输入加价率",
    "BaoJiaDanShiLi": "报价单示例",
    "WanShanGongSiXinXi": "完善公司信息",
    "GeiBaoJiaDanQiGeMingZi": "给报价单起个名字,方便管理历史导出,客户在线浏览时展示",
    "KeHuZaiXianLiuLanBaoJiaDanShi": "客户在线浏览报价单时,展示，自动根据客户语种翻译。",
    "KeHuChaKanShiKeZiZhuQieHuan": "客户查看时可自主切换，当前是设置默认展示方式",
    "LieBiaoXingShi": "列表形式",
    "XinXiDuo": "信息多",
    "TuPianDa": "图片大",
    "GuDingHuiLU": "固定汇率",
    "QingShuRuGuDingHuiLU": "请输入固定汇率",
    "QingTianXieZhengQueDeHuiLU": "请填写正确的汇率",
    "PingTaiHuiLU": "平台汇率",
    "MeiRiGengXin": "每日更新",
    "QingTianXieZhengQueDeJiaJiaLU": "请填写正确的加价率",
    "QingShuRuF0B": "请输入F0B",
    "QingTianXieZhengQueFOBFeiYong": "请填写正确FOB费用",
    "GongChangXinXi": "工厂信息",
    "BuBaoHanGongChangHuoHao": "不包含工厂货号",
    "DaoChuDeBaoJiaDanBuBaoHanGongChangHuoHao": "导出的报价单不包含工厂货号",
    "ShanChuYiDaoChu": "删除已导出",
    "DaoChuDeShangPinZiDongShanChu": "导出的商品自动删除",
    "DaoChuBaoJiaDanHouShanChuYiDaoChuShangPin": "导出报价单后，删除已导出商品",
    "ZhiNengXuanZeTongLeiXingKeHuPingTaiHuoSiYou": "只能选择同类型客户（平台或私有）",
    "NianChuHuoN": "年出货 {0}",
    "BaoJiaDanJiangGenJuKeHuDangAnYuSheZhiJieShengChengDuiYingYuYan": "选择客户，报价单将根据客户档案预设直接生成对应语言、币种、加价率等报价单信息。如不选择客户，可自行设置语言、币种、加价率;",
    "XinZengKeHu": "新增客户",
    "SouSuoKeHuMingChengYouXiangBeiZhu": "搜索客户名称/邮箱/备注",
    "QuanBuSiYou": "全部私有",
    "QuanBuPingTai": "全部平台",
    "ZanWuKeHuXinXi": "暂无客户信息",
    "JianLiKeHuXinXiTiShi": "建立客户信息，导出报价单、询价压价更加方便",
    "NiDeKeHuXinXiJiangDeDaoYinSiBaoHu": "请放心，你的客户信息将得到隐私保护",
    "LiJiTianJia": "立即添加",
    "YiXuanKeHu": "已选客户",
    "YiXiaShangPinWeiWanChengXunJia": "以下商品未完成询价",
    "XunJiaChengGong": "询价成功",
    "WanShanKeHuXinXi": "完善客户信息",
    "QingWanShanYiXiaXinXiZaiJinXingPinGuiXiaDanCaoZuo": "请完善以下信息，再进行拼柜下单操作",
    "WanShanKeHuDeGongSiMingCheng": "完善客户的公司名称",
    "ShangChuanXiaoShouHeTongHou": "上传销售合同后",
    "QueDingYaoTiJiaoPiLiangXunJiaMa": "确定要提交批量询价吗？",
    "NKuanZongTiJiNZongJiN": "{0}款，总体积{1}，总计{2}",
    "QueDingShanChuSuoYouXuanZhongDeShangPin": "确定删除所有选中的商品？",
    "GongChangGeiDeChengJiaoJia": "工厂给的成交价",
    "QingShuRuDaYu0DeJinE": "请输入大于{0}的金额",
    "QueDingYaoShanChuZiDingYiJiaGeMa": "确定要删除自定义价格吗？",
    "ShanChuZiDingYiJiaGe": "删除自定义价格",
    "GeiKeHuDeChengJiaoJia": "给客户的成交价",
    "GongChangDeCaiGouJia": "工厂的采购价",
    "LiRunLU": "利润率",
    "JiaRuGouWuCheShiBai": "加入购物车失败",
    "YiJiaZhong": "议价中",
    "XunJiaJiaGeYiGuoQi": "询价价格已过期（下单以改价为准）",
    "JiaGeYiGuoQiXiaDanXuChongXinQueRen": "价格已过期，下单需重新确认",
    "YiGaiJia": "已改价",
    "FuLiRun": "负利润",
    "YiZhangN": "已涨{0}",
    "YiJiangN": "已降{0}",
    "GongChangHuiFu": "工厂回复",
    "GeiKeHuChengJiaoJia": "给客户成交价",
    "YiJia": "议价",
    "XiuGaiJiaGe": "修改价格",
    "QingZhuYiYouBuFenGaiJiaShangPinShiFuLiRun": "请注意：有部分改价商品是负利润。",
    "ShaiXuanFuLiRunShangPin": "筛选负利润商品",
    "QueDingYaoShanChuZiDingYiBaoJiaMa": "确定要删除自定义报价吗？",
    "RenGongGaiJia": "人工改价",
    "XunQianChuLiGongChangHuiFuHouGengXin": "询前，处理工厂回复后更新",
    "YouXiaoQiZhi1": "有效期至{0}",
    "ShengNTian": "剩{0}天",
    "YiXiangChengJiaoJia": "意向成交价",
    "QingXianChuLiGongChangHuiFu": "请先处理工厂回复",
    "HanXunJiaLiRun": "含询价利润",
    "HaiMeiYouShangPin": "还没有商品",
    "XuanPinDaoChuZhuanShuNiDeZaiXianBaoJiaDan": "选品，导出专属你的在线报价单",
    "ZhiChiXianShangFenXiangGengFangBianKuaiJieKeHuHaiKeYiZhiJieFanKui": "支持线上分享，更方便快捷，客户还可以直接反馈",
    "MaShangQuXuanPin": "马上去选品",
    "QuanXuanPingTaiKeHu": "全选平台客户",
    "QuanXuanSiYouKeHu": "全选私有客户",
    "NKuanShangPinYiJiaRuTuiJianChi2": "{0}款商品已加入选品池，已添加分组",
    "TianJiaFenZu": "添加分组",
    "ShanChuFenZu": "删除分组",
    "NiQueDingYaoShanChuNFenZu": "你确定要删除{0}分组？？",
    "XiuGaiFenZuChengGong": "修改分组成功",
    "ShuRuFenZuMingChengBiTianZuiChangNGeZi": "输入分组名称（必填），最长{0}个字",
    "XinZengFenZu": "新增分组",
    "QingXuanZeYiGeFenZuFangBianKuaiJieShaiXuan": "请选择一个分组, 方便快捷筛选",
    "SouSuoFenZuMingZi": "搜索分组名字",
    "ZanBuShiYongFenZu": "暂不使用分组",
    "XiTongYiZiDongGenGongChangXunZuiXinJiaGe": "系统已自动跟工厂询最新价格",
    "YiTianJiaFenZu": "已添加分组",
    "XiuGaiFenZu": "修改分组",
    "KeHuChi": "客户池",
    "ShengYuKaiFaQuanYi": "剩余开发权益",
    "WeiYouGenJin": "未有跟进",
    "YiYouGenJin": "已有跟进",
    "DangQianKeHuYiYouXiaoShouJingLiGenJin": "当前客户已有销售经理跟进，你依然可以申请跟进，一旦客户接受你的申请后，该客户将由你跟进",
    "ShenQingGuo": "申请过",
    "ShangPinTiCheng": "商品提成",
    "XiaoShouE": "销售额",
    "XiaoShouGuiMo": "销售规模",
    "QuNianChengJiao": "去年成交",
    "JinNTianXuanKuan": "近{0}天选款",
    "NWanYuan": "{0}万元",
    "ShengYuMuBiao": "剩余目标",
    "JinNianWeiWanChengMuBiao￥NHaiChaN%": "今年未完成目标￥{0}还差{1}%",
    "JieShouYuJiNengZhuan": "接手预计能赚",
    "ChaXunShiBai": "账号未激活，请先激活账号",
    "DaiQueRenShengChanYaoQiu": "待确认生产要求",
    "DaiQueRenPaiBanTu": "待确认排版图",
    "DaiSheTieMai": "待设贴唛",
    "DingJinYuQi": "定金逾期",
    "HuoKuanYuQi": "货款逾期",
    "NYue": "{0}月",
    "NNianYueFenChengJiaoFenBuTu": "{0}年月份成交分布图",
    "DangQianKaiFaKeHuQuanYiShuLiangShengYuN": "当前开发客户权益数量剩余N",
    "ShiFouJiXuKaiFaGaiKeHu": "是否继续开发该客户?",
    "QingXianWanShan/QueRenKeHuJiDuMuBiao": "请先完善/确认客户季度目标",
    "KeHuGongGongChi": "客户公共池",
    "DaiKaiFaKeHuXiangQing": "待开发客户详情",
    "YiYouKeHuJingLiGenJin": "已有客户经理跟进",
    "YeWuDengJi": "业务等级",
    "CaiGouGuiMo": "采购规模",
    "MoRenCaiGou": "默认采购",
    "GongSiGuanWang": "公司官网",
    "ShangYiCiXuanPin": "上一次选品",
    "ShangYiCiTuiJian": "上一次推荐",
    "ShangYiCiDengLu": "上一次登录",
    "JinNTianXuanPin": "近{0}天选品",
    "ShengYuNianDuMuBiao（HaiChaN%)": "剩余年度目标（还差{0}%)",
    "JiSuanFangShi": "计算方式",
    "JiaoYiHuiLv": "交易汇率",
    "DanBaoFangShi": "担保方式",
    "FanDianLv": "返点率",
    "ZhengDan2": "整单",
    "JunTan": "均摊",
    "WeiQiYong": "未启用",
    "JiaoYiTiaoKuan": "交易条款",
    "YiShenQingDengDaiQueRenZhong": "已申请，等待确认中",
    "ShenQingGenJin": "申请跟进",
    "TongXun": "通讯",
    "ZuiJinDengLuShiJian": "最近登录时间",
    "DengLuCiShu": "登录次数",
    "XuanPinShu": "选品数",
    "ChaKanShangPinShu": "查看商品数",
    "ZhaoYangShu": "找样数",
    "TianXieGengDuoZiLiao": "填写更多资料",
    "ShouQiGengDuoZiLiao": "收起更多资料",
    "NinTiJiaoXinXiYiChang": "您提交信息异常",
    "KeHuDaiHao": "客户代号",
    "BaoJiaBiZhong": "报价币种",
    "BaoJiaDanYuYan": "报价单语言",
    "KeHuDingJinFangShi": "客户定金方式",
    "XunJiaXiangGuan": "询价相关",
    "XunJiaLiRunZai": "询价利润在",
    "NeiZhiJieRangLiGeiKeHuChaoChuBuFenLiRunZaiFenPei": "直接让利给客户，超出部分利润再分配",
    "XunJiaLiRunFenPei": "询价利润分配",
    "GeiKeHuQiTaBaoLiu": "给客户，其他保留",
    "BianJiKeHuLiRunFenPeiShiLi": "示例：设置5%和20%，商品报价10，询价9，询价利润10%，则 5%直接让利给客户（10*5%=5），超出部分再分配20%给客户（5*20%=1），则一共让利5+1给客户，剩余4保留作为自己的利润。",
    "XunJiaZhangJiaShenHe": "询价涨价审核",
    "BuXuYaoShenHe": "不需要审核",
    "XuYaoShenHe": "需要审核",
    "DangYiCaiCaiGouZhongXinXunJiaHouDeJiaGeBiXunJiaQianGaoShi": "当宜采采购中心询价后的价格比询价前高时，如果不对询价后涨价进行再次协商谈判则选择不需要审核，如果询价后涨价需要亲自向工厂进行协商谈判价格的则选择需要审核",
    "MoRenGeiGongChangXunJiaDeYiXiangCaiGouXiangShu": "默认给工厂询价的意向采购箱数",
    "MoRenCaiGouXiangShu": "默认采购箱数",
    "WanJuCaiGouGuiMo": "玩具采购规模",
    "QingXuanZeCaiGouGuiMo": "请选择采购规模",
    "QingXuanZeXiaoShouGuiMo": "请选择销售规模",
    "KeHuZhuYingLeiMu": "客户主营类目",
    "QingXuanZeZhuYingLeiMu": "请选择主营类目",
    "XiTongJiangGenJuNiDeKeHuZhuYingLeiMuZhiNengTuiJianXiangGuanShangPin": "系统将根据你的客户主营类目智能推荐相关商品，方便选择",
    "DanGuiDingJinBiLi": "单柜定金比例",
    "DanGuiDingJiaBiLi": "单柜定价比例",
    "CaiGouShangDangQianDeKeYongZiJin": "采购商当前的可用资金",
    "MeiJin": "美金",
    "RenMinBi": "人民币",
    "ShiYongZhuangTai": "使用状态",
    "DaiTiaoZhengBaoZhengJinJinE": "待调整保证金金额",
    "DanBaoDaiKuanEDu": "担保贷款额度",
    "ZhangHuGuDingBaoZhengJin": "账户固定保证金",
    "DanGuiGuDingDingJin": "单柜固定定金",
    "DengJi": "等级",
    "MeiJinEDu": "美金额度",
    "RenMinBiEDu": "人民币额度",
    "GuiXing": "柜型",
    "FOBFeiYong：": "FOB费用：",
    "DengLuShiJian": "登录时间",
    "JianGeShangYiCiDengLu": "间隔上一次登录",
    "XiaDanXiangShu": "下单箱数",
    "JiQiFanYi": "机器翻译",
    "FuZhiGuanJianZi": "复制关键字",
    "KeHuJin60TianWeiFangWenPingTai": "客户近60天未访问平台",
    "QingXuanZeZhangHao": "请选择账号",
    "Jin60TianGuiJi": "近60天轨迹",
    "LiShiSouTu": "历史搜图",
    "XiaDanShangPin": "下单商品",
    "ShenHeZhuangTai": "审核状态",
    "XuanZeLianXiRen": "选择联系人",
    "GenJinLeiXing": "跟进类型",
    "QingXuanZeGenJinLeiXing": "请选择跟进类型",
    "ShangChuanJieTuHuoBaoJiaDan": "上传截图或报价单",
    "JieTuShiLi": "截图示例（邮件截图，要求包含发件人信息xxx；报价单必须包含xxxx……）",
    "GenJinWenJianShangChuan": "支持上传图片、word、excel、pdf。最多支持10个文件，每个文件大小限制10m",
    "QingShangChuanJieTuHuoBaoJiaDan": "请上传截图或报价单",
    "YouJianJieTuShiLi：XuYaoBaoHan": "邮件截图示例：需要包含xxxxxxxx",
    "BaoJiaDanJieTuShiLi：XuYaoBaoHan": "报价单截图示例：需要包含xxxxxxxx",
    "QingXuanZeLianXiRenZhangHao": "请选择联系人账号",
    "QingXianSheZhiJiDuMuBiaoHou": "请先设置季度目标后，再进行操作",
    "QueRenShiFouBuZaiFuWuCiKeHu": "确认是否不再服务此客户？解绑后，若客户无其他业务员进行跟进，则该客户在有需要时仍可以联系到您，但不会占用您的客户名额。",
    "JieBangChengGong": "解绑成功",
    "KeHuPODaiBan": "客户PO待办",
    "GenJinDengJi": "跟进登记",
    "LianXiRenGuanLi": "联系人管理",
    "XiaoShouHeTong": "销售合同",
    "TieZhiZiLiao": "贴纸资料",
    "MaiTouZiLiao": "唛头资料",
    "WenTiSheZhi": "问题设置",
    "ShengChanYaoQiuSheZhi": "生产要求设置",
    "WuLiuChuanWuZiLiao": "物流船务资料",
    "NianDuMuBiaoJinE": "年度目标金额",
    "NianDuDingHuoJinE": "年度订货金额",
    "NianDuChuHuoJinE": "年度出货金额",
    "NianDuWanChengBiLi": "年度完成比例",
    "NianDuJinE": "年度金额",
    "JiDuMuBiaoJinE": "季度目标金额",
    "JiDuDingHuoJinE": "季度订货金额",
    "YueDuMuBiaoJinE": "月度目标金额",
    "YueDuDingHuoJinE": "月度订货金额",
    "JiDu/YueDuJinE": "季度/月度金额",
    "LaoZiBuXiangFuWuTA": "老子不想服务 TA",
    "WoYiJingSheZhi": "我已经设置",
    "ShenQingZhong": "申请中",
    "ZuiJinDengLu": "最近登录",
    "ZuiJinCaoZuo": "最近操作",
    "FengXianZhi": "风险值",
    "BianJiCaiGouGenJinFenZu": "编辑采购跟进分组",
    "XinZengCaiGouGenJinFenZu": "新增采购跟进分组",
    "WeiXuanZeCaiGouFenZu": "未选择采购分组",
    "ZhuYe": "主页",
    "DongTai": "动态",
    "DengLuPingTai": "登录平台",
    "TiJiaoGouWuChe": "提交购物车",
    "SheZhiTieZhi": "设置贴纸",
    "NinMeiYouCaoZuoQuanXian": "您没有操作权限",
    "RenZhengRiQi": "认证日期",
    "ZhuCeRiQi": "注册日期",
    "QuanBuGuoJia": "全部国家",
    "QingXuanZeYeWuYuan": "请选择业务员",
    "SouSuoKeHuMingZi/BeiZhu/YouXiang": "搜索客户名字/备注/邮箱",
    "QuanBuYeWuYuan": "全部业务员",
    "SouSuoKeHuDaiHao/NiCheng": "搜索客户代号/昵称",
    "QingXuanZeYaoShanChuDeKeHu": "请选择要删除的客户",
    "LiJiXinZeng": "立即新增",
    "JianLiKeHuXinXi": "建立客户信息，导出报价单、询价压价更加方便请放心，你的客户信息将得到隐私保护",
    "GenDanYuanGong": "跟单员工",
    "CaiGouGenJinXiaoZu": "采购跟进小组",
    "QingXianXuanZeGongYingLianFenZu": "请先选择供应链分组，以便后续的询价跟单等有对应的供应链分组提供服务",
    "QingXuanZeYouXiaoQi": "请选择有效期",
    "ShangChuanHeTong": "上传合同",
    "QingShangChuanHeTong": "请上传合同",
    "HeTongWenJianShangChuan": "支持上传图片、pdf。最多支持10个文件，每个文件大小限制50m",
    "KeHuGongSiXinXi": "客户公司信息",
    "YinHangXinXi": "银行信息",
    "HeTongHeZuoYaoQiuBeiZhu": "合同合作要求备注",
    "ChuanWu": "船务",
    "CaiWu": "财务",
    "YaoQiuBeiZhu": "要求备注",
    "GenDan": "跟单",
    "QCCangKu": "QC、仓库",
    "YeWu": "业务",
    "WoSiQianYueZhuTi": "我司签约主体",
    "QingXuanZeGongSi": "请选择公司",
    "BianJiHeTong": "编辑合同",
    "FuKuanTiaoJianShuoMing": "付款条件说明",
    "KaiFaQuanYiShuoMing": "开发权益说明",
    "KaiFaQuanYiShuoMing1": "每个业务员可以跟进开发50个未成交的客户，其中含历史未下单的新客户，以及超过365天没有新订单的客户。当业务员跟进了成交客户时，每拥有一个成交客户都会使总开发权益数量减少5个（封底为10），举例如下：",
    "ChengJiaoKeHuShuLiang": "成交客户数量",
    "KaiFaQuanYi": "开发权益",
    "KaiFaQuanYiShuoMing2": "开发权益：10（封底最低有10个权益）",
    "QuanYiFanHai": "权益返还：",
    "KaiFaQuanYiShuoMing3": "1、业务员主动解绑客户或未成交客户主动解绑，系统将补回相应开发权益名额；",
    "KaiFaQuanYiShuoMing4": "2、成交客户主动解绑业务员，仅补回一个名额；",
    "KaiFaQuanYiShuoMing5": "3、业务员考核不通过，系统将不会补回名额；",
    "KaiFaQuanYiShuoMing6": "4、任何情况下，解绑超出名额部分的客户，不补回名额。",
    "PingTaiKeHu": "平台客户",
    "SiYouKeHu": "私有客户",
    "GongNTiaoJiLu": "共{0}条记录",
    "XinKe": "新客",
    "NianDuXiaoShou": "年度销售",
    "JiDuMuBiao": "季度目标",
    "FengXianYuJing": "风险预警",
    "XiTongKaoHeWeiDu": "系统考核维度",
    "XiTongJianKongDaoYouFengXianShi": "系统监控到有风险时，如无及时跟进，可能将开放客户给其他业务跟进",
    "WoDeDaiBan": "我的待办",
    "KuanXiangCuiShou": "款项催收",
    "PODanDaiQueRen": "PO单待确认",
    "DaiShenHeXunJiaRenWu": "待审核询价任务",
    "DaiQueRenTieZhiPaiBan": "待确认贴纸排版",
    "DaiSheZhiTieZhiMaiTou": "待设置贴纸唛头",
    "DaiShenHeJieDanYiChang": "待审核接单异常",
    "ChuanWuZiLiao": "船务资料",
    "ChuanWuYiChang": "船务异常",
    "DaiQueRenFeiYongDan": "待确认费用单",
    "ZhouRi": "周日",
    "ZhouYi": "周一",
    "ZhouEr": "周二",
    "ZhouSan": "周三",
    "ZhouSi": "周四",
    "ZhouWu": "周五",
    "ZhouLiu": "周六",
    "HanXinKeShouDan": "含新客首单",
    "ChengJiao": "成交",
    "Ji": "急",
    "DaiYeWuQueRen": "待业务确认",
    "DaiKeHuQueRen": "待客户确认",
    "YiChaoShi": "已超时",
    "ShangPinBianHaoNBuCunZai": "商品编号{0}不存在",
    "XiuGaiFeiYongDan": "修改费用单",
    "XinZengFeiYongDan": "新增费用单",
    "QingShuRuZhengQueDeFeiYongChengBen": "请输入正确的费用成本，(0.01-999999999)最多保留两位小数！",
    "QingXuanZeKeHu": "请选择客户",
    "QingXuanZeFeiYongXiangMu": "请选择费用项目",
    "FeiYongChengBen": "费用成本",
    "MoRenKeHuBiZhong": "默认客户币种，指定PO后，以PO币种为准",
    "QingTianXieFeiYongChengBen": "请填写费用成本",
    "ZhiDingPOShouQu": "指定PO收取",
    "DangQianBuZhiDingPO": "当前不指定PO，随系统规则",
    "ZaiZhiDingPOWanChengFeiYongShouQu": "在指定PO完成费用收取",
    "QingShuRuPODan": "请输入PO单",
    "NKuanShangPin": "N款商品",
    "QueRenFeiYongDanWenJianShangChuan": "支持图片，单文件最大支持10M，最多上传4个文件",
    "FuJian": "附件",
    "KeHuBeiZhu": "客户备注",
    "GaiBeiZhuJiangBeiKeHuKanDao": "该备注将被客户看到，请使用客户语言填写备注",
    "QingShuRuBeiZhu": "请输入备注",
    "QueRenBuXiangKeHuShouQu": "确认不向客户收取？",
    "QueRenShanChuGaiFeiYongDan？": "确认删除该费用单？",
    "YouBianGeng": "有变更",
    "ShiFouZhiDingPOShouQu": "是否指定PO收取",
    "XiangKeHuShiShou": "向客户实收",
    "BaoCunJiangGengXinFeiYongDanXinXi": "保存将更新费用单信息，同时可能会翻转费用单状态。",
    "RuGuoFeiYongDanShiShouDiYuChengBen": "如果费用单实收低于成本，将会影响PO的毛利",
    "ShiShouJinE": "实收金额",
    "MoRenAnPODanHuiLvJiSuan": "默认按PO单汇率计算，参考价格：",
    "QingTianXieShiShouJinE": "请填写实收金额",
    "BeiZhuGeiKeHu": "备注给客户",
    "QueRenXiangKeHuShouQu": "确认向客户收取",
    "BuXiangKeHuShouQu": "不向客户收取",
    "ChaKanBianGeng": "查看变更",
    "WuQuanXianXiuGaiQiTaJueSeFaQiFeiYongDan": "无权限修改其他角色发起费用单",
    "KeHuYiQueRen": "客户已确认",
    "QueRenShuoMing": "确认说明",
    "FeiYongDanXiangQing": "费用单详情",
    "HeJiNZhangFeiYongDanGongN": "合计{0}张费用单，共{1}",
    "DaiKeHuQueRenFeiYongDan": "代客户确认费用单",
    "DaiKeHuQueRenFeiYongChengGong": "代客户确认费用成功！",
    "DaiKeHuQueRenFeiYongDanWenJianShangChuan": "限制10个，支持PDF、JPG、PNG文件，最大支持10M",
    "ShangChuanQueRenPingZheng": "上传确认凭证",
    "QingShangChuanQueRenPingZheng": "请上传确认凭证",
    "QingTianXieBeiZhu": "请填写备注",
    "QingXuanZePODan": "请选择PO单！",
    "ZhiDingPOJiangBuGenSuiShangPinHuoXiTongGuiZe": "指定PO将不跟随商品或系统规则，只在指定PO完成费用收取",
    "ShuRuPODanHaoChaXun": "输入PO单号查询",
    "ChengSeXiangBiaoShiDuiBiShangYiCiYouXiuGai": "当前（橙色项表示对比上一次有修改）",
    "ShuLiangKuan": "数量(款)",
    "费用单合计": "费用单合计",
    "无PO费用": "无PO费用",
    "有变更": "有变更",
    "XiangKeHuShouQu": "向客户收取",
    "GuDingHuiLvBuNengWeiKong": "固定汇率不能为空",
    "QingXuanZeGangKouHeTianXieFOBFeiYong": "请选择港口和填写FOB费用",
    "QingXuanZeGangKou": "请选择港口",
    "FOBFeiYongBuNengWeiKong": "FOB费用不能为空",
    "QingZhiShaoBaoLiuYiGeXiaShuiGang": "请至少保留一个下水港",
    "MoRen40HQGuiXing": "默认40HQ柜型，多个下水港时，报单价默认第一个下水港。",
    "TianJiaXiaShuiGang": "添加下水港",
    "KeHuDaiHaoBuNengWeiKong": "客户代号不能为空",
    "QingShiYongZiMuHuoShuZiZuoWeiDaiHao": "请使用字母或数字作为代号",
    "TianXieKeHuDeDaiHao/BianHao": "填写客户的代号/编号（英文或数字）",
    "KeHuChaKanBaoJiaDanXuYaoShuRuDaiHao": "客户查看报价单，需要输入代号，提供报价单隐私保护",
    "KeHuNiCheng": "客户昵称",
    "TianXieKeHuDeNiCheng": "填写客户的昵称",
    "GuDingHuiLv": "固定汇率",
    "ShouDongSheZhiHuiLv": "手动设置汇率",
    "QingShuRuGuDingHuiLv": "请输入固定汇率",
    "BaoJiaDanJiaJiaLv": "报价单加价率",
    "FenPeiYeWuYuan": "分配业务员",
    "GengDuoZiLiao": "更多资料",
    "RuDiYuShangPinMOQYiMOQShuLiangXunJia": "给工厂询价时，默认的意向采购箱数，如低于商品MOQ以MOQ数量询价",
    "MoRenYaJiaBiLi": "默认压价比例",
    "XiangGongChangXunJiaShiZiDongAnCiBiLiJinXingYaJia": "向工厂询价时，自动按此比例进行压价",
    "XinZengZhaoYang": "新增找样",
    "SouSuoKeHuBianHao/YouXiang": "搜索客户编号/邮箱",
    "ZhaoYangFenXi": "找样分析",
    "FangAn/BaoJia": "方案/报价",
    "KeHuYouJiaGou": "客户有加购",
    "WuXiao": "无效",
    "FuZhiShiBai": "复制失败",
    "BenYueShengYuCuiBanCiShuNCi": "本月剩余催办次数{0}次，是否使用加急催办？",
    "CuiBanChengGong": "催办成功！",
    "BenYueShengYuCuiBanCiShu0Ci": "本月剩余催办次数 0 次，已无法加急。",
    "QuXiaoRenWuHouJiangBuZaiShouDaoHuiFu": "取消任务后将不再收到回复，是否取消？",
    "KeHuDeZhaoYangXiangQing": "客户的找样详情",
    "QuXiaoRenWu": "取消任务",
    "JiaJiCuiBan": "加急催办",
    "ZhaoYangPingZheng": "找样凭证",
    "WeiShangChuan": "未上传",
    "ShangPinShuoMing": "商品说明",
    "LiRuGongNeng": "例如功能、颜色、材质、指定的品牌、包装要求等",
    "FuZhiShuoMing": "复制说明",
    "KeHuPianHao": "客户偏好",
    "KeJieShouLeiSi": "可接受类似",
    "ZhiKanYiJiaGou": "只看已加购",
    "RenWuidGeShiZhengQue": "任务id格式正确！",
    "GongZuoTai": "工作台",
    "KeHuZhaoYangJiLu": "客户找样记录",
    "RenWuID": "任务ID",
    "YouJiaGou": "有加购",
    "DaiKeHuFaQiZhaoYang": "代客户发起找样",
    "XuanZeZhangHao": "选择账号",
    "FaBuZhaoYangWenJianShangChuan1": "上传邮件/聊天截图，以证客户真实找样",
    "FaBuZhaoYangWenJianShangChuan2": "上传文件，支持图片/压缩包/Excel，单文件最大支持200M，最多上传5个文件",
    "QingXuanZeShangChuanYouJianHuoZheLiaoTianJieTu": "请选择上传邮件或者聊天截图",
    "MiaoShuYaoZhaoDeShangPin": "描述要找的商品",
    "ShuoShuiKeHuDeYiXiePianHao": "说说客户的一些偏好，可以获得更精准更符合的商品",
    "TiGongZiLiao/TuPian": "提供资料/图片",
    "FaBuZhaoYangWenJianShangChuan3": "上传文件，支持图片/压缩包/Excel，单文件最大支持200M，最多上传100个文件",
    "KeJieShouTuiJianXiangSiKuan": "可接受推荐相似款",
    "ChaiJieRenWu": "拆解任务",
    "BianJiFenZu": "编辑分组",
    "FenZuMing": "分组名",
    "QingShuRuFenZuMing": "请输入分组名",
    "FenZuWenJianShangChuan": "上传文件，支持图片，最多上传5张图片",
    "QueRenShanChuGaiFenZu": "确认删除该分组？",
    "ZanBuFenZu": "暂不分组",
    "XuanZeYiGeFenZu": "选择一个分组",
    "MeiYouTuPian": "没有图片",
    "SouSuoFenZu": "搜索分组",
    "ZhuanWeiWuXiaoXuQiu": "转为无效需求",
    "TianXieYuanYin": "填写原因",
    "QingTianXieLiYou": "请填写理由",
    "YiDengNTian": "已等{0}天",
    "RenWuDaiFenJie": "任务待分解",
    "JiJiaJiChu": "计价基础",
    "ShengYuNTianJieShuJieZhiZhiN": "剩余{0}天结束，截止至{1}",
    "BuChongShangPin": "补充商品",
    "BuManYi": "不满意",
    "TuiJianDangQianZuiDuoHuiFuNKuan": "推荐当前最多回复{0}款",
    "YiXuanPinNKuanRenWuZhiYunXuTuiJianNKuan": "已选品{0}款，任务只允许推荐{1}款，超出的选品将被忽略。是否继续推荐？",
    "YiXuanShangPin": "已选商品",
    "WeiTuiJianNKuan": "未推荐{0}款",
    "ChongFuDeShangPinHuiFuKeHuShiXiTongHuiZiDongQuZhong": "重复的商品回复客户时，系统会自动去重",
    "JiaRuChengGong": "加入成功",
    "PinPai/GongYingShang": "品牌/供应商",
    "KeBanShangPin": "客版商品",
    "YiQuanBuHuiFuKeHu": "已全部回复客户",
    "YiHuiFuKeHu": "已回复客户",
    "BiaoJiYiQuanBuHuiFuKeHu": "标记已全部回复客户",
    "BiaoJiYiHuiFu": "标记已回复",
    "YouXinDeBuChong": "有新的补充",
    "EXWBiaoZhunBaoJiaGuiZeWenBen": "EXW标准报价规则<br/>出货仓为商品产地的报价<br/>FOB标准报价规则<br/>\n商品产地为汕头时：汕头（出货仓）-汕头（下水港）-40HQ（货柜）组合报价<br/>\n商品产地为广州时：广州（出货仓）-广州（下水港）-40HQ（货柜）组合报价<br/>\n商品产地为义乌时：义乌（出货仓）-宁波（下水港）-40HQ（货柜）组合报价<br/>\n注意：下单时若柜子出货仓、下水港、货柜类型变化，可能会影响商品FOB均摊<br/>\n及产生短途运费（出货仓与产地不在同一区域时，将产生短途运费）。",
    "ShangPinChuHuoCangMoRenWeiShangPinChanDi": "商品出货仓默认为商品产地",
    "ZhiDingShangPinBaoJiaFangShiDaoBaoJiaDan": "指定商品报价方式导报价单",
    "GenJuXuanZeDeChuHuoQuYu": "FOB报价：根据选择的出货区域、下水港、货柜类型计算；DDP报价：根据选择航线的标准的出货区域、下水港、货柜类型计算",
    "ShangPinChuHuoJiangAnSuoXuanChuHuoCang": "商品出货将按所选出货仓、下水港、货柜类型报价，中间可能影响FOB均摊费及可能产生短途运费",
    "XiaDanShiRuoGuiZiChuHuoCang": "注意：下单时若柜子出货仓、下水港、货柜类型变化，可能会影响商品FOB均摊及产生短途运费（出货仓与产地不在同一区域时，将产生短途运费）。",
    "XuanZeMuBanHeYuYan": "选择模板和语言",
    "DanGePCS": "单个PCS",
    "ShangPinChanDi": "商品产地",
    "GuoJiaBuNengWeiKong": "国家不能为空",
    "DingJinCuiShou": "定金催收",
    "WeiKuanCuiShou": "尾款催收",
    "ChuHuoKuanXiangYiChangCuiShou": "出货款项异常催收",
    "WeiKuanCaiWuRenGongCuiShou": "尾款财务人工催收",
    "BenDanDingJinYiJingShenQingChaoXin": "本单定金已经申请超信",
    "ZuiWanQueRenShiJian": "最晚确认时间",
    "YiYuQiNTian": "已逾期{0}天",
    "JiangHuiYanQiChuHuo": "将会延期出货",
    "ShiJiZhuangGuiShiJian": "实际装柜时间",
    "HuoGuiYiDaoGang": "货柜已到港",
    "HuoGuiHaiYouNTianDaoDaGangKou": "货柜还有N天到达港口",
    "WeiAnShiShouKuanJiangYingXiangKeHuTiGui": "未按时收款将影响客户提柜",
    "KaiChuanShiJian": "开船时间",
    "HaiXuZhiFuDingJin": "还需支付定金",
    "HaiXuZhiFuWeiKuan": "还需支付尾款(含其他费用)",
    "YuJiXuZhiFuWeiKuan": "预计需支付尾款(含其他费用)",
    "GeQuYuZhongQingDouXuanZeYiZuGenDanRenYuan": "各区域中请都选择一组跟单人员",
    "XiuGaiCaiGouGenJinFenZu": "修改采购跟进分组",
    "XunJiaKeFu": "询价客服",
    "JieDanKeFu": "接单客服",
    "GenDanKeFu": "跟单客服",
    "YiGenJinKeHuShu": "已跟进客户数",
    "XunJiaHuiFu": "询价回复",
    "KeHuXuQiuGuanLi": "客户需求管理",
    "KeHuYiJingJinRuBanGongKaiZhuangTai": "客户已经进入半公开状态，可能会被其他销售经理跟进",
    "BianJiDingCangQiTaShouHuoRenXinXi": "编辑订舱其他收货人信息",
    "XinZengDingCangQiTaShouHuoRenXinXi": "新增订舱其他收货人信息",
    "DangDingCangShouHuoRenYuHeTongMaiFangBuYiZhiShi": "当订舱收货人与合同买方不一致时，需要辅助证明，邮件或协议",
    "ShuRuGongSiMingCheng": "输入公司名称",
    "ZhengMingWenJian": "证明文件",
    "ShouHuoRenTuPianShangChuan": "支持上传图片、word、excel、pdf。最多支持10个文件，每个文件大小限制50m",
    "QingTianXieHuoDaiLianXiRenXinXi": "请填写货代联系人信息",
    "QingShuRuZhengQueDeQQ": "请输入正确的QQ",
    "QingShuRuZhengQueDeYouXiang": "请输入正确的邮箱",
    "BianJiHuoDaiLianXiRen": "编辑货代联系人",
    "XinZengHuoDaiLianXiRen": "新增货代联系人",
    "BianJiHuoDaiXinXi": "编辑货代信息",
    "XinZengHuoDaiXinXi": "新增货代信息",
    "GuoNeiHuoDai": "国内货代",
    "HuoDaiGongSi": "货代公司",
    "QingShuRuHuoDaiGongSiMingCheng": "请输入货代公司名称",
    "ShuRuHuoDaiGongSiMingCheng": "输入货代公司名称",
    "HuoDaiGongSiDiZhi": "货代公司地址",
    "ShuRuHuoDaiGongSiDiZhi": "输入货代公司地址",
    "GuoNeiHuoDaiLianXiRen": "国内货代联系人（至少补充一个）",
    "ZhiShaoYouYiGeGuoNeiHuoDaiLianXiRen": "至少有一个国内货代联系人",
    "QingShuRuZhengQueDeEmail": "请输入正确的Email",
    "BianJiTongZhiRenXinXi": "编辑通知人信息",
    "XinZengTongZhiRenXinXi": "新增通知人信息",
    "QingZuiShaoGouXuanYiGeDingDan": "请最少勾选一个订单",
    "DanGeDaoChu": "单个导出",
    "ChuanWuZiLiaoMuBanDaoChu": "船务资料模板导出",
    "YiChaoShiNTian": "已超时{0}天",
    "ChaoShiNTianJiangWuFaDingCang": "超时{0}天将无法订舱",
    "HuiYanQiChuHuo": "会延期出货",
    "ZuiWanChuLiShiJian": "最晚处理时间",
    "YuZhuangGuiRiQi": "预装柜日期",
    "MaiFang1": "卖方1",
    "QueRenYiJingJianChaSuoYouDeChuanWuZiLiao": "确认已经检查所有的船务资料？提交后一旦变更，可能影响订舱订车。",
    "BianGengChuanWuZiLiaoKeNengYingXiangDingCangDingChe": "变更船务资料可能影响订舱订车，请谨慎变更资料。",
    "HeTongXinXiWeiWanShan": "合同信息未完善，请前往客户主页-销售合同下完善合同信息再继续操作",
    "ChuanWuDaiBan": "船务待办",
    "GengXinChuanWuZiLiao": "更新船务资料",
    "QueRenChuanWuZiLiao": "确认船务资料",
    "DaoRuTianChong": "导入填充",
    "ShouQuanDiaoHuo": "授权调货",
    "YunShuFangShi": "运输方式",
    "HuoDaiXinXi": "货代信息",
    "GuoNei": "国内",
    "JingWai": "境外",
    "QingXuanZeYiGeHuoDai": "请选择一个货代",
    "RuXuZhiDingLianXiRenQingZaiYiXiaLianXiRenZhongJinXingZhiDing": "如需指定联系人请在以下联系人中进行指定，船务将与指定联系人联系",
    "QingXuanZeXiaoShouHeTong": "请选择销售合同",
    "FaHuoRenXinXi": "发货人信息",
    "QingXuanZeYiGeFaHuoRen": "请选择一个发货人",
    "DingCangShouHuoRen": "订舱收货人",
    "QingXuanZeYiGeShouHuoRen": "请选择一个收货人",
    "TongZhiFang": "通知方",
    "QingXuanZeYiGeTongZhiFang": "请选择一个通知方",
    "QingXuanZeYunShuFangShi": "请选择运输方式",
    "HaiYun": "海运",
    "TieLu": "铁路",
    "KongYun": "空运",
    "QiYun": "汽运",
    "ChuDanFangShi": "出单方式",
    "TiDanLeiXing": "提单类型",
    "QingXuanZeTiDanLeiXing": "请选择提单类型",
    "GangKouXinXi": "港口信息",
    "MuDiGang": "目的港",
    "GuoJia-ZhiChiShuRuShaiXuan": "国家-支持输入筛选",
    "QingTianXieMuDiGang": "请填写目的港",
    "MuDiDi": "目的地",
    "QingShuRuMuDiDiChengShiMingCheng": "请输入目的地城市名称",
    "ZhiDingTiDanPinMing": "指定提单品名",
    "BuZhiDing": "不指定",
    "ZhiDing": "指定",
    "QingShuRuZhiDingDePinMing": "请输入指定的品名",
    "ZhiDingDePinMing": "指定的品名",
    "HuoWuMiaoShu": "货物描述",
    "BaoKuoDanBuXianYuHuoWuPinMing": "包括但不限于货物品名，中转条款以及客户要求的内容，如不填写则船务归类品名",
    "QingXianChuLiZaiTiJiao": "请先处理再提交",
    "QingXianChuLiWanChengZaiTiJiao": "请先处理完成再提交",
    "YuanChuHuoQuYu": "原出货区域",
    "YuanBaoJiaFangShi": "原报价方式",
    "YuanXiaShuiGang": "原下水港",
    "YuanHuoGuiLeiXing": "原货柜类型",
    "XinChuHuoQuYu": "新出货区域",
    "XinBaoJiaFangShi": "新报价方式",
    "XinHuoGuiLeiXing": "新货柜类型",
    "XinXiaShuiGang": "新下水港",
    "TiaoZheng": "调整",
    "ChuanWuFeiYongYiChang": "船务费用异常",
    "ChuanWuDingCangQiTaFuJiaZongFeiYong": "船务订舱其他附加总费用",
    "FuJiaHuoDaiFeiYong": "附加货代费用",
    "FeiYongShuoMing": "费用说明",
    "WoSiQuanBuChengDan": "我司全部承担",
    "KeHuChengDan": "客户承担",
    "WoSiChengDan": "我司承担",
    "WoSiChengDanBuFenJiangHuiYingXiangXiaoShouLiRunJiSuan": "注：我司承担部分，将会影响销售利润计算",
    "QueRenShanChuHuoDaiXinXi": "确认删除货代信息？",
    "ShiFouYaoShanChuShouHuoRenXinXi": "是否要删除收货人信息？",
    "ShiFouYaoShanChuTongZhiRenXinXi": "是否要删除通知人信息？",
    "WuLiuChuanWuZiLiaoGuanLi": "物流船务资料管理",
    "XinZengHuoDai": "新增货代",
    "TongZhiRenXinXi": "通知人信息",
    "XinZengTongZhiRen": "新增通知人",
    "DaiQueRenChuanWuZiLiao": "待确认船务资料",
    "ChuanQiBianDong": "船期变动",
    "PODanHuoHaoYanQiShangPinYiChuLi": "PO单货好延期商品已处理，暂不需要调补货处理",
    "ChuLiChengGong": "处理成功",
    "DingCangYiChangChuLi": "订舱异常处理",
    "QuDiaoBuHuo": "去调补货",
    "ChuLiYiChang": "处理异常",
    "HuoHaoYanQi": "货好延期",
    "ShouHuoKuanXiangYiChang": "收货款项异常",
    "ZhuangGuiKuanXiangYiChang": "装柜款项异常",
    "AnYuanShouHuoShiJian": "按原收货时间",
    "XiuGaiShouHuoShiJian": "修改收货时间",
    "XiuGaiShouHuoShiJianZhi": "修改收货时间至（本次订舱最晚收货时间{0})",
    "AnYuanYuZhuangGuiShiJian": "按原预装柜时间",
    "DiaoBu/QuXiaoShangPin": "调补/取消商品",
    "JieShouXinYuZhuangGuiShiJian": "接受新预装柜时间",
    "KuanXiangYiDaoAnYuanYuZhuangGui": "款项已到，按原预装柜",
    "ChaoXinChuHuoAnYuanYuZhuangGui": "超信出货，按原预装柜",
    "YanQiZhuangGui": "延期装柜",
    "XuanZeRiQi": "选择日期",
    "ChuLi": "处理",
    "YuZhuangGui": "预装柜",
    "Dai2KeHuQueRen": "代客户确认",
    "YuJiYouFengXian": "预计有风险",
    "YouFengXian": "有风险",
    "ShuiHao": "税号",
    "MuBiao": "目标",
    "ShiJi": "实际",
    "JiDuWanChengBiLi": "季度完成比例",
    "JiDuJinE": "季度金额",
    "NQianYuan": "{0}千元",
    "PinTaiZhangHao": "平台账号",
    "WuZhangHao": "无账号",
    "XinBieWeiWanShan": "性别未完善",
    "QiTaLianXiFangShi": "其他联系方式",
    "Jin30TianDengLuTianShu": "近30天登录天数",
    "DangQianKaiFaKeHuQuanYiShuLiangShengYu": "当前开发客户权益数量剩余 {0}",
    "YiFaSongShenQingKeYiQianWang": "可以前往【我的客户】查看",
    "ShenQingXinNeiRongBuNengWeiKong": "申请信内容不能为空",
    "QingXuanZeNiDeKeHuMuBiao": "请选择你的客户目标",
    "QingXuanZeShiFouFaSongYouJian": "请选择是否发送邮件",
    "FaSongShenQing": "发送申请",
    "XiTongFaYouJian": "系统发邮件",
    "XiTongBuYaoFaYouJian": "系统不要发邮件，我自己发",
    "YuLanYouJian": "预览邮件",
    "FuZhiYouJianHTML": "复制邮件HTML",
    "RuGuoYaoZiJiFaSongYouJian": "如果要自己发送邮件，请复制邮件HTML，粘贴到邮件编辑器中（HTML视图）",
    "WoYaoTiShengKeHuMuBiao": "我要提升客户目标（可多选）",
    "TiShengXiaoShouE": "提升销售额",
    "TiGaoKeHuDengLuCiShu": "提高客户登录次数",
    "ZengJiaKeHuZiZhuXuanPin": "增加客户自助选品",
    "ZengJiaShangPinTuiJianCiShu": "增加商品推荐次数",
    "FaSongYouJian": "发送邮件",
    "RuGuoXuanZeZiJiFaSongYouJian": "如果选择自己发送邮件，请发送申请后，复制HTML自行编辑内容。",
    "QingTianXieShenQingTuiJianXin": "请填写申请推荐信，展现你的特长更容易获得客户的接受，请注意客户的语言",
    "KeHuGenJin": "客户跟进",
    "QingXuanZeJieBangDeKeHu": "请选择解绑的客户",
    "NiXuYaoWanChengYiXiaCaoZuo": "你需要完成以下操作",
    "DaiJieBangKeHu": "待解绑客户",
    "YiXiaKeHuChuYuWuDingDanGenJinZhuangTai": "以下客户处于无订单跟进状态，可以安全解除，请选择要解除绑定的客户",
    "JieChuBangDingNGeKeHu": "解除绑定{0}个客户",
    "DaiSheZhiCaiGouFenZu": "待设置采购分组",
    "YiXiaKeHuWuCaiGouZu": "以下客户无采购组，必须全部设置采购组后，才能进入工作台操作。",
    "QingJieBangNGeKeHuHouJiXuCaoZuo": "当前绑定客户数已超指定权益数，请解绑{0}个客户后继续操作",
    "BuBaoHanGongChangLianXiFangShi": "不包含工厂联系方式",
    "QuanBuYeJiZuZhang": "全部业绩组长",
    "QingXuanZeYeJiZuZhang": "请选择业绩组长",
    "DaoChuDeBaoJiaDanBuBaoHanGongChangLianXiFangShi": "导出的报价单不包含工厂联系方式",
    "PiLiangSheZhiFenZu": "批量设置分组",
    "TuPianXingShi": "图片形式",
    "MoRenPaiBanFangShi": "默认排版方式",
    "ChongXinJiaRuXuanPin": "重新加入选品",
    "PingTai1": "平台1",
    "TianJiaDaoFenZu": "提交到分组",
    "ZanBuJiaRu": "暂不加入",
    "XiaoShouShiChang": "销售市场",
    "WuMuBiao": "暂无目标",
    "QuanBuZuZhang": "全部组长",
    "LianXiKeFu2": "联系客服",
    "YiCaiShouYe": "宜采首页",
    "GuanZhuYiCai": "关注宜采",
    "APPXiaZai": "APP下载",
    "WeiXinSaoYiSaoTianJiaKeFu": "微信扫一扫，添加客服",
    "APPLiuLanGengBianJie": "APP浏览更便捷",
    "GongChangRuZhu": "工厂入驻",
    "WoDeYiCai": "我的宜采",
    "ZhanDianQuYu": "站点区域",
    "ShangPinPinLei": "商品品类",
    "JiaGe（Yuan）": "价格（元）",
    "MOQ（WaiXiang）": "MOQ（外箱）",
    "HuoQi (Tian)": "货期 (天)",
    "WaiXiangTiJi (m3)": "外箱体积 (m3)",
    "BaoZhuangTiJi (m3)": "包装体积 (m³)",
    "QingXuanZeBaoZhuangLeiXing": "请选择包装类型",
    "QingXuanZeRenZhengBiaoZhun": "请选择认证标准",
    "GongChangDaQuan": "工厂大全",
    "ZhanTingTuiJian": "展厅推荐",
    "HuanYingNin": "欢迎您",
    "MianFeiZhuCeMianFeiShiYong": "免费注册，免费试用",
    "GongChangShangXin": "工厂上新",
    "ChaKanXinPin": "查看新品",
    "XuanPinDongTai": "选品动态",
    "HaoGongChang": "好工厂",
    "BaiYuanGaoXingJiaBiHaoHuoGaoLiRunDanPinJinZaiYiCai": "百元高性价比好货，高利润单品尽在宜采",
    "ChaKanQuanBuGongChang": "查看全部工厂",
    "YouZhiGongChang": "优质工厂",
    "ZhuYing": "主营",
    "GongChangTuiJianHaoHuoXunZhaoShangJiJinZaiQiZhong": "工厂推荐好货，寻找商机，尽在其中",
    "SouSuoZhaoShangPin": "搜索找商品",
    "ShiTuZhaoShangPin": "识图找商品",
    "LeiMuZhaoShangPin": "类目找商品",
    "DaoChuShangPinZiLiao": "导出商品资料",
    "FaZhanLiShi": "发展历史",
    "PingTaiShiLi": "平台实力",
    "ChanPinTeSe": "产品特色",
    "QiYeWeiXin": "企业微信",
    "FuWuShiJian": "服务时间",
    "LianXiKeFu3": "联系客服",
    "YiCaiXuanPinNReXiaoPaiHangBangTuiJianSEO_T": "宜采选品-{0}热销排行榜推荐",
    "YiCaiXuanPinNReXiaoPaiHangBangTuiJianSEO_KW": "宜采选品{0}推荐,{1}热销排行榜",
    "YiCaiXuanPinNReXiaoPaiHangBangTuiJianSE_DS": "在宜采选品上根据用户选品行为统计出玩具细分类目的热销榜单，为用户提供真实的选品参考",
    "YiCaiXuanPinYiXiangChuHuoSEO_T": "一箱快出 批发 - 第{0}页 - 宜采选品",
    "YiCaiXuanPinYiXiangChuHuoSEO_KW": "宜采选品一箱可购",
    "YiCaiXuanPinYiXiangChuHuoSEO3_DS": "在宜采选品上寻找优质制造商，知名工厂，大牌供应商，实力卖家，超过300万畅销商品，以便宜的价格批发给全球五大地区客户：玩具用品、体育用品、文具、节庆用品、儿童户外车、婴儿用品和餐具，支持电脑和APP端在线选品、询价和导出报价单推荐客户。",
    "YiCaiXuanPinGuoNeiZhuanGongSEO_T": "内销专区批发 - 第{0}页 - 宜采选品",
    "YiCaiXuanPinGuoNeiZhuanGongSEO_KW": "宜采选品内销专区",
    "YiCaiXuanPinGuoNeiZhuanGongSEO_DS": "在宜采选品上寻找优质制造商，知名工厂，大牌供应商，实力卖家，超过300万畅销商品，以便宜的价格批发给全球五大地区客户：玩具用品、体育用品、文具、节庆用品、儿童户外车、婴儿用品和餐具，支持电脑和APP端在线选品、询价和导出报价单推荐客户。",
    "YiCaiXuanPinXinPinSEO_T": "{0}批发厂家-_{1}批发平台_{2}批发一手货源网站_宜采选品",
    "YiCaiXuanPinXinPinSEO_T2": "{0}批发厂家-_{1}批发平台_{2}批发一手货源网站_宜采选品_第{3}页",
    "YiCaiXuanPinXinPinSEO_T3": "益智玩具批发厂家_益智玩具批发平台_益智玩具批发一手货源网站_宜采选品",
    "YiCaiXuanPinXinPinSEO_T4": "宜采选品页新品标题4：益智玩具批发厂家_益智玩具批发平台_益智玩具批发一手货源网站_宜采选品_第{0}页",
    "YiCaiXuanPinXinPinSEO_KW": "玩具批发一手货源网站,益智玩具批发网站,益智玩具批发厂家,益智玩具批发平台,益智玩具批发一手货源",
    "YiCaiXuanPinXinPinSEO_DS": "宜采益智玩具批发一手货源网站每日实时更新新品玩具的的详细参数,、实时报价、价格行情，为贸易商给采购商推荐新品提供重要参考。`",
    "YiCaiXuanPinLeiMuSEO_T": "{0}-{1}批发-{2}大全厂家直销【最新报价|一箱快出】_宜采选品",
    "YiCaiXuanPinLeiMuSEO_T2": "{0}-{1}批发-{2}大全厂家直销【最新报价|一箱快出】_第{3}页宜采选品",
    "YiCaiXuanPinLeiMuSEO_DS": "在宜采选品找到了{0}的商品。这里有{1}的最新报价，优惠促销，供应商及图片等相关信息。",
    "DiNYe": "第{0}页",
    "ShenQingChaKan": "申请查看",
    "ZhangHaoWeiRenZheng2": "账号未认证",
    "QuanBuLianXiRen": "全部联系人",
    "GouWuCheBaoJiaDan": "购物车(报价单)",
    "FaBuXinZhaoYang": "发布新找样",
    "ChaKanCiKuanShangPinXiangQing": "查看此款商品详情",
    "JiaRuXuanYangChiYiShiGongChangZuiJinGengXinJiaGe": "加入选样池，已是工厂最近更新价格",
    "JiaRuXuanYangChiChengGong2": "加入选样池成功，系统已自动跟工厂询最新价格",
    "XuanYangChiYiYouCiShangPin": "选样池已有此商品，已是工厂最近更新价格",
    "XuanYangChiYiYouCiShangPin2": "选样池已有此商品，系统已自动跟工厂询最新价格",
    "JiaGeGengXinJiaRuXuanPinChiZiDongXunZuiXinJia": "价格更新，加入选品池自动询最新价",
    "GengXinJiaGe": "更新价格",
    "XuanYangChiZhongYiCunZaiCiShangPin": "选样池中已存在此商品",
    "GongChangJianJie": "工厂简介",
    "ChaKanLiShiZuJi": "查看历史足迹",
    "WanShanZiLiao": "完善资料",
    "BaoHuShangPinShenQingChaK": "保护商品申请查看",
    "ShuJuYinQing": "数据引擎",
    "YiDaCheng": "已达成VIP",
    "JiJiangDaCheng": "即将达成VIP",
    "NCiDengLu": "{0}+次登录",
    "NKuanXuanPin": "{0}款选品",
    "NKuanXunJia": "{0}款询价",
    "NCiDengLuTianYouDengLuSuan": "{0}次登录（1天有登录算1次）",
    "QingShuRuXuYaoSouSuoDeNei": "请输入需要搜索的内容",
    "DaYin": "打印",
    "ShangPinTiWen": "商品提问",
    "FaPiaoXuCaiWuQueRenHouZaiDaoChu2": "发票需财务确认后再导出",
    "FaPiaoZhongBao": "发票（中包）",
    "FaPiaoPcs": "发票（PCS）",
    "TieZhiDeZhiZuoXuYaoYiDingChengBen": "贴纸的制作需要一定成本，贴纸费用根据货柜商品使用的数量决定。",
    "DingDanCaoZuoXuYaoRenGongChengBen": "订单操作需要人工成本，服务费根据货柜商品款数决定",
    "TongYiESSAXieZhuDiaoHuo": "同意ESSA协助调货",
    "BuTongYiXuYaoTongZhiWo": "不同意，需要通知我",
    "XiaDanHouHuoPinZaiShengChanGuoChengZhong": "下单后，货品在生产过程中，可能因为某种原因发生货期延误情况，为了避免因少量商品货期问题导致装柜时间延误，是否允许授权ESSA根据生产进度进行合理调货并通知我。 （调货说明：当某些商品出现货期延误影响到整个货柜的出货时间时，ESSA将帮您把其他生产中的柜子里的商品与本柜进行部分商品调换，确保本柜能按照预定时间出货）",
    "TieZhiHeMaiTou": "贴纸和唛头",
    "XiuGaiDingDanYaoQiu": "修改订单要求",
    "DiaoHuo": "调货",
    "BianGengChuanWuZiLiao": "变更船务资料",
    "QueRenQuXiaoGaiShangPin": "确认取消该商品?",
    "JuYouBanQuanZhengYi": "具有版权争议",
    "XiaDanRiQi": "下单日期",
    "CaiGouDeShangPin": "采购的商品",
    "YouTiWen": "有提问",
    "YouGongChangFanKui": "有工厂反馈",
    "QuXiaoDeShangPin": "取消的商品",
    "BuManGuiChuHuo": "不满柜出货",
    "QueDingQuXiaoGaiDingDan": "确定取消该订单？",
    "BuManGuiKeYiDiaoRuShangPin": "不满柜，可以调入商品或者补货",
    "ShouQiQuanBu": "收起全部",
    "XianShiQuanBu": "显示全部",
    "BuManGuiChuHuoChengGong": "不满柜出货成功!",
    "QueRenBuManGuiChuHuo": "确认不满柜出货?",
    "SouSuoShangPinBianHaoHuoGongChangHuoHao": "搜索商品编号或工厂货号",
    "YiYuQiNTianWeiZhiFuDingJin": "注意：已逾期{0}天未支付定金，请您尽快联系客户",
    "YiYuQiKuanXianQiNei": "注意：已逾期（宽限期内），请您尽快联系客户支付定金",
    "CaiGouShangDeGuDingBaoZhengJinHaiKeDanBaoHuoKuanEDu": "注意：采购商的固定保证金还可担保货款额度{0},请尽快联系采购商确认PO，以免延误货期。",
    "CaiGouShangDeHaiKeDanBaoHuoKuan": "注意：采购商的还可担保货款{0}，不足以担保本单，请联系采购商提升担保额度。",
    "CaiGouShangDangQianWeiMianDingJinKeHu": "注意：采购商当前为免定金客户，请直接确认PO 。",
    "CaiGouShangDeKeYongZiJinZuGouZhiFuGaiBiDingDanDingJin": "注意：采购商的可用资金足够支付该笔订单定金{0},请尽快确认PO，以免影响工厂生产。",
    "DangQianKeYongZiJinBuZuZhiFuBenDanDingJin": "注意：当前可用资金不足支付本单定金{0}，请联系采购商增加可用资金，尽快完成定金支付，以免影响生产",
    "ZhangHuBaoZhengJinJinEBuZu": "注意：账户保证金金额不足，还需分配{0}到账户保证金，请尽快完成分配，以免影响担保。",
    "DingDanYiTiJiaoQingZhiFuDingJin": "注意：订单已提交，请支付定金。",
    "QingZaiChuHuoQianZhiFuDingJinN": "注意：请在出货前支付定金{0}。",
    "GaiDingDanHaiXuZhiFuDingJinN": "注意：该订单还需支付定金{0}。",
    "CaiGouShangDangQianWeiMianDingJinKeHu2": "注意：采购商当前为免定金客户，请联系采购商确认PO。",
    "CaiGouShangDeDingDanYiTiJiao": "注意：采购商的订单已提交，请尽快联系采购商支付定金，以免影响工厂生产。",
    "CaiGouShangDeDingJinYiZhiFu": "注意：采购商的定金已支付，请尽快联系采购商确认订单，以免影响工厂生产。",
    "CaiGouShangDeDingDanShangPinJiJiangWanChengShengChan": "注意：采购商的订单商品即将完成生产，请尽快联系采购商支付货款，以免延误到港日期。",
    "CaiGouShangDeDingDanShangPinYiJingZhuangGuiFaWangMuDiChengShi": "注意：采购商的订单商品已经装柜发往目的城市，请尽快联系采购商支付PO尾款。",
    "YiTiJiaoDingDanNTianWeiTiGongTieMaiXinXiDe": "注意：已提交订单{0}天，超出{1}天未提供贴唛信息的，出货时间将根据贴纸提供时间顺延。",
    "QingShuRuXuYaoSouSuoDeNeiRong": "请输入需要搜索的内容",
    "QuanBuYuanGong": "全部员工",
    "KeHuZhuDongTianJia": "客户主动添加",
    "ZuiJinGenJin": "最近跟进",
    "MoRenPaiXu": "默认排序",
    "LiShiKeHu": "历史客户",
    "QingXuanZeXiaoShouQuYu": "请选择销售区域",
    "ShengYuMuBiaoJinE": "剩余目标金额",
    "JinNTianXuanPinShuLiang": "近{0}天选品数量",
    "ZuiHouZhaoYangShiJian": "最后找样时间",
    "XiTongKaoHe": "系统考核",
    "SheZhiCaiGouFenZu": "设置采购分组",
    "JiaZaiZhong": "加载中",
    "JinTianGenJinGuo": "今天跟进过",
    "NTianQianGenJinGuo": "{0} 天前跟进过",
    "QingXuanZeChanDiQuYu": "请选择产地区域",
    "GongChangHuoHao（KeHu）": "工厂货号（客户）",
    "WeiQueRenDingDanHuoZheKongDingDanCaiNengQuXiao": "未确认po或者空po才能取消",
    "WeiQueRenDingDanDeShangPinCaiNengQuXiao": "未确认po的商品才能取消",
    "QingShuRuXuSouSuoDeNeiRon": "请输入需搜索的内容",
    "ChaKanCaiGouShangQianKuan": "查看采购商欠款明细",
    "ZhuWeiXiangKeHuShouQuWeiT": "注：“+”为向客户收取，“-”为退还给客户",
    "BenDanYingShouFeiYongMing": "本单营收费用明细",
    "BenDanHeJiDaiZhiFu": "本单合计待支付",
    "ShangPinBianHaoShangPinMi": "商品编号，商品名称，工厂货号，客户订单号等关键字",
    "QuXiaoZiDongTiaoZhuan": "取消自动跳转",
    "ZhongBo": "重播",
    "YuZhuangJuRiQiBianGengJiL": "预装柜日期变更记录",
    "ShiFouYiSheZhiPinMing": "是否已设置品名",
    "ShiFouManJu": "是否满柜",
    "ShiFouYiChang": "是否异常",
    "ShiFouDingJinYuQi": "是否定金逾期",
    "ShiFouHuoKuanYuQi": "是否货款逾期",
    "ShiFouXianShang": "是否线上PO",
    "YuQiTianShu": "逾期天数",
    "QueRenShengChanYaoQiu": "确认生产要求",
    "EssaoneLianXiWoMenSEO_BiaoTi": "联系我们SEO标题",
    "EssaoneLianXiWoMenSEO_MiaoShu": "联系我们SEO描述",
    "EssaoneLianXiWoMenSEO_H1": "联系我们SEO_H1",
    "DingDanWeiZhiFuWeiKuanBuYunXuChuKu": "%s订单未支付尾款不允许出库",
    "DaoChuTuPianYiBianHaoMing": "导出SKU图片，以SKU编号命名",
    "XuanZeBaoBiaoYuYan": "选择报表语言",
    "BaoBiaoDaYin": "报表打印",
    "QingXuanZeTuPianGuiGe": "请选择图片规格",
    "YuanTu": "原图",
    "QingShuRuShangPinBianHaoH": "请输入商品编号或工厂货号",
    "TeBieYaoQiu2": "特别要求",
    "HongShengJiuBianHao2": "宏升旧编号",
    "QuXiaoJiLu": "取消记录",
    "YeWuYuan": "业务员",
    "DingDanHouTaiChuLiZhong": "订单后台处理中",
    "BianGengYuZhuangJuRiQi": "变更预装柜日期",
    "YuanZhuangJuShiJian": "原装柜时间",
    "DangQianZhuangJuShiJian": "当前装柜时间",
    "XinZhuangJuShiJian": "新装柜时间",
    "QingXuanZeXinZhuangJuShiJ": "请选择新装柜时间",
    "BianGengYuanYin": "变更原因",
    "QingXuanZeBianGengYuanYin": "请选择变更原因",
    "QingShuRuBianGengYuanYinB": "请输入变更原因备注信息",
    "DuanTu": "短途",
    "SouSuoDingDanHao/ShangPinBianHao": "搜索订单号/商品编号",
    "QuQueRen": "去确认",
    "DaiQueRenChuHuo": "待确认出货",
    "FaHuoQueRen": "发货确认",
    "ShiFouYaoQuBuChongChuanWuN": "是否要去补充船务资料单号{0}",
    "QueRenChuHuoXinXi": "确认出货信息",
    "DingCang": "订舱",
    "XuanZeWoSiDingCangShiHouX": "选择我司订舱时后续订单需要上传船务资料",
    "QingXuanZeDingCang": "请选择订舱",
    "WoSiDingCang": "我司订舱",
    "BuDingCang": "不订舱",
    "YiHeShiQueRenYiShangXinXi": "已核实确认以上信息,确定提交",
    "DingDanZhengZaiChuLiDiaoH": "订单正在处理调货，请稍后处理。",
    "ZanWuChaKanQuanXian": "暂无查看权限",
    "POZhuangTai": "PO状态",
    "XuHao": "序号",
    "BianGengRen": "变更人",
    "BianGengShiJian": "变更时间",
    "BianGengLeiXing": "变更类型",
    "XinYuJiDaoGangRiQi": "新预计到港日期",
    "QuXiaoShuLiang": "取消数量",
    "SouSuoShangPinBianHaoMing": "搜索商品编号/名称",
    "DingDanShangPinQuXiaoJiLu": "订单商品取消记录",
    "KuaiDiDanSaoMiaoJian2": "快递单扫描件",
    "KuaiDiHao": "快递号",
    "DianFangBianMa": "电放编码",
    "KuaiDiGongSi": "快递公司",
    "ZhiJianDan": "质检单",
    "DingDanJinEXinXi": "订单金额信息",
    "ZhangHuYuE": "账户余额",
    "ShangPinZongJia": "商品总价",
    "KeYongDanBaoHuoKuanEDu": "可用担保货款额度",
    "ESSAZhuYiShiXiangNotCn": "ESSA注意事项（外文）",
    "ESSAZhuYiShiXiangNotCnBeiZhu": "（给到客户查看）您可以填写您本次订单中，质检的要求及生产完成之后货品装柜摆放组合等非生产过程的要求",
    "ESSAZhuYiShiXiangCn": "ESSA注意事项（中文）",
    "ESSAZhuYiShiXiangCnBeiZhu": "（给到跟单查看）请以中文填写",
    "QiTaShengChanYaoQiuNotCn": "其他生产要求（外文）",
    "QiTaShengChanYaoQiuNotCnBeiZhu": "给客户查看，你针对上面订单生产要求还有其他补充，可以进行填写，例如：所有带电池的商品需要把电池进行拆装",
    "QiTaShengChanYaoQiuCn": "其他生产要求（中文）",
    "QiTaShengChanYaoQiuCnBeiZhu": "下到工厂的要求，请使用中文填写生产要求",
    "GeXingYaoQiuNotCn": "个性要求（外文）",
    "GeXingYaoQiuCn": "个性要求（中文）",
    "GeXingYaoQiuNotCnBeiZhu": "(给到客户查看)您可以填写您本次订单中该商品的一些个性化生产要求，例如：贴纸贴在商品那个位置",
    "GeXingYaoQiuCnBeiZhu": "(给到工厂查看)您可以填写您本次订单中该商品的一些个性化生产要求，例如：贴纸贴在商品那个位置",
    "ShiFouRangKeHuQueRenPO": "是否让客户确认 PO",
    "ShiFouRangKeHuQueRenPOTiShi1": "该客户有积分，优惠券，提交订单后是否推送给客户自己确认PO？",
    "ShiFouRangKeHuQueRenPOTiShi2": "客户使用积分/优惠券，不影响你的收益",
    "TuiSongGeiKeHuQueRen": "推送给客户确认",
    "BuTuiSong": "不推送",
    "QingShuRuKeHuDingDanHao": "请输入客户订单号",
    "FanHuiGouWuChe": "返回购物车",
    "SheZhiKeHuDingDanHao": "设置客户订单号",
    "LaiYuan": "来源",
    "ChengJiaoDanJia": "成交单价",
    "PiLiangSheZhi": "批量设置",
    "SouSuoShangPinBianHaoGongChangHuoHao": "搜索商品编号/工厂货号",
    "NGe": "{0}个",
    "QingXuanZeHeTongXinXi": "请选择合同信息",
    "SuoYouKeHuDeDingDan": "所有客户的订单",
    "QuanBuDingDan": "全部订单",
    "DaiQueRenPO": "待确认PO",
    "HuoQiYuQi": "货期逾期",
    "ZhuangGuiZhong": "装柜中",
    "7TianNei": "7天内",
    "NYueNei": "{0}月内",
    "NYueHou": "{0}月后",
    "SouSuoDingDanHaoShangPinBianHao": "搜索订单号/商品编号",
    "PODanXinXi": "PO单信息",
    "KeYongDanBaoEDu": "可用担保额度",
    "ESSABUY_ResultPageType8": "根据采购商的良好信用，ESSA已授信金额{0}用来临时支付本单定金。",
    "ESSABUY_ResultPageType1": "当前账户固定保证金额不足，请尽快分配资金进保证金，以免影响担保订单。还需分配{0}到账户保证金。",
    "ESSABUY_ResultPageType2": "采购商固定保证金还可担保额度{0}，不足以担保此张订单。为能顺利确认订单，可以建议采购商的保证金额度需提升至{1}",
    "ESSABUY_ResultPageType3": "当前账户固定保证金额足够担保该笔订单，请直接点击确认。确认PO后，可以进入采购商的PO单列表查看订单的生产进度情况。",
    "ESSABUY_ResultPageType4": "请确认PO,以免影响工厂生产。 为避免影响订单出货，请通知采购商在出货前支付本单定金:{0}",
    "ESSABUY_ResultPageType5": "账户可用资金足够支付本单所需定金，请尽快完成本单定金支付。",
    "ESSABUY_ResultPageType6": "采购商账户可用资金不足支付本单所需定金，请尽快联系采购商增加可用资金。",
    "ESSABUY_ResultPageType7": "订单免定金，请直接确认PO。",
    "ESSABUY_ConfimTips_1": "确认支付将会从可用资金扣除{0}作为本单定金，支付定金后采购商账户还剩可用资金：{1}。",
    "ESSABUY_ConfimTips_2": "确认支付将会从可用资金扣除{0}作为本单定金，支付定金后采购商账户还剩可用资金：{1}。ESSA授信该笔单{2}的金额临时满足定金支付，实际还需支付定金：{3}，该笔资金需要在支付该单尾款前支付。",
    "ChaKanKeHuZiJinXinXi": "查看客户资金信息",
    "ChaKanBaoZhengJinXinXi": "查看保证金信息",
    "ESSABUY_SubmitTips_1": "不好意思，订单已经被 {0} 确认！2s后跳转PO单详情页",
    "ESSABUY_SubmitTips_2": "确认订单成功，采购部门将尽快安排工厂生产！2秒后自动关闭，后续可以进入PO单详情页查看生产进度情况",
    "KeHuZiJinXinXi": "客户资金信息",
    "GuDingBaoZhengJinXinXi": "固定保证金信息",
    "ZhangHuBaoZhengJin": "账户保证金",
    "GuDingDingJinEDu": "固定定金额度",
    "DanBaoHuoKuanEDu2": "担保货款额度",
    "MeiYuanGuDingDingJin": "美元固定定金",
    "RenMinBiGuDingDingJin": "人民币固定定金",
    "GongChangShengChanYaoQiuZhongWenHeWaiWenBiXuTongShiSheZhi": "工厂生产要求中文和外文必须同时设置",
    "ESSAZhuYiShiXiangZhongWenHeWaiWenBiXuTongShiSheZhi": "ESSA注意事项中文和外文必须同时设置",
    "ShangPinShengChanYaoQiuZhongWenHeWaiWenBiXuTongShiSheZhi": "商品生产要求中文和外文必须同时设置",
    "ShangPinShengChanYaoQiuZhongWenHeWaiWenBiXuTongShiSheZhi2": "商品生产要求中文和外文必须同时设置，当条数据为无效数据/当条数据将不被保存",
    "DingDanShengChanYaoQiu": "订单生产要求",
    "WuPOFeiYong": "无PO费用",
    "FeiYongDanHeJi": "费用单合计",
    "JinTianXuGenJin": "今天需跟进",
    "YeWuJinTianXuGenJin": "业务今天需跟进",
    "XiaCiGenJinNeiRong": "下次跟进内容",
    "XiaCiGenJinN": "下次跟进 {0}",
    "WuWeiHuoShangPin": "无尾货商品",
    "NTianHou": "{0} 天后",
    "GenJinLiShi": "跟进历史",
    "XiaCiGenJin": "下次跟进",
    "FenPeiDeRenWu": "分配的任务",
    "XinZengGenJin": "新增跟进",
    "XinZengGenJinDengJi": "新增跟进登记",
    "DaiQueRenPI": "待确认PI",
    "ZiJinZhangHu": "资金账户",
    "KuanXuanZongJi": "款选总计",
    "KeZiYouZhiPei": "可自由支配",
    "YiDongJie": "已冻结",
    "ChuHuoHouHuiKouJianDuiYin": "用于订单出货的定金保证，出货后会扣减对应的保证金",
    "YingFuKuan": "应付款",
    "XinYongBaoZhengJinEDu": "信用保证金额度",
    "DingDanChuHuoHouTuiHaiEDu": "订单出货后扣减额度",
    "YiSuoDing": "已锁定",
    "YongYuDingDanDeDingJinDan": "用于订单的定金担保，锁定的信用保证金额度。订单支付定金后，释放相应锁定的信用额度。",
    "DingDanFuKuanHouTuiHaiEDu": "订单付款后退还额度",
    "HuanChongYinYinXingHuoHui": "缓冲因银行或汇率引起的问题",
    "YiDongJieMingXi": "已冻结明细",
    "XinYongEDuMingXi": "信用额度明细",
    "SouSuoJinE": "搜索金额",
    "SouSuoDingDanHaoFeiYongDa": "搜索订单号/费用单号",
    "LaiKuanHeJi": "来款合计",
    "YingFuKuanHeJi": "应付款合计",
    "YiFuKuan": "已付款",
    "QianKuan": "欠款",
    "WeiFenPei": "未分配",
    "KeDanBaoDeHuoKuan": "可担保的货款(￥)",
    "QiChuYuE": "期初余额",
    "LaiKuan": "来款",
    "LaiKuanFang": "来款方",
    "SuoYouWeiChuHuoDingDan": "所有未出货订单",
    "YiChuHuo": "已出货",
    "ZhiFuDingDanDingJin": "支付订单定金",
    "ZhiFuDingDanWeiKuan": "支付订单尾款",
    "ZhiFuDingDanQiTaFeiYong": "支付订单其他费用",
    "NGeDingDanYiZhiFuN": "{0}个订单,已支付{1}",
    "HaiQianN": "还欠{0}",
    "TiJiaoDingDanSuoDingDingJ": "提交订单，锁定定金",
    "ChuHuoKouJianBaoZhengJin": "出货扣减保证金",
    "SuoDingEDu": "锁定额度",
    "YiTuiHai": "已退还",
    "ChuangJianRiQi": "创建日期",
    "XuanZeGenJinLianXiRen": "选择跟进联系人",
    "ShangChuanFuJian": "上传附件",
    "KuanXianQiNei": "宽限期内",
    "NTianYiShang": "{0}天以上",
    "NGeYingFuYiZhiFuN": "{0}个应付,已支付{1}",
    "NGeYingFu": "{0}个应付",
    "GenJinShuoMing": "跟进说明",
    "MeiYouKeDaoChuDeShangPin": "没有可导出的商品",
    "ZiJiGenJin": "自己跟进",
    "YeWuGenJin": "业务跟进",
    "XiaCiGenJinRiQi": "下次跟进日期",
    "XiaCiGenJinNeiRongBeiWang": "下次跟进内容备忘",
    "XuanZeYaoGenJinDeYeWuYuan": "选择要跟进的业务员，支持多选（必填项）",
    "NDeDingDan": "{0} 的订单",
    "QingXuanZeGenJinLianXiRen": "请选择跟进联系人",
    "QingShuRuGenJinShuoMing": "请输入跟进说明",
    "ChuHuo1": "出货",
    "GaiBuFenEDuNiKeJiXuYongYu": "可用额度=信用保证金额度-已锁定，该部分额度你可继续用于订单的定金担保",
    "KeYongZhangHuZongJiBaoZhe": "可用=账户总计-保证金，该部分金额你可自由支配",
    "KeDanBaoHuoKuanZongE": "可担保货款总额",
    "ShengYuKeYongDanBaoEDu": "剩余可用担保额度",
    "GaiBiDingDanSuoXuHuoKuanD": "该笔订单所需货款担保",
    "KeDing": "客户订单号",
    "ZhuangXiangShangPinQingDa": "装箱商品清单",
    "WaiXiangZhang": "外箱-长",
    "WaiXiangKuan": "外箱-宽",
    "WaiXiangGao": "外箱-高",
    "NeiXiangShu": "内箱数",
    "Essaone_PingTaiYinSiZhengCe": "隐私政策",
    "NinYouDingDanZaiDanBaoZho": "您有订单在担保中，请先处理",
    "ShenQingChaoXin": "申请超信",
    "ChuLiChaoXinShenQing": "处理超信申请",
    "ChaEShuMu": "差额数目",
    "QingShuRuChaEShuMu": "请输入差额数目",
    "YuJiHaiKuanRiQi": "预计还款日期",
    "QingXuanZeYuJiHaiKuanRiQi": "请选择预计还款日期",
    "ShenQingYuanYin": "申请原因",
    "QingShuRuShenQingYuanYin": "请输入申请原因",
    "QingShuRuBuTongGuoYuanYin": "请输入不通过原因（必填）",
    "ShenHeYiJian": "审核意见",
    "TongGuo": "通过",
    "BuTongGuo": "不通过",
    "DaiChuLiChaoXinShenQing": "待处理超信申请",
    "QueDingXiuGaiDingDanYaoQi": "确定/修改订单要求",
    "YiShenQingChaoXinDengDaiS": "已申请超信，等待审核",
    "ShangCiShenHeBuTongGuo": "上次审核不通过",
    "DingDanXuYaoZhiFuDingJin": "订单需要支付定金 {0}",
    "DingDanXuYaoZhiFuWeiKuan": "订单需要支付尾款 {0}",
    "QingTianXieShenHeYiJian": "请填写审核意见",
    "QingShuRuBuTongGuoYuanYin2": "请输入不通过原因",
    "DingJinTuiHai": "定金退还",
    "QueRenBuManJuChuHuo2": "确认不满柜出货",
    "WaiXiangTiJiAndMaoZhong": "外箱体积&毛重",
    "ChaKanHeTongXinXi": "查看合同信息",
    "MeiZhiChanPinDouXuYaoTieTieZhi": "每只产品都需要贴贴纸",
    "YuZhuangJuRiQi": "预装柜日期",
    "DaiSheZhi": "待设置",
    "YuJiZhuangGuiShiJian": "预计装柜时间",
    "QingShuRuZhengQueDeChaESh": "请输入正确的差额数目",
    "ChaEShuMuBuNengDaYuFeiYon": "差额数目不能大于费用金额",
    "XinZengKeHuXinXi1": "新增客户信息",
    "BianJiKeHuXinXi1": "编辑客户信息",
    "DingDanDaiChuLi": "订单待处理",
    "ShenQingChaoXinJiLu": "申请超信记录",
    "ZhiChiDanGeWenJianBuNengC": "支持{0}，单个文件不能超过{1}M，最多支持 {2} 个文件",
    "ShenHeXiangQing": "审核详情",
    "GouWuQuanKeDuiHuanLiPin": "购物券可兑换礼品",
    "MaShangShengQian": "马上省钱",
    "DiKouDuiHuan": "50% 抵扣，50% 兑换",
    "QuanBuDuiHuanGouWuQuan": "全部兑换购物券",
    "JiFenContent4": "当前积分余额 0，请获取积分后再使用。",
    "JiFenContent1": "当前积分余额 {0}，使用{1} 积分，50% 用于订单抵扣 {2} 用于兑换购物券 {3}（存入购物券）。",
    "JiFenTip1": "50% 抵扣，50% 兑换：每笔订单最多抵扣订单金额的{0}%，其中{1}%用于订单抵扣，{2}%兑换成购物券。",
    "JiFenContent2": "当前积分余额 {0}，使用{1} 积分，全部兑换购物券 {2}。",
    "JiFenTip2": "全部兑换购物券：每笔订单最多抵扣订单金额的 {0}% 兑换成购物券。",
    "JiFenContent3": "当前积分余额 {0}，本次订单不使用积分。积分并非永久有效，建议及时使用。",
    "PingJia": "评价",
    "FaBiaoPingLun": "发表评论",
    "ChaKanWoDeGouWuQuan": "查看我的购物券",
    "BenDingDanPingJiaHouKeJia": "本订单评价后可奖励 {0} 购物券",
    "BenDingDanPingJiaJiangLiG": "本订单评价奖励 {0} 购物券",
    "PingJiaChengGong": "评价成功",
    "WoDeGouWuQuan": "我的购物券",
    "GouWuQuanMingXi": "购物券明细",
    "QueRenDuiHuan": "确认兑换",
    "YiDanQueRenDuiHuanHouJian": "一旦确认兑换后，将无法撤销，请确认信息后再兑换。兑换后你专属销售经理会主动联系你，30天内会送达你指定地址，请等待收货。",
    "DuiHuanChengGong": "兑换成功",
    "DuiHuanShiBaiGouWuQuanBuZ": "兑换失败，购物券不足",
    "JiaRuShiJian2": "加入时间",
    "1001GP0019": "商品信息不存在",
    "DuiHuanJiaZhiYiChaoGuoNin": "兑换价值已超过您的购物券余额",
    "YongJiuShanChuDingDanXinX": "永久删除订单信息",
    "ShanChuDingDanJiLu": "删除订单记录",
    "GouWuQuanDingDan": "购物券订单",
    "FaHuo": "发货",
    "ChaKanFaHuoXinXi": "查看发货信息",
    "BuTuiKuanYiZaiQiTaRenWuTu": "无需退款",
    "ChuFaDi": "出发地",
    "YunFeiFuKuanDan": "运费付款单",
    "YunFeiZongJi": "运费总计",
    "YunFeiDanShangWeiSheZhi": "运费单尚未设置",
    "AnXinPin": "按新品",
    "AnJiaGe": "按价格",
    "AnHuoQi": "按货期",
    "QingXuanZeShiFouRangKeHuQ": "请选择是否让客户确认 PO",
    "YiXuanTiaoJian": "已选条件",
    "JiJiangDaoZhangGouWuQuan": "即将到账购物券 {0}。",
    "FaHuoXinXi": "发货信息",
    "FaHuoDanPingZheng": "发货单凭证",
    "TuPianDanGeWenJianBuNengC": "图片jpeg,jpg,png,bmp，单个文件不能超过{0}m，最多 {1} 张",
    "BuNengQuanBuPingJiaXing": "不能全部评价5星",
    "KeHuShiYongLeYouHui": "客户使用了优惠",
    "JiFenContent5": "当前积分余额 {0}",
    "QingShangChuanFaHuoDanPin": "请上传发货单凭证",
    "JinNTianChaKanShangPin": "近 {0} 天查看商品",
    "YongJiuShanChuDingDanXinX2": "永久删除订单信息，但商品依然发送",
    "QingXuanZeShiFouShiYongJi": "请选择是否使用积分",
    "YouHuiDeJinEYiJunTanDaoSh": "优惠的金额已均摊到商品单价",
    "DengDaiKeHuQueRenShiFouSh": "等待客户确认是否使用优惠券或积分。请您谨慎操作确认PO，你一旦确认PO，客户将无法再使用优惠券或积分。",
    "BuHuoChiShangPin": "补货池商品",
    "DingDanShuJuYiJingBianDongQingShuaXinHou1": "1. 停留页面时间太长，提交订单的商品已发生变化。<br /> 2. 提交的商品含有异常，或不满足下单要求：订购量不满足工厂的起送量，订购量达不到MOQ。<br /> 3. 请刷新后重新核对商品，或返回购物车重新提交订单。<br />",
    "ZhengJuPaiDan": "整柜排单",
    "RuXiGuanAnJiJuXiaDanKeXua": "如习惯按集柜下单，可选择【整柜排单】",
    "PinJuZhiNengCaoZuoZiJiZha": "拼柜只能操作自己账号加购的商品",
    "ShuXiDeGongNeng": "Hi，熟悉的功能！",
    "RuXiGuanAnZhengJuXiaDanKe": "如习惯按整柜下单，可选择【整柜排单】进行下单。如果大批量商品下单后再考虑装柜出货，建议直接下单。",
    "DingDanDeShangPinZhuanXia": "订单 %s 的商品%s转现存尾货 退还",
    "DingDanDeShangPinZhuanZai": "订单 %s 的商品%s转在途尾货 退还",
    "XiaDanDuiHuanGouWuQuan": "essa下单兑换购物券",
    "XiaDanDiKouJinE": "essa下单抵扣金额",
    "NTianQian": "{0}天前",
    "NJiFenJiJiangZaiNGuoQiQing": "{0}积分即将在{1}过期， 请尽快使用！",
    "WenJianMingMingGeShi": "文件命名格式",
    "GongChangMingChengShangPi": "工厂名称_商品货号",
    "TuPianDaXiao": "图片大小",
    "ShangPinBianHao2": "商品编号",
    "XiuGaiBaoJiaDanXinXi": "修改报价单信息",
    "NiHaiMeiYouTianXieGaiKeHu": "你还没有填写该客户的分析报告，逾期未填写将解绑客户。",
    "TianXieFenXiBaoGao": "填写分析报告",
    "XiuGaiFenXiBaoGao": "修改分析报告",
    "XinZengFenXiBaoGao": "新增分析报告",
    "ShangYiNianDuChengJiaoFen": "上一年度成交分布",
    "XianYouMuBiao": "现有目标",
    "PingGuDeMuBiao": "评估的目标",
    "TuiJianPinLv": "推荐频率",
    "DingJiaCeLve": "定价策略",
    "QingShuRuTuiJianPinLvShiL": "请输入推荐频率，示例：一月3次",
    "DiYiJiDu": "第一季度",
    "DiErJiDu": "第二季度",
    "DiSanJiDu": "第三季度",
    "DiSiJiDu": "第四季度",
    "QingShuRuDingJiaCeLveShiL": "请输入定价策略，示例：客户热销款不加价，其他加8个点；客户需求变动多，一口价，要留空间，建议加15个点。",
    "XuanPinCeLve": "选品策略",
    "QingShuRuXuanPinCeLveShiL": "请输入选品策略。参考以下维度：1，主推的小品类，包装方式，价位。2，商品选品主打类型，如：新品，性价比高，找替代商品，功能奇特，包装新颖，卡价位等。3，主推单品，还是主推系列。4，每款推品的数量",
    "JiaoYiTiaoJianCeLve": "交易条件策略",
    "QingShuRuJiaoYiTiaoJianCe": "请输入交易条件策略，示例：客户目前所有供应商都支持客户账期，需要直接谈账期支持；客户目前合作都以30%订金方式，可直接做发货前30%，给客户资金多一个月的时间周转。",
    "ZhuanHuaZhouQiMuBiao": "转化周期目标",
    "QingShuRuZhuanHuaZhouQiMu": "请输入转化周期目标，如：一个月，2个月，半年。",
    "KeHuGuanZhuDengJi": "客户关注等级",
    "QingShuRuKeHuGuanZhuDengJ": "请输入客户关注等级",
    "TiJiaoFenXiBaoGao": "提交分析报告",
    "JinNianDuMuBiao": "今年度目标",
    "RuGuoLinJinNianMoYunXuTia": "如果临近年末，允许填0",
    "JunTanDaoJiDuMuBiao": "均摊到季度目标",
    "RuGuoLinJinJiDuMoYunXuTia": "如果临近季度末，允许填0",
    "ZanMeiLiShiMuBiao": "暂没历史目标",
    "NianDuMuBiao": "年度目标",
    "YiGuoBuYongTian": "已过，不用填",
    "QingShuRuJinNianDuMuBiao": "请输入今年度目标",
    "ZhaoYangYiBanHuiZaiTianNe": "找样一般会在5天内回复，请留意结果通知。",
    "ZhengMian": "正面",
    "QingShangChuanZhengMian": "请上传正面",
    "BeiMian": "背面",
    "QingShangChuanBeiMian": "请上传背面",
    "QingShuRuMiaoShuLiRuGongN": "请输入描述，例如功能、颜色、材质、品牌、包装、商品网址等",
    "BiXuYuTuPianShangPinYiZhi": "必须与图片商品一致",
    "BiXuDaiShangPinZhengShu": "必须带商品证书",
    "ShangPinJiaGeBuChaoGuo": "商品价格不超过",
    "ZhiShaoShangChuanYiZhangT": "至少上传一张图片或填写说明",
    "ShangChuanShangPinTuPian": "上传商品图片",
    "RenWuWanCheng": "任务完结",
    "YouZhaoDao": "有找到",
    "QueRenChuHuoChengGong": "确认出货成功",
    "YuJiCaiGouLiang": "预计采购量",
    "QingTianXieYuJiCaiGouLian": "请填写预计采购量",
    "NianDuMuBiaoYuJiDuMuBiaoJ": "年度目标与季度目标金额总和不一致",
    "YouXiangXiaoYanChengGong": "邮箱校验成功",
    "YouChengJiao": "有成交",
    "ZhongYaoXiaoXi": "重要消息",
    "ShengNTianTianXieKeHuKaiFa": "剩{0}天填写客户开发报告，逾期填写将解绑客户",
    "QuTianXie": "去填写",
    "ShangWeiSheZhiXiaoShouHeT": "尚未设置销售合同",
    "NiYiZhuDongFangQiGenJinGa": "你已主动放弃跟进该客户，等待解绑中。客户已经进入半公开状态，可能会被其他销售经理跟进。",
    "YiShenQingGenJinKeHuDengD": "已申请跟进客户，等待客户确认中。",
    "KeHuShuJuGaiLan": "客户数据概览",
    "GengDuoDongTaiXinXiQingQi": "更多动态信息，请前往{0}查看",
    "MuBiaoWanCheng": "目标完成",
    "NianDuMuBiaoQingKuang": "年度目标情况",
    "NianDuDingHuo": "年度订货",
    "XiaoShouQuDaoXiangXiXinXi": "销售渠道详细信息",
    "ZhuCeCaiGouPinLei": "注册采购品类",
    "RenZhengCaiGouPinLei": "认证采购品类",
    "CaiGouPinLv": "采购频率",
    "DanKuanCaiGouXiangShu": "单款采购箱数",
    "YingYuJiaoLiu": "英语交流",
    "QingGuanFangShi": "清关方式",
    "HaiGuanJinKouGuiMo": "海关进口规模",
    "Hui": "会",
    "BuHui": "不会",
    "HuiGuan": "灰关",
    "BaiGuan": "白关",
    "YiNianZaiZhongGuoDeJinKou": "一年在中国的进口额",
    "GongSiQiTaZhuTi": "公司其他主体",
    "GongSiDianMianShuLiang": "公司店面数量",
    "GongSiDianMianZhanTingFen": "公司店面/展厅分布城市",
    "ZanWeiWanShan": "暂未完善",
    "GongSiBanGongDaLouZhanTin": "公司办公大楼/展厅/店面图片",
    "ShangPinJieGou": "商品结构",
    "ChanPinDangCi": "产品档次",
    "BaoZhuangLeiXingXiHuan": "包装类型喜欢",
    "TianJiaTuPian": "添加图片",
    "KeHuPinPai": "客户品牌",
    "ZhuYaoXiaoShouChengShiDia": "主要销售城市/店面地址",
    "BanGongDiZhi": "办公地址",
    "KeHuTouXiangHuoHeYing": "客户头像或合影",
    "ZuiXinBeiZhu": "最新备注",
    "ChaKanQuanBuBeiZhu": "查看全部备注",
    "XunJiaYuJiaoYi": "询价与交易",
    "ShouQu": "收取",
    "BuShouQu": "不收取",
    "ChongDan": "冲单",
    "BuChongDan": "不冲单",
    "ZhongSuanJiaGeChongDan": "重算价格(冲单)",
    "XinKeShouNianYouHuiJiYouH": "新客首年优惠(及优惠结束时间)",
    "JieShu": "结束",
    "HeTong": "合同",
    "YouXiao": "有效",
    "ShanChuHouBuKeHuiFuShiFou": "删除后不可恢复，是否确定要删除？",
    "XiuGaiXinXi": "修改信息",
    "ZhuZhangHao": "主账号",
    "ZiZhangHao": "子账号",
    "ZhuYingCaiGouLeiMu": "主营采购类目",
    "MingPian": "名片",
    "QingTianXieYouXiang": "请填写邮箱",
    "XinZengLianXiFangShi": "新增联系方式",
    "XiuGaiLianXiFangShi": "修改联系方式",
    "SheZhiGaiZhangHaoWeiZhuZh": "设置该账号为主账号，将替换已有主账号",
    "XuanZeShuLiangYiChaoGuoGe": "选择数量已超过5个，请取消部分选择后再继续",
    "NinTianXieDeYouXiangYouWu": "您填写的邮箱有误",
    "SheZhiWeiZhuZhangHaoDangQ": "设置为主账号，当前账号未激活",
    "SheZhiWeiZhuZhangHao": "设置为主账号",
    "YouXiangZhenWeiWeiZhi": "邮箱真伪未知",
    "YouXiangYiYanZheng": "邮箱已验证",
    "YouTianXieXiuGaiWuTianXie": "有填写修改无填写不修改",
    "QingXuanZeCaiGouLeiMu": "请选择采购类目",
    "DaiChuLiGouWuQuanDingDan": "待处理购物券订单",
    "NTiJiaoDengDaiZhuGuanShenH": "{0} 提交，等待主管审核中",
    "YiShenHeTongGuoXiuGaiJian": "已审核通过。修改将重新审核。",
    "ShouJiHaoChongFu": "手机号重复",
    "ZhangHaoChongFu": "账号重复",
    "YiShenQingGenJinChaKanXia": "已申请跟进，查看详情",
    "ZhaoYangRenWuYouGengXin": "找样任务有更新",
    "ShangPinJingLiYiGengXinZh": "商品经理已更新找样任务，请查看！",
    "QingWanShanWeiTianXieDeSh": "请完善未填写的社媒信息",
    "ShangPinJieGouPinLeiShuLi": "商品结构品类数量最大制5，请检查您选择的品类",
    "QingWanShanKeHuXiangXiXin": "请完善客户详细信息",
    "LianXiKeHuJingLi": "联系商品经理",
    "GongSiSheMeiXinXiZhongFu": "公司社媒信息重复",
    "YiFenXiXuQiuPinLeiJingLiZ": "已分析需求，品类经理正在为你找样中",
    "QiTaLianXiFangShiZhongFu": "其他联系方式重复",
    "WeiNiZhaoDaoDeYangPinGong": "为你找到的样品，共 {0} 款",
    "BianJiGongSiXinXi": "编辑公司信息",
    "YouXinHuiFu": "有新回复",
    "QingXuanZeGongSiLeiXingYu": "请选择公司类型（原渠道）",
    "ZhangHuWeiTongGuoPingTaiR": "账户未通过平台认证，找样任务暂无法获得回复，请稍等完成认证。",
    "QingTianXieGongSiQiTaZhuT": "请填写公司其他主体",
    "LianXiShangPinJingLi": "联系商品经理",
    "QingXuanZeZhuCeCaiGouPinL": "请选择注册采购品类",
    "RenZhengZhuYaoCaiGouPinLe": "认证主要采购品类",
    "QingXuanZeRenZhengZhuYaoC": "请选择认证主要采购品类",
    "ZhengJu": "整柜",
    "HuiYingYu": "会英语",
    "BuHuiYingYu": "不会英语",
    "TuPianShiPinDanGeWenJianB": "图片/视频（mp4,flv,jpeg.jpg.png,bmp），单个文件不能超过20M，最多10个",
    "KeHuShangPinJieGou": "客户商品结构",
    "QingMiaoShuPinLeiDeJiaGeQ": "请描述品类的价格区间，注意备注币种",
    "QingMiaoShuPinLeiDeChanPi": "请描述品类的产品档次",
    "PinPaiZhuYingLeiMu": "品牌主营类目",
    "QingXuanZeKeHuPinPaiLeiMu": "请选择客户品牌类目",
    "PinPaiBeiZhu": "品牌备注",
    "GongSiSheMei": "公司社媒",
    "KeHuTouXiangHeYingXiangPi": "客户头像/合影相片",
    "BiXuYuTuPianYiZhi": "必须与图片一致",
    "BiXuDaiZhengShu": "必须带证书",
    "YuJiCaiGou": "预计采购 {0} PCS",
    "DiYu": "低于 {0}",
    "XunJiaSheZhi": "询价设置",
    "QingShuRuFanDianLv": "请输入返点率",
    "BuQiYong": "不启用",
    "ShiFouZhongSuanJiaGeChong": "是否重算价格（冲单）",
    "XianZhiZhiNengXiuGaiHouXu": "限制只能 3%- 15%，修改后需要审核。特殊要求请联系业务主管处理",
    "KeHuDingDanDuiGongChangDe": "客户订单对工厂的账期天数，如有填写的则询价，FO单接单等都将按照此账期执行，将影响工厂请款换单时间",
    "GongChangZhangQi": "工厂账期",
    "YuKeHuJieSuanDeZhangQiTia": "与客户结算的账期天数，将影响客户应收款的到期日等",
    "KeHuZhangQi": "客户账期",
    "DangYiCaiCaiGouZhongXinXu": "当宜采采购中心询价后的价格比询价前高时，如果不对询价后涨价进行再次协商谈判则选择不需要审核，如果询价后涨价需要亲自向工厂进行协商谈判价格的则选择需要审核",
    "RenMinBiJiaoYi": "人民币交易",
    "MeiYuanJiaoYi": "美元交易",
    "QingTianXieZhangQiXinXi": "请填写账期信息",
    "QingXuanZeFanDianLv": "请选择返点率",
    "XiuGaiXunJiaHeJiaoYiXinXi": "修改询价和交易信息",
    "QianWanChengHuiFu": "{0} 前完成回复",
    "DangJiMuBiaoQingKuang": "当季目标情况",
    "DangJiMuBiao": "当季目标",
    "DangJiDingHuo": "当季订货",
    "GuanLiHeTong": "管理合同",
    "PinLeiJingLiZhengZaiWeiNi": "品类经理正在为你找样中",
    "BaoQianWoMenMeiYouZhaoDao": "抱歉，我们没有找到合适的商品",
    "YiQuanBuZhaoWanGongZhaoDa": "{0} 已全部找完，共找到 {1} 款",
    "YouGengXinGongZhaoDaoKuan": "{0} 有更新，共找到 {1} 款",
    "QingWanShanWeiTianXieDeQi": "请完善未填写的其他联系方式",
    "QingQueRenZhangHaoXinXiDe": "请确认账号信息的手机号码是否完整？",
    "QingXianXuanZeRenZhengCai": "请先选择认证采购类目",
    "YuanYouMuBiao": "原有目标",
    "WeiShengXiao": "未生效",
    "ZhangHaoLianXiRenXinXi": "账号/联系人信息",
    "FenXiBaoGao": "分析报告",
    "GongGongChi": "公共池",
    "KeHuXiangQing": "客户详情",
    "TianXieDeBeiZhuBuNengWeiK": "填写的备注不能为空",
    "QuanBuBeiZhu": "全部备注",
    "TianJiaBeiZhu": "添加备注",
    "ShiFouShanChuGaiBeiZhu": "是否删除该备注？",
    "ShangChuanPinPai": "上传品牌logo",
    "WanChengBiLi": "完成比例",
    "PiLiangJiaRuXuanPinChi": "批量加入选品池",
    "DaiShenHeFenXiBaoGao": "审核分析报告",
    "ChanPinDangCiShiZhiKeHuSu": "产品档次是指客户所销售产品的质量和市场定位，可以参考使用的材料、技术、品牌知名度高低、主要面向市场等维度去判断中高低端",
    "HeTongkeyMsg": "合同编号感叹号信息",
    "HeTongeffectiveTimeMsg": "合同在有效期内，提交订单才可以选取关联到对应的合同，请注意填写的有效期范围",
    "HeTongcompanyNameMsg": "发票及其他单证使用，请正确填写以免影响使用",
    "HeTongcontactNameMsg": "发票及其他单证使用，请正确填写以免影响使用",
    "HeTongmobileMsg": "发票及其他单证使用，请正确填写以免影响使用",
    "HeTongcompanyAddressMsg": "发票及其他单证使用，请正确填写以免影响使用",
    "ShenQingRen": "申请人",
    "JiJiangLiuShiKeHu": "即将流失客户",
    "YiLiuShiKeHu": "已流失客户",
    "HeTongbankInfoMsg": "发票及其他单证使用，请正确填写以免影响使用",
    "HeTongbankAccountMsg": "发票及其他单证使用，请正确填写以免影响使用",
    "HeTongswiftCodeMsg": "发票及其他单证使用，请正确填写以免影响使用",
    "HeTongpayConditionRemarkMsg": "此部分将应用显示到 发票中的 Terms of payment 请正确填写",
    "HeTongshippingRemarkMsg": "如果客户货物装柜及相关物流有合作要求的需告知物流部门的，请详细填写，船务接收到的船务资料信息有做对应的提醒和展示",
    "HeTongfinRemarkMsg": "财务合作要求备注",
    "HeTongpurchaseRemarkMsg": "如果客户的采购及生产要求需要特别强调及通知采购部门的，请详细填写，对应的工厂单界面和跟单界面有做对应的提醒和展示",
    "HeTongdocumentaryRemarkMsg": "如果客户的采购及生产要求需要特别强调及通知采购部门的，请详细填写，对应的工厂单界面和跟单界面有做对应的提醒和展示",
    "HeTongwarehouseRemarkMsg": "如果客户对质检收货需要特别合作要求通知仓储部门的，请详细填写，系统跟单界面和收货清单中有做对应的提醒和展示",
    "HeTongcustomerServiceRemarkMsg": "对于客户合作备注需要业务/买手主要的，请详细填写",
    "HeTongsigningCompanyIdMsg": "我司签约主体在系统报关、船务、财务发票等单证都有多处应用，请准确选择",
    "ShangPinJingLiHuiFuLeXinD": "商品经理回复了新的消息",
    "ZuiHouJiaGouShiJian": "最后加购时间",
    "ZuiHouGenJinMaiShou": "最后跟进买手",
    "YiLiuShi": "已流失",
    "JiJiangLiuShi": "即将流失",
    "LiuShiShiJian": "流失时间",
    "QuShenHe": "去审核",
    "HeTongpaymentTypeMsg": "读取显示客户交易信息中的结算方式",
    "HeTongfileListMsg": "合同附件",
    "SouSuoKeHuMingZiBianMaYou": "搜索客户名字/编码/邮箱",
    "HeTongcodeMsg": "合同编码",
    "ShangJiDuWanCheng": "上季度完成",
    "YiNianZhongGuoJinKouE": "一年中国进口额",
    "QingShuRuCaiGouPinLv": "请输入采购频率",
    "NiKeYiChangShiShiYongJiao": "你可以尝试使用较少关键字或不同关键字，或者发起找样",
    "QingTianXieZhenShiYuJiCai": "请填写真实预计采购量。如果填写的与实际差异太大，将会出现价格不准确、不符合最低起订量等情况。",
    "DaiGenJin": "待跟进",
    "BieRenGenJin": "别人跟进",
    "WoDeGenJin": "我的跟进",
    "RenWuBianHao": "任务编号",
    "DaiTianXieFenXiBaoGao": "待填写分析报告",
    "WeiTianXieBaoGao": "未填写报告",
    "YiYuQi": "已逾期",
    "ShengTianTianXieKeHuFenXi": "剩{0}天填写客户分析报告，逾期填写将解绑客户",
    "SouSuoKeHuMingZiYouXiang": "搜索客户名字/邮箱",
    "NianDuMuBiaoBuKeDaYuJiDuM": "年度目标不可大于 {0},季度目标总和不可大于 {0}",
    "LianXiKeHu": "联系客户",
    "KeHuFenXiBaoGaoTianXieYuQ": "客户分析报告填写逾期，转弱绑。",
    "ZhuGuanDaiBan": "主管待办",
    "ChangYongYuYan": "常用语言",
    "WoYaoGenJin": "我要跟进",
    "ZhaoYangRenWu": "找样任务",
    "GenJinChengGong": "跟进成功",
    "TuPianDanGeWenJianBuNeng2": "图片jpeg.jpg.png,bmp，单个文件不能超过10M",
    "JiJiangShengChengDingDan": "即将生成订单",
    "JiaoYiXinXiYiXiuGaiDengDa": "交易信息已修改，等待审核中。",
    "FuWuFeiLvDingJinFangShiXi": "服务费率、定金方式信息修改，需要主管审核后才能生效。",
    "DaiShenHeJiaoYiXinXi": "待审核交易信息",
    "TianXieBuTongGuoYuanYin": "填写不同过原因",
    "QueRenBianGengXinXi": "确认变更信息",
    "YiTongGuo": "已通过",
    "ShenHeJiaoYiXinXiBianGeng": "审核交易信息变更",
    "BuTongGuoYuanYin": "不通过原因",
    "GaiCheng": "改成",
    "img_upload_400": "图片尺寸须>=100px,<=4096px,并且小于4MB",
    "img_upload_403": "操作太频繁了,请稍候在试",
    "KaiTongESSAONE": "开通ESSAONE",
    "YiShenQing": "已申请",
    "WeiShenQing": "未申请",
    "YiKaiTong": "已开通",
    "WeiKaiTong": "未开通",
    "DDPJiaGe": "DDP价格",
    "KeHuKeXiangYouHuiXinTuoCh": "客户可享优惠（新拓产品）",
    "JiaRuTuiJian": "加入推荐",
    "DaiLiShangZiYuanShangDaiB": "代理商&资源商待办",
    "NiLeiJiTuiJianKuanShangPi": "你累计推荐 {0} 款商品，{1} 款被选中，选品率 {2}%",
    "TiaoXuanShangPin": "挑选商品",
    "JuLiFaBuYiDengDaiTian": "距离发布已等待 {0} 天",
    "ZhaoDaoKuanKeHuJiaGouKuan": "找到 {0} 款，客户加购 {1} 款",
    "ZhaoYangShengYuTian": "找样剩余 {0} 天",
    "KeHuMeiYouLiuYan": "客户没有留言",
    "KeHuYouXinLiuYanQingLiuYi": "客户有新留言，请留意！！",
    "KeHuYouLiuYan": "客户有留言",
    "ZhaoYangRenWuChi": "找样任务池",
    "DangQianRenWuGenJin": "当前任务跟进",
    "ShangPinBanQuan": "商品版权",
    "YiChuXuanPin": "移除选品",
    "ZhiDingShangPinKeYong2": "指定商品 {0} 可用",
    "QingKongXuanPin": "清空选品",
    "XuanPinZhuangTai": "选品状态",
    "PinLeiJingLi": "品类经理",
    "DangQianYouHuiQuanBuYunXu": "当前优惠券不允许叠加积分。",
    "XuYaoGenJinRenWuHouCaiNen": "需要跟进任务后才能操作。",
    "NDeZhaoYang": "{0} 的找样",
    "QueRenMiMa": "确认密码",
    "TianJiaYuanGongZhangHao": "添加员工账号",
    "ZhaoYangGuanLi": "找样管理",
    "DangQianShangPin": "当前商品",
    "XiaDanZuiGaoKeXiangZheKou": "下单最高可享 5% 折扣",
    "NHouYiYouHuiQuanXingShiFaF": "{0} 后，优惠券将发放。请在“我的优惠券”查看。",
    "YiDaoGangRiQi": "已到港日期",
    "TuiJianChengGong": "推荐成功",
    "YiChuChengGong": "移除成功",
    "FaJianRenMaiJia": "发件人/卖家",
    "QingZhuCeDengLuZhangHaoHo": "请注册登录账号后使用",
    "YiCaiXuanPinXiaoQi": "宜采选品-小七",
    "ZhuXiaoZhangHao": "注销账号",
    "BaoHuShangPinChaKanShenQi": "保护商品查看申请",
    "ZhuZhangHaoQingSheZhiQiTa": "主账号请设置其他员工账号为BOSS主账号后才能注销。",
    "QianWangYuanGongZhangHaoG": "前往员工账号管理",
    "YuanGongTouXiang": "员工头像",
    "MoRenMiMaShiYuanGongDianH": "默认密码是员工电话",
    "YongHuLeiXing": "用户类型",
    "LaXinYeWu": "拉新业务",
    "LaShengYeWu": "拉升业务",
    "MaiShou": "买手",
    "PuTongYongHu": "普通用户",
    "QingXuanZeYongHuLeiXing": "请选择用户类型",
    "MaiShouDengJi": "买手等级",
    "QingXuanZeMaiShouDengJi": "请选择买手等级",
    "KaiFaKeHuShu": "开发客户数",
    "QingTianXieKaiFaKeHuShu": "请填写开发客户数",
    "QingTianXieDaYuHuoDengYuD": "请填写大于或等于0的整数",
    "NRiLiuLanShangPinShu": "{0}日 浏览商品数",
    "QingWanShanDanJuDingJinBi": "请完善单柜定金比例",
    "QingWanShanDingJinZhiFuSh": "请完善 定金支付时间",
    "ZhuGongShiChangHeZhuGongQ": "请注意：主攻市场和主攻区域，一年只允许修改一次",
    "WoYiQingChu": "我已清楚",
    "YiNianZiRanNianZhiYunXuXi": "请注意：一年（自然年）只允许修改一次",
    "ShangCiXiuGai": "上次修改",
    "ShuJuYinQingJiangGenJuNiS": "数据引擎将根据你所选的市场和区域展示数据。",
    "ZhenShiZhunQueTianXieZhuG": "真实准确填写主攻市场和区域，能获得精准的商品推荐，支持多选",
    "PCS": "PCS",
    "YouJiHuiYingDeYouHuiQuan": "有机会赢得5%优惠券",
    "MeiZhouYiGengXin": "每周一更新",
    "QuYuShuJuQingBao": "区域数据情报（近4周）",
    "XiuGaiZhuGongQuYu": "修改主攻区域",
    "XuanPinPinLeiTop": "选品品类TOP 10",
    "XunPanPinLeiTop": "询盘品类TOP 5",
    "JinTianNeiMaoYiShangYiJia": "近30天内贸易商议价商品最多的top5类目",
    "ShangXinPinLeiTop": "上新品类TOP 10",
    "JinTianNeiPingTaiShangXin": "近30天内平台上新商品最多的top10类目",
    "ReMaiGongYingShangTop": "热卖供应商TOP 6",
    "JinTianNeiPingTaiShangJia": "近30天内平台上加购商品数量top6的工厂",
    "JinKeChaKanQingBaoChiHuoY": "仅VIP可查看,请保持活跃升级为VIP",
    "LeiJiDengLuNTianShuTianYiS": "累计登录天数{0}天以上",
    "XuanPinNKuanHuoXunJiaNKuan": "选品{0}款或询价{1}款以上",
    "YiCaiXuanPinShuJuYinQingK": "宜采选品数据引擎，可以查看主攻区域的客户选品趋势，洞察市场先机。",
    "WeiXinSaoYiSaoMianFeiJieS": "微信扫一扫，免费解锁商品最新价格",
    "XianShiFuLiSaoMaLingDuJia": "限时福利，扫码领独家新品清单",
    "MianFeiLingZhangShangPinG": "免费领200张商品高清图",
    "MianFeiJieSuoShangPinZuiX": "免费，解锁商品最新价格",
    "MianFeiLingZhangShangPinG2": "免费，领200张商品高清图",
    "DangQianCunZaiWeiShenHeJiLuWuFaChongFuTianJiaJiLu": "当前存在未审核记录无法重复添加记录",
    "ZiChanHeXinYong": "资产和信用",
    "ShuBaiJiaZhiMingMaoYiGong": "数百家知名贸易公司在用",
    "YaoZhaoShenMe": "要找什么?",
    "QingJianDanShuoMingYaoZha": "请简单说明要找什么",
    "ZhiChiTuPianDanWenJianZui": "支持图片，单文件最大支持10M，最多上传5个文件",
    "GengXiangXiDeShangPinXinX": "更详细的商品信息，例如功能、颜色、材质、指定的品牌、包装要求等",
    "ZuiDi": "最低",
    "ZuiGao": "最高",
    "ZhaoYangFaBuHouTianJieZhi": "找样发布后{0}天截止，最快30分钟即可收到工厂回复",
    "LeJieXinYongTiXi": "了解 ESSA 信用体系",
    "XinYongFenShu": "信用分数",
    "XinYongTiXiShuoMing": "信用体系说明",
    "ZuiJinMeiYouBianDong": "最近没有变动",
    "ZuiJinBianDong": "最近变动",
    "ZhangQiTianShu": "账期天数",
    "ZhangQiLiXiJiSuanFangShi": "账期利息计算方式",
    "ZhangQiJiSuanBiaoZhun": "账期计算标准",
    "OAEDu": "OA 额度",
    "ShenQingOA": "申请 OA",
    "XinYongDaDaoFenKeShenQing": "信用达到 {0} 分可申请",
    "YiManZu": "已满足",
    "ChaKanOAXiangQing": "查看 OA 详情",
    "ShenQingTiShengEDu": "申请提升额度",
    "NTianNeiBuShiYongXuZhongXi": "{0} 天内不使用需重新申请",
    "ZhuGuanShenHeZhong": "主管审核中",
    "CaiWuShenHeZhong": "财务审核中",
    "ZhuGuanShenHeBuTongGuo": "主管审核不通过",
    "CaiWuShenHeBuTongGuo": "财务审核不通过",
    "WeiKaiTongESSAONE": "未开通ESSAONE",
    "XinYongFen": "信用分",
    "XinYongFenMingXi": "信用分明细",
    "XunJiaXinXi": "询价信息",
    "ShiYongYouHui": "使用优惠",
    "RenZhengHouCaoZuo": "认证后操作",
    "WeiJiHuo": "未激活",
    "JiHuo": "激活",
    "ShiFouQueRenJiHuo": "是否确认激活",
    "FeiKeHuBuNengBangDing": "非ESSAONE客户不能绑定",
    "JiangChanShengPeiChangBin": "将产生赔偿，并扣除信用分 {0}",
    "TiXing": "提醒",
    "YiXiaQingKuangQuXiaoShang": "以下情况取消商品，将收取赔偿费用",
    "WuXuPeiChang": "很幸运本次取消无需赔偿，因为产品未进行生产",
    "DangQianXuPeiChangHeJi": "当前需赔偿 {0}%，合计 {1}",
    "JiangChanShengYiZhangFeiY": "将产生一张费用单收取对应的费用，请留意及时收款。",
    "QuXiaoXiangShuBuNengQuanB": "取消箱数不能全部为0",
    "FanKuiXiaoLv": "反馈效率",
    "ShenHeZhongBuNengXiuGaiFu": "交易信息已修改，等待审核中（审核中不能修改服务费率、定金方式）。",
    "XiuGaiJiaoYiXinXiShenHeBu": "修改交易信息，审核不通过",
    "ShenQingOA2": "申请OA",
    "ChaKanFeiYongDan": "查看费用单",
    "MoRenJieSuanFangShi": "默认结算方式",
    "FuWuFeiLvZhiWei": "服务费率值为3~15",
    "DangQianXuPeiChangHeJi2": "需赔偿 {0}%，合计 {1}",
    "QueDingQuXiaoShangPin": "确定取消商品",
    "ZhangQiFeiYongJiSuanFangS": "账期费用计算方式",
    "XinYongNFenYiDaBiaoKeShenQ": "信用 {0} 分已达标，可申请 OA 结算",
    "XinYongNFen": "信用 {0} 分",
    "DengDaiShenHeZhong": "等待审核中",
    "ShangCiShenQingBuTongGuo": "上次申请不通过",
    "QueDingBuZaiTiShi": "确定不再提示？",
    "ZhuangGuiWanChengHouQuXiaoTongKuanShangPinZhiNengCaoZuoYiCi": "装柜完成后取消同款商品允许操作一次",
    "HuoKuanYiHeXiaoBuNengQuXiaoShangPin": "货款已核销不能取消商品",
    "ESSAONEWangZhanJieShaoH1": "中国批发市场<br/>\n从 1 箱起直接从工厂交钥匙合作",
    "ESSAONEWangZhanJieShao2": "中国中小企业采购新经验！",
    "ESSAONEWangZhanJieShao1": "运作方式",
    "ESSAONEWangZhanJieShao3": "小批量采购的现成解决方案",
    "ESSAONEWangZhanJieShao4": "价格与交钥匙交付",
    "ESSAONEWangZhanJieShao5": "可靠的服务保障",
    "ESSAONEWangZhanJieShao6": "多种服务集中在一个地方",
    "ESSAONEWangZhanJieShao7": "与ESSAONE合作的过程",
    "ESSAONEWangZhanJieShao8": "活动信息和客户评价",
    "QingGouXuanXuYaoBuHuoDeSh": "请勾选需要补货的商品",
    "ShenQingHeZuoFangShi": "申请 OA 合作方式",
    "ZhuGuanShenHe": "主管审核",
    "CaiWuShenHe": "财务审核",
    "KeHuZhuCeHao": "客户注册号",
    "KeHuGongSiMingCheng": "客户公司名称",
    "KeHuGongSiDiZhi": "客户公司地址",
    "ShenQingEDu": "申请额度",
    "ZhangQiFeiLv": "账期费率",
    "ShenQingZhangQi": "申请帐期",
    "DaiShenHeShenQing": "待审核OA申请",
    "GongChangJieDanHouQuXiaoS": "工厂接单后取消商品，需要进行一定比例的赔偿，同时每笔费用均暂扣1分信用分，客户支付赔偿款后将恢复被暂扣的信用分。",
    "GongChangYiJieDanHuoWuZhe": "工厂已接单，货物正在生产中时取消，赔付订单中该商品总金额的10%；",
    "HuoWuShengChanWanBiShiQuX": "货物生产完毕时取消，赔付订单中该商品总金额的30%；",
    "HuoWuYiRuKuDengDaiZhuangJ": "货物已入库，等待装柜时取消，赔付订单中该商品总金额的50%；",
    "HuoWuZhuangJuWanChengHouQ": "货物装柜完成后取消，100%赔付订单中该商品的总金额。",
    "ChengShiDeBiaoZhi": "诚实的标志",
    "GuoJiaTiXi": "国家体系",
    "ShuZiBiaoJi": "数字标记",
    "ShiELuoSiShiChangShangZui": "Lighthouse（兆光科技）是俄罗斯最受欢迎、最经济实惠的市场业务开发平台。",
    "MianFeiKuoZhanGongNeng": "免费扩展选项：",
    "YiZhongJianDanDeFangFaKeY": "快速分析销售量、订单数量、价格变化等数据的简单方法 + 实时监控仓库余额、按类别划分的商品赎回百分比、监控广告拍卖和竞争对手广告价格的能力。",
    "FuFeiJiHuaTiGongEWaiDeGon": "在付费服务中，还提供了增加利润的附加工具。",
    "DuiYuNeiXieZhengZaiXunZha": "对于那些正在寻找利基市场的人",
    "QianFenWeiNaXieLeiBieZaiL": "<li>哪些类目有钱赚？</li>\n<li>在利基市场推出新产品有多容易？</li>\n<li>在哪些类别中需求超过供应？</li>\n<li>WB 上最成功的 1000 种产品</li>\n<li>哪些类别的供应商不成功？</li>",
    "DuiYuNeiXieYiJingYuShiCha": "对于已经与市场平台合作的供应商",
    "JiangChanPinTuiXiangDingF": "<li>让您的产品名列前茅</li> <li>自动计算交付量</li> <li>内部和外部分析</li> <li>搜索引擎优化</li> <li>位置监控</li> <li>广告柜和广告费率管理</li> <li>与 1C 集成</li> <li>自 2020 年起提供外部分析数据</li>",
    "RenZhengHouKeXuanPinHeHuo": "认证后可选品和获取工厂信息",
    "DengLuRenZhengHouKeChaKan": "登录认证后可查看联系方式",
    "SouSuoKeHuMingChengBianHa": "搜索客户名称/编号/联系电话",
    "QuanBuXinKeHu": "全部新客户",
    "WeiYongHuTiGongDeLiWuTian": "为用户提供的礼物 - 3 天的测试费率访问链接：",
    "QingXuanZeZhangQiTianShu": "请选择账期天数",
    "QingShuRuKeHuZhuCeHao": "请输入客户注册号",
    "QingShuRuGongSiMingCheng": "请输入公司名称",
    "QingShuRuKeHuGongSiDiZhi": "请输入客户公司地址",
    "QingShuRuShenQingEDu": "请输入申请额度",
    "QingXuanZeZhangQiLiXiJiSu": "请选择账期利息计算方式",
    "QingXuanZeZhangQiJiSuanBi": "请选择账期计算标准",
    "QingShuRuZhengQueDeShenQi": "请输入正确的申请额度，(0.01-1000000000)最多保留两位小数！",
    "XinYongFenJiangGenJuDingD": "信用分将根据订单履约情况产生变动。",
    "ShiYongJieSuanShiZaiHuoWu": "使用DP/TT结算时：在货物到港前并提前支付货款，信用分加1分。若在货物到港时间或应付款日期（以较晚者为准算起）后，超过7天仍未付款，将扣减1分。",
    "ShiYongJieSuanShiZaiZhang": "使用OA结算时：在账期到达前，提前支付货款，信用分加1分。若超出账期7天仍未支付，将扣减1分。",
    "ShangShuLiangZhongJieSuan": "上述两种结算方式中，工厂接单后取消订单/商品，均暂扣1分直至支付赔偿金。",
    "XinYongFenJiangGenJuDing": "信用分将根据订单履约情况产生变动，初始分值为90分。",
    "JiaFenZaiHuoWuDaoGangQian": "加分：在货物到港前并提前支付货款，信用分加1分。",
    "JianFenRuoZaiHuoWuDaoGang": "减分：1，若在货物到港时间或应付款日期（以较晚者为准算起）后，超过7天仍未付款，将扣减1分；2，工厂接单后取消订单/商品，暂时扣减1分直至支付赔偿金。",
    "HeZuoHanYiWoSiXianJiangHu": "OA合作含义：我司先将货物发送给采购客户，客户收到货物后需要在约定期限内付款。同时客户有“赊账”的最高金额限制，每位客户能申请到的额度将根据其自身的风险价值进行评估。",
    "ShenQingTiaoJianDangKeHuY": "申请条件：当客户信用分在{0}分及以上时，该客户可以申请OA合作。同时完成申请后，客户需要维持信用分在{1}分及以上，才可持续享受OA账期待遇。",
    "ZhangQiFenWeiTianTianTian": "OA账期：分为{0}。申请不同的账期天数将加收不同的利息，分别为{1}。",
    "XinYongTiXiYongYuDingQiPi": "ESSACHINA信用体系用于定期评估和更新客户的信用状况，判断客户OA合作风险，并用于申请OA账期和金额的审核。",
    "DangKeHuYiChengGongWanChe": "当客户信用分在{0}分及以上时，该客户可以申请OA合作。同时完成申请后，客户需要维持信用分在{1}分及以上，才可持续享受OA账期待遇。",
    "XinYongFenJiaJianGuiZeRuX": "信用分加减规则如下：",
    "KeHuShiYongJieSuanZaiHuoW": "客户使用DP/TT结算，在货物到港前并提前支付货款，信用分加1分。若在货物到港时间或应付款日期（以较晚者为准算起）后，超过7天仍未付款，将扣减1分。",
    "KeHuYiShiYongJieSuanZaiZh": "客户已使用OA结算，在账期到达前，提前支付货款，信用分加1分。若超出账期7天仍未支付，将扣减1分。",
    "CiWaiZaiShangShuLiangZhon": "此外在上述两种结算方式中，工厂接单后取消订单/商品，均暂扣1分直至客户支付赔偿金。",
    "XinKeHu": "注册客户",
    "ZuiJinFangWen": "最近访问",
    "JieDuan": "阶段",
    "DaiChuBuLianXi": "待初步联系",
    "BaoChiDuiHua": "保持对话",
    "ChengJiaoShiXian": "成交实现",
    "ChengJiaoWeiShiXian": "成交失败",
    "PiFuEDu": "批复额度",
    "PiFuZhangQiTianShu": "批复账期天数",
    "1059PR10001": "参数错误",
    "QingXuanZeKeHuJieDuan": "请选择客户阶段",
    "XiaZaiDuiZhangDan": "下载对账单",
    "YongYuDingDanChuHuoDeDing": "用于订单出货的定金保证",
    "CaiWuShenHeTongGuo": "财务审核通过",
    "ZhuGuanShenHeTongGuoDengD": "主管审核通过，等待财务审核",
    "JiangChanShengYiZhangFeiYyicaiguoji": "将产生一张费用单，需要支付对应的费用，请留意并及时联系客户经理付款",
    "GenJinKeHu": "跟进客户",
    "GongChangJieDanHouQuXiaoSyicaiguoji": "工厂接单后取消商品，需要进行一定比例的赔偿，同时每笔费用均暂扣1分信用分，在您支付赔偿款后将恢复被暂扣的信用分。",
    "DianJiChaKan": "点击查看",
    "GenJuQuXiaoShangPinPeiChangGuiZeKeHuXuZhiFuPeiChangKuan": "{0} 商品 {1} 根据取消商品赔偿规则需支付的赔偿款",
    "BenCiGenJinNeiRong": "本次跟进内容",
    "AnGongSiFeiYongDanZhiDuGu": "按公司费用单制度管理要求，晚于装柜时间的费用单无法发起",
    "ShenQingBuTongGuo": "申请不通过",
    "ZhengZaiDengDaiShenHe": "正在等待审核",
    "FeiMuBiaoKeHu": "非目标客户",
    "QingXuanZeShenHeYiJian": "请选择审核意见",
    "QingTianXieGongChangZhang": "请填写工厂账期",
    "AnZhuCeShiJian": "按注册时间",
    "AnFangWenShiJian": "按访问时间",
    "AnJiaGouShiJian": "按加购时间",
    "AnGenJinShiJian": "按跟进时间",
    "QingShuRuZhengQueDeGongCh": "请输入正确的工厂账期",
    "KeHuXinXiWanShan": "客户信息完善",
    "KeHuRenZheng": "客户认证",
    "KeHuFuHeYiXiaTiaoJianHuiZ": "客户符合以下条件会自动变为目标客户：",
    "ShiFouShiFaRenQiYeHtml": "<ul><li>必须是法人企业；</li><li>经营类目在我们范围之内</li><li>能接受1箱起订</li></ul>",
    "ShenQingTiShengEDuZhong": "申请提升额度中",
    "QuXiaoDanHao": "取消单号",
    "KeHuGenJinJieDuan": "客户跟进阶段",
    "BaoChiLianXi": "保持联系",
    "ZhuanDaoXiaYiJieDuanJianGNTian": "转到下一阶段间隔 ：{0} 天",
    "HaiShengNTianXuYaoDaChengC": "还剩 {0} 天，需要达成成交。",
    "CongZhuCeDaoShouDanChengJ": "从注册到首单成交实现，用了 {0} 天",
    "BuZaiGenJin": "不再跟进",
    "ZanWeiQueRen": "暂未确认",
    "MuBiaoYongHu2": "目标用户",
    "EDu": "额度",
    "ShiFouFaRenQiYe": "是否法人企业",
    "ShiFouXiangQiDing": "是否 1 箱起订",
    "SouSuoKeHuBianMaMingZiYou": "搜索客户编码/名字/邮箱",
    "DingDanZhongShangPinYiQua": "订单中商品已全部取消，不能再进行支付定金",
    "WoFangQiGaiKeHu": "我放弃该客户",
    "ShiYongShiJian": "使用时间",
    "ShiYongEDu": "使用额度",
    "YiLaiKuan": "已来款",
    "OAMingXi": "OA 明细",
    "ShenQingTiShengOAEDu": "申请提升 OA 额度",
    "YiChengJiaoKeHu": "成交客户",
    "ChengZhangKeHu": "成长客户",
    "LiuCunKeHu": "留存客户",
    "YuLiuShiKeHu": "预流失客户",
    "ZuiJinXiaDan": "最近下单",
    "KeHuNTianHouLiuShiQingGenJ": "客户{0}天后流失，请跟进客户完成交易",
    "ZaiYingShouZhangKuanDaoQi": "在应收账款到期日后的5天内免收利息费，超过5天后将从应收账款到期日开始计算利息，每天逾期利息费=未支付金额 * {0}‰",
    "YuQiHouMeiTianAnJiSuanLiX": "逾期后，每天按 {0}‰计算利息",
    "KeHuDeXinYongFenBuZuBuNen": "客户的信用分不足{0}，不能使用OA结算方式，本单将使用 DP(T/T) 结算。",
    "JiXuDPJieSuan": "继续DP结算",
    "YiQianHeTong": "已签合同",
    "QueRenBuZaiGenJin": "确认不再跟进？",
    "QueRenFangQiGaiKeHu": "确认放弃该客户？",
    "BangDingChengGong2": "绑定成功",
    "ZhangQiLiXiFei": "账期利息费",
    "LiXiJiangJunTanDaoShangPi": "利息将均摊到商品单价后按整单收取。订单需支付定金时，利息费用=（订单总金额-定金）x 对应账期利息费率；当订单免付定金时，利息费用=订单总金额 x 对应账期利息费率",
    "OAZhangQi": "OA账期",
    "XiuGaiYuYanXuYaoZhongQiCa": "修改语言需要重启APP才能生效",
    "WeiJiaGou": "未加购",
    "ShiFouYaoQieHuanDaoNYuYan": "是否要切换到 {0} 语言？",
    "YuYanJiaGeSheZhi": "语言 & 价格设置",
    "XuanZeQuYu": "选择区域",
    "WoDePODan": "我的PO单",
    "XiaoShouJiaSheZhi": "销售价设置",
    "XiaoShouJiaJiSuanFangShi": "销售价计算方式",
    "XianShiBiZhong": "显示币种",
    "XiaoShouJia": "销售价",
    "XianShi": "显示",
    "BuXianShi": "不显示",
    "SheZhiXiaoShouJia": "设置销售价",
    "XiuGaiXianShiBiZhong": "修改显示币种",
    "JiangTongBuXiuGaiNinDeXia": "将同步修改您的销售国家信息",
    "PingJiaDingDanFuWu": "评价订单服务",
    "XingQiYi": "星期一",
    "XingQiEr": "星期二",
    "XingQiSan": "星期三",
    "XingQiSi": "星期四",
    "XingQiWu": "星期五",
    "XingQiLiu": "星期六",
    "XingQiRi": "星期日",
    "YiChenShuiNTian": "已沉睡 {0} 天",
    "YiLiuShiNTian": "已流失 {0} 天",
    "NiXiuGaiDeXinXiShangWeiBa": "你修改的信息尚未保存，继续离开本次修改信息将不会生效。是否继续离开？",
    "ShengChanZhong": "生产中",
    "ZhuangJu": "装柜",
    "DaiPingJia": "待评价",
    "FuZeNaXieKeHu": "负责哪些客户",
    "SouSuoRenWu": "搜索任务",
    "ShouCiZhuCePingTai": "首次注册平台",
    "ShiXiangDaiBan": "事项待办",
    "TiHuoTiXing": "提货提醒",
    "DaiChuLiSuoPei": "待处理索赔",
    "XinKeManYiDuDiaoCha": "新客满意度调查",
    "YuLiuShiYongHuManYiDuDiao": "预流失用户满意度调查",
    "GenJinTiXing": "跟进提醒",
    "DaiChuBuLianXiKeHu": "待初步联系客户",
    "KeHuXuanPin": "客户选品",
    "ZhuanHuaLvKanBan": "转化率看板",
    "ZhiYouLuoZaiShiJianFanWei": "只有符合时间范围内的数据才会被统计",
    "QuanBuZhuCeQuDao": "全部注册渠道",
    "QuanBuGenJinRen": "全部跟进人",
    "ShangYue": "上月",
    "XiaDan2": "下单",
    "DaiGenJinShiXiang": "待跟进事项",
    "ZhuanHuaLvN": "转化率 {0}%",
    "HuoWuZhuiZongChaXun": "货物追踪查询",
    "QuChaXun2": "去查询",
    "ChaKanYuanYin": "查看原因",
    "ZongJinE": "总金额",
    "YiLianXiGuo": "已通知",
    "ZhuCeKeHuDaiBanTiXing": "注册客户—待办提醒",
    "YiChengJiaoKeHuDaiBanTiXi": "已成交客户—待办提醒",
    "TiHuo": "提货",
    "YiLianXiGuo2": "已联系过",
    "ZanWuGenJinNeiRongBeiWang": "暂无跟进内容备忘",
    "NYiGuoQiNTian": "{0} 已过期 {1} 天",
    "MingTian": "明天",
    "ChuanWuYiChangChuLi": "船务异常处理",
    "DingCangXinXiYiChangChuLi": "订舱信息异常处理",
    "BaoJiaFangShiYiChang": "报价方式异常",
    "TiJiaoShiJian": "提交时间",
    "ZiDingYiShengChanYaoQiu": "自定义生产要求",
    "ZiDingYiShengChanYaoQiuWaiWen": "自定义生产要求(外文)",
    "NPCS": "{0} PCS",
    "NWaiXiang": "{0} 外箱",
    "ZhongYaoQingZaiTianNeiTiG": "【重要】请在{0}天内提供贴纸。",
    "ChaoGuoTianTiGongTieZhiKe": "超过{0}天提供贴纸，可能会影响工厂生产进度，导致交货日期推后，请尽快提供贴纸信息。",
    "QueRenZanBuSheZhiTieZhiMa": "确认暂不设置贴纸吗？",
    "EssaoneQuanTaoChanPin": "Essaone的Fulfillment服务",
    "WoMenZhengZaiQingTingKeHu": "我们正在倾听客户的意愿，这就是为什么我们很高兴地宣布，埃桑推出了一项完整的服务。现在我们开始接受邮件申请",
    "NiZaiXunZhaoFuErFeiMenTe": "你在寻找Fulfillment",
    "ZheiYeShiNiDeRuGuoNiBaTa": "如果你把这个任务交给了<br />专业人士",
    "WoMenYouShenMeJianYi": "我们有什么建议？",
    "ZaiShiChangShangJiaoFuCha": "在Wildberries、Ozon市场上交付产品的全面准备",
    "BaoZhuang2": "包装",
    "BiaoJi2": "标记",
    "XiangHeCangKuJiaoFuDingDa": "向Wildberries和Ozon仓库交付订单",
    "WoMenDeYouShi": "我们的优势",
    "BuXuYaoZhiFuYunFei": "不需要支付从仓库到<br /> 成品的运费",
    "ShouHuoWuXuFuFei": "收货无需付费",
    "BuXuYaoZhiFuShangPinYanHu": "不需要支付<br />商品验货",
    "WuXuZhiFuBaoZhuangHeHuoTu": "无需支付包装盒或托盘的形成费",
    "WoMenGanXieWoMenDeKeHu": "我们感谢我们的客户",
    "ZaiDingGouChanPinYongXinD": "在Essaone订购产品，用新的服务发展您的业务！",
    "YanShouHuoWu": "验收货物",
    "ShangPinBiaoJi": "商品标记",
    "ChuCunHuoWu": "储存货物",
    "DingDanChuLi": "订单处理",
    "HuiKuan2": "汇款",
    "JiaoHuo2": "交货",
    "DingDanBaoZhuang": "订单包装",
    "XieShang": "协商",
    "DeDaoBaoJia": "得到报价",
    "ESSAONEWanQuanMianFei": "<span class=\"fw_700\">ESSAONE</span>完全免费！",
    "TiDanHao": "提单号",
    "TiDanSaoMiaoJian": "提单扫描件",
    "QingShuRuShenQingLiYou": "请输入申请理由",
    "TouBaoMaiFangDaiMa": "投保买方代码",
    "ShangPinZhengZaiTiJiaoDingDan": "商品正在提交订单，请稍后刷新数据后再操作。",
    "NNianChengJiao": "{0}年成交",
    "ZhanShiHe": "展示盒",
    "FeiZhanShiHe": "非展示盒",
    "RuKuNTian": "入库 {0}天",
    "ManYiDuDiaoCha": "满意度调查",
    "ZuiJinJiaGou": "最近加购",
    "QueRenYiLianXiGuo": "确认已联系过？",
    "MiMaGuiZe5": "请输入6-20位字符，由字母+数字组合",
    "ShangPinBianMaJiuBianMaHu": "商品编码、旧编码、货号",
    "NinWuQuanXianFangWenGaiYe": "您无权限访问该页面!",
    "ShouHuoQuYu": "收货区域",
    "DaiBanTiShiDingJinCuiShou": "<p>请联系这些客户并发出支付提醒，争取让他们及时支付定金。否则，<b>订单将在14天后被自动取消！</b></p><p>系统提醒规则：</p><p>第1次，下单日起第3天</p><p>第2次，下单日起第7天</p><p>第3次，下单日起第11天</p>",
    "RuKuNTian2": "入库 {0}天，免费停仓时间剩余 {1}天",
    "DaiBanTiShiTiHuoTiXing": "<p>以下订单已完成了全部付款。请通知这些客户及时预约提货，并有必要向客户强调，<b>订单在仓库的免费停留时间只有30天！逾期将收费。</b></p><p>系统提醒规则：</p><p>第1次，入库后第2天</p><p>第2次，入库后第15天</p><p>第3次，入库后第25天</p>",
    "DaiBanTiShiWeiKuanCuiShou": "<p>请联系这些客户并发出支付提醒，争取让他们及时支付尾款并预约提货。<b>订单在仓库的免费停留时间只有30天！</b></p><p>系统提醒规则：</p><p>第1次，入库后第2天</p><p>第2次，入库后第10天</p><p>第3次，入库后第20天</p>",
    "DaiBanTiShiTiDaiChuLiSuoPei": "<p><b>你应在客户发起索赔的15天内完成审核。</b>根据公司索赔的标准先判断赔偿是否合理，再接受或拒绝客户的赔偿要求。特殊情况可与客户协商赔偿解决方案。</p>",
    "DaiBanTiShiDaiChuBuLianXiKeHu": "<p><b>你需要在7天内给这些客户打电话</b>，记录第一次联系的内容，并填写客户的基本信息，认证他是否为目标客户。</p>",
    "DaiBanTiShiKeHuXuanPin": "<p>这些客户值得关注。<b>请进一步确认客户是否有合作意向</b>，充分了解其购买的需求，尽可能促进成交。</p>",
    "DaiBanTiShiXiaDan": "<p>现在，你需要检查是否与这些客户签订了合同，并<b>通知客户在14天内支付定金。</b></p>",
    "DaiBanTiShiChengJiaoShiBai": "<p>很遗憾这些订单被取消了，<b>你需要去了解取消的原因并在系统中记录它。</b></p>",
    "HeJiDingJin": "合计定金",
    "HeJiWeiKuan": "合计尾款",
    "PingJunTingLiuS": "平均停留时间 {0} 天",
    "ZhuanHuaLvPingJunTingLiuS": "转化率 {0}%，平均停留时间 {1} 天",
    "RuKuNTian3": "入库 {0}天，超出免费停仓 {1}天",
    "ShengChengKongPo": "生成空PO",
    "QueRenDingDanChuHuoXinXi": "确认订单出货信息",
    "QueRenHouJiangShengChengY": "确认后将生成一个待集柜的空PO单可供跟单调货",
    "QueRenShiFouYouWoSiChuanW": "确认是否由我司船务进行订舱报关放单（散货指定地点交货不需要我司订舱）",
    "DiaoChaWenJuan": "调查问卷",
    "QuanBuGongChang": "全部工厂",
    "DengLuHouChaKanGengDuoJie": "登录后查看更多结果",
    "AnTuiJianPaiXu": "按推荐排序",
    "AnShangShiShiJianPaiXu": "按上市时间排序",
    "GenJuNianYueRiYiShangYeFa": "根据 {0} 以NO.{1} 商业发票交付一批货物",
    "DaiBanTiShiXinKeHu": "<p>调研目的：了解新客户对首单服务的满意度评价，及时发现问题完善服务，避免新客户的流失。并进一步促进第2-3个订单成交。</p> <p>沟通话术：</p> <p>xxx,您好！我是ESSAONE网站的客服人员。因为您是第一次在ESSAONE订购，我们想对您进行首次订购的满意度调查，能占用您几分钟时间参与本次答题吗？。您的意见将有助于ESSAONE变得更好。</p> <p>1）客户回答-YES。开始答题。</p> <p>2）客户回答-NO。现在很忙。需询问客户下次方便电话的时间。</p>",
    "DaiBanTiShiYuLiuShiDiaoYan": "<p>调研目的：了解平台流失用户的流失原因，改善处理平台存在的不友好问题，避免后续流失，同时为流失用户的召回提供决策依据。</p> <p>沟通话术：</p> <p>xxx,您好！我是ESSAONE网站的客服人员。我们正在进行用户满意度调查，能占用您几分钟时间参与本次答题吗？。您的意见将有助于ESSAONE变得更好。</p> <p>1）客户回答-YES。开始答题。</p> <p>2）客户回答-NO。现在很忙。请询问客户下次方便电话的时间。</p>",
    "DiYiGeDingDanShiJian": "第一个订单时间",
    "DengLuHouChaKanGouWuCheSh": "登录后查看购物车商品",
    "YunFeiDanLuXianMiaoShu2": "<p>1.到{0}海关关卡通行检查站：{1}（{2}公里）;</p> <p>2.从海关关卡：{3}（{4}公里）;</p> <p>百分比：</p> <p>中国 -{5}%; 俄罗斯 - {6}%。</p>",
    "HaiGuanGuanKaLuXianYunFei": "从{0}中转站到{1}海关检查站运费",
    "KeHuDiaoYanJieGuo": "客户调研结果",
    "WenJuanDiaoChaJieGuo": "问卷调查结果",
    "XinKeHu2": "新客户",
    "QingXuanZeWenJuan": "请选择问卷",
    "DiaoYanHuoDong": "调研活动",
    "DiYiGeDingDan": "第一个订单",
    "WenJuanTianXieShiJian": "问卷填写时间",
    "TianXieRen": "填写人",
    "ZunJingDeHuoBan": "<div><b>尊敬的客户</b>：</div><br />\n<div>感谢您选择了与ESSAONE合作！为不断地提高我们的服务水平，更好地为您提供优质服务，我们诚挚地邀请您参加我们的满意度调查，聆听您对网站订购服务的感受与评价意见。您的建议将有助于ESSAONE变得更好。</div><br />\n<div>感谢您的支持与配合！</div>",
    "TuiChuBianJi": "退出编辑",
    "LiuLanShangPinJiaRuGouWuC": "浏览商品，加入购物车",
    "QieHuanXiaoShouJingLi": "切换销售经理",
    "TianJiaYiWei": "添加一位",
    "QieHuanShiBai": "切换失败",
    "ShangPinYouYiChangXuYaoNi": "商品有异常，需要你处理。你可以接受，或重新议价",
    "YuanLaiJiaGe": "原来价格",
    "XianJiaGe": "现价格",
    "QueDingJieShouGaiShangPin": "确定接受该商品？",
    "QingShuRuQiWangJiaGe": "请输入期望价格",
    "JiXuZiXunYiJia": "继续咨询&议价",
    "GongChangQueRenShengChanY": "工厂确认生产要求中",
    "YiQueRenKeXiaDan2": "已确认，可下单",
    "ShiFangJiKeShuaXin": "释放即可刷新...",
    "ShangPinYiGuoJiaGeBaoHuQi": "商品已过价格保护期",
    "WenJuanYiJingTianXieGuo": "问卷已经填写过",
    "DiaoChaWenJuanTiJiaoCheng": "调查问卷提交成功，感谢你的配合！",
    "DingDanZhengZaiGenJinChuL": "订单正在跟进处理，如需操作请联系您的销售顾问。",
    "ZuiJinQueRenShiJian": "最近确认PO时间",
    "ShouDanRuKuShiJian": "首单入库时间",
    "ShouDanChuKuShiJian": "首单出库时间",
    "WenJuanDiaoChaJieGuoXiang": "<div><i class=\"popRoundNum\">1</i>首单确认时间</div> <div><i class=\"popRoundNum\">2</i>首单入库时间</div> <div><i class=\"popRoundNum\">3</i>首单出库时间</div>",
    "QingQianWangDuanTiJiaoDin": "请前往PC端提交订单",
    "ZuiJinXiaDanRiQi": "最近下单日期",
    "YiSheZhiYaoQiu": "已设置要求",
    "WeiRenZheng": "未认证",
    "ShouJiYanZhengMa": "手机验证码",
    "DanDuTie": "贴纸单独贴",
    "ZhengShuLeiXing": "证书类型",
    "ShouZiMu": "首字母",
    "ZuiShaoQiDingLiang": "最少起订量",
    "YouShiPin": "有视频",
    "XiaoShouJingLiXiangQing": "销售经理详情",
    "CiBaoJiaZaiQianYouXiao": "此报价在 {0} 前有效",
    "ZhuTu": "主图",
    "DengLuQieRenZhengHouXianS": "登录且认证后显示价格",
    "QuanBuXinXi": "全部信息",
    "BaoZhuangFenLei": "包装分类",
    "NiXuYaoXianXuanZeYiGeKeHu": "你需要先选择一个客户经理",
    "ZaiAnYiCiFanHuiTuiChuYing": "再按一次返回退出应用",
    "ZuiJinYiGeDingDan": "最近一个订单",
    "WenJuanDiaoChaJieGuoXiang2": "<div><i class=\"popRoundNum\">1</i>最近确认PO时间</div> <div><i class=\"popRoundNum\">2</i>最近入库时间</div> <div><i class=\"popRoundNum\">3</i>最近出库时间</div>",
    "ShouDanQueRenShiJian": "首单确认PO时间",
    "ZuiJinRuKuShiJian": "最近入库时间",
    "ZuiJinChuKuShiJian": "最近出库时间",
    "ShangYiCiShiYong": "上一次使用",
    "FaWangNaGeChengShi": "发往哪个城市",
    "ShouHuoDianCangKu": "收货点(仓库)",
    "ShanChuDiZhi": "删除地址",
    "ShiFouShanChuDiZhi": "是否删除地址?",
    "QingShuRuLianXiRenXingMin": "请输入联系人姓名",
    "FaYunLianXiRen": "发运联系人",
    "QingShuRuFaYunLianXiRen": "请输入发运联系人",
    "FaYunLianXiRenDianHua": "发运联系人电话",
    "QingShuRuFaYunLianXiRenDi": "请输入发运联系人电话",
    "KeHuBianHaoWuLiuGongSi": "客户编号（物流公司）",
    "DingDanFeiYong": "订单费用",
    "YingFu": "应付",
    "XuanZeShouHuoRen": "选择收货人",
    "WuLiuKeHuBianHao": "物流/客户编号",
    "SouSuoDingDan": "搜索订单",
    "DuanGongNengKaiFaZhongQin": "PC端功能开发中，请前往ESSACHINA APP提交订单",
    "HuoHao2": "货好",
    "YouDingDanYiShengChanWanB": "有订单已生产完毕，可以安排出货计划。",
    "ChuHuoAnPai": "出货安排",
    "DangQianYouYiChangDingDan": "当前有异常订单，需要你及时处理",
    "XiaoXi": "消息",
    "WenXinTiShiZaiXiaDanEDuFa": "温馨提示：在下单额度范围内，将按照货物生产进度分配出货",
    "TiJiaoDingDanChengGong": "提交订单成功",
    "PingTaiYiAnZhaoChuHuoShiJ": "平台已按照出货时间给你拆分订单",
    "GuanZhuBingShenQing": "关注并申请",
    "CaiZhi2": "材质",
    "DingDanYiChang": "订单异常",
    "XianHuoQi": "现货期",
    "XianMOQ": "现MOQ",
    "YiXiaShangPinYouYiChangXu": "以下商品有异常需要你及时处理",
    "ShangPinQuXiao": "商品取消",
    "ChaKanZiJinZhangHu": "查看资金账户",
    "YouDingDanYiChuHuoQingJin": "有订单已出货，请尽快安排支付相关款项。",
    "ZiJinZongLan": "资金总览",
    "ZongEDu": "总额度",
    "YiShiYongEDu": "已使用额度",
    "HaiKeChuHuo": "还可出货",
    "NiDeEDuYiBuZuChuHuo": "你的额度已不足出货",
    "ChaKanFuKuanXinXi": "查看付款信息",
    "HuoHaoDingDan": "可出货订单",
    "LaiKuanHouShiFangDuiYingC": "来款后释放对应出货额度",
    "YinXingZhangHao": "银行帐号",
    "ZhiFuBaoZhiFu": "支付宝支付",
    "WeiXinZhiFuTianJiaHaoYou": "微信支付（添加好友）",
    "XiaLaJiKeShuaXin": "下拉即可刷新...",
    "DanCiHuoQuDeFuKuanXinXiJi": "单次获取的付款信息仅 {0} 天有效",
    "DengJiRenXiaLaShaiXuan": "登记人下拉筛选",
    "KeHuZhaoYang": "客户找样",
    "YiGuiHai": "已归还",
    "HaiQian": "还欠",
    "PaiZhaoSouTu": "拍照搜图",
    "ShangPinQuXiaoHuoDiaoChu": "商品取消或调出",
    "QuanBuNShangPin": "全部{0}商品",
    "XinYuJiChuHuoShiJian": "新预计出货时间",
    "YuanYuJiChuHuoShiJian": "原预计出货时间",
    "ChuHuoShiJian2": "出货时间",
    "ShaiXuanYiChangDingDan": "筛选异常订单",
    "ZhongXinFaSongQueRenYouJi": "重新发送确认邮件",
    "DengDaiZhuZhangHaoQueRen": "等待主账号确认",
    "XiaoShouJingLi": "销售经理",
    "ZiChanXinYong": "资产 & 信用",
    "ZhaoYangGuanLiGuoWai": "找样管理（国外）",
    "ZhaoYangGuanLiGuoNei": "找样管理（国内）",
    "GuanYuAPP": "关于APP",
    "FuWuTiaoKuan": "服务条款",
    "YingYongQuanXianShuoMing": "应用权限说明",
    "XiTongQuanXian": "系统权限",
    "JianCeXinBanBen": "检测新版本",
    "QingXuanZeDengJiRen": "请选择登记人",
    "GongSiYuanGongZhangHao": "公司员工账号",
    "ZhangHaoRenZhengBuTongGuo": "账号认证不通过",
    "ZhangHaoRenZhengZhong": "账号认证中",
    "ChaKanRenZhengXinXi": "查看认证信息",
    "QingShuRuSouSuoNeiRong": "请输入搜索内容",
    "NinYiJingShiZuiXinDeBanBe": "您已经是最新的版本",
    "SouTuJieGuo": "搜图结果",
    "DianJiKeQieHuanSouTuZhuTi": "点击可切换搜图主体",
    "ShouDongKuangXuanZhuTi": "手动框选主体",
    "LiKeDengLu": "立刻登录",
    "ZhengZaiShangChuan": "正在上传",
    "XuanZeXiGuanDeYuYan": "选择习惯的语言",
    "SheZhiChengGong": "设置成功",
    "YiXuanZeNGeLeiMu": "已选择{0}个类目",
    "ZhongXinRenZheng": "重新认证",
    "QingDengDaiPingTaiRenZhen": "请等待平台认证",
    "AnZhengXiangChuHuo": "按整箱出货",
    "YiXuanZeNGe": "已选择{0}个",
    "ShangChuanShuiDanXinXi": "上传水单信息",
    "LeJieDingJinMoShi": "了解 ESSA 定金模式",
    "GuDingBaoZhengJinEDu": "固定保证金额度",
    "DingDanChuHuoHouTuiHaiEDu2": "订单出货后退还额度",
    "LeJieOAEDu": "了解 OA 额度",
    "XuanZeKeHuJingLi": "选择客户经理",
    "PingTaiMaiShou": "平台买手",
    "GongSiYiCunZaiShiFouYaoJi": "公司已存在，是否要加入到已有公司？",
    "TongYiJiaGongSiKeYi": "同一家公司可以",
    "GongYongDiZhi": "共用地址",
    "GongYongZhiFu": "共用支付",
    "GongYongHeTong": "共用合同",
    "JiaRuYiYouGongSi": "加入已有公司",
    "QingXuanZeLianXiFangShi": "请选择联系方式",
    "YuanGongZhangHaoXinXi": "员工账号信息",
    "TianJiaLianXiFangShi": "添加联系方式",
    "QingTianXieDianZiYouXiang": "请填写电子邮箱",
    "QueRenNinShiZhenRen": "确认您是真人",
    "XinJianShouHuoRenXinXi": "新建收货人信息",
    "XinJianWuLiuGongSiXinXi": "新建物流公司信息",
    "DingDanShangPinChuLiZhong": "订单商品处理中，稍后查看",
    "QingShuRuLianXiFangShi": "请输入联系方式",
    "DianJiYanZhengZhenRenJiKe": "点击验证真人即可访问",
    "ZhiShaoBaoHanNGeZiFu": "至少包含{0}个字符",
    "BaoKuoZiMuHeShuZi": "包括字母和数字",
    "YouHuiQuanMa": "优惠券码",
    "QingShuRuYouHuiQuanMa": "请输入优惠券码",
    "GongSiXingZhi": "公司性质",
    "GongSiZhangHaoXinXi": "公司账号信息",
    "QingXuanZeYiXiangCaiGouSh": "请选择主要采购品类，最多选择五个",
    "QingXuanZeGongSiXingZhi": "请选择公司性质",
    "QingXuanZeQingGuanFangShi": "请选择清关方式",
    "QingXuanZeZhuYaoXiaoShouQ": "请选择主要销售区域",
    "TiaoGuo": "跳过",
    "ZhongGuoPiFaShiChang2": "中国批发市场",
    "WoMenZhiZuoPiFaBuZuoLingS": "我们只与法人实体和个体企业家合作，只批发不零售。",
    "XiuGaiShouJiHaoMa": "修改手机号码",
    "XiuGaiDianZiYouXiang": "修改电子邮箱",
    "QingShuRuDianZiYouXiang": "请输入电子邮箱",
    "XuanZeChengShi": "选择城市",
    "XuanZeDiQuYouZhuYuWoMenJi": "选择地区有助于我们计算价格",
    "QingXuanZeZhuYaoCaiGouPin2": "请选择主要采购品类",
    "GongSiXingZhiWeiShiChangP": "公司性质为市场批发的，清关方式不能选择白关。",
    "ZhangHaoShenQingJiaRuGong": "账号申请加入公司 {0}",
    "FaSongShiBai": "发送失败",
    "GongSiXingZhiZanBuZhiChiX": "公司性质暂不支持修改，如需修改请联系客服",
    "QingGuanFangShiZanBuZhiCh": "清关方式暂不支持修改，如需修改请联系客服",
    "ZhuCeChengGongNiDeZhangHa": "注册成功！你的账号：<a href=\"mailto:{0}\">{0}</a>",
    "WeiBaoZhangYongHuDeZhangH": "<div>1.为保障用户的账户安全，方便沟通交流，我们已向您发送了一封邮件。请您查收并点击邮件中的链接完成验证。</div> <div>2.我们的客户经理将在工作日48小时内与您联系，帮助您寻找合适的产品和最好的折扣！</div>",
    "ShenMeShiESSAONE2": "什么是ESSAONE",
    "XinRenZhuanQu": "新人专区",
    "QiTaLianXiFangShiBuNengZh": "其他联系方式不能重复或者为空",
    "ShouCiXiaDanJinXuZhiFuDeD": "首次下单仅需支付10%的定金！",
    "DianZiYouXiangYongHuZhang": "电子邮箱/用户账号",
    "XiuGaiHuoYanZhengYouXiang": "修改或验证邮箱",
    "YouXiangYiChengGongJieSho": "邮箱已成功接收邮件，但用户未完成验证",
    "YouXiangDiZhiWuXiao": "邮箱地址无效",
    "YouJianFaSongShiBai": "邮件发送失败",
    "WeiZhi": "未知",
    "KeHuYuYan": "客户语言",
    "NiDeYouXiangYiYanZhengChe": "你的邮箱已验证成功！",
    "WoMenChengNuoBuHuiXiangNi": "我们承诺不会向您发送大量电子邮件，只会向您发送有关网站工作、促销活动以及精选新产品和流行趋势的重要信息。",
    "ZhiShaoGeZiFuZiMuYuShuZiZ": "至少8个字符，字母与数字组合，不能全为数字",
    "SouSuoKeHuMingChengBianHa2": "搜索客户名称/编号/联系电话/邮箱",
    "YouXiangYiZhi": "邮箱没变，无需更改",
    "YouXiangYiBianGeng": "邮箱已变更",
    "GaiLianJieYiBieShiYong": "该链接已被使用",
    "ZiJiGenJinDeKeHuCaiNengQuXiaoGenJin": "自己跟进的客户才能取消跟进",
    "TuiGuangQuDao": "推广渠道",
    "TuiGuangQuDaoLaiYuan": "推广渠道来源",
    "XinYongTiXiJiangGenJuDing": "1，ESSACHINA信用体系将根据订单履约的情况，定期评估并更新您的信用状况，初始分值为90分。",
    "PingFenLaiYuanYuYeWuJingL": "评分来源于业务经理服务过的客户的真实评价，您可以从他人对该经理的语言能力、服务态度、反馈问题时效和解决问题能力的评价，在四个方面来参考并选择自己的业务经理。",
    "EDuYongYuDingDanChuHuoDeD": "OA额度用于订单出货的定金保证，出货后会扣减对应的保证金。可用额度=信用保证金额度-已锁定该部分额度，当前余额可继续用于订单的定金担保。",
    "ZongHe": "综合",
    "QingXuanZeGanXingQuDeLeiM": "请选择感兴趣的类目",
    "ShenQingJiaRuGongSi": "申请加入公司",
    "XinBanBenShengJi": "新版本升级",
    "GengXinNeiRong": "更新内容",
    "LiJiGengXin": "立即更新",
    "ZhengZaiXiaZaiYingYong": "正在下载应用",
    "JinDu": "进度",
    "YiMingYongHuZhengZaiShenQ": "一名用户正在申请加入您的公司。",
    "NinKeYiPiZhunHuoJuJueGaiQ": "您可以批准或拒绝该请求",
    "order_pay_shipment": "支付与出货",
    "order_status_change": "订单状态更新",
    "order_abnormal": "订单异常通知",
    "system_salesman_change": "销售顾问变更",
    "system_account_change": "帐号信息变更",
    "system_other": "其他系统通知",
    "XiaoXiSheZhi": "消息设置",
    "WeiXinTongHao": "微信同号",
    "WhatsAppTongHao": "WhatsApp 同号",
    "GongNengKaiFaZhong": "功能开发中",
    "TiGaoSouTuJingZhunXiaoJiQ": "提高搜索的准确性",
    "ChaKanKeXiaDanDeShangPin": "查看可下单的商品",
    "QuLianXi": "去联系",
    "QingLianXiNinDeKeHuJingLi": "请联系您的客户经理",
    "NinXianZaiXuYaoCaiGouShan": "您现在需要采购商品吗？请联系您的客户经理协助你处理下单相关事项",
    "XiTong": "系统",
    "MeiYouGengDuoShangPin": "没有更多商品",
    "RenGongGaiJiaFuLiRun": "人工改价负利润",
    "1059PR10020": "采购商名称重复",
    "QingTianXieZhengQueTianSh": "请填写正确天数",
    "QingShuRuDaYuDeTianShu": "请输入大于{0}的天数",
    "GaiJiaGeYouXiaoQi": "该价格有效期",
    "ZaiQianXiaDanYiGaiJiaGeWe": "在 {0} 前下单以该价格为准",
    "GongChangZhangJiaXianChuL": "工厂涨价先处理异常",
    "GongChangZhangJiaLeYaoXia": "工厂涨价了，要先处理",
    "GongChangCaiGouJiaXunHou": "工厂采购价询后",
    "GongChangCaiGouJia": "工厂采购价",
    "RangLiHouCaiGouJia": "让利后采购价",
    "YongYuJiSuanChengJiaoJia": "用于计算成交价",
    "XunHouYouZhangJiaXianChuL": "询后有涨价，先处理异常",
    "XunHou": "询后",
    "XunQian": "询前",
    "GaiJia": "改价",
    "ChengJiaoJiaZhangJiaHou": "成交价(涨价后)",
    "GongChangCaiGouJiaZhangJi": "工厂采购价(涨价后)",
    "DangAnJia": "档案价",
    "DangNiShiYongShiHuiZaiShi": "当你使用 ESSACHINA APP时，会在使用图片搜索商品、公司用户账号个人头像信息 时访问相册、相机、存储权限，用于搜索商品和用户信息完善，是否允许？",
    "PaiZhao": "拍照",
    "CongXiangCeXuanZe": "从相册选择",
    "QingXianShanChuSuoYouDeZi": "请先注销所有的子账号，再注销主账号！",
    "QueDingZhuXiaoZhangHao": "确定注销账号？",
    "YiTongZhiKeHu": "已通知客户",
    "TieZhiShenHe": "贴纸审核",
    "TiJiaoQueRenShiJian": "提交确认时间",
    "GaiDingDanShangPinTieZhiY": "该订单商品贴纸已确认完成",
    "XiuGaiTieZhi": "修改贴纸",
    "RenZhengShiJian": "认证时间",
    "QueRenShiJian": "确认时间",
    "TieZhiMoBan2": "贴纸模版",
    "XiuGaiShuoMing": "修改说明",
    "QingShuRuMiaoShuBenCiYaoX": "请输入描述本次要修改的贴纸内容",
    "JieTuShuoMing": "截图说明",
    "XiuGaiLeiXing": "修改类型",
    "GongChangTuiJianShangPin": "工厂推荐商品",
    "TuiJianDuiXiangShiYou": "推荐对象/事由",
    "GongChangHeCaiGouXunJiaZh": "工厂和采购询价中可见",
    "QingShuRuTuiJianDuiXiangS": "请输入推荐对象/事由",
    "ZuiDuoZhiNengShuRuGeWenZi": "最多只能输入{0}个文字",
    "XunJiaCaiGouZu": "询价采购组",
    "QingXuanZeXunJiaCaiGouZu": "请选择询价采购组",
    "DanKuanYiXiangLiang": "单款意向量",
    "QingXuanZeDanKuanYiXiangL": "请选择单款意向量",
    "AnXunJia": "按PCS询价",
    "AnXiangXunJia": "按箱询价",
    "QingShuRuDanKuanYiXiangLi": "请输入单款意向量",
    "QingShuRuZhengQueDeDanKua": "请输入正确的单款意向量",
    "XunJiaYiXiangLiang": "询价意向量",
    "XuanZeShangPinTianXieTeSh": "选择商品并填写生产要求",
    "RuNinDuiDingDanHuoDingDan": "如您对订单的商品有特别要求，请清楚地写明。这些要求可能涉及商品颜色、指定款式、配件功能等方面。",
    "DingDanYaoQiuBeiZhu": "订单要求备注",
    "SouSuoZhuTiShangPinBianMa": "搜索主题、商品编码",
    "ShangPinTuiJianXiangQing": "商品推荐详情",
    "HuiLvAnPingTaiBiaoZhunFei": "汇率按平台标准，FOB费按商品产地下水计算",
    "MeiYouXiuGaiXiang": "无任何修改",
    "QueRen": "确认",
    "ZhuYiDuiDingDanHuoDingDan": "注意：对订单的商品有特别要求，清楚地写明。这些要求可能涉及商品颜色、指定款式、配件功能等方面。",
    "KeHuDuiDingDanHuoDingDanZ": "客户对订单的商品有特别要求，请清楚地写明。这些要求可能涉及商品颜色、指定款式、配件功能等方面。",
    "TianXieYiBaoCunChengGong": "填写已保存成功",
    "ShengChanZhuangTai": "生产状态",
    "ZhiDingTiaoXingMa": "指定条形码",
    "YiXiuGaiZaiQueRen": "已修改再确认",
    "ZhiDingShangPinTiaoXingMa": "指定商品条形码",
    "QingShuRuMiaoShuLiRuShang": "请输入描述，例如商品颜色、指定款式、配件功能等方面",
    "DingDanYiJingZaiShengChan": "订单已经在生产，不支持再继续增加特殊要求",
    "ZhiDingShangPinTiaoMa": "指定商品条码",
    "ShenQingXiaZai": "申请下载",
    "TuPianKeDaoChu": "图片可导出",
    "ShenQingXiaZaiZhongQingNa": "申请下载中，请耐心等1-3分钟",
    "DaiZhuangJuRenYuanShangCh": "待装柜人员上传图片",
    "DaiChuanWuQueRenHouXiaZai": "待船务确认后下载",
    "XiaZaiZhuangXiangDan": "下载装箱单",
    "ZhaoYangLeiXing": "找样类型",
    "GenJuShiJiZhaoYangXuQiuXu": "根据实际找样需求，选择找样类型",
    "QingXuanZeZhaoYangLeiXing": "请选择找样类型",
    "KeHuYouTiGongZhaoYangZiLi": "客户有提供找样资料需上传，以便保留原始找样资料",
    "YiNianNeiDeZhaoYang": "一年内的找样",
    "YouXinDeTuiJian": "有新的推荐",
    "YiZuoBaoJiaDan": "已做报价单",
    "RenWuBianMa": "任务编码",
    "YiHeJia": "已核价",
    "WeiZuoBaoJiaDan": "未做报价单",
    "WanChengZhaoYang": "完成找样",
    "QueRenWanChengZhaoYang": "确认完成找样",
    "ChangGuiZhaoYangZhuYaoJia": "常规找样主要将由采购组承接",
    "XiangMuZhaoYangJiangYouSh": "项目找样将由商品经理承接",
    "XiaZaiQuanBu": "下载全部",
    "YuShangChuan": "{0} 于 {1} 上传",
    "ZuiDuoXuanZeWuGe": "最多选择五个",
    "GengDuoTiWen": "更多提问",
    "YiZhaoWang": "已找到",
    "XiangYouHuaDongTianChongP": "向右滑动填充拼图 验证真人即可访问",
    "DianJiJinRu": "点击进入",
    "BuGenJin": "不跟进",
    "ShangPinDangAnJia": "商品档案价",
    "ChanQianYang": "产前样",
    "PiLiangXiaZai": "批量下载",
    "FuZhiXiaZaiLianJie": "复制下载链接",
    "PiLiangXiaZaiHouCaiShengC": "批量下载后才生成下载链接可供复制",
    "GaiJiaGe": "改价格",
    "ShangChuanPIDan": "上传PI单",
    "ShangChuanPIWenJian": "上传PI文件",
    "ShangChuanWenJianZhiChiTu": "上传文件，支持图片/PDF/Excel",
    "ShuiDan": "水单",
    "QingShuRuZengZhiShuiLv": "请输入增值税率",
    "AIZhiXuan": "AI 智选",
    "SiKaoZhong": "思考中",
    "FenXiTuiDaoGuoCheng": "分析推导过程",
    "FenXiNinDeXuQiu": "分析您的需求",
    "NinSouSuoDeNeiRong": "您搜索的内容",
    "SouSuoGuanJianCiTuiJian": "搜索关键词推荐",
    "QingZaiDuiHuaKuangZhongSh": "请在对话框中输入内容",
    "ShaiXuanTuiJian": "筛选推荐",
    "NiShiYaoCaiGouDeShangPin": "你是要采购的商品",
    "NiShiYaoCaiGouDeShangPinQiDingLiang": "你是要采购的商品起订量",
    "NiShiYaoCaiGouDeShangPinBaoZhuangYuYan": "你是要采购的商品包装语言",
    "NiShiYaoCaiGouDeShangPinBaoZhuangLeiXing": "你是要采购的商品包装类型",
    "NiShiYaoCaiGouDeShangPinHuoQi": "你是要采购的商品货期",
    "NiShiYaoCaiGouDeShangPinJiaGe": "你是要采购的商品价格",
    "NiShiYaoCaiGouDeShangPinBiaoQian": "你是要采购的商品标签",
    "NiShiYaoCaiGouDeShangPinCaiZhi": "你是要采购的商品材质",
    "NiShiYaoCaiGouDeShangPinZhengShu": "你是要采购的商品证书",
    "SouSuoShangPinJieGuo": "搜索商品结果",
    "ShaiXuanYouXiaoXinXi": "筛选有效信息",
    "FenXiNinDeXuanPinPianHaoH": "分析您的选品偏好和背景信息",
    "SouSuoYouXiangBianHaoLian": "搜索 邮箱/编号/联系电话",
    "ChengGongZhuCe": "成功注册",
    "GenJinZhong": "跟进中",
    "GenJinShiBai": "跟进失败",
    "LaiYuanQuDao": "来源渠道",
    "ChengJiaoYiXiangDengJi": "注册意向等级",
    "KeHuLaiYuan": "客户来源",
    "ChengRenYongPin": "成人用品",
    "QueRenNinDeNianLing": "确认您的年龄",
    "CiShangPinJinShiYongYuNia": "此商品仅适用于年满 18 岁的用户进行浏览！",
    "ShiDeWoYiNianManSui": "是的，我已年满 18 岁",
    "BuShi": "不是",
    "QingMiaoShuNiDeXuQiu": "请描述你的需求",
    "XinKaiHuiHua": "新开会话",
    "KaoLvZhongZanBuNengXinKai": "思考中暂不能新开会话",
    "MiaoShuNinDeXuQiu": "描述你的采购需求，我来帮你匹配货源",
    "TieZhiTuBiao": "贴纸图标",
    "XuanZeTieZhiTuBiao": "选择贴纸图标",
    "ShiFouQiangZhiBiaoJi": "是否强制标记",
    "ShangPinXinXiYouXiuGaiXuZ": "商品信息有修改需重新申请",
    "QingXuanZeShangPinFenLei": "请选择商品分类",
    "FaqTitle": "诚实标志（Честный знак）常见问题｜ESSAONE",
    "FaqTitleInfo": "诚实标志一站式服务：申请码、打印/贴标、清关与数据传输（ОФД/ЦРПТ）。覆盖玩具、自行车、成人服饰配饰、部分家纺等。签约并在平台下单的客户可享受免费办理与贴标。",
    "FaqIssue1": "什么是“诚实标志”，进口为什么需要？",
    "FaqAnswer1": "“诚实标志”是俄罗斯国家级商品标识与追溯系统（ЦРПТ）。服装/纺织、玩具、鞋等品类必须贴标，并在进口与销售环节向系统传输数据。",
    "FaqIssue2": "ESSAONE 提供哪些“一站式”服务？",
    "FaqAnswer2": "申请码 → 打印/贴标 → 合法清关 → 通过 ОФД/ЦРПТ 传输数据 → 提供合规文件与对账凭证。",
    "FaqIssue3": "ESSAONE 目前覆盖哪些品类？",
    "FaqAnswer3": "玩具、自行车、成人服饰配饰、部分家纺（如毛巾/围裙）；儿童服饰配饰正在推进中。",
    "FaqIssue4": "EAC 与“诚实标志”有什么区别？",
    "FaqAnswer4": "EAC 解决技术法规合规（认证/声明）；“诚实标志”解决商品标识与追溯。ESSAONE 两者均可办理。",
    "FaqIssue5": "贴标在中国做还是到俄罗斯再做？",
    "FaqAnswer5": "建议在中国生产阶段完成贴标，并随货提供清关所需文件，实现全程可追溯与快速通关。",
    "FaqIssue6": "买家需要提供什么资料？",
    "FaqAnswer6": "公司资质（ИНН/ОГРН）与联系人信息；如需加急，建议同时提供 SKU 清单与包装样式。",
    "FaqIssue7": "时效与费用如何？",
    "FaqAnswer7": "准备通常 2–5 个工作日，贴标 1–3 天。该流程会在原有入仓/上架基础上增加时间与人力，存在额外成本；与 ESSAONE 签订合同并在平台下单的客户可享受办理与贴标免费（按约定范围执行）。",
    "FaqIssue8": "数据如何传输到系统？",
    "FaqAnswer8": "通过已接入的运营方/ОФД/ЦРПТ完成数据传输；传输后可在后台获取确认与对账文件。",
    "FaqIssue9": "不按规定贴标会有什么风险？",
    "FaqAnswer9": "可能被罚款并限制流通。与 ESSAONE 合作可降低合规风险，确保交易流程符合法律法规。",
    "FaqIssue10": "如何开始？",
    "FaqAnswer10": "与 ESSAONE 签订合同，并在平台下单支付定金后，其余流程由 ESSAONE 处理。",
    "FaqIssue11": "联系方式",
    "FaqAnswer11": "电话：8-800-550-3301｜WhatsApp：+7-925-949-1117｜Telegram：+7-925-703-1115｜邮箱：service@essaone.com",
    "DaKaiDianNaoShangDeYingYo": "打开电脑上的 Whats App 应用",
    "ShiYongXiangJiSaoMiaoHuoS": "使用 WhatsApp 相机扫描或上传此二维码，加我为 WhatsApp联系人",
    "CaiWuDaiBan": "财务待办",
    "ZiJinHeXiao": "资金核销",
    "TuiKuanChuLi": "退款处理",
    "TuiHuiQianBaoJiLu": "退回钱包记录",
    "YongYuWoMenLianXi": "留言或者打电话",
    "KeHuZiJinMingXi": "客户资金明细",
    "Jia": "加",
    "Jian2": "减",
    "QianBaoYuE": "钱包余额",
    "ZanBuTiXian": "暂不提现",
    "NiTiJiaoDeTiXianShenQingJ": "你提交的提现申请，将在财务审核通过后 3 个工作日汇到到账",
    "XuanZeShouKuanYinXingKa": "选择收款银行卡",
    "TiXianJinE": "提现金额",
    "DangQianQianBaoQuanBuYuE": "当前钱包全部余额 {0}",
    "QuanBuTiXian": "全部提现",
    "XinZengShouKuanYinXingKa": "新增收款银行卡",
    "TianXieYinXingKaHao": "填写银行卡号",
    "TuiKuanLeiXing": "退款类型",
    "ShouKuanXinXi": "收款信息",
    "TuiKuanDengJi2": "退款登记",
    "DengJiWanCheng": "登记完成",
    "JiKeHuHuiKuanHouJiangFuKu": "给客户汇款后，将付款凭证上传到系统，供客户查看",
    "WanChengDengJi": "完成登记",
    "ChaKanQueRen": "查看确认",
    "GaoFengXianDingDan": "高风险订单",
    "RuKuTianShu": "入库天数",
    "KeHuBuXiangYaoLe": "客户不想要了",
    "KeHuHaiYao": "客户还要",
    "KeHuFangQiHuoWu": "客户放弃货物",
    "KeHuFangQiHuoWuCiCaoZuoJi": "客户放弃货物，此操作将不退款，并把货物转为库存商品。请确认是否已放弃货物？",
    "HuoQuanGenJin": "货权跟进",
    "DaiFuKuan2": "待付款",
    "KeHuFangQi": "客户放弃",
    "QueRenChanPinPoSunQingKua": "确认产品破损情况",
    "GongNPcs": "共 {0} PCS",
    "JiangZiDongZhuanKuCunShan": "将自动转库存商品，且会折算成箱",
    "TuiKuanDanZheng": "退款单证",
    "YiPeiChang": "已赔偿",
    "ZhenDuiPoSunDeQingKuangJi": "针对破损的情况进行登记处理，登记提交后，将有业务或客服与客户协商赔偿方式",
    "ShuRuPoSunDeShangPinBianM": "输入破损的商品编码",
    "PoSunChanPinShuLiangKeHuG": "破损产品数量（客户购买共 {0} 箱 ｜{1} PCS）",
    "PoSunYuanYin": "破损原因",
    "YiRuKuTian": "已入库 {0}天",
    "BuTuiKuan": "不退款",
    "XuTuiKuan": "需退款",
    "YinXing": "银行",
    "GongSi": "公司",
    "KaHao": "卡号",
    "ZhuCeHouCaiGouLianXiGongC": "获取来自中国工厂的批发价格（无中间商）",
    "ShouKuanGongSi": "收款公司",
    "ZhiNengHuiKuanDaoQianDing": "只能汇款到签订合同的公司主体",
    "QingXianXinZengHeTong": "请先新增合同",
    "ZiXunGuWen": "咨询顾问",
    "QingShuRuTiXianJinE": "请输入提现金额",
    "QingXuanZeWenJian": "请选择文件",
    "GaiBiTuiKuanBuXuYaoTuiKua": "该笔退款不需要退款给客户",
    "QingQueRenZaiCaiWuXiTongZ": "请确认在财务系统中已经完成处理",
    "PoSunChanPinShuLiang": "破损产品数量",
    "KeHuGouMaiGongXiang": "客户购买共 {0} 箱 ｜{1} PCS",
    "PoSunShangPinShuLiang": "破损商品数量",
    "ZhengChangShangPinShuLian": "正常商品数量",
    "PingZhengJiShuoMing": "凭证及说明",
    "TiJiaoShouHouChuLi": "提交售后处理",
    "PoSunChanPinXiangShu": "破损产品箱数",
    "HuiKuanJiaoCheng": "汇款教程",
    "ShouXuMaFanDengDaiCaiWuSh": "手续麻烦，等待财务审核通过后打款。",
    "KeHuBianHaoMingCheng": "客户编号/名称",
    "PoSunChanPinShuLiangBuNen": "破损产品数量不能大于箱数",
    "WeiHuiKuan": "未汇款",
    "AnPoSunShuLiangPeiChang": "按破损数量赔偿",
    "AnZhengXiangPeiChang": "按整箱赔偿",
    "QingXuanZeShouHouFangAn": "请选择售后方案",
    "QingXuanZePeiChangChuLi": "请选择赔偿处理",
    "QingZaiCaiWuXiTongChuLiHo": "请在财务系统处理后进行操作完成，该笔退款不需要退款给客户",
    "YinXingKaHaoGeShiYouWu": "银行卡号格式有误",
    "QingLianXiKeHuChaKanNinHe": "请联系客户查看您和平台签订的合同，只能使用合同的公司主体进行收款",
    "RuXuXiuGaiQingLianXiCaiWu": "如需修改请联系财务返回待确认",
    "FaQiHouTianNeiWanChengQue": "发起后 {0} 天内完成确认，过期默认不向客户收，如需修改联系财务",
    "FeiYongDanHao": "费用单号",
    "YingShouJinE": "应收金额",
    "WeiHeXiaoJinE": "未核销金额",
    "YiHeXiaoJinE": "已核销金额",
    "QueRenPODan": "确认 PO单",
    "ZiDongQueRenShiJian": "自动确认时间",
    "FaQiDan": "发起PO单",
    "ShouDan10DingJin": "首单10%定金，购买越多，享受的折扣越大。",
    "DanKongBuChuHuoWuFaSuiFaP": "PI单、空PO不出货，无法随发票出具",
    "FeiYongDanTiCheng": "费用单提成",
    "JiTiZhuangTai": "计提状态",
    "JieSuanZhuangTai": "结算状态",
    "BangDingJiTi": "绑定计提 PO",
    "JiTiDan": "计提 PO 单",
    "BangDing": "绑定",
    "XiangKeHuShouQuDe": "向客户收取的 PO",
    "BangDingJiTiPO": "绑定计提 PO",
    "ZhiNengBangDingDanDuiYuKo": "只能绑定 PO 单，对于空 PO 、PI、已结算的 PO 单不能绑定",
    "QingXuanZeJiTiChengBen": "请选择计提成本 PO",
    "JiTiChengBen": "计提成本 PO",
    "JiTiShouRu": "计提收入 PO",
    "QingXuanZeJiTiShouRu": "请选择计提收入 PO",
    "FeiYongDanGuanLi": "费用单管理",
    "FeiYongDanQueRen": "费用单确认",
    "FeiYongDanYiJingWanChengQ": "联系财务返回待确认",
    "FeiYongDanJieSuanQianTiDa": "费用单结算前提：PO 单已出货，PO 单无欠款",
    "QingShuRuJuHao": "请输入柜号",
    "JiTiPO": "计提 PO 单",
    "XuKeHuQueRen": "需客户确认",
    "KuCunShuLiang": "库存数量",
    "QingCangTeMaiJiaGeYouHui": "清仓特卖 价格优惠",
    "FaPiaoYIQueRenRu": "发票已确认如需绑定该 PO 单，联系财务处理，不能提交",
    "FeiYongDanQueRenHouRuXuXi": "费用单确认后，如需修改联系财务退回待确认",
    "GouXuanHouJiangXuYaoKeHuC": "勾选后将需要客户操作确认，默认客户不需要确认",
    "YiChuHuoYuFaQiRenQueRenFe": "PO已出货，确认费用是否合理，通知财务更新发票",
    "DingZhiTiaoMa": "定制条码",
    "TiaoXingMaShiYongShuoMing": "条形码使用说明？",
    "ShangPinTiaoXingMaDingZhi": "商品条形码定制说明",
    "DingZhiTiaoMaJiangTiHuanQ": "定制条码将替换清关贴纸上的原商品条码",
    "YinXingShiBieMa": "银行识别码",
    "DaiLiXingZhangHu": "代理行账户",
    "ZhiYouXianZeRenGongSiJing": "致“essaone”有限责任公司经理<br /> 纳税人识别号 7751205614 <br /> Вовк Татьяне Анатольевне<br /> 由  {0}<br /> 纳税人识别号 {1}<br />",
    "TuiKuanShenQing": "退款申请",
    "TuiKuanShenQingShuoMing": "退款申请说明{0}",
    "NaShuiRenShiBieHaoYinXing": "ИНН{0}<br />р/сч{1}<br />БИК{2}<br />Кор./сч{3}<br />Банк{4}<br />",
    "QianMing": "签名",
    "ShenQingWenJian": "申请文件",
    "DaoRuShiBai": "导入失败",
    "YeWuGenDan": "业务跟单",
    "DaoRuMoBan": "导入模版",
    "ChengShiBiaoZhi": "诚实标志",
    "QingShuRuHaiGuanShenBaoBianMa": "请输入海关申报编码",
    "QingXuanZeHaiGuanShenBaoRiQi": "请选择海关申报日期",
    "DingZhiFuWuPeiZhi": "定制服务配置",
    "XuanZeBaoZhuangFuWu": "选择包装服务",
    "XiTongJiangGenJuShangPinC": "系统将根据商品尺寸自动匹配型号",
    "DangQianXuanZe": "当前选择",
    "TiaoMaDingZhi": "条码定制",
    "DingZhiTiaoMaShuoMing": "定制条码说明",
    "ShangChuanTiaoMa": "上传条码",
    "ShuRuTiaoMa": "输入条码",
    "YiKuanDuoTiaoMa": "SKU多条码",
    "QingShuRuTeShuCaoZuoZhiLi": "请输入特殊操作指令，例如：拆除吊牌、更换包装盒、放置卡片等..",
    "SuoYouDingZhiFuWuJiangZai": "所有定制服务将在发货前完成操作",
    "YunFeiJiaShou": "运费加收",
    "ATKBianMa": "ATK编码",
    "XiaoHao": "小号",
    "ZhongHao": "中号",
    "DaHao": "大号",
    "GenJuShangPinPiPeiXuShiYo": "根据商品匹配需使用的型号",
    "BaoZhuangFuWu": "Fulfillment",
    "MESSAONEHomeTitle": "中国直采批发，EAC与诚实标志一站式 | ESSAONE",
    "MESSAONEHomeDescription": "ESSAONE：面向俄罗斯的中国工厂直采平台——玩具/餐具/文具/童品等批发。支持诚实标志贴码、清关与数据传输，一站式完成。",
    "XunQianChangJia": "询前厂价",
    "XunHouChangJia": "询后厂价",
    "ShiJiCaiGouJia": "实际采购价",
    "RangLiKeHu": "让利客户",
    "SuanLiRun": "算利润",
    "TuiN": "含退 {0}%",
    "TuiDian": "退点",
    "FufilmentKey2": "fulfillment  服务",
    "QiTaYaoQiuShuoMing": "其他要求说明",
    "YuGu": "预估",
    "ShangPinDeFaHuoFangShiShi": "商品的发货方式是中国直发的，暂不提供 fulfillment 服务",
    "ShangPinZengJiaEWaiBaoZhu": "商品增加额外包装后包装的体积变大，因体积变大需要多增加收取运费",
    "RuoNinXuYaoJiangCaiGouDeS": "<div><div class=\"mb_6\">1.提供贴纸服务——在中国出货前贴好WB/OZON等电商平台的 SKU ID 条码，无需您自行处理。</div>\n<div class=\"mb_6\">2.您只需提供 ID 条码文件——在WB/OZON等电商平台的后台生成条码（PDF/图片/条码信息）并上传到 ESSAONE 平台。</div>\n<div class=\"mb_6\">3.ID条码与诚实标志码合成一张贴纸——如果有Fulfillment 服务，将会在产品包装与 Fulfillment 外包装各贴一张。</div>\n<div class=\"mb_6\">4. 到达俄罗斯仓库后，不再需要再一次制作贴纸，可直接进入WB/OZON等电商平台的仓库。</div>\n<div class=\"mb_6\">5. 注意：如果同一SKU不同颜色/款式对应不同条码（混色/混款），请写明每个条码对应的具体商品。</div></div>",
    "TiaoMaDingZhiShuoMing": "条码定制说明",
    "QingGuanTieZhiYangLi": "清关贴纸样例",
    "EwaiBaoZhuangYaoQiu": "额外包装要求",
    "TiaoXingMaDingZhi": "条形码定制",
    "BenDanShiYongJiFenDiKou": "本单使用 {0} 积分抵扣 {1}",
    "ChaKanPiFaJiaGe": "查看批发价格",
    "KeHuDuiDingDanHuoDingDanZ2": "客户对订单或订单中的任意商品有特殊要求，请清楚地写明。这些要求可能涉及商品颜色、指定款式、配件功能等方面。",
    "ShenQingXiaZaiTieZhiWenJi": "申请下载贴纸文件",
    "TieZhiWenJianShengChengZh": "贴纸文件生成中",
    "TieZhiWenJianKeXiaZai": "贴纸文件可下载",
    "TieZhiWenJian": "贴纸文件",
    "ZhongXinShengCheng": "重新生成",
    "ChuLiChengShiBiaoZhiZhong": "处理诚实标志中",
    "KeHuYouHuiQuan": "客户优惠券",
    "KeDiKou": "可抵扣",
    "NDeJiFen": "{0} 的积分",
    "TieZhiWenJianShengChengSh": "贴纸文件生成失败",
    "HuoQuJiaGe": "获取价格",
    "ZanWuShuJuXiaZai": "暂无数据下载",
    "DingDanHaiMeiWanChengChengShiBiaoZhiMaDeGouMai": "订单还没完成诚实标志码的购买，暂无法下载贴纸文件",
    "WangZhanJiaGeBingFeiZuiZh": "网站价格并非最终价格",
    "HuoQuZhongGuoGongChangZhe": "获取中国工厂真实报价（无中间商"
}
 export default lang;